import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, Optional, Attribute, HostBinding, forwardRef, ChangeDetectionStrategy, ViewChild, LOCALE_ID, Inject, HostListener, Injectable, Directive, ElementRef, ViewEncapsulation, InjectionToken, TemplateRef, ContentChildren, ContentChild, Injector, PLATFORM_ID, Pipe, NgModule, ViewChildren } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import * as i2 from '@store-components/icons';
import { ScIconModule, GdsIcons } from '@store-components/icons';
import * as i2$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NgControl, FormsModule, FormControl, ReactiveFormsModule } from '@angular/forms';
import flatpickr from 'flatpickr';
import { Czech } from 'flatpickr/dist/l10n/cs';
import { english } from 'flatpickr/dist/l10n/default';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { takeUntil, auditTime, startWith, tap, debounceTime, filter, map, delay, pluck, distinctUntilChanged } from 'rxjs/operators';
import { animationFrameScheduler, asapScheduler, Subject, fromEvent, merge, of, timer, Observable, Subscription, debounceTime as debounceTime$1 } from 'rxjs';
import * as i1$1 from 'ngx-currency';
import { NgxCurrencyModule } from 'ngx-currency';
import { __decorate, __metadata } from 'tslib';
import * as i1$2 from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i1$3 from 'ngx-popperjs';
import { NgxPopperjsContentComponent, NgxPopperjsDirective, NgxPopperjsModule, NgxPopperjsPlacements } from 'ngx-popperjs';
import * as i3 from '@angular/cdk/bidi';
import { RIGHT_ARROW, UP_ARROW, LEFT_ARROW, DOWN_ARROW } from '@angular/cdk/keycodes';
import * as i2$2 from '@angular/cdk/platform';
import { gsap } from 'gsap';

class ScAccordionComponent {
    constructor() {
        this.expanded = false;
        this.mode = 'default';
        this.openText = 'Rozbalit';
        this.closeText = 'Sbalit';
        this.closed = new EventEmitter();
        this.opened = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes['expanded'] && !changes['expanded'].isFirstChange) {
            this.expanded = changes['expanded'].currentValue;
            this.emitStateChange();
        }
    }
    toggle() {
        this.expanded = !this.expanded;
        this.emitStateChange();
    }
    emitStateChange() {
        if (this.expanded === true) {
            this.opened.emit();
        }
        else {
            this.closed.emit();
        }
    }
}
ScAccordionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScAccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScAccordionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScAccordionComponent, isStandalone: true, selector: "sc-accordion", inputs: { expanded: "expanded", mode: "mode", label: "label", openText: "openText", closeText: "closeText" }, outputs: { closed: "closed", opened: "opened" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"sc-accordion\" [ngClass]=\"{'sc-accordion-centered': mode === 'centered'}\">\n  <div *ngIf=\"label\" (click)=\"toggle()\" class=\"sc-accordion-label\">{{label}}</div>\n\n  <div (click)=\"toggle()\" class=\"sc-accordion-header\" [ngClass]=\"{expanded: expanded}\">\n    <div class=\"sc-accordion-action\">\n      <div>{{ expanded ? closeText : openText }}</div>\n      <svg sc-icon icon=\"ico-caret-down\" size=\"20\"></svg>\n    </div>\n  </div>\n\n  <div class=\"sc-accordion-content\" *ngIf=\"expanded\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScAccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-accordion', standalone: true, imports: [CommonModule, ScIconModule], template: "<div class=\"sc-accordion\" [ngClass]=\"{'sc-accordion-centered': mode === 'centered'}\">\n  <div *ngIf=\"label\" (click)=\"toggle()\" class=\"sc-accordion-label\">{{label}}</div>\n\n  <div (click)=\"toggle()\" class=\"sc-accordion-header\" [ngClass]=\"{expanded: expanded}\">\n    <div class=\"sc-accordion-action\">\n      <div>{{ expanded ? closeText : openText }}</div>\n      <svg sc-icon icon=\"ico-caret-down\" size=\"20\"></svg>\n    </div>\n  </div>\n\n  <div class=\"sc-accordion-content\" *ngIf=\"expanded\">\n    <ng-content></ng-content>\n  </div>\n</div>\n" }]
        }], propDecorators: { expanded: [{
                type: Input
            }], mode: [{
                type: Input
            }], label: [{
                type: Input
            }], openText: [{
                type: Input
            }], closeText: [{
                type: Input
            }], closed: [{
                type: Output
            }], opened: [{
                type: Output
            }] } });

/* eslint-disable @angular-eslint/component-selector */
class ScButtonComponent {
    get primaryClass() {
        return this.mode === 'primary' ? 'primary' : null;
    }
    get secondaryClass() {
        return this.mode === 'secondary' ? 'secondary' : null;
    }
    get tertiaryClass() {
        return this.mode === 'tertiary' ? 'tertiary' : null;
    }
    get dangerClass() {
        return this.mode === 'danger' ? 'danger' : null;
    }
    get invertedClass() {
        return this.inverted ? 'inverted' : null;
    }
    get iconClass() {
        return this.isIconButton ? 'icon-button' : null;
    }
    get iconLeftClass() {
        return this.iconPlacement === 'left' ? 'left' : null;
    }
    get iconRightClass() {
        return this.iconPlacement === 'right' ? 'right' : null;
    }
    get smallClass() {
        return this.size === 'small' ? 'small' : null;
    }
    get activeClass() {
        return this.active ? 'active' : null;
    }
    get disabledClass() {
        return this.disabled ? 'disabled' : null;
    }
    get disabledAttr() {
        return this.disabled ? this.disabled : null;
    }
    constructor(iconButton) {
        this.isIconButton = false;
        this.disabled = false;
        this.size = 'normal';
        this.active = false;
        this.mode = 'primary';
        this.iconPlacement = 'left';
        this.iconSize = '';
        this.icon = null;
        this.inverted = false;
        this.mainClass = 'sc-button';
        this.buttonType = 'button';
        this.isIconButton = iconButton !== null;
    }
}
ScButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScButtonComponent, deps: [{ token: 'sc-icon-button', attribute: true, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ScButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScButtonComponent, isStandalone: true, selector: "button[sc-button], button[sc-icon-button]", inputs: { disabled: "disabled", size: "size", active: "active", mode: "mode", iconPlacement: "iconPlacement", iconSize: "iconSize", icon: "icon", inverted: "inverted" }, host: { properties: { "class.sc-button": "this.mainClass", "class.primary": "this.primaryClass", "class.secondary": "this.secondaryClass", "class.tertiary": "this.tertiaryClass", "class.danger": "this.dangerClass", "class.inverted": "this.invertedClass", "class.icon-button": "this.iconClass", "class.icon-left": "this.iconLeftClass", "class.icon-right": "this.iconRightClass", "class.sc-button-small": "this.smallClass", "class.active": "this.activeClass", "class.disabled": "this.disabledClass", "attr.type": "this.buttonType", "attr.disabled": "this.disabledAttr" } }, ngImport: i0, template: "<span class=\"sc-button-content\"><ng-content></ng-content></span>\n<ng-container *ngIf=\"icon\">\n  <svg [size]=\"iconSize\" sc-icon [icon]=\"icon\"></svg>\n</ng-container>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'button[sc-button], button[sc-icon-button]', standalone: true, imports: [CommonModule, ScIconModule], template: "<span class=\"sc-button-content\"><ng-content></ng-content></span>\n<ng-container *ngIf=\"icon\">\n  <svg [size]=\"iconSize\" sc-icon [icon]=\"icon\"></svg>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: i0.Attribute, decorators: [{
                    type: Optional
                }, {
                    type: Attribute,
                    args: ['sc-icon-button']
                }] }]; }, propDecorators: { disabled: [{
                type: Input
            }], size: [{
                type: Input
            }], active: [{
                type: Input
            }], mode: [{
                type: Input
            }], iconPlacement: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], icon: [{
                type: Input
            }], inverted: [{
                type: Input
            }], mainClass: [{
                type: HostBinding,
                args: ['class.sc-button']
            }], primaryClass: [{
                type: HostBinding,
                args: ['class.primary']
            }], secondaryClass: [{
                type: HostBinding,
                args: ['class.secondary']
            }], tertiaryClass: [{
                type: HostBinding,
                args: ['class.tertiary']
            }], dangerClass: [{
                type: HostBinding,
                args: ['class.danger']
            }], invertedClass: [{
                type: HostBinding,
                args: ['class.inverted']
            }], iconClass: [{
                type: HostBinding,
                args: ['class.icon-button']
            }], iconLeftClass: [{
                type: HostBinding,
                args: ['class.icon-left']
            }], iconRightClass: [{
                type: HostBinding,
                args: ['class.icon-right']
            }], smallClass: [{
                type: HostBinding,
                args: ['class.sc-button-small']
            }], activeClass: [{
                type: HostBinding,
                args: ['class.active']
            }], disabledClass: [{
                type: HostBinding,
                args: ['class.disabled']
            }], buttonType: [{
                type: HostBinding,
                args: ['attr.type']
            }], disabledAttr: [{
                type: HostBinding,
                args: ['attr.disabled']
            }] } });

class ScAlertComponent {
    constructor() {
        this.icons = {
            danger: 'ico-error-circle',
            info: 'ico-info',
            warning: 'ico-warning',
            success: 'ico-checkmark-circle',
        };
        this.largeIcons = {
            danger: 'ico-error-circle-xl',
            info: 'ico-info-xl',
            warning: 'ico-warning-xl',
            success: 'ico-checkmark-circle-xl',
        };
        this.actionsTemplate = null;
        this.size = 'medium';
        this.type = 'info';
        this.closeClick = new EventEmitter();
        this.closeFocus = new EventEmitter();
        this.closeBlur = new EventEmitter();
        this.ctaButtonClick = new EventEmitter();
        this.ctaButtonFocus = new EventEmitter();
        this.ctaButtonBlur = new EventEmitter();
    }
    buttonClicked(event) {
        this.ctaButtonClick.emit(event);
    }
    buttonFocused(event) {
        this.ctaButtonFocus.emit(event);
    }
    buttonBlurred(event) {
        this.ctaButtonBlur.emit(event);
    }
    closeClicked(event) {
        this.closeClick.emit(event);
    }
    closeFocused(event) {
        this.closeFocus.emit(event);
    }
    closeBlurred(event) {
        this.closeBlur.emit(event);
    }
}
ScAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScAlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScAlertComponent, isStandalone: true, selector: "sc-alert", inputs: { actionsTemplate: "actionsTemplate", buttonLabel: "buttonLabel", closeable: "closeable", description: "description", label: "label", size: "size", type: "type", vertical: "vertical" }, outputs: { closeClick: "closeClick", closeFocus: "closeFocus", closeBlur: "closeBlur", ctaButtonClick: "ctaButtonClick", ctaButtonFocus: "ctaButtonFocus", ctaButtonBlur: "ctaButtonBlur" }, ngImport: i0, template: "<div\n  class=\"sc-alert\"\n  [ngClass]=\"{\n    'sc-alert-layout-closeable': closeable,\n    'sc-alert-layout-buttons': (buttonLabel || actionsTemplate) && !closeable,\n    'sc-alert-layout-buttons-closeable': (buttonLabel || actionsTemplate) && closeable,\n    'sc-alert-vertical': vertical,\n    'sc-alert-small': size === 'small',\n    'sc-alert-large': size === 'large',\n    'alert-danger': type === 'danger',\n    'alert-info': type === 'info',\n    'alert-success': type === 'success',\n    'alert-warning': type === 'warning'\n  }\"\n>\n  <svg\n    sc-icon\n    [icon]=\"size === 'large' ? largeIcons[type] : icons[type]\"\n    class=\"sc-alert-icon\"\n    aria-hidden=\"true\"\n    focusable=\"false\"\n  ></svg>\n  <button\n    sc-button\n    mode=\"tertiary\"\n    icon=\"ico-error\"\n    iconPlacement=\"right\"\n    size=\"small\"\n    class=\"sc-alert-close\"\n    *ngIf=\"closeable && size !== 'small'\"\n    (click)=\"closeClicked($event)\"\n    (focus)=\"closeFocused($event)\"\n    (blur)=\"closeBlurred($event)\"\n  >\n    <span class=\"sc-alert-close-label\">Zav\u0159\u00EDt</span>\n  </button>\n  <h2 class=\"sc-alert-label\" *ngIf=\"label && size !== 'small'\">{{ label }}</h2>\n  <div class=\"sc-alert-content\">\n    <p *ngIf=\"description\" class=\"mb-0\">{{ description }}</p>\n    <ng-content></ng-content>\n  </div>\n  <div class=\"sc-alert-actions flex flex-col gap-16 items-center justify-center\" *ngIf=\"buttonLabel || actionsTemplate\">\n    <ng-container *ngIf=\"buttonLabel\">\n      <button\n        *ngIf=\"size !== 'small'\"\n        class=\"sc-alert-button w-full\"\n        sc-button\n        mode=\"secondary\"\n        size=\"normal\"\n        (click)=\"buttonClicked($event)\"\n        (focus)=\"buttonFocused($event)\"\n        (blur)=\"buttonBlurred($event)\"\n      >\n        {{ buttonLabel }}\n      </button>\n      <button\n        *ngIf=\"size === 'small'\"\n        class=\"sc-alert-button justify-self-center self-center\"\n        sc-button\n        mode=\"tertiary\"\n        size=\"small\"\n        (click)=\"buttonClicked($event)\"\n        (focus)=\"buttonFocused($event)\"\n        (blur)=\"buttonBlurred($event)\"\n      >\n        {{ buttonLabel }}\n      </button>\n    </ng-container>\n    <ng-container *ngTemplateOutlet=\"actionsTemplate\"></ng-container>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: ScButtonComponent, selector: "button[sc-button], button[sc-icon-button]", inputs: ["disabled", "size", "active", "mode", "iconPlacement", "iconSize", "icon", "inverted"] }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-alert', standalone: true, imports: [CommonModule, ScButtonComponent, ScIconModule], template: "<div\n  class=\"sc-alert\"\n  [ngClass]=\"{\n    'sc-alert-layout-closeable': closeable,\n    'sc-alert-layout-buttons': (buttonLabel || actionsTemplate) && !closeable,\n    'sc-alert-layout-buttons-closeable': (buttonLabel || actionsTemplate) && closeable,\n    'sc-alert-vertical': vertical,\n    'sc-alert-small': size === 'small',\n    'sc-alert-large': size === 'large',\n    'alert-danger': type === 'danger',\n    'alert-info': type === 'info',\n    'alert-success': type === 'success',\n    'alert-warning': type === 'warning'\n  }\"\n>\n  <svg\n    sc-icon\n    [icon]=\"size === 'large' ? largeIcons[type] : icons[type]\"\n    class=\"sc-alert-icon\"\n    aria-hidden=\"true\"\n    focusable=\"false\"\n  ></svg>\n  <button\n    sc-button\n    mode=\"tertiary\"\n    icon=\"ico-error\"\n    iconPlacement=\"right\"\n    size=\"small\"\n    class=\"sc-alert-close\"\n    *ngIf=\"closeable && size !== 'small'\"\n    (click)=\"closeClicked($event)\"\n    (focus)=\"closeFocused($event)\"\n    (blur)=\"closeBlurred($event)\"\n  >\n    <span class=\"sc-alert-close-label\">Zav\u0159\u00EDt</span>\n  </button>\n  <h2 class=\"sc-alert-label\" *ngIf=\"label && size !== 'small'\">{{ label }}</h2>\n  <div class=\"sc-alert-content\">\n    <p *ngIf=\"description\" class=\"mb-0\">{{ description }}</p>\n    <ng-content></ng-content>\n  </div>\n  <div class=\"sc-alert-actions flex flex-col gap-16 items-center justify-center\" *ngIf=\"buttonLabel || actionsTemplate\">\n    <ng-container *ngIf=\"buttonLabel\">\n      <button\n        *ngIf=\"size !== 'small'\"\n        class=\"sc-alert-button w-full\"\n        sc-button\n        mode=\"secondary\"\n        size=\"normal\"\n        (click)=\"buttonClicked($event)\"\n        (focus)=\"buttonFocused($event)\"\n        (blur)=\"buttonBlurred($event)\"\n      >\n        {{ buttonLabel }}\n      </button>\n      <button\n        *ngIf=\"size === 'small'\"\n        class=\"sc-alert-button justify-self-center self-center\"\n        sc-button\n        mode=\"tertiary\"\n        size=\"small\"\n        (click)=\"buttonClicked($event)\"\n        (focus)=\"buttonFocused($event)\"\n        (blur)=\"buttonBlurred($event)\"\n      >\n        {{ buttonLabel }}\n      </button>\n    </ng-container>\n    <ng-container *ngTemplateOutlet=\"actionsTemplate\"></ng-container>\n  </div>\n</div>\n" }]
        }], propDecorators: { actionsTemplate: [{
                type: Input
            }], buttonLabel: [{
                type: Input
            }], closeable: [{
                type: Input
            }], description: [{
                type: Input
            }], label: [{
                type: Input
            }], size: [{
                type: Input
            }], type: [{
                type: Input
            }], vertical: [{
                type: Input
            }], closeClick: [{
                type: Output
            }], closeFocus: [{
                type: Output
            }], closeBlur: [{
                type: Output
            }], ctaButtonClick: [{
                type: Output
            }], ctaButtonFocus: [{
                type: Output
            }], ctaButtonBlur: [{
                type: Output
            }] } });

class ScAlertValidationComponent {
    constructor() {
        this.type = 'danger';
        this.description = 'Lorem ipsum';
    }
}
ScAlertValidationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScAlertValidationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScAlertValidationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScAlertValidationComponent, isStandalone: true, selector: "sc-alert-validation", inputs: { type: "type", description: "description" }, ngImport: i0, template: "<sc-alert [type]=\"type\" [size]=\"'small'\">{{ description }}</sc-alert>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: ScAlertComponent, selector: "sc-alert", inputs: ["actionsTemplate", "buttonLabel", "closeable", "description", "label", "size", "type", "vertical"], outputs: ["closeClick", "closeFocus", "closeBlur", "ctaButtonClick", "ctaButtonFocus", "ctaButtonBlur"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScAlertValidationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-alert-validation', standalone: true, imports: [CommonModule, ScIconModule, ScAlertComponent], template: "<sc-alert [type]=\"type\" [size]=\"'small'\">{{ description }}</sc-alert>\n" }]
        }], propDecorators: { type: [{
                type: Input
            }], description: [{
                type: Input
            }] } });

class ScBannerComponent {
    constructor() {
        this.class = 'sc-banner';
        this.role = 'banner';
    }
}
ScBannerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScBannerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScBannerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScBannerComponent, isStandalone: true, selector: "sc-banner", inputs: { alt: "alt", src: "src" }, host: { properties: { "class": "this.class", "attr.role": "this.role" } }, ngImport: i0, template: '<img [src]="src" [alt]="alt">', isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScBannerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-banner',
                    standalone: true,
                    imports: [CommonModule],
                    template: '<img [src]="src" [alt]="alt">',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], alt: [{
                type: Input
            }], src: [{
                type: Input
            }] } });

class ScBannerBrandComponent {
    constructor() {
        this.class = 'sc-banner-brand';
        this.role = 'banner';
    }
}
ScBannerBrandComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScBannerBrandComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScBannerBrandComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScBannerBrandComponent, isStandalone: true, selector: "sc-banner-brand", inputs: { src: "src", alt: "alt" }, host: { properties: { "class": "this.class", "attr.role": "this.role" } }, ngImport: i0, template: '<img [src]="src" [alt]="alt">', isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScBannerBrandComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-banner-brand',
                    standalone: true,
                    imports: [CommonModule],
                    template: '<img [src]="src" [alt]="alt">',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], src: [{
                type: Input
            }], alt: [{
                type: Input
            }] } });

/**
 * A basic content container component that adds the styles of a card.
 *
 * While this component can be used alone, it also provides a number
 * of preset styles for common card sections, including:
 * - sc-card-header
 * - sc-card-content
 */
class ScCardComponent {
    constructor() {
        this.customClass = '';
    }
    get componentClass() {
        const baseClass = 'sc-card';
        return this.customClass ? baseClass + ' ' + this.customClass : baseClass;
    }
}
ScCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScCardComponent, isStandalone: true, selector: "sc-card", inputs: { customClass: "customClass" }, host: { properties: { "class": "this.componentClass" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-card',
                    standalone: true,
                    template: `<ng-content></ng-content>`,
                }]
        }], propDecorators: { customClass: [{
                type: Input
            }], componentClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScCardContentComponent {
    constructor() {
        this.mode = 'default';
    }
    get classByMode() {
        const baseClass = 'sc-card-content';
        return this.mode == 'function' ? baseClass + ' sc-card-content-function' : baseClass;
    }
}
ScCardContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCardContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScCardContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScCardContentComponent, isStandalone: true, selector: "sc-card-content", inputs: { mode: "mode" }, host: { properties: { "class": "this.classByMode" } }, ngImport: i0, template: "<ng-content></ng-content>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCardContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-card-content', standalone: true, template: "<ng-content></ng-content>\n" }]
        }], propDecorators: { mode: [{
                type: Input
            }], classByMode: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * A card header container.
 * Accepts headline text, description and can be shown with icon on left or right side.
 */
class ScCardHeaderComponent {
    constructor() {
        this.headline = 'Headline';
        this.iconPosition = 'left';
        this.class = 'sc-card-header flex flex-col p-16';
    }
}
ScCardHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCardHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScCardHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScCardHeaderComponent, isStandalone: true, selector: "sc-card-header", inputs: { headline: "headline", description: "description", icon: "icon", iconPosition: "iconPosition" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<div class=\"sc-card-header-headline flex flex-row\">\n  <div class=\"flex flex-none items-center justify-center mr-8\" *ngIf=\"icon && iconPosition === 'left'\">\n    <svg sc-icon [icon]=\"icon\" size=\"20\"></svg>\n  </div>\n  <div class=\"flex-grow\">{{ headline }}</div>\n  <div class=\"flex flex-none items-center justify-center mr-9\" *ngIf=\"icon && iconPosition === 'right'\">\n    <svg sc-icon [icon]=\"icon\" size=\"20\"></svg>\n  </div>\n</div>\n\n<div class=\"sc-card-header-description\" *ngIf=\"description\">\n  {{ description }}\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCardHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-card-header', standalone: true, imports: [CommonModule, ScIconModule], template: "<div class=\"sc-card-header-headline flex flex-row\">\n  <div class=\"flex flex-none items-center justify-center mr-8\" *ngIf=\"icon && iconPosition === 'left'\">\n    <svg sc-icon [icon]=\"icon\" size=\"20\"></svg>\n  </div>\n  <div class=\"flex-grow\">{{ headline }}</div>\n  <div class=\"flex flex-none items-center justify-center mr-9\" *ngIf=\"icon && iconPosition === 'right'\">\n    <svg sc-icon [icon]=\"icon\" size=\"20\"></svg>\n  </div>\n</div>\n\n<div class=\"sc-card-header-description\" *ngIf=\"description\">\n  {{ description }}\n</div>\n" }]
        }], propDecorators: { headline: [{
                type: Input
            }], description: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
const CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ScCheckboxComponent),
    multi: true,
};
function coerceBooleanProperty$1(value) {
    return value != null && `${value}` !== 'false';
}
class ScCheckboxComponent {
    /**
     * Whether the checkbox is required.
     */
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBooleanProperty$1(value);
        this._changeDetectorRef.markForCheck();
    }
    /**
     * Whether the checkbox is disabled.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        const newValue = value;
        if (newValue !== this.disabled) {
            this._disabled = coerceBooleanProperty$1(value);
            this._changeDetectorRef.markForCheck();
        }
    }
    /**
     * Whether the checkbox is checked.
     */
    get checked() {
        return this._checked;
    }
    set checked(value) {
        if (value !== this.checked) {
            this._checked = coerceBooleanProperty$1(value);
            this._changeDetectorRef.markForCheck();
        }
    }
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this.id = `sc-checkbox-${crypto.randomUUID()}`;
        this.name = null;
        this.indeterminate = false;
        this._required = false;
        this._disabled = false;
        this._checked = false;
        this.checkboxChange = new EventEmitter();
        this.onChange = (_) => { };
        this.onTouched = (_) => { };
    }
    getAriaChecked() {
        return this.checked ? 'true' : 'false';
    }
    emitChangeEvent() {
        this.onChange(this.checked);
        this.checkboxChange.emit(this.checked);
        // Assigning the value again here is redundant, but we have to do it in case it was
        // changed inside the `change` listener which will cause the input to be out of sync.
        if (this._inputElement) {
            this._inputElement.nativeElement.checked = this.checked;
        }
    }
    /**
     * Event handler for checkbox input element.
     * Toggles checked state if element is not disabled.
     * Do not toggle on (change) event since IE does not fire change event when
     *   indeterminate checkbox is clicked.
     * @param event
     */
    onInputClick(event) {
        event.stopPropagation();
        this.toggle();
        this.emitChangeEvent();
    }
    onInteractionEvent(event) {
        this.indeterminate = false;
        event.stopPropagation();
    }
    toggle() {
        this.checked = !this.checked;
    }
    writeValue(value) {
        this.checked = !!value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
ScCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCheckboxComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
ScCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScCheckboxComponent, isStandalone: true, selector: "sc-checkbox", inputs: { id: "id", name: "name", value: "value", label: "label", ariaLabelledBy: "ariaLabelledBy", ariaLabel: "ariaLabel", indeterminate: "indeterminate", required: "required", disabled: "disabled", checked: "checked" }, outputs: { checkboxChange: "checkboxChange" }, providers: [CHECKBOX_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "_inputElement", first: true, predicate: ["input"], descendants: true, static: true }], ngImport: i0, template: "<label [attr.for]=\"id\" class=\"sc-checkbox flex\">\n  <span class=\"sc-checkbox-icon-container\">\n    <input\n      type=\"checkbox\"\n      class=\"sc-checkbox-input\"\n      [class.sc-checkbox-input-indeterminate]=\"indeterminate\"\n      #input\n      [disabled]=\"disabled\"\n      [id]=\"id\"\n      [required]=\"required\"\n      [checked]=\"checked\"\n      [attr.value]=\"value\"\n      [attr.name]=\"name\"\n      [attr.aria-checked]=\"getAriaChecked()\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.aria-labelledby]=\"ariaLabelledBy\"\n      (change)=\"onInteractionEvent($event)\"\n      (click)=\"onInputClick($event)\"\n      (blur)=\"onTouched($event)\"\n    />\n    <span class=\"sc-checkbox-icon\"></span>\n  </span>\n  <span class=\"sc-label-inline\">\n    <span *ngIf=\"label\">{{ label }}</span>\n    <ng-content></ng-content>\n  </span>\n</label>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.Default });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-checkbox', standalone: true, imports: [CommonModule], providers: [CHECKBOX_CONTROL_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.Default, template: "<label [attr.for]=\"id\" class=\"sc-checkbox flex\">\n  <span class=\"sc-checkbox-icon-container\">\n    <input\n      type=\"checkbox\"\n      class=\"sc-checkbox-input\"\n      [class.sc-checkbox-input-indeterminate]=\"indeterminate\"\n      #input\n      [disabled]=\"disabled\"\n      [id]=\"id\"\n      [required]=\"required\"\n      [checked]=\"checked\"\n      [attr.value]=\"value\"\n      [attr.name]=\"name\"\n      [attr.aria-checked]=\"getAriaChecked()\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.aria-labelledby]=\"ariaLabelledBy\"\n      (change)=\"onInteractionEvent($event)\"\n      (click)=\"onInputClick($event)\"\n      (blur)=\"onTouched($event)\"\n    />\n    <span class=\"sc-checkbox-icon\"></span>\n  </span>\n  <span class=\"sc-label-inline\">\n    <span *ngIf=\"label\">{{ label }}</span>\n    <ng-content></ng-content>\n  </span>\n</label>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], label: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], indeterminate: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], checked: [{
                type: Input
            }], checkboxChange: [{
                type: Output
            }], _inputElement: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-case-declarations */
const CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ScDatepickerComponent),
    multi: true,
};
class ScDatepickerComponent {
    constructor(locale) {
        this.locale = locale;
        this.placeholder = 'Select date';
        this.altFormat = 'F j, Y';
        this.allowInput = false;
        this.dateFormat = 'd.m.Y';
        this.disabled = false;
        this.disable = [];
        this.enableTime = false;
        this.mode = 'single';
        this.noCalendar = false;
        this.showMonths = 1;
        this.monthSelectorType = 'static';
        this.flatpickrReady = new EventEmitter();
        this.flatpickrChange = new EventEmitter();
        this.flatpickrValueUpdate = new EventEmitter();
        this.flatpickrOpen = new EventEmitter();
        this.flatpickrClose = new EventEmitter();
        this.flatpickrMonthChange = new EventEmitter();
        this.flatpickrYearChange = new EventEmitter();
        this.flatpickrDayCreate = new EventEmitter();
        this.onChangeFn = () => {
            /**/
        };
        this.onTouchedFn = () => {
            /**/
        };
    }
    ngAfterViewInit() {
        const language = this.locale?.split('-')[0] ?? 'cs';
        let locale = english;
        if (language === 'cs' || language === 'sk') {
            locale = Czech;
        }
        const options = {
            altFormat: this.altFormat,
            allowInput: this.allowInput,
            dateFormat: this.dateFormat,
            disable: this.disable,
            enableTime: this.enableTime,
            defaultDate: this.initialValue,
            maxDate: this.maxDate,
            minDate: this.minDate,
            mode: this.mode,
            noCalendar: this.noCalendar,
            showMonths: this.showMonths,
            monthSelectorType: this.monthSelectorType,
            disableMobile: true,
            time_24hr: true,
            locale: locale,
            onChange: (selectedDates, dateString, instance) => {
                this.flatpickrChange.emit({ selectedDates, dateString, instance });
            },
            onOpen: (selectedDates, dateString, instance) => {
                this.flatpickrOpen.emit({ selectedDates, dateString, instance });
            },
            onClose: (selectedDates, dateString, instance) => {
                this.flatpickrClose.emit({ selectedDates, dateString, instance });
            },
            onMonthChange: (selectedDates, dateString, instance) => {
                this.flatpickrMonthChange.emit({ selectedDates, dateString, instance });
            },
            onYearChange: (selectedDates, dateString, instance) => {
                this.flatpickrYearChange.emit({ selectedDates, dateString, instance });
            },
            onReady: (selectedDates, dateString, instance) => {
                this.flatpickrReady.emit({ selectedDates, dateString, instance });
            },
            onValueUpdate: (selectedDates, dateString, instance) => {
                this.flatpickrValueUpdate.emit({ selectedDates, dateString, instance });
            },
            onDayCreate: (selectedDates, dateString, instance, dayElement) => {
                this.flatpickrDayCreate.emit({
                    selectedDates,
                    dateString,
                    instance,
                    dayElement,
                });
            },
        };
        this.instance = flatpickr(this.datepicker?.nativeElement, options);
    }
    ngOnChanges(changes) {
        if (this.instance) {
            Object.keys(changes).forEach((inputKey) => {
                this.instance?.set(inputKey, this[inputKey]);
            });
        }
    }
    ngOnDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }
    writeValue(value) {
        let convertedValue = value;
        if (this.mode === 'range' && value) {
            convertedValue = [value.from, value.to];
        }
        if (this.instance) {
            this.instance.setDate(convertedValue);
        }
        else {
            this.initialValue = convertedValue;
        }
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    inputChanged() {
        const value = this.datepicker?.nativeElement.value;
        if (typeof value === 'string') {
            switch (this.mode) {
                case 'multiple':
                    const dates = value
                        .split('; ')
                        .map((str) => this.instance.parseDate(str, this.instance.config.dateFormat, !this.instance.config.enableTime));
                    this.onChangeFn(dates);
                    break;
                case 'range':
                    const [from, to] = value
                        .split(this.instance.l10n.rangeSeparator)
                        .map((str) => this.instance?.parseDate(str, this.instance.config.dateFormat, !this.instance.config.enableTime));
                    this.onChangeFn({ from, to });
                    break;
                case 'single':
                default:
                    this.onChangeFn(this.instance?.parseDate(value, this.instance.config.dateFormat, !this.instance.config.enableTime));
            }
        }
        else {
            this.onChangeFn(value);
        }
    }
}
ScDatepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDatepickerComponent, deps: [{ token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Component });
ScDatepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScDatepickerComponent, isStandalone: true, selector: "sc-datepicker", inputs: { placeholder: "placeholder", altFormat: "altFormat", allowInput: "allowInput", dateFormat: "dateFormat", disabled: "disabled", disable: "disable", enableTime: "enableTime", maxDate: "maxDate", minDate: "minDate", mode: "mode", noCalendar: "noCalendar", formatDate: "formatDate", parseDate: "parseDate", getWeek: "getWeek", showMonths: "showMonths", monthSelectorType: "monthSelectorType" }, outputs: { flatpickrReady: "flatpickrReady", flatpickrChange: "flatpickrChange", flatpickrValueUpdate: "flatpickrValueUpdate", flatpickrOpen: "flatpickrOpen", flatpickrClose: "flatpickrClose", flatpickrMonthChange: "flatpickrMonthChange", flatpickrYearChange: "flatpickrYearChange", flatpickrDayCreate: "flatpickrDayCreate" }, host: { listeners: { "input": "inputChanged()" } }, providers: [CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "datepicker", first: true, predicate: ["datepicker"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"sc-input-group sc-datepicker sc-addon-input\">\n  <input\n    class=\"sc-input\"\n    type=\"text\"\n    #datepicker\n    [placeholder]=\"placeholder\"\n    [disabled]=\"disabled\"\n    (blur)=\"onTouchedFn()\"\n  />\n  <div\n    class=\"sc-input-group-append\"\n    (click)=\"instance.toggle()\"\n  >\n    <button sc-icon-button mode=\"secondary\" icon=\"ico-calendar\"></button>\n  </div>\n  <ng-content></ng-content>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: ScButtonComponent, selector: "button[sc-button], button[sc-icon-button]", inputs: ["disabled", "size", "active", "mode", "iconPlacement", "iconSize", "icon", "inverted"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-datepicker', standalone: true, imports: [CommonModule, ScButtonComponent], providers: [CONTROL_VALUE_ACCESSOR], template: "<div class=\"sc-input-group sc-datepicker sc-addon-input\">\n  <input\n    class=\"sc-input\"\n    type=\"text\"\n    #datepicker\n    [placeholder]=\"placeholder\"\n    [disabled]=\"disabled\"\n    (blur)=\"onTouchedFn()\"\n  />\n  <div\n    class=\"sc-input-group-append\"\n    (click)=\"instance.toggle()\"\n  >\n    <button sc-icon-button mode=\"secondary\" icon=\"ico-calendar\"></button>\n  </div>\n  <ng-content></ng-content>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }]; }, propDecorators: { placeholder: [{
                type: Input
            }], altFormat: [{
                type: Input
            }], allowInput: [{
                type: Input
            }], dateFormat: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disable: [{
                type: Input
            }], enableTime: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], minDate: [{
                type: Input
            }], mode: [{
                type: Input
            }], noCalendar: [{
                type: Input
            }], formatDate: [{
                type: Input
            }], parseDate: [{
                type: Input
            }], getWeek: [{
                type: Input
            }], showMonths: [{
                type: Input
            }], monthSelectorType: [{
                type: Input
            }], flatpickrReady: [{
                type: Output
            }], flatpickrChange: [{
                type: Output
            }], flatpickrValueUpdate: [{
                type: Output
            }], flatpickrOpen: [{
                type: Output
            }], flatpickrClose: [{
                type: Output
            }], flatpickrMonthChange: [{
                type: Output
            }], flatpickrYearChange: [{
                type: Output
            }], flatpickrDayCreate: [{
                type: Output
            }], datepicker: [{
                type: ViewChild,
                args: ['datepicker', { static: true }]
            }], inputChanged: [{
                type: HostListener,
                args: ['input']
            }] } });

class ScDividerComponent {
    constructor() {
        this._vertical = false;
        this.role = 'separator';
        this.mainClass = 'sc-divider';
    }
    get vertical() {
        return this._vertical;
    }
    set vertical(value) {
        this._vertical = value;
    }
    get class() {
        return this.vertical ? 'sc-divider-vertical' : null;
    }
}
ScDividerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScDividerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScDividerComponent, isStandalone: true, selector: "sc-divider", inputs: { vertical: "vertical" }, host: { properties: { "attr.role": "this.role", "class.sc-divider": "this.mainClass", "class.sc-divider-vertical": "this.class" } }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDividerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-divider',
                    standalone: true,
                    template: '',
                }]
        }], propDecorators: { vertical: [{
                type: Input
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], mainClass: [{
                type: HostBinding,
                args: ['class.sc-divider']
            }], class: [{
                type: HostBinding,
                args: ['class.sc-divider-vertical']
            }] } });

class ScLoaderComponent {
    constructor() {
        this.width = '48px';
    }
}
ScLoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScLoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScLoaderComponent, isStandalone: true, selector: "sc-loader", inputs: { width: "width" }, ngImport: i0, template: "<div class=\"sc-circle-loader\" [ngStyle]=\"{ width: width }\">\n  <svg class=\"sc-circle-loader-circular\" viewBox=\"25 25 50 50\">\n    <circle\n      class=\"sc-circle-loader-path\"\n      cx=\"50\"\n      cy=\"50\"\n      r=\"20\"\n      fill=\"none\"\n      stroke-width=\"4\"\n      stroke-miterlimit=\"10\"\n    />\n  </svg>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-loader', standalone: true, imports: [CommonModule], template: "<div class=\"sc-circle-loader\" [ngStyle]=\"{ width: width }\">\n  <svg class=\"sc-circle-loader-circular\" viewBox=\"25 25 50 50\">\n    <circle\n      class=\"sc-circle-loader-path\"\n      cx=\"50\"\n      cy=\"50\"\n      r=\"20\"\n      fill=\"none\"\n      stroke-width=\"4\"\n      stroke-miterlimit=\"10\"\n    />\n  </svg>\n</div>\n" }]
        }], propDecorators: { width: [{
                type: Input
            }] } });

class ScLoaderContainerComponent {
    constructor() {
        this.loading = false;
        this.loadingMessage = 'Chvilku strpení...';
        this.fadein = true;
        this.width = '48px';
        this.class = 'sc-loader-container flex-1 justify-center';
    }
}
ScLoaderContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLoaderContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScLoaderContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScLoaderContainerComponent, isStandalone: true, selector: "sc-loader-container", inputs: { loading: "loading", loadingMessage: "loadingMessage", fadein: "fadein", width: "width" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<ng-container *ngIf=\"!loading\">\n  <ng-content></ng-content>\n</ng-container>\n\n<ng-container *ngIf=\"loading\">\n  <div [ngClass]=\"{ 'loader-fade-in': fadein }\">\n    <div class=\"flex pb-16 justify-center\">\n      <sc-loader [width]=\"width\"></sc-loader>\n    </div>\n    <div class=\"text-center text-blue-400\" *ngIf=\"loadingMessage\">\n      {{ loadingMessage }}\n    </div>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ScLoaderComponent, selector: "sc-loader", inputs: ["width"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLoaderContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-loader-container', standalone: true, imports: [CommonModule, ScLoaderComponent], template: "<ng-container *ngIf=\"!loading\">\n  <ng-content></ng-content>\n</ng-container>\n\n<ng-container *ngIf=\"loading\">\n  <div [ngClass]=\"{ 'loader-fade-in': fadein }\">\n    <div class=\"flex pb-16 justify-center\">\n      <sc-loader [width]=\"width\"></sc-loader>\n    </div>\n    <div class=\"text-center text-blue-400\" *ngIf=\"loadingMessage\">\n      {{ loadingMessage }}\n    </div>\n  </div>\n</ng-container>\n" }]
        }], propDecorators: { loading: [{
                type: Input
            }], loadingMessage: [{
                type: Input
            }], fadein: [{
                type: Input
            }], width: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScStepperComponent {
    constructor() {
        this.icon = GdsIcons.ICO_MORE_VERTICAL;
        this.showBack = false;
        this.showMenu = false;
        this.routeBack = new EventEmitter();
        this.openMenu = new EventEmitter();
    }
    onClickMenu() {
        this.openMenu.emit();
    }
    getCssWidth() {
        return (this.progress || 0) * 100 + '%';
    }
    onClickBack() {
        this.routeBack.emit();
    }
}
ScStepperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStepperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScStepperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScStepperComponent, isStandalone: true, selector: "sc-stepper", inputs: { label: "label", progress: "progress", icon: "icon", showBack: "showBack", showMenu: "showMenu" }, outputs: { routeBack: "routeBack", openMenu: "openMenu" }, ngImport: i0, template: "<div class=\"sc-stepper\">\n  <div class=\"sc-stepper-left\">\n    <a *ngIf=\"showBack\" (click)=\"onClickBack()\" class=\"sc-stepper-click-area\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"25\" fill=\"none\">\n        <path\n          fill=\"#1A67D2\"\n          fill-rule=\"evenodd\"\n          d=\"M16.707 3.793a1 1 0 0 1 0 1.414L9.414 12.5l7.293 7.293a1 1 0 0 1-1.414 1.414l-8-8a1 1 0 0 1 0-1.414l8-8a1 1 0 0 1 1.414 0Z\"\n          clip-rule=\"evenodd\"\n        />\n      </svg>\n    </a>\n  </div>\n\n  <div class=\"sc-stepper-container\" *ngIf=\"label || progress\">\n    <div class=\"sc-stepper-headline\" *ngIf=\"label\">{{ label }}</div>\n    <div class=\"sc-stepper-bar\" *ngIf=\"progress !== undefined\">\n      <div class=\"sc-stepper-value\" [style.width]=\"getCssWidth()\"></div>\n    </div>\n  </div>\n\n  <div class=\"sc-stepper-right\">\n    <div *ngIf=\"showMenu\" (click)=\"onClickMenu()\" class=\"sc-stepper-click-area\">\n      <svg sc-icon [icon]=\"icon\" class=\"sc-stepper-icon sc-stepper-icon-right\"></svg>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-stepper', standalone: true, imports: [CommonModule, ScIconModule], template: "<div class=\"sc-stepper\">\n  <div class=\"sc-stepper-left\">\n    <a *ngIf=\"showBack\" (click)=\"onClickBack()\" class=\"sc-stepper-click-area\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"25\" fill=\"none\">\n        <path\n          fill=\"#1A67D2\"\n          fill-rule=\"evenodd\"\n          d=\"M16.707 3.793a1 1 0 0 1 0 1.414L9.414 12.5l7.293 7.293a1 1 0 0 1-1.414 1.414l-8-8a1 1 0 0 1 0-1.414l8-8a1 1 0 0 1 1.414 0Z\"\n          clip-rule=\"evenodd\"\n        />\n      </svg>\n    </a>\n  </div>\n\n  <div class=\"sc-stepper-container\" *ngIf=\"label || progress\">\n    <div class=\"sc-stepper-headline\" *ngIf=\"label\">{{ label }}</div>\n    <div class=\"sc-stepper-bar\" *ngIf=\"progress !== undefined\">\n      <div class=\"sc-stepper-value\" [style.width]=\"getCssWidth()\"></div>\n    </div>\n  </div>\n\n  <div class=\"sc-stepper-right\">\n    <div *ngIf=\"showMenu\" (click)=\"onClickMenu()\" class=\"sc-stepper-click-area\">\n      <svg sc-icon [icon]=\"icon\" class=\"sc-stepper-icon sc-stepper-icon-right\"></svg>\n    </div>\n  </div>\n</div>\n" }]
        }], propDecorators: { label: [{
                type: Input
            }], progress: [{
                type: Input
            }], icon: [{
                type: Input
            }], showBack: [{
                type: Input
            }], showMenu: [{
                type: Input
            }], routeBack: [{
                type: Output
            }], openMenu: [{
                type: Output
            }] } });

class ScOverlayMenuComponent {
    constructor() {
        this.isOpen = false;
        this.menuOpen = new EventEmitter();
        this.menuClose = new EventEmitter();
    }
    ngOnDestroy() {
        this.removeScrollLock();
    }
    open() {
        this.isOpen = true;
        this.menuOpen.emit();
        this.addScrollLock();
    }
    close() {
        this.isOpen = false;
        this.menuClose.emit();
        this.removeScrollLock();
    }
    addScrollLock() {
        document.body.classList.add('sc-scroll-lock');
    }
    removeScrollLock() {
        document.body.classList.remove('sc-scroll-lock');
    }
}
ScOverlayMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOverlayMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScOverlayMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScOverlayMenuComponent, isStandalone: true, selector: "sc-overlay-menu", inputs: { description: "description", backBtnLabel: "backBtnLabel" }, outputs: { menuOpen: "menuOpen", menuClose: "menuClose" }, ngImport: i0, template: "<div class=\"sc-overlay-menu\" *ngIf=\"isOpen\">\n  <sc-card>\n    <sc-card-content class=\"flex flex-col border-b dark:border-dgray-100\" *ngIf=\"description\" [innerHTML]=\"description\">\n    </sc-card-content>\n    <ng-content></ng-content>\n    <sc-card-content\n      class=\"flex flex-col font-semibold text-blue-300 cursor-pointer\"\n      *ngIf=\"backBtnLabel\"\n    >\n      <div (click)=\"close()\">{{ backBtnLabel }}</div>\n    </sc-card-content>\n  </sc-card>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ScCardComponent, selector: "sc-card", inputs: ["customClass"] }, { kind: "component", type: ScCardContentComponent, selector: "sc-card-content", inputs: ["mode"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOverlayMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-overlay-menu', standalone: true, imports: [CommonModule, ScCardComponent, ScCardContentComponent, ScCardHeaderComponent], template: "<div class=\"sc-overlay-menu\" *ngIf=\"isOpen\">\n  <sc-card>\n    <sc-card-content class=\"flex flex-col border-b dark:border-dgray-100\" *ngIf=\"description\" [innerHTML]=\"description\">\n    </sc-card-content>\n    <ng-content></ng-content>\n    <sc-card-content\n      class=\"flex flex-col font-semibold text-blue-300 cursor-pointer\"\n      *ngIf=\"backBtnLabel\"\n    >\n      <div (click)=\"close()\">{{ backBtnLabel }}</div>\n    </sc-card-content>\n  </sc-card>\n</div>\n" }]
        }], propDecorators: { description: [{
                type: Input
            }], backBtnLabel: [{
                type: Input
            }], menuOpen: [{
                type: Output
            }], menuClose: [{
                type: Output
            }] } });

var slideType;
(function (slideType) {
    slideType[slideType["NONE"] = 0] = "NONE";
    slideType[slideType["OPENING"] = 1] = "OPENING";
    slideType[slideType["CLOSING"] = 2] = "CLOSING";
})(slideType || (slideType = {}));
class ScOffcanvasPageComponent {
    get isShown() {
        return this._isShown;
    }
    set isShown(value) {
        if (this._isShown === true && value === false) {
            this.animationType = slideType.CLOSING;
        }
        else if (this._isShown === false && value === true) {
            this.animationType = slideType.OPENING;
        }
        this._isShown = value;
    }
    constructor(document) {
        this.animationType = slideType.NONE;
        this._isShown = false;
        this.document = document;
    }
    ngOnInit() {
        this.body = this.document.querySelector('body');
    }
    onAnimationEvent(event) {
        if (event.phaseName === 'done' && this.animationType === slideType.OPENING) {
            this.body?.classList.add('sc-scroll-lock');
        }
        if (event.phaseName === 'start' && this.animationType === slideType.CLOSING) {
            this.body?.classList.remove('sc-scroll-lock');
        }
    }
}
ScOffcanvasPageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOffcanvasPageComponent, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
ScOffcanvasPageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScOffcanvasPageComponent, isStandalone: true, selector: "sc-offcanvas-page", inputs: { isShown: "isShown" }, ngImport: i0, template: "<div\n  @pageSlide\n  *ngIf=\"isShown\"\n  (@pageSlide.start)=\"onAnimationEvent($event)\"\n  (@pageSlide.done)=\"onAnimationEvent($event)\"\n  class=\"sc-page-slide\"\n>\n  <div class=\"page-slide-wrapper\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], animations: [
        trigger('pageSlide', [
            transition(':enter', [
                style({ opacity: 1, transform: 'translateX(100%)' }),
                animate('100ms', style({ opacity: 1, transform: 'translateX(0)' })),
            ]),
            transition(':leave', [animate('100ms', style({ opacity: 1, transform: 'translateX(100%)' }))]),
        ]),
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOffcanvasPageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-offcanvas-page', standalone: true, imports: [CommonModule], animations: [
                        trigger('pageSlide', [
                            transition(':enter', [
                                style({ opacity: 1, transform: 'translateX(100%)' }),
                                animate('100ms', style({ opacity: 1, transform: 'translateX(0)' })),
                            ]),
                            transition(':leave', [animate('100ms', style({ opacity: 1, transform: 'translateX(100%)' }))]),
                        ]),
                    ], template: "<div\n  @pageSlide\n  *ngIf=\"isShown\"\n  (@pageSlide.start)=\"onAnimationEvent($event)\"\n  (@pageSlide.done)=\"onAnimationEvent($event)\"\n  class=\"sc-page-slide\"\n>\n  <div class=\"page-slide-wrapper\">\n    <ng-content></ng-content>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { isShown: [{
                type: Input
            }] } });

class ScPageComponent {
    get cssgradient() {
        return this.mode === 'fixed-grad';
    }
    get cssfixed() {
        return this.mode === 'fixed';
    }
    get cssgrow() {
        return this.mode === 'grow';
    }
    constructor(document) {
        this.mode = 'default';
        this.altBodyBGLight = null;
        this.altBodyBGDark = null;
        this.classes = 'sc-page';
        this._document = document;
    }
    ngOnInit() {
        if (this.altBodyBGLight) {
            this._document?.body.classList.add(this.altBodyBGLight);
        }
        if (this.altBodyBGDark) {
            this._document?.body.classList.add(this.altBodyBGDark);
        }
    }
    ngOnDestroy() {
        if (this.altBodyBGLight) {
            this._document?.body.classList.remove(this.altBodyBGLight);
        }
        if (this.altBodyBGDark) {
            this._document?.body.classList.remove(this.altBodyBGDark);
        }
    }
}
ScPageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScPageComponent, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
ScPageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScPageComponent, isStandalone: true, selector: "sc-page", inputs: { mode: "mode", altBodyBGLight: "altBodyBGLight", altBodyBGDark: "altBodyBGDark" }, host: { properties: { "class": "this.classes", "class.page-fixed-gradient": "this.cssgradient", "class.page-fixed": "this.cssfixed", "class.page-grow": "this.cssgrow" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScPageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-page',
                    standalone: true,
                    template: `<ng-content></ng-content>`,
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { mode: [{
                type: Input
            }], altBodyBGLight: [{
                type: Input
            }], altBodyBGDark: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], cssgradient: [{
                type: HostBinding,
                args: ['class.page-fixed-gradient']
            }], cssfixed: [{
                type: HostBinding,
                args: ['class.page-fixed']
            }], cssgrow: [{
                type: HostBinding,
                args: ['class.page-grow']
            }] } });

class ScPageActionsComponent {
    constructor() {
        this.border = true;
        this.tplCustomWrapper = null;
        this.class = 'sc-page-actions';
    }
    get borderClass() {
        return this.border;
    }
}
ScPageActionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScPageActionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScPageActionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScPageActionsComponent, isStandalone: true, selector: "sc-page-actions", inputs: { border: "border", tplCustomWrapper: "tplCustomWrapper" }, host: { properties: { "class": "this.class", "class.border-t": "this.borderClass", "class.border-t-ui-grey-200": "this.borderClass" } }, ngImport: i0, template: "<ng-container *ngTemplateOutlet=\"tplCustomWrapper || defaultContainerTemplate\"></ng-container>\n\n<!-- default template which controls simple button layout -->\n<ng-template #defaultContainerTemplate>\n  <div class=\"flex flex-col-reverse p-16 gap-16 justify-center sm:p-32 sm:flex-row\">\n    <ng-content></ng-content>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScPageActionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-page-actions', standalone: true, imports: [CommonModule], template: "<ng-container *ngTemplateOutlet=\"tplCustomWrapper || defaultContainerTemplate\"></ng-container>\n\n<!-- default template which controls simple button layout -->\n<ng-template #defaultContainerTemplate>\n  <div class=\"flex flex-col-reverse p-16 gap-16 justify-center sm:p-32 sm:flex-row\">\n    <ng-content></ng-content>\n  </div>\n</ng-template>\n" }]
        }], propDecorators: { border: [{
                type: Input
            }], tplCustomWrapper: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], borderClass: [{
                type: HostBinding,
                args: ['class.border-t']
            }, {
                type: HostBinding,
                args: ['class.border-t-ui-grey-200']
            }] } });

class ScPageContentComponent {
    constructor() {
        this.class = 'page-content';
    }
}
ScPageContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScPageContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScPageContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScPageContentComponent, isStandalone: true, selector: "sc-page-content", host: { properties: { "class": "this.class" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScPageContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-page-content',
                    standalone: true,
                    template: `<ng-content></ng-content>`,
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
const RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ScRadioComponent),
    multi: true,
};
class RadioControlRegistry {
    constructor() {
        this.accessors = [];
    }
    add(control, accessor) {
        this.accessors.push([control, accessor]);
    }
    remove(accessor) {
        this.accessors = this.accessors.filter((c) => {
            return c[1] !== accessor;
        });
    }
    select(accessor) {
        this.accessors.forEach((c) => {
            if (this.isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].writeValue(accessor.value);
            }
        });
    }
    isSameGroup(controlPair, accessor) {
        if (!controlPair[0].control) {
            return false;
        }
        if (!accessor.control?.control) {
            return false;
        }
        return controlPair[0].control.root === accessor.control.control.root && controlPair[1].name === accessor.name;
    }
}
RadioControlRegistry.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: RadioControlRegistry, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
RadioControlRegistry.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: RadioControlRegistry, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: RadioControlRegistry, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });
class ScRadioComponent {
    constructor(cd, injector, registry) {
        this.cd = cd;
        this.injector = injector;
        this.registry = registry;
        this.classes = 'sc-radio';
        this.inputId = 'sc-radio-' + crypto.randomUUID();
        this.labelStyleClass = '';
        this.onClick = new EventEmitter();
        this.onModelChange = () => { };
        this.onModelTouched = () => { };
    }
    ngOnInit() {
        this.control = this.injector.get(NgControl);
        this.checkName();
        this.registry.add(this.control, this);
    }
    select(event) {
        if (!this.disabled) {
            if (this.inputViewChild) {
                this.inputViewChild.nativeElement.checked = true;
            }
            this.checked = true;
            this.onModelChange(this.value);
            this.registry.select(this);
            this.onClick.emit({ originalEvent: event, value: this.value });
        }
    }
    writeValue(value) {
        this.checked = value == this.value;
        if (this.inputViewChild && this.inputViewChild.nativeElement) {
            this.inputViewChild.nativeElement.checked = this.checked;
        }
        this.cd.markForCheck();
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onModelTouched = fn;
    }
    setDisabledState(val) {
        this.disabled = val;
        this.cd.markForCheck();
    }
    onChange(event) {
        this.select(event);
    }
    ngOnDestroy() {
        this.registry.remove(this);
    }
    checkName() {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this.throwNameError();
        }
        if (!this.name && this.formControlName) {
            this.name = this.formControlName;
        }
    }
    throwNameError() {
        throw new Error(`
          If you define both a name and a formControlName attribute on your radio button, their values
          must match. Ex: <sc-radio formControlName="food" name="food"></sc-radio>
        `);
    }
}
ScRadioComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScRadioComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: RadioControlRegistry }], target: i0.ɵɵFactoryTarget.Component });
ScRadioComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScRadioComponent, isStandalone: true, selector: "sc-radio", inputs: { value: "value", formControlName: "formControlName", name: "name", disabled: "disabled", label: "label", tabindex: "tabindex", inputId: "inputId", ariaLabelledBy: "ariaLabelledBy", ariaLabel: "ariaLabel", labelStyleClass: "labelStyleClass" }, outputs: { onClick: "onClick" }, host: { properties: { "class": "this.classes" } }, providers: [RADIO_VALUE_ACCESSOR], viewQueries: [{ propertyName: "inputViewChild", first: true, predicate: ["rb"], descendants: true }], ngImport: i0, template: "<input\n  class=\"sc-radio-input\"\n  #rb\n  type=\"radio\"\n  [attr.id]=\"inputId\"\n  [attr.name]=\"name\"\n  [attr.value]=\"value\"\n  [attr.tabindex]=\"tabindex\"\n  [attr.aria-checked]=\"checked\"\n  [attr.aria-label]=\"ariaLabel || ''\"\n  [attr.aria-labelledby]=\"ariaLabelledBy || ''\"\n  [checked]=\"checked\"\n  (change)=\"onChange($event)\"\n  [disabled]=\"disabled\"\n/>\n<label\n  class=\"sc-radio-label {{labelStyleClass}}\"\n  [attr.for]=\"inputId\"\n  >{{ label }}</label\n>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-radio', standalone: true, providers: [RADIO_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, template: "<input\n  class=\"sc-radio-input\"\n  #rb\n  type=\"radio\"\n  [attr.id]=\"inputId\"\n  [attr.name]=\"name\"\n  [attr.value]=\"value\"\n  [attr.tabindex]=\"tabindex\"\n  [attr.aria-checked]=\"checked\"\n  [attr.aria-label]=\"ariaLabel || ''\"\n  [attr.aria-labelledby]=\"ariaLabelledBy || ''\"\n  [checked]=\"checked\"\n  (change)=\"onChange($event)\"\n  [disabled]=\"disabled\"\n/>\n<label\n  class=\"sc-radio-label {{labelStyleClass}}\"\n  [attr.for]=\"inputId\"\n  >{{ label }}</label\n>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: RadioControlRegistry }]; }, propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }], value: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input
            }], label: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], inputId: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], labelStyleClass: [{
                type: Input
            }], onClick: [{
                type: Output
            }], inputViewChild: [{
                type: ViewChild,
                args: ['rb']
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
const unescapedHTMLExp = /[&<>"']/g;
const hasUnescapedHTMLExp = RegExp(unescapedHTMLExp.source);
const htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};
function escapeHTML(string) {
    return string && hasUnescapedHTMLExp.test(string)
        ? string.replace(unescapedHTMLExp, (chr) => htmlEscapes[chr])
        : string;
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function isObject(value) {
    return typeof value === 'object' && isDefined(value);
}
function isPromise(value) {
    return value instanceof Promise;
}
function isFunction(value) {
    return value instanceof Function;
}

/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @typescript-eslint/no-explicit-any */
class ScItemLabelDirective {
    constructor(element) {
        this.element = element;
        this.scItemLabel = '';
        this.escape = true;
    }
    ngOnChanges() {
        this.element.nativeElement.innerHTML = this.escape
            ? escapeHTML(this.scItemLabel)
            : this.scItemLabel;
    }
}
ScItemLabelDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScItemLabelDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ScItemLabelDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScItemLabelDirective, selector: "[scItemLabel]", inputs: { scItemLabel: "scItemLabel", escape: "escape" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScItemLabelDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[scItemLabel]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { scItemLabel: [{
                type: Input
            }], escape: [{
                type: Input
            }] } });
class ScOptionTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScOptionTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOptionTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScOptionTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScOptionTemplateDirective, selector: "[sc-option-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOptionTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-option-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScOptgroupTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScOptgroupTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOptgroupTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScOptgroupTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScOptgroupTemplateDirective, selector: "[sc-optgroup-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOptgroupTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-optgroup-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScLabelTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScLabelTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLabelTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScLabelTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScLabelTemplateDirective, selector: "[sc-label-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLabelTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-label-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScMultiLabelTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScMultiLabelTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScMultiLabelTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScMultiLabelTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScMultiLabelTemplateDirective, selector: "[sc-multi-label-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScMultiLabelTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-multi-label-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScHeaderTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScHeaderTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScHeaderTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScHeaderTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScHeaderTemplateDirective, selector: "[sc-header-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScHeaderTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-header-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScFooterTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScFooterTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScFooterTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScFooterTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScFooterTemplateDirective, selector: "[sc-footer-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScFooterTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-footer-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScNotFoundTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScNotFoundTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScNotFoundTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScNotFoundTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScNotFoundTemplateDirective, selector: "[sc-notfound-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScNotFoundTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-notfound-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScTypeToSearchTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScTypeToSearchTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTypeToSearchTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScTypeToSearchTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScTypeToSearchTemplateDirective, selector: "[sc-typetosearch-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTypeToSearchTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-typetosearch-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScLoadingTextTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScLoadingTextTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLoadingTextTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScLoadingTextTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScLoadingTextTemplateDirective, selector: "[sc-loadingtext-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLoadingTextTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-loadingtext-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScTagTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScTagTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTagTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScTagTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScTagTemplateDirective, selector: "[sc-tag-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTagTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-tag-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class ScLoadingSpinnerTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ScLoadingSpinnerTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLoadingSpinnerTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
ScLoadingSpinnerTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScLoadingSpinnerTemplateDirective, selector: "[sc-loadingspinner-tmp]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScLoadingSpinnerTemplateDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[sc-loadingspinner-tmp]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class ConsoleService {
    warn(message) {
        console.warn(message);
    }
}
ConsoleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ConsoleService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ConsoleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ConsoleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ConsoleService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/* eslint-disable no-control-regex */
const diacritics = {
    '\u24B6': 'A',
    '\uFF21': 'A',
    '\u00C0': 'A',
    '\u00C1': 'A',
    '\u00C2': 'A',
    '\u1EA6': 'A',
    '\u1EA4': 'A',
    '\u1EAA': 'A',
    '\u1EA8': 'A',
    '\u00C3': 'A',
    '\u0100': 'A',
    '\u0102': 'A',
    '\u1EB0': 'A',
    '\u1EAE': 'A',
    '\u1EB4': 'A',
    '\u1EB2': 'A',
    '\u0226': 'A',
    '\u01E0': 'A',
    '\u00C4': 'A',
    '\u01DE': 'A',
    '\u1EA2': 'A',
    '\u00C5': 'A',
    '\u01FA': 'A',
    '\u01CD': 'A',
    '\u0200': 'A',
    '\u0202': 'A',
    '\u1EA0': 'A',
    '\u1EAC': 'A',
    '\u1EB6': 'A',
    '\u1E00': 'A',
    '\u0104': 'A',
    '\u023A': 'A',
    '\u2C6F': 'A',
    '\uA732': 'AA',
    '\u00C6': 'AE',
    '\u01FC': 'AE',
    '\u01E2': 'AE',
    '\uA734': 'AO',
    '\uA736': 'AU',
    '\uA738': 'AV',
    '\uA73A': 'AV',
    '\uA73C': 'AY',
    '\u24B7': 'B',
    '\uFF22': 'B',
    '\u1E02': 'B',
    '\u1E04': 'B',
    '\u1E06': 'B',
    '\u0243': 'B',
    '\u0182': 'B',
    '\u0181': 'B',
    '\u24B8': 'C',
    '\uFF23': 'C',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010A': 'C',
    '\u010C': 'C',
    '\u00C7': 'C',
    '\u1E08': 'C',
    '\u0187': 'C',
    '\u023B': 'C',
    '\uA73E': 'C',
    '\u24B9': 'D',
    '\uFF24': 'D',
    '\u1E0A': 'D',
    '\u010E': 'D',
    '\u1E0C': 'D',
    '\u1E10': 'D',
    '\u1E12': 'D',
    '\u1E0E': 'D',
    '\u0110': 'D',
    '\u018B': 'D',
    '\u018A': 'D',
    '\u0189': 'D',
    '\uA779': 'D',
    '\u01F1': 'DZ',
    '\u01C4': 'DZ',
    '\u01F2': 'Dz',
    '\u01C5': 'Dz',
    '\u24BA': 'E',
    '\uFF25': 'E',
    '\u00C8': 'E',
    '\u00C9': 'E',
    '\u00CA': 'E',
    '\u1EC0': 'E',
    '\u1EBE': 'E',
    '\u1EC4': 'E',
    '\u1EC2': 'E',
    '\u1EBC': 'E',
    '\u0112': 'E',
    '\u1E14': 'E',
    '\u1E16': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u00CB': 'E',
    '\u1EBA': 'E',
    '\u011A': 'E',
    '\u0204': 'E',
    '\u0206': 'E',
    '\u1EB8': 'E',
    '\u1EC6': 'E',
    '\u0228': 'E',
    '\u1E1C': 'E',
    '\u0118': 'E',
    '\u1E18': 'E',
    '\u1E1A': 'E',
    '\u0190': 'E',
    '\u018E': 'E',
    '\u24BB': 'F',
    '\uFF26': 'F',
    '\u1E1E': 'F',
    '\u0191': 'F',
    '\uA77B': 'F',
    '\u24BC': 'G',
    '\uFF27': 'G',
    '\u01F4': 'G',
    '\u011C': 'G',
    '\u1E20': 'G',
    '\u011E': 'G',
    '\u0120': 'G',
    '\u01E6': 'G',
    '\u0122': 'G',
    '\u01E4': 'G',
    '\u0193': 'G',
    '\uA7A0': 'G',
    '\uA77D': 'G',
    '\uA77E': 'G',
    '\u24BD': 'H',
    '\uFF28': 'H',
    '\u0124': 'H',
    '\u1E22': 'H',
    '\u1E26': 'H',
    '\u021E': 'H',
    '\u1E24': 'H',
    '\u1E28': 'H',
    '\u1E2A': 'H',
    '\u0126': 'H',
    '\u2C67': 'H',
    '\u2C75': 'H',
    '\uA78D': 'H',
    '\u24BE': 'I',
    '\uFF29': 'I',
    '\u00CC': 'I',
    '\u00CD': 'I',
    '\u00CE': 'I',
    '\u0128': 'I',
    '\u012A': 'I',
    '\u012C': 'I',
    '\u0130': 'I',
    '\u00CF': 'I',
    '\u1E2E': 'I',
    '\u1EC8': 'I',
    '\u01CF': 'I',
    '\u0208': 'I',
    '\u020A': 'I',
    '\u1ECA': 'I',
    '\u012E': 'I',
    '\u1E2C': 'I',
    '\u0197': 'I',
    '\u24BF': 'J',
    '\uFF2A': 'J',
    '\u0134': 'J',
    '\u0248': 'J',
    '\u24C0': 'K',
    '\uFF2B': 'K',
    '\u1E30': 'K',
    '\u01E8': 'K',
    '\u1E32': 'K',
    '\u0136': 'K',
    '\u1E34': 'K',
    '\u0198': 'K',
    '\u2C69': 'K',
    '\uA740': 'K',
    '\uA742': 'K',
    '\uA744': 'K',
    '\uA7A2': 'K',
    '\u24C1': 'L',
    '\uFF2C': 'L',
    '\u013F': 'L',
    '\u0139': 'L',
    '\u013D': 'L',
    '\u1E36': 'L',
    '\u1E38': 'L',
    '\u013B': 'L',
    '\u1E3C': 'L',
    '\u1E3A': 'L',
    '\u0141': 'L',
    '\u023D': 'L',
    '\u2C62': 'L',
    '\u2C60': 'L',
    '\uA748': 'L',
    '\uA746': 'L',
    '\uA780': 'L',
    '\u01C7': 'LJ',
    '\u01C8': 'Lj',
    '\u24C2': 'M',
    '\uFF2D': 'M',
    '\u1E3E': 'M',
    '\u1E40': 'M',
    '\u1E42': 'M',
    '\u2C6E': 'M',
    '\u019C': 'M',
    '\u24C3': 'N',
    '\uFF2E': 'N',
    '\u01F8': 'N',
    '\u0143': 'N',
    '\u00D1': 'N',
    '\u1E44': 'N',
    '\u0147': 'N',
    '\u1E46': 'N',
    '\u0145': 'N',
    '\u1E4A': 'N',
    '\u1E48': 'N',
    '\u0220': 'N',
    '\u019D': 'N',
    '\uA790': 'N',
    '\uA7A4': 'N',
    '\u01CA': 'NJ',
    '\u01CB': 'Nj',
    '\u24C4': 'O',
    '\uFF2F': 'O',
    '\u00D2': 'O',
    '\u00D3': 'O',
    '\u00D4': 'O',
    '\u1ED2': 'O',
    '\u1ED0': 'O',
    '\u1ED6': 'O',
    '\u1ED4': 'O',
    '\u00D5': 'O',
    '\u1E4C': 'O',
    '\u022C': 'O',
    '\u1E4E': 'O',
    '\u014C': 'O',
    '\u1E50': 'O',
    '\u1E52': 'O',
    '\u014E': 'O',
    '\u022E': 'O',
    '\u0230': 'O',
    '\u00D6': 'O',
    '\u022A': 'O',
    '\u1ECE': 'O',
    '\u0150': 'O',
    '\u01D1': 'O',
    '\u020C': 'O',
    '\u020E': 'O',
    '\u01A0': 'O',
    '\u1EDC': 'O',
    '\u1EDA': 'O',
    '\u1EE0': 'O',
    '\u1EDE': 'O',
    '\u1EE2': 'O',
    '\u1ECC': 'O',
    '\u1ED8': 'O',
    '\u01EA': 'O',
    '\u01EC': 'O',
    '\u00D8': 'O',
    '\u01FE': 'O',
    '\u0186': 'O',
    '\u019F': 'O',
    '\uA74A': 'O',
    '\uA74C': 'O',
    '\u01A2': 'OI',
    '\uA74E': 'OO',
    '\u0222': 'OU',
    '\u24C5': 'P',
    '\uFF30': 'P',
    '\u1E54': 'P',
    '\u1E56': 'P',
    '\u01A4': 'P',
    '\u2C63': 'P',
    '\uA750': 'P',
    '\uA752': 'P',
    '\uA754': 'P',
    '\u24C6': 'Q',
    '\uFF31': 'Q',
    '\uA756': 'Q',
    '\uA758': 'Q',
    '\u024A': 'Q',
    '\u24C7': 'R',
    '\uFF32': 'R',
    '\u0154': 'R',
    '\u1E58': 'R',
    '\u0158': 'R',
    '\u0210': 'R',
    '\u0212': 'R',
    '\u1E5A': 'R',
    '\u1E5C': 'R',
    '\u0156': 'R',
    '\u1E5E': 'R',
    '\u024C': 'R',
    '\u2C64': 'R',
    '\uA75A': 'R',
    '\uA7A6': 'R',
    '\uA782': 'R',
    '\u24C8': 'S',
    '\uFF33': 'S',
    '\u1E9E': 'S',
    '\u015A': 'S',
    '\u1E64': 'S',
    '\u015C': 'S',
    '\u1E60': 'S',
    '\u0160': 'S',
    '\u1E66': 'S',
    '\u1E62': 'S',
    '\u1E68': 'S',
    '\u0218': 'S',
    '\u015E': 'S',
    '\u2C7E': 'S',
    '\uA7A8': 'S',
    '\uA784': 'S',
    '\u24C9': 'T',
    '\uFF34': 'T',
    '\u1E6A': 'T',
    '\u0164': 'T',
    '\u1E6C': 'T',
    '\u021A': 'T',
    '\u0162': 'T',
    '\u1E70': 'T',
    '\u1E6E': 'T',
    '\u0166': 'T',
    '\u01AC': 'T',
    '\u01AE': 'T',
    '\u023E': 'T',
    '\uA786': 'T',
    '\uA728': 'TZ',
    '\u24CA': 'U',
    '\uFF35': 'U',
    '\u00D9': 'U',
    '\u00DA': 'U',
    '\u00DB': 'U',
    '\u0168': 'U',
    '\u1E78': 'U',
    '\u016A': 'U',
    '\u1E7A': 'U',
    '\u016C': 'U',
    '\u00DC': 'U',
    '\u01DB': 'U',
    '\u01D7': 'U',
    '\u01D5': 'U',
    '\u01D9': 'U',
    '\u1EE6': 'U',
    '\u016E': 'U',
    '\u0170': 'U',
    '\u01D3': 'U',
    '\u0214': 'U',
    '\u0216': 'U',
    '\u01AF': 'U',
    '\u1EEA': 'U',
    '\u1EE8': 'U',
    '\u1EEE': 'U',
    '\u1EEC': 'U',
    '\u1EF0': 'U',
    '\u1EE4': 'U',
    '\u1E72': 'U',
    '\u0172': 'U',
    '\u1E76': 'U',
    '\u1E74': 'U',
    '\u0244': 'U',
    '\u24CB': 'V',
    '\uFF36': 'V',
    '\u1E7C': 'V',
    '\u1E7E': 'V',
    '\u01B2': 'V',
    '\uA75E': 'V',
    '\u0245': 'V',
    '\uA760': 'VY',
    '\u24CC': 'W',
    '\uFF37': 'W',
    '\u1E80': 'W',
    '\u1E82': 'W',
    '\u0174': 'W',
    '\u1E86': 'W',
    '\u1E84': 'W',
    '\u1E88': 'W',
    '\u2C72': 'W',
    '\u24CD': 'X',
    '\uFF38': 'X',
    '\u1E8A': 'X',
    '\u1E8C': 'X',
    '\u24CE': 'Y',
    '\uFF39': 'Y',
    '\u1EF2': 'Y',
    '\u00DD': 'Y',
    '\u0176': 'Y',
    '\u1EF8': 'Y',
    '\u0232': 'Y',
    '\u1E8E': 'Y',
    '\u0178': 'Y',
    '\u1EF6': 'Y',
    '\u1EF4': 'Y',
    '\u01B3': 'Y',
    '\u024E': 'Y',
    '\u1EFE': 'Y',
    '\u24CF': 'Z',
    '\uFF3A': 'Z',
    '\u0179': 'Z',
    '\u1E90': 'Z',
    '\u017B': 'Z',
    '\u017D': 'Z',
    '\u1E92': 'Z',
    '\u1E94': 'Z',
    '\u01B5': 'Z',
    '\u0224': 'Z',
    '\u2C7F': 'Z',
    '\u2C6B': 'Z',
    '\uA762': 'Z',
    '\u24D0': 'a',
    '\uFF41': 'a',
    '\u1E9A': 'a',
    '\u00E0': 'a',
    '\u00E1': 'a',
    '\u00E2': 'a',
    '\u1EA7': 'a',
    '\u1EA5': 'a',
    '\u1EAB': 'a',
    '\u1EA9': 'a',
    '\u00E3': 'a',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u1EB1': 'a',
    '\u1EAF': 'a',
    '\u1EB5': 'a',
    '\u1EB3': 'a',
    '\u0227': 'a',
    '\u01E1': 'a',
    '\u00E4': 'a',
    '\u01DF': 'a',
    '\u1EA3': 'a',
    '\u00E5': 'a',
    '\u01FB': 'a',
    '\u01CE': 'a',
    '\u0201': 'a',
    '\u0203': 'a',
    '\u1EA1': 'a',
    '\u1EAD': 'a',
    '\u1EB7': 'a',
    '\u1E01': 'a',
    '\u0105': 'a',
    '\u2C65': 'a',
    '\u0250': 'a',
    '\uA733': 'aa',
    '\u00E6': 'ae',
    '\u01FD': 'ae',
    '\u01E3': 'ae',
    '\uA735': 'ao',
    '\uA737': 'au',
    '\uA739': 'av',
    '\uA73B': 'av',
    '\uA73D': 'ay',
    '\u24D1': 'b',
    '\uFF42': 'b',
    '\u1E03': 'b',
    '\u1E05': 'b',
    '\u1E07': 'b',
    '\u0180': 'b',
    '\u0183': 'b',
    '\u0253': 'b',
    '\u24D2': 'c',
    '\uFF43': 'c',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010B': 'c',
    '\u010D': 'c',
    '\u00E7': 'c',
    '\u1E09': 'c',
    '\u0188': 'c',
    '\u023C': 'c',
    '\uA73F': 'c',
    '\u2184': 'c',
    '\u24D3': 'd',
    '\uFF44': 'd',
    '\u1E0B': 'd',
    '\u010F': 'd',
    '\u1E0D': 'd',
    '\u1E11': 'd',
    '\u1E13': 'd',
    '\u1E0F': 'd',
    '\u0111': 'd',
    '\u018C': 'd',
    '\u0256': 'd',
    '\u0257': 'd',
    '\uA77A': 'd',
    '\u01F3': 'dz',
    '\u01C6': 'dz',
    '\u24D4': 'e',
    '\uFF45': 'e',
    '\u00E8': 'e',
    '\u00E9': 'e',
    '\u00EA': 'e',
    '\u1EC1': 'e',
    '\u1EBF': 'e',
    '\u1EC5': 'e',
    '\u1EC3': 'e',
    '\u1EBD': 'e',
    '\u0113': 'e',
    '\u1E15': 'e',
    '\u1E17': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u00EB': 'e',
    '\u1EBB': 'e',
    '\u011B': 'e',
    '\u0205': 'e',
    '\u0207': 'e',
    '\u1EB9': 'e',
    '\u1EC7': 'e',
    '\u0229': 'e',
    '\u1E1D': 'e',
    '\u0119': 'e',
    '\u1E19': 'e',
    '\u1E1B': 'e',
    '\u0247': 'e',
    '\u025B': 'e',
    '\u01DD': 'e',
    '\u24D5': 'f',
    '\uFF46': 'f',
    '\u1E1F': 'f',
    '\u0192': 'f',
    '\uA77C': 'f',
    '\u24D6': 'g',
    '\uFF47': 'g',
    '\u01F5': 'g',
    '\u011D': 'g',
    '\u1E21': 'g',
    '\u011F': 'g',
    '\u0121': 'g',
    '\u01E7': 'g',
    '\u0123': 'g',
    '\u01E5': 'g',
    '\u0260': 'g',
    '\uA7A1': 'g',
    '\u1D79': 'g',
    '\uA77F': 'g',
    '\u24D7': 'h',
    '\uFF48': 'h',
    '\u0125': 'h',
    '\u1E23': 'h',
    '\u1E27': 'h',
    '\u021F': 'h',
    '\u1E25': 'h',
    '\u1E29': 'h',
    '\u1E2B': 'h',
    '\u1E96': 'h',
    '\u0127': 'h',
    '\u2C68': 'h',
    '\u2C76': 'h',
    '\u0265': 'h',
    '\u0195': 'hv',
    '\u24D8': 'i',
    '\uFF49': 'i',
    '\u00EC': 'i',
    '\u00ED': 'i',
    '\u00EE': 'i',
    '\u0129': 'i',
    '\u012B': 'i',
    '\u012D': 'i',
    '\u00EF': 'i',
    '\u1E2F': 'i',
    '\u1EC9': 'i',
    '\u01D0': 'i',
    '\u0209': 'i',
    '\u020B': 'i',
    '\u1ECB': 'i',
    '\u012F': 'i',
    '\u1E2D': 'i',
    '\u0268': 'i',
    '\u0131': 'i',
    '\u24D9': 'j',
    '\uFF4A': 'j',
    '\u0135': 'j',
    '\u01F0': 'j',
    '\u0249': 'j',
    '\u24DA': 'k',
    '\uFF4B': 'k',
    '\u1E31': 'k',
    '\u01E9': 'k',
    '\u1E33': 'k',
    '\u0137': 'k',
    '\u1E35': 'k',
    '\u0199': 'k',
    '\u2C6A': 'k',
    '\uA741': 'k',
    '\uA743': 'k',
    '\uA745': 'k',
    '\uA7A3': 'k',
    '\u24DB': 'l',
    '\uFF4C': 'l',
    '\u0140': 'l',
    '\u013A': 'l',
    '\u013E': 'l',
    '\u1E37': 'l',
    '\u1E39': 'l',
    '\u013C': 'l',
    '\u1E3D': 'l',
    '\u1E3B': 'l',
    '\u017F': 'l',
    '\u0142': 'l',
    '\u019A': 'l',
    '\u026B': 'l',
    '\u2C61': 'l',
    '\uA749': 'l',
    '\uA781': 'l',
    '\uA747': 'l',
    '\u01C9': 'lj',
    '\u24DC': 'm',
    '\uFF4D': 'm',
    '\u1E3F': 'm',
    '\u1E41': 'm',
    '\u1E43': 'm',
    '\u0271': 'm',
    '\u026F': 'm',
    '\u24DD': 'n',
    '\uFF4E': 'n',
    '\u01F9': 'n',
    '\u0144': 'n',
    '\u00F1': 'n',
    '\u1E45': 'n',
    '\u0148': 'n',
    '\u1E47': 'n',
    '\u0146': 'n',
    '\u1E4B': 'n',
    '\u1E49': 'n',
    '\u019E': 'n',
    '\u0272': 'n',
    '\u0149': 'n',
    '\uA791': 'n',
    '\uA7A5': 'n',
    '\u01CC': 'nj',
    '\u24DE': 'o',
    '\uFF4F': 'o',
    '\u00F2': 'o',
    '\u00F3': 'o',
    '\u00F4': 'o',
    '\u1ED3': 'o',
    '\u1ED1': 'o',
    '\u1ED7': 'o',
    '\u1ED5': 'o',
    '\u00F5': 'o',
    '\u1E4D': 'o',
    '\u022D': 'o',
    '\u1E4F': 'o',
    '\u014D': 'o',
    '\u1E51': 'o',
    '\u1E53': 'o',
    '\u014F': 'o',
    '\u022F': 'o',
    '\u0231': 'o',
    '\u00F6': 'o',
    '\u022B': 'o',
    '\u1ECF': 'o',
    '\u0151': 'o',
    '\u01D2': 'o',
    '\u020D': 'o',
    '\u020F': 'o',
    '\u01A1': 'o',
    '\u1EDD': 'o',
    '\u1EDB': 'o',
    '\u1EE1': 'o',
    '\u1EDF': 'o',
    '\u1EE3': 'o',
    '\u1ECD': 'o',
    '\u1ED9': 'o',
    '\u01EB': 'o',
    '\u01ED': 'o',
    '\u00F8': 'o',
    '\u01FF': 'o',
    '\u0254': 'o',
    '\uA74B': 'o',
    '\uA74D': 'o',
    '\u0275': 'o',
    '\u01A3': 'oi',
    '\u0223': 'ou',
    '\uA74F': 'oo',
    '\u24DF': 'p',
    '\uFF50': 'p',
    '\u1E55': 'p',
    '\u1E57': 'p',
    '\u01A5': 'p',
    '\u1D7D': 'p',
    '\uA751': 'p',
    '\uA753': 'p',
    '\uA755': 'p',
    '\u24E0': 'q',
    '\uFF51': 'q',
    '\u024B': 'q',
    '\uA757': 'q',
    '\uA759': 'q',
    '\u24E1': 'r',
    '\uFF52': 'r',
    '\u0155': 'r',
    '\u1E59': 'r',
    '\u0159': 'r',
    '\u0211': 'r',
    '\u0213': 'r',
    '\u1E5B': 'r',
    '\u1E5D': 'r',
    '\u0157': 'r',
    '\u1E5F': 'r',
    '\u024D': 'r',
    '\u027D': 'r',
    '\uA75B': 'r',
    '\uA7A7': 'r',
    '\uA783': 'r',
    '\u24E2': 's',
    '\uFF53': 's',
    '\u00DF': 's',
    '\u015B': 's',
    '\u1E65': 's',
    '\u015D': 's',
    '\u1E61': 's',
    '\u0161': 's',
    '\u1E67': 's',
    '\u1E63': 's',
    '\u1E69': 's',
    '\u0219': 's',
    '\u015F': 's',
    '\u023F': 's',
    '\uA7A9': 's',
    '\uA785': 's',
    '\u1E9B': 's',
    '\u24E3': 't',
    '\uFF54': 't',
    '\u1E6B': 't',
    '\u1E97': 't',
    '\u0165': 't',
    '\u1E6D': 't',
    '\u021B': 't',
    '\u0163': 't',
    '\u1E71': 't',
    '\u1E6F': 't',
    '\u0167': 't',
    '\u01AD': 't',
    '\u0288': 't',
    '\u2C66': 't',
    '\uA787': 't',
    '\uA729': 'tz',
    '\u24E4': 'u',
    '\uFF55': 'u',
    '\u00F9': 'u',
    '\u00FA': 'u',
    '\u00FB': 'u',
    '\u0169': 'u',
    '\u1E79': 'u',
    '\u016B': 'u',
    '\u1E7B': 'u',
    '\u016D': 'u',
    '\u00FC': 'u',
    '\u01DC': 'u',
    '\u01D8': 'u',
    '\u01D6': 'u',
    '\u01DA': 'u',
    '\u1EE7': 'u',
    '\u016F': 'u',
    '\u0171': 'u',
    '\u01D4': 'u',
    '\u0215': 'u',
    '\u0217': 'u',
    '\u01B0': 'u',
    '\u1EEB': 'u',
    '\u1EE9': 'u',
    '\u1EEF': 'u',
    '\u1EED': 'u',
    '\u1EF1': 'u',
    '\u1EE5': 'u',
    '\u1E73': 'u',
    '\u0173': 'u',
    '\u1E77': 'u',
    '\u1E75': 'u',
    '\u0289': 'u',
    '\u24E5': 'v',
    '\uFF56': 'v',
    '\u1E7D': 'v',
    '\u1E7F': 'v',
    '\u028B': 'v',
    '\uA75F': 'v',
    '\u028C': 'v',
    '\uA761': 'vy',
    '\u24E6': 'w',
    '\uFF57': 'w',
    '\u1E81': 'w',
    '\u1E83': 'w',
    '\u0175': 'w',
    '\u1E87': 'w',
    '\u1E85': 'w',
    '\u1E98': 'w',
    '\u1E89': 'w',
    '\u2C73': 'w',
    '\u24E7': 'x',
    '\uFF58': 'x',
    '\u1E8B': 'x',
    '\u1E8D': 'x',
    '\u24E8': 'y',
    '\uFF59': 'y',
    '\u1EF3': 'y',
    '\u00FD': 'y',
    '\u0177': 'y',
    '\u1EF9': 'y',
    '\u0233': 'y',
    '\u1E8F': 'y',
    '\u00FF': 'y',
    '\u1EF7': 'y',
    '\u1E99': 'y',
    '\u1EF5': 'y',
    '\u01B4': 'y',
    '\u024F': 'y',
    '\u1EFF': 'y',
    '\u24E9': 'z',
    '\uFF5A': 'z',
    '\u017A': 'z',
    '\u1E91': 'z',
    '\u017C': 'z',
    '\u017E': 'z',
    '\u1E93': 'z',
    '\u1E95': 'z',
    '\u01B6': 'z',
    '\u0225': 'z',
    '\u0240': 'z',
    '\u2C6C': 'z',
    '\uA763': 'z',
    '\u0386': '\u0391',
    '\u0388': '\u0395',
    '\u0389': '\u0397',
    '\u038A': '\u0399',
    '\u03AA': '\u0399',
    '\u038C': '\u039F',
    '\u038E': '\u03A5',
    '\u03AB': '\u03A5',
    '\u038F': '\u03A9',
    '\u03AC': '\u03B1',
    '\u03AD': '\u03B5',
    '\u03AE': '\u03B7',
    '\u03AF': '\u03B9',
    '\u03CA': '\u03B9',
    '\u0390': '\u03B9',
    '\u03CC': '\u03BF',
    '\u03CD': '\u03C5',
    '\u03CB': '\u03C5',
    '\u03B0': '\u03C5',
    '\u03C9': '\u03C9',
    '\u03C2': '\u03C3',
};
function stripSpecialChars(text) {
    const match = (a) => {
        return diacritics[a] || a;
    };
    return text.replace(/[^\u0000-\u007E]/g, match);
}

class ItemsList {
    constructor(_scSelect, _selectionModel) {
        this._scSelect = _scSelect;
        this._selectionModel = _selectionModel;
        this._groups = new Map();
        this._items = [];
        this._filteredItems = [];
        this._markedIndex = -1;
    }
    get items() {
        return this._items;
    }
    get filteredItems() {
        return this._filteredItems;
    }
    get markedIndex() {
        return this._markedIndex;
    }
    get selectedItems() {
        return this._selectionModel.value;
    }
    get markedItem() {
        return this._filteredItems[this._markedIndex];
    }
    get noItemsToSelect() {
        return (this._scSelect.hideSelected &&
            this._items.length === this.selectedItems.length);
    }
    get maxItemsSelected() {
        return (this._scSelect.multiple &&
            this._scSelect.maxSelectedItems <= this.selectedItems.length);
    }
    get lastSelectedItem() {
        let i = this.selectedItems.length - 1;
        for (; i >= 0; i--) {
            const item = this.selectedItems[i];
            if (!item.disabled) {
                return item;
            }
        }
        return null;
    }
    setItems(items) {
        this._items = items.map((item, index) => this.mapItem(item, index));
        if (this._scSelect.groupBy) {
            this._groups = this._groupBy(this._items, this._scSelect.groupBy);
            this._items = this._flatten(this._groups);
        }
        else {
            this._groups = new Map();
            this._groups.set('', this._items);
        }
        this._filteredItems = [...this._items];
    }
    select(item) {
        if (item.selected || this.maxItemsSelected) {
            return;
        }
        const multiple = this._scSelect.multiple;
        if (!multiple) {
            this.clearSelected();
        }
        this._selectionModel.select(item, multiple, this._scSelect.selectableGroupAsModel);
        if (this._scSelect.hideSelected) {
            this._hideSelected(item);
        }
    }
    unselect(item) {
        if (!item.selected) {
            return;
        }
        this._selectionModel.unselect(item, this._scSelect.multiple);
        if (this._scSelect.hideSelected &&
            isDefined(item.index) &&
            this._scSelect.multiple) {
            this._showSelected(item);
        }
    }
    findItem(value) {
        let findBy;
        if (this._scSelect.compareWith) {
            findBy = (item) => this._scSelect.compareWith(item.value, value);
        }
        else if (this._scSelect.bindValue) {
            findBy = (item) => !item.children &&
                this.resolveNested(item.value, this._scSelect.bindValue) === value;
        }
        else {
            findBy = (item) => item.value === value ||
                (!item.children &&
                    !!item.label &&
                    item.label === this.resolveNested(value, this._scSelect.bindLabel));
        }
        return this._items.find((item) => findBy(item));
    }
    addItem(item) {
        const option = this.mapItem(item, this._items.length);
        this._items.push(option);
        this._filteredItems.push(option);
        return option;
    }
    clearSelected(keepDisabled = false) {
        this._selectionModel.clear(keepDisabled);
        this._items.forEach((item) => {
            item.selected = keepDisabled && item.selected && item.disabled;
            item.marked = false;
        });
        if (this._scSelect.hideSelected) {
            this.resetFilteredItems();
        }
    }
    findByLabel(term) {
        term = stripSpecialChars(term).toLocaleLowerCase();
        return this.filteredItems.find((item) => {
            const label = stripSpecialChars(item.label)
                .toLocaleLowerCase();
            return label.substr(0, term.length) === term;
        });
    }
    filter(term) {
        if (!term) {
            this.resetFilteredItems();
            return;
        }
        this._filteredItems = [];
        term = this._scSelect.searchFn
            ? term
            : stripSpecialChars(term).toLocaleLowerCase();
        const match = this._scSelect.searchFn || this._defaultSearchFn;
        const hideSelected = this._scSelect.hideSelected;
        for (const key of Array.from(this._groups.keys())) {
            const matchedItems = [];
            if (this._groups.get(key) !== undefined) {
                for (const item of this._groups.get(key)) {
                    if (item &&
                        hideSelected &&
                        ((item.parent && item.parent.selected) || item.selected)) {
                        continue;
                    }
                    const searchItem = this._scSelect.searchFn ? item.value : item;
                    if (match(term, searchItem)) {
                        matchedItems.push(item);
                    }
                }
                if (matchedItems.length > 0) {
                    const [last] = matchedItems.slice(-1);
                    if (last.parent) {
                        const head = this._items.find((x) => x === last.parent);
                        this._filteredItems.push(head);
                    }
                    this._filteredItems.push(...matchedItems);
                }
            }
        }
    }
    resetFilteredItems() {
        if (this._filteredItems.length === this._items.length) {
            return;
        }
        if (this._scSelect.hideSelected && this.selectedItems.length > 0) {
            this._filteredItems = this._items.filter((x) => !x.selected);
        }
        else {
            this._filteredItems = this._items;
        }
    }
    unmarkItem() {
        this._markedIndex = -1;
    }
    markNextItem() {
        this._stepToItem(+1);
    }
    markPreviousItem() {
        this._stepToItem(-1);
    }
    markItem(item) {
        this._markedIndex = this._filteredItems.indexOf(item);
    }
    markSelectedOrDefault(markDefault) {
        if (this._filteredItems.length === 0) {
            return;
        }
        const lastMarkedIndex = this._getLastMarkedIndex();
        if (lastMarkedIndex > -1) {
            this._markedIndex = lastMarkedIndex;
        }
        else {
            this._markedIndex = markDefault
                ? this.filteredItems.findIndex((x) => !x.disabled)
                : -1;
        }
    }
    resolveNested(option, key) {
        if (!isObject(option)) {
            return option;
        }
        if (key.indexOf('.') === -1) {
            return option[key];
        }
        else {
            const keys = key.split('.');
            let value = option;
            for (let i = 0, len = keys.length; i < len; ++i) {
                if (value == null) {
                    return null;
                }
                value = value[keys[i]];
            }
            return value;
        }
    }
    mapItem(item, index) {
        const label = isDefined(item.$ScOptionLabel)
            ? item.$ScOptionLabel
            : this.resolveNested(item, this._scSelect.bindLabel);
        const value = isDefined(item.$ScOptionValue) ? item.$ScOptionValue : item;
        return {
            index: index,
            label: isDefined(label) ? label.toString() : '',
            value: value,
            disabled: item.disabled,
            htmlId: `sc-option-${this._scSelect.dropdownId}-${index}`,
        };
    }
    mapSelectedItems() {
        const multiple = this._scSelect.multiple;
        for (const selected of this.selectedItems) {
            const value = this._scSelect.bindValue
                ? this.resolveNested(selected.value, this._scSelect.bindValue)
                : selected.value;
            const item = isDefined(value) ? this.findItem(value) : null;
            this._selectionModel.unselect(selected, multiple);
            this._selectionModel.select(item || selected, multiple, this._scSelect.selectableGroupAsModel);
        }
        if (this._scSelect.hideSelected) {
            this._filteredItems = this.filteredItems.filter((x) => this.selectedItems.indexOf(x) === -1);
        }
    }
    _showSelected(item) {
        this._filteredItems.push(item);
        if (item.parent) {
            const parent = item.parent;
            const parentExists = this._filteredItems.find((x) => x === parent);
            if (!parentExists) {
                this._filteredItems.push(parent);
            }
        }
        else if (item.children) {
            for (const child of item.children) {
                child.selected = false;
                this._filteredItems.push(child);
            }
        }
        this._filteredItems = [
            ...this._filteredItems.sort((a, b) => a.index && b.index ? a.index - b.index : 0),
        ];
    }
    _hideSelected(item) {
        this._filteredItems = this._filteredItems.filter((x) => x !== item);
        if (item.parent) {
            const children = item.parent.children;
            if (children?.every((x) => x.selected)) {
                this._filteredItems = this._filteredItems.filter((x) => x !== item.parent);
            }
        }
        else if (item.children) {
            this._filteredItems = this.filteredItems.filter((x) => x.parent !== item);
        }
    }
    _defaultSearchFn(search, opt) {
        const label = stripSpecialChars(opt.label)
            .toLocaleLowerCase();
        return label.indexOf(search) > -1;
    }
    _getNextItemIndex(steps) {
        if (steps > 0) {
            return this._markedIndex >= this._filteredItems.length - 1
                ? 0
                : this._markedIndex + 1;
        }
        return this._markedIndex <= 0
            ? this._filteredItems.length - 1
            : this._markedIndex - 1;
    }
    _stepToItem(steps) {
        if (this._filteredItems.length === 0 ||
            this._filteredItems.every((x) => x.disabled)) {
            return;
        }
        this._markedIndex = this._getNextItemIndex(steps);
        if (this.markedItem.disabled) {
            this._stepToItem(steps);
        }
    }
    _getLastMarkedIndex() {
        if (this._scSelect.hideSelected) {
            return -1;
        }
        if (this._markedIndex > -1 && this.markedItem === undefined) {
            return -1;
        }
        const selectedIndex = this._filteredItems.indexOf(this.lastSelectedItem);
        if (this.lastSelectedItem && selectedIndex < 0) {
            return -1;
        }
        return Math.max(this.markedIndex, selectedIndex);
    }
    _groupBy(items, prop) {
        const groups = new Map();
        if (items.length === 0) {
            return groups;
        }
        // Check if items are already grouped by given key.
        if (Array.isArray(items[0].value[prop])) {
            for (const item of items) {
                const children = (item.value[prop] || []).map((x, index) => this.mapItem(x, index));
                groups.set(item, children);
            }
            return groups;
        }
        const isFnKey = isFunction(this._scSelect.groupBy);
        const keyFn = (item) => {
            const key = isFnKey
                ? prop(item.value)
                : item.value[prop];
            return isDefined(key) ? key : undefined;
        };
        // Group items by key.
        for (const item of items) {
            const key = keyFn(item);
            const group = groups.get(key);
            if (group) {
                group.push(item);
            }
            else {
                groups.set(key, [item]);
            }
        }
        return groups;
    }
    _flatten(groups) {
        const isGroupByFn = isFunction(this._scSelect.groupBy);
        const items = [];
        for (const key of Array.from(groups.keys())) {
            let i = items.length;
            if (key === undefined) {
                const withoutGroup = groups.get('') || [];
                items.push(...withoutGroup.map((x) => {
                    x.index = i++;
                    return x;
                }));
                continue;
            }
            const isObjectKey = isObject(key);
            const parent = {
                label: isObjectKey ? '' : String(key),
                children: undefined,
                parent: undefined,
                index: i++,
                disabled: !this._scSelect.selectableGroup,
                htmlId: 'sc-option-' + crypto.randomUUID(),
            };
            const groupKey = isGroupByFn
                ? this._scSelect.bindLabel
                : this._scSelect.groupBy;
            const groupValue = this._scSelect.groupValue ||
                (() => {
                    if (isObjectKey) {
                        return key.value;
                    }
                    return { [groupKey]: key };
                });
            const children = groups.get(key)?.map((x) => {
                x.parent = parent;
                x.children = undefined;
                x.index = i++;
                return x;
            });
            if (children) {
                parent.children = children;
                parent.value = groupValue(key, children.map((x) => x.value));
                items.push(parent);
                items.push(...children);
            }
        }
        return items;
    }
}

var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Tab"] = 9] = "Tab";
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Esc"] = 27] = "Esc";
    KeyCode[KeyCode["Space"] = 32] = "Space";
    KeyCode[KeyCode["ArrowUp"] = 38] = "ArrowUp";
    KeyCode[KeyCode["ArrowDown"] = 40] = "ArrowDown";
    KeyCode[KeyCode["Backspace"] = 8] = "Backspace";
})(KeyCode || (KeyCode = {}));

class ScDropdownPanelService {
    constructor() {
        this._dimensions = {
            itemHeight: 0,
            panelHeight: 0,
            itemsPerViewport: 0,
        };
    }
    get dimensions() {
        return this._dimensions;
    }
    calculateItems(scrollPos, itemsLength, buffer) {
        const d = this._dimensions;
        const scrollHeight = d.itemHeight * itemsLength;
        const scrollTop = Math.max(0, scrollPos);
        const indexByScrollTop = (scrollTop / scrollHeight) * itemsLength;
        let end = Math.min(itemsLength, Math.ceil(indexByScrollTop) + (d.itemsPerViewport + 1));
        const maxStartEnd = end;
        const maxStart = Math.max(0, maxStartEnd - d.itemsPerViewport);
        let start = Math.min(maxStart, Math.floor(indexByScrollTop));
        let topPadding = d.itemHeight * Math.ceil(start) - d.itemHeight * Math.min(start, buffer);
        topPadding = !isNaN(topPadding) ? topPadding : 0;
        start = !isNaN(start) ? start : -1;
        end = !isNaN(end) ? end : -1;
        start -= buffer;
        start = Math.max(0, start);
        end += buffer;
        end = Math.min(itemsLength, end);
        return {
            topPadding,
            scrollHeight,
            start,
            end,
        };
    }
    setDimensions(itemHeight, panelHeight) {
        const itemsPerViewport = Math.max(1, Math.floor(panelHeight / itemHeight));
        this._dimensions = {
            itemHeight,
            panelHeight,
            itemsPerViewport,
        };
    }
    getScrollTo(itemTop, itemHeight, lastScroll) {
        const { panelHeight } = this.dimensions;
        const itemBottom = itemTop + itemHeight;
        const top = lastScroll;
        const bottom = top + panelHeight;
        if (panelHeight >= itemBottom && lastScroll === itemTop) {
            return null;
        }
        if (itemBottom > bottom) {
            return top + itemBottom - bottom;
        }
        else if (itemTop <= top) {
            return itemTop;
        }
        return null;
    }
}
ScDropdownPanelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownPanelService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ScDropdownPanelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownPanelService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownPanelService, decorators: [{
            type: Injectable
        }] });

/* eslint-disable @angular-eslint/no-output-native */
/* eslint-disable @typescript-eslint/no-explicit-any */
const TOP_CSS_CLASS = 'sc-select-top';
const BOTTOM_CSS_CLASS = 'sc-select-bottom';
const SCROLL_SCHEDULER = typeof requestAnimationFrame !== 'undefined' ? animationFrameScheduler : asapScheduler;
class ScDropdownPanelComponent {
    constructor(_renderer, _zone, _panelService, _elementRef, _document) {
        this._renderer = _renderer;
        this._zone = _zone;
        this._panelService = _panelService;
        this._document = _document;
        this.items = [];
        this.position = 'auto';
        this.bufferAmount = 0;
        this.virtualScroll = false;
        this.filterValue = '';
        this.update = new EventEmitter();
        this.scroll = new EventEmitter();
        this.scrollToEnd = new EventEmitter();
        this.outsideClick = new EventEmitter();
        this._destroy$ = new Subject();
        this._scrollToEndFired = false;
        this._updateScrollHeight = false;
        this._lastScrollPosition = 0;
        this._dropdown = _elementRef.nativeElement;
    }
    get currentPosition() {
        return this._currentPosition;
    }
    get itemsLength() {
        return this._itemsLength;
    }
    set itemsLength(value) {
        if (value !== this._itemsLength) {
            this._itemsLength = value;
            this._onItemsLengthChanged();
        }
    }
    get _startOffset() {
        if (this.markedItem) {
            const { itemHeight, panelHeight } = this._panelService.dimensions;
            const offset = this.markedItem.index ? this.markedItem.index * itemHeight : 0;
            return panelHeight > offset ? 0 : offset;
        }
        return 0;
    }
    ngOnInit() {
        this._select = this._dropdown.parentElement;
        this._virtualPadding = this.paddingElementRef.nativeElement;
        this._scrollablePanel = this.scrollElementRef.nativeElement;
        this._contentPanel = this.contentElementRef.nativeElement;
        this._handleScroll();
        this._handleOutsideClick();
        this._appendDropdown();
        this._setupMousedownListener();
    }
    ngOnChanges(changes) {
        if (changes['items']) {
            const change = changes['items'];
            this._onItemsChange(change.currentValue, change.firstChange);
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
        this._destroy$.unsubscribe();
        if (this.appendTo) {
            this._renderer.removeChild(this._dropdown.parentNode, this._dropdown);
        }
    }
    scrollTo(option, startFromOption = false) {
        if (!option) {
            return;
        }
        const index = this.items.indexOf(option);
        if (index < 0 || index >= this.itemsLength) {
            return;
        }
        let scrollTo;
        if (this.virtualScroll) {
            const itemHeight = this._panelService.dimensions.itemHeight;
            scrollTo = this._panelService.getScrollTo(index * itemHeight, itemHeight, this._lastScrollPosition);
        }
        else {
            const item = this._dropdown.querySelector(`#${option.htmlId}`);
            const lastScroll = startFromOption ? item.offsetTop : this._lastScrollPosition;
            scrollTo = this._panelService.getScrollTo(item.offsetTop, item.clientHeight, lastScroll);
        }
        if (isDefined(scrollTo)) {
            this._scrollablePanel.scrollTop = scrollTo;
        }
    }
    scrollToTag() {
        const panel = this._scrollablePanel;
        panel.scrollTop = panel.scrollHeight - panel.clientHeight;
    }
    adjustPosition() {
        this._updateYPosition();
    }
    _handleDropdownPosition() {
        this._currentPosition = this._calculateCurrentPosition(this._dropdown);
        if (this._currentPosition === 'top') {
            this._renderer.addClass(this._dropdown, TOP_CSS_CLASS);
            this._renderer.removeClass(this._dropdown, BOTTOM_CSS_CLASS);
            this._renderer.addClass(this._select, TOP_CSS_CLASS);
            this._renderer.removeClass(this._select, BOTTOM_CSS_CLASS);
        }
        else {
            this._renderer.addClass(this._dropdown, BOTTOM_CSS_CLASS);
            this._renderer.removeClass(this._dropdown, TOP_CSS_CLASS);
            this._renderer.addClass(this._select, BOTTOM_CSS_CLASS);
            this._renderer.removeClass(this._select, TOP_CSS_CLASS);
        }
        if (this.appendTo) {
            this._updateYPosition();
        }
        this._dropdown.style.opacity = '1';
    }
    _handleScroll() {
        this._zone.runOutsideAngular(() => {
            fromEvent(this.scrollElementRef.nativeElement, 'scroll')
                .pipe(takeUntil(this._destroy$), auditTime(0, SCROLL_SCHEDULER))
                .subscribe((e) => {
                const path = e.path || (e.composedPath && e.composedPath());
                const scrollTop = !path || path.length === 0 ? e.target.scrollTop : path[0].scrollTop;
                this._onContentScrolled(scrollTop);
            });
        });
    }
    _handleOutsideClick() {
        if (!this._document) {
            return;
        }
        this._zone.runOutsideAngular(() => {
            merge(fromEvent(this._document, 'touchstart', { capture: true }), fromEvent(this._document, 'mousedown', { capture: true }))
                .pipe(takeUntil(this._destroy$))
                .subscribe(($event) => this._checkToClose($event));
        });
    }
    _checkToClose($event) {
        if (this._select.contains($event.target) || this._dropdown.contains($event.target)) {
            return;
        }
        const path = $event.path || ($event.composedPath && $event.composedPath());
        if ($event.target && $event.target.shadowRoot && path && path[0] && this._select.contains(path[0])) {
            return;
        }
        this._zone.run(() => this.outsideClick.emit());
    }
    _onItemsChange(items, firstChange) {
        this.items = items || [];
        this._scrollToEndFired = false;
        this.itemsLength = items.length;
        if (this.virtualScroll) {
            this._updateItemsRange(firstChange);
        }
        else {
            this._setVirtualHeight();
            this._updateItems(firstChange);
        }
    }
    _updateItems(firstChange) {
        this.update.emit(this.items);
        if (firstChange === false) {
            return;
        }
        this._zone.runOutsideAngular(() => {
            Promise.resolve().then(() => {
                const panelHeight = this._scrollablePanel.clientHeight;
                this._panelService.setDimensions(0, panelHeight);
                this._handleDropdownPosition();
                this.scrollTo(this.markedItem, firstChange);
            });
        });
    }
    _updateItemsRange(firstChange) {
        this._zone.runOutsideAngular(() => {
            this._measureDimensions().then(() => {
                if (firstChange) {
                    this._renderItemsRange(this._startOffset);
                    this._handleDropdownPosition();
                }
                else {
                    this._renderItemsRange();
                }
            });
        });
    }
    _onContentScrolled(scrollTop) {
        if (this.virtualScroll) {
            this._renderItemsRange(scrollTop);
        }
        this._lastScrollPosition = scrollTop;
        this._fireScrollToEnd(scrollTop);
    }
    _updateVirtualHeight(height) {
        if (this._updateScrollHeight) {
            this._virtualPadding.style.height = `${height}px`;
            this._updateScrollHeight = false;
        }
    }
    _setVirtualHeight() {
        if (!this._virtualPadding) {
            return;
        }
        this._virtualPadding.style.height = `0px`;
    }
    _onItemsLengthChanged() {
        this._updateScrollHeight = true;
    }
    _renderItemsRange(scrollTop = 0) {
        if (scrollTop && this._lastScrollPosition === scrollTop) {
            return;
        }
        scrollTop = scrollTop || this._scrollablePanel.scrollTop;
        const range = this._panelService.calculateItems(scrollTop, this.itemsLength, this.bufferAmount);
        this._updateVirtualHeight(range.scrollHeight);
        this._contentPanel.style.transform = `translateY(${range.topPadding}px)`;
        this._zone.run(() => {
            this.update.emit(this.items.slice(range.start, range.end));
            this.scroll.emit({ start: range.start, end: range.end });
        });
        if (isDefined(scrollTop) && this._lastScrollPosition === 0) {
            this._scrollablePanel.scrollTop = scrollTop;
            this._lastScrollPosition = scrollTop;
        }
    }
    _measureDimensions() {
        if (this._panelService.dimensions.itemHeight > 0 || this.itemsLength === 0) {
            return Promise.resolve(this._panelService.dimensions);
        }
        const [first] = this.items;
        this.update.emit([first]);
        return Promise.resolve().then(() => {
            const option = this._dropdown.querySelector(`#${first.htmlId}`);
            if (option) {
                const optionHeight = option.clientHeight;
                this._virtualPadding.style.height = `${optionHeight * this.itemsLength}px`;
                const panelHeight = this._scrollablePanel.clientHeight;
                this._panelService.setDimensions(optionHeight, panelHeight);
            }
            return this._panelService.dimensions;
        });
    }
    _fireScrollToEnd(scrollTop) {
        if (this._scrollToEndFired || scrollTop === 0) {
            return;
        }
        const padding = this.virtualScroll ? this._virtualPadding : this._contentPanel;
        if (scrollTop + this._dropdown.clientHeight >= padding.clientHeight - 1) {
            this._zone.run(() => this.scrollToEnd.emit());
            this._scrollToEndFired = true;
        }
    }
    _calculateCurrentPosition(dropdownEl) {
        if (this.position !== 'auto') {
            return this.position;
        }
        const selectRect = this._select.getBoundingClientRect();
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const offsetTop = selectRect.top + window.pageYOffset;
        const height = selectRect.height;
        const dropdownHeight = dropdownEl.getBoundingClientRect().height;
        if (offsetTop + height + dropdownHeight > scrollTop + document.documentElement.clientHeight) {
            return 'top';
        }
        else {
            return 'bottom';
        }
    }
    _appendDropdown() {
        if (!this.appendTo) {
            return;
        }
        this._parent = document.querySelector(this.appendTo);
        if (!this._parent) {
            throw new Error(`appendTo selector ${this.appendTo} did not found any parent element`);
        }
        this._updateXPosition();
        this._parent.appendChild(this._dropdown);
    }
    _updateXPosition() {
        const select = this._select.getBoundingClientRect();
        const parent = this._parent.getBoundingClientRect();
        const offsetLeft = select.left - parent.left;
        this._dropdown.style.left = offsetLeft + 'px';
        this._dropdown.style.width = select.width + 'px';
        this._dropdown.style.minWidth = select.width + 'px';
    }
    _updateYPosition() {
        const select = this._select.getBoundingClientRect();
        const parent = this._parent.getBoundingClientRect();
        const delta = select.height;
        if (this._currentPosition === 'top') {
            const offsetBottom = parent.bottom - select.bottom;
            this._dropdown.style.bottom = offsetBottom + delta + 'px';
            this._dropdown.style.top = 'auto';
        }
        else if (this._currentPosition === 'bottom') {
            const offsetTop = select.top - parent.top;
            this._dropdown.style.top = offsetTop + delta + 'px';
            this._dropdown.style.bottom = 'auto';
        }
    }
    _setupMousedownListener() {
        this._zone.runOutsideAngular(() => {
            fromEvent(this._dropdown, 'mousedown')
                .pipe(takeUntil(this._destroy$))
                .subscribe((event) => {
                const target = event.target;
                if (target.tagName === 'INPUT') {
                    return;
                }
                event.preventDefault();
            });
        });
    }
}
ScDropdownPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownPanelComponent, deps: [{ token: i0.Renderer2 }, { token: i0.NgZone }, { token: ScDropdownPanelService }, { token: i0.ElementRef }, { token: DOCUMENT, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ScDropdownPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScDropdownPanelComponent, selector: "sc-dropdown-panel", inputs: { items: "items", markedItem: "markedItem", position: "position", appendTo: "appendTo", bufferAmount: "bufferAmount", virtualScroll: "virtualScroll", headerTemplate: "headerTemplate", footerTemplate: "footerTemplate", filterValue: "filterValue" }, outputs: { update: "update", scroll: "scroll", scrollToEnd: "scrollToEnd", outsideClick: "outsideClick" }, viewQueries: [{ propertyName: "contentElementRef", first: true, predicate: ["content"], descendants: true, read: ElementRef, static: true }, { propertyName: "scrollElementRef", first: true, predicate: ["scroll"], descendants: true, read: ElementRef, static: true }, { propertyName: "paddingElementRef", first: true, predicate: ["padding"], descendants: true, read: ElementRef, static: true }], usesOnChanges: true, ngImport: i0, template: `
    <div *ngIf="headerTemplate" class="sc-dropdown-header">
      <ng-container
        [ngTemplateOutlet]="headerTemplate"
        [ngTemplateOutletContext]="{ searchTerm: filterValue }"
      ></ng-container>
    </div>
    <div #scroll class="sc-dropdown-panel-items scroll-host">
      <div #padding [class.total-padding]="virtualScroll"></div>
      <div #content [class.scrollable-content]="virtualScroll && items.length">
        <ng-content></ng-content>
      </div>
    </div>
    <div *ngIf="footerTemplate" class="ng-dropdown-footer">
      <ng-container
        [ngTemplateOutlet]="footerTemplate"
        [ngTemplateOutletContext]="{ searchTerm: filterValue }"
      ></ng-container>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownPanelComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    selector: 'sc-dropdown-panel',
                    template: `
    <div *ngIf="headerTemplate" class="sc-dropdown-header">
      <ng-container
        [ngTemplateOutlet]="headerTemplate"
        [ngTemplateOutletContext]="{ searchTerm: filterValue }"
      ></ng-container>
    </div>
    <div #scroll class="sc-dropdown-panel-items scroll-host">
      <div #padding [class.total-padding]="virtualScroll"></div>
      <div #content [class.scrollable-content]="virtualScroll && items.length">
        <ng-content></ng-content>
      </div>
    </div>
    <div *ngIf="footerTemplate" class="ng-dropdown-footer">
      <ng-container
        [ngTemplateOutlet]="footerTemplate"
        [ngTemplateOutletContext]="{ searchTerm: filterValue }"
      ></ng-container>
    </div>
  `,
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.NgZone }, { type: ScDropdownPanelService }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { items: [{
                type: Input
            }], markedItem: [{
                type: Input
            }], position: [{
                type: Input
            }], appendTo: [{
                type: Input
            }], bufferAmount: [{
                type: Input
            }], virtualScroll: [{
                type: Input
            }], headerTemplate: [{
                type: Input
            }], footerTemplate: [{
                type: Input
            }], filterValue: [{
                type: Input
            }], update: [{
                type: Output
            }], scroll: [{
                type: Output
            }], scrollToEnd: [{
                type: Output
            }], outsideClick: [{
                type: Output
            }], contentElementRef: [{
                type: ViewChild,
                args: ['content', { read: ElementRef, static: true }]
            }], scrollElementRef: [{
                type: ViewChild,
                args: ['scroll', { read: ElementRef, static: true }]
            }], paddingElementRef: [{
                type: ViewChild,
                args: ['padding', { read: ElementRef, static: true }]
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
class ScOptionComponent {
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = this._isDisabled(value);
    }
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.stateChange$ = new Subject();
        this._disabled = false;
        this._previousLabel = '';
    }
    get label() {
        return (this.elementRef.nativeElement.textContent || '').trim();
    }
    ngOnChanges(changes) {
        if (changes['disabled']) {
            this.stateChange$.next({
                value: this.value,
                disabled: this._disabled,
            });
        }
    }
    ngAfterViewChecked() {
        if (this.label !== this._previousLabel) {
            this._previousLabel = this.label;
            this.stateChange$.next({
                value: this.value,
                disabled: this._disabled,
                label: this.elementRef.nativeElement.innerHTML,
            });
        }
    }
    ngOnDestroy() {
        this.stateChange$.complete();
    }
    _isDisabled(value) {
        return value != null && `${value}` !== 'false';
    }
}
ScOptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOptionComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
ScOptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScOptionComponent, selector: "sc-option", inputs: { value: "value", disabled: "disabled" }, usesOnChanges: true, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScOptionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-option',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: `<ng-content></ng-content>`,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { value: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

class ScSelectConfig {
    constructor() {
        this.placeholder = '';
        this.notFoundText = 'No items found';
        this.typeToSearchText = 'Type to search';
        this.addTagText = 'Add item';
        this.loadingText = 'Loading...';
        this.clearAllText = 'Clear all';
        this.disableVirtualScroll = true;
        this.openOnEnter = true;
        this.appendTo = '';
        this.bindValue = '';
        this.bindLabel = 'label';
        this.appearance = 'underline';
        this.clearSearchOnAdd = true;
    }
}
ScSelectConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSelectConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ScSelectConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSelectConfig, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSelectConfig, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @angular-eslint/no-output-native */
/* eslint-disable @angular-eslint/no-output-rename */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
const SELECTION_MODEL_FACTORY = new InjectionToken('sc-select-selection-model');
class ScSelectComponent {
    get account() {
        return this._account;
    }
    set account(value) {
        this._account = coerceBooleanProperty(value);
    }
    get items() {
        return this._items;
    }
    set items(value) {
        if (value === null) {
            value = [];
        }
        this._itemsAreUsed = true;
        this._items = value;
    }
    get compareWith() {
        return this._compareWith;
    }
    set compareWith(fn) {
        if (fn !== undefined && fn !== null && !isFunction(fn)) {
            throw Error('`compareWith` must be a function.');
        }
        this._compareWith = fn;
    }
    get clearSearchOnAdd() {
        if (isDefined(this._clearSearchOnAdd)) {
            return this._clearSearchOnAdd;
        }
        else if (isDefined(this.config.clearSearchOnAdd)) {
            return this.config.clearSearchOnAdd;
        }
        return this.closeOnSelect;
    }
    set clearSearchOnAdd(value) {
        this._clearSearchOnAdd = value;
    }
    get disabled() {
        return this.readonly || this._disabled;
    }
    get filtered() {
        return (!!this.searchTerm && this.searchable) || this._isComposing;
    }
    get accountClass() {
        return this.account ? 'sc-select-account' : null;
    }
    get _editableSearchTerm() {
        return this.editableSearchTerm && !this.multiple;
    }
    constructor(classes, autoFocus, config, newSelectionModel, _elementRef, _cd, _console) {
        this.classes = classes;
        this.autoFocus = autoFocus;
        this.config = config;
        this._cd = _cd;
        this._console = _console;
        this.viewPortItems = [];
        this.searchTerm = '';
        this.dropdownId = 'sc-dropdown-' + crypto.randomUUID();
        this.focused = false;
        this.escapeHTML = true;
        this.useDefaultClass = true;
        this._items = [];
        this._itemsAreUsed = true;
        this._defaultLabel = 'label';
        this._primitive = true;
        this._disabled = false;
        this._pressedKeys = [];
        this._clearSearchOnAdd = true;
        this._isComposing = false;
        this._account = false;
        this._destroy$ = new Subject();
        this._keyPress$ = new Subject();
        // output events
        this.blurEvent = new EventEmitter();
        this.focusEvent = new EventEmitter();
        this.changeEvent = new EventEmitter();
        this.openEvent = new EventEmitter();
        this.closeEvent = new EventEmitter();
        this.searchEvent = new EventEmitter();
        this.clearEvent = new EventEmitter();
        this.addEvent = new EventEmitter();
        this.removeEvent = new EventEmitter();
        this.scroll = new EventEmitter();
        this.scrollToEnd = new EventEmitter();
        this.typeahead = new Subject();
        this.multiple = false;
        this.single = true;
        this.defaultClass = this.useDefaultClass;
        this.addTag = false;
        this.searchable = false;
        this.clearable = false;
        this.isOpen = false;
        this.markFirst = true;
        this.dropdownPosition = 'auto';
        this.loading = false;
        this.closeOnSelect = true;
        this.hideSelected = false;
        this.selectOnTab = false;
        this.maxSelectedItems = 99;
        this.bufferAmount = 4;
        this.virtualScroll = false;
        this.selectableGroup = false;
        this.selectableGroupAsModel = true;
        this.searchFn = null;
        this.trackByFn = null;
        this.clearOnBackspace = true;
        this.labelForId = null;
        this.inputAttrs = {};
        this.readonly = false;
        this.searchWhileComposing = true;
        this.minTermLength = 0;
        this.editableSearchTerm = false;
        this.accWarningMsg = 'This account can not be used.';
        this.keyDownFn = (_) => true;
        this._onChange = (_) => { };
        this._onTouched = () => { };
        this.clearItem = (item) => {
            const option = this.selectedItems.find((x) => x.value === item);
            this.unselect(option);
        };
        this.trackByOption = (_, item) => {
            if (this.trackByFn) {
                // return this.trackByFn(item.value);
            }
            return item;
        };
        this._mergeGlobalConfig(config);
        this.itemsList = new ItemsList(this, newSelectionModel());
        this.element = _elementRef.nativeElement;
    }
    get selectedItems() {
        return this.itemsList.selectedItems;
    }
    get selectedValues() {
        return this.selectedItems.map((x) => x.value);
    }
    get hasValue() {
        return this.selectedItems.length > 0;
    }
    get currentPanelPosition() {
        if (this.dropdownPanel) {
            return this.dropdownPanel.currentPosition;
        }
        return 'bottom';
    }
    ngOnInit() {
        // set custom templates
        if (this.customOptionTemplate) {
            this.optionTemplate = this.customOptionTemplate;
        }
        if (this.customLabelTemplate) {
            this.labelTemplate = this.customLabelTemplate;
        }
        this._handleKeyPresses();
        this._setInputAttributes();
    }
    ngOnChanges(changes) {
        if (changes['multiple']) {
            this.itemsList.clearSelected();
        }
        if (changes['items']) {
            this._setItems(changes['items'].currentValue || []);
        }
        if (changes['isOpen']) {
            this._manualOpen = isDefined(changes['isOpen'].currentValue);
        }
    }
    ngAfterViewInit() {
        if (!this._itemsAreUsed) {
            this.escapeHTML = false;
            this._setItemsFromScOption();
        }
        if (isDefined(this.autoFocus)) {
            this.focus();
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleKeyDown($event) {
        const keyCode = KeyCode[$event.which];
        if (keyCode) {
            if (this.keyDownFn($event) === false) {
                return;
            }
            this.handleKeyCode($event);
        }
        else if ($event.key && $event.key.length === 1) {
            this._keyPress$.next($event.key.toLocaleLowerCase());
        }
    }
    handleKeyCode($event) {
        switch ($event.which) {
            case KeyCode.ArrowDown:
                this._handleArrowDown($event);
                break;
            case KeyCode.ArrowUp:
                this._handleArrowUp($event);
                break;
            case KeyCode.Space:
                this._handleSpace($event);
                break;
            case KeyCode.Enter:
                this._handleEnter($event);
                break;
            case KeyCode.Tab:
                this._handleTab($event);
                break;
            case KeyCode.Esc:
                this.close();
                $event.preventDefault();
                break;
            case KeyCode.Backspace:
                this._handleBackspace();
                break;
        }
    }
    handleMousedown($event) {
        const target = $event.target;
        if (target.tagName !== 'INPUT') {
            $event.preventDefault();
        }
        if (target.classList.contains('sc-clear-wrapper')) {
            this.handleClearClick();
            return;
        }
        if (target.classList.contains('sc-arrow-wrapper')) {
            this.handleArrowClick();
            return;
        }
        if (target.classList.contains('sc-value-icon')) {
            return;
        }
        if (!this.focused) {
            this.focus();
        }
        if (this.searchable) {
            this.open();
        }
        else {
            this.toggle();
        }
    }
    handleArrowClick() {
        if (this.isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    }
    handleClearClick() {
        if (this.hasValue) {
            this.itemsList.clearSelected(true);
            this._updateNgModel();
        }
        this._clearSearch();
        this.focus();
        this.clearEvent.emit();
        this._onSelectionChanged();
    }
    clearModel() {
        if (!this.clearable) {
            return;
        }
        this.itemsList.clearSelected();
        this._updateNgModel();
    }
    writeValue(value) {
        this.itemsList.clearSelected();
        this._handleWriteValue(value);
        this._cd.markForCheck();
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(state) {
        this._disabled = state;
        this._cd.markForCheck();
    }
    toggle() {
        if (!this.isOpen) {
            this.open();
        }
        else {
            this.close();
        }
    }
    open() {
        if (this.disabled || this.isOpen || this.itemsList.maxItemsSelected || this._manualOpen) {
            return;
        }
        if (!this._isTypeahead && !this.addTag && this.itemsList.noItemsToSelect) {
            return;
        }
        this.isOpen = true;
        this.itemsList.markSelectedOrDefault(this.markFirst);
        this.openEvent.emit();
        if (!this.searchTerm) {
            this.focus();
        }
        this.detectChanges();
    }
    close() {
        if (!this.isOpen || this._manualOpen) {
            return;
        }
        this.isOpen = false;
        this._isComposing = false;
        if (!this._editableSearchTerm) {
            this._clearSearch();
        }
        else {
            this.itemsList.resetFilteredItems();
        }
        this.itemsList.unmarkItem();
        this._onTouched();
        this.closeEvent.emit();
        this._cd.markForCheck();
    }
    toggleItem(item) {
        if (!item || item.disabled || this.disabled) {
            return;
        }
        if (this.multiple && item.selected) {
            this.unselect(item);
        }
        else {
            this.select(item);
        }
        if (this._editableSearchTerm) {
            this._setSearchTermFromItems();
        }
        this._onSelectionChanged();
    }
    select(item) {
        if (!item.selected) {
            this.itemsList.select(item);
            if (this.clearSearchOnAdd && !this._editableSearchTerm) {
                this._clearSearch();
            }
            this._updateNgModel();
            if (this.multiple) {
                this.addEvent.emit(item.value);
            }
        }
        if (this.closeOnSelect || this.itemsList.noItemsToSelect) {
            this.close();
        }
    }
    focus() {
        this.searchInput.nativeElement.focus();
    }
    blur() {
        this.searchInput.nativeElement.blur();
    }
    unselect(item) {
        if (!item) {
            return;
        }
        this.itemsList.unselect(item);
        this.focus();
        this._updateNgModel();
        this.removeEvent.emit(item);
    }
    selectTag() {
        let tag;
        if (isFunction(this.addTag)) {
            tag = this.addTag(this.searchTerm ? this.searchTerm : '');
        }
        else {
            tag = this._primitive ? this.searchTerm : { [this.bindLabel]: this.searchTerm };
        }
        const handleTag = (item) => this._isTypeahead || !this.isOpen ? this.itemsList.mapItem(item, 0) : this.itemsList.addItem(item);
        if (isPromise(tag)) {
            tag.then((item) => this.select(handleTag(item))).catch(() => { });
        }
        else if (tag) {
            this.select(handleTag(tag));
        }
    }
    showClear() {
        return this.clearable && (this.hasValue || this.searchTerm) && !this.disabled;
    }
    get showAddTag() {
        if (!this._validTerm) {
            return false;
        }
        const term = this.searchTerm?.toLowerCase().trim();
        return (this.addTag &&
            !this.itemsList.filteredItems.some((x) => x.label?.toLowerCase() === term) &&
            ((!this.hideSelected && this.isOpen) || !this.selectedItems.some((x) => x.label?.toLowerCase() === term)) &&
            !this.loading);
    }
    showNoItemsFound() {
        const empty = this.itemsList.filteredItems.length === 0;
        return (((empty && !this._isTypeahead && !this.loading) ||
            (empty && this._isTypeahead && this._validTerm && !this.loading)) &&
            !this.showAddTag);
    }
    showTypeToSearch() {
        const empty = this.itemsList.filteredItems.length === 0;
        return empty && this._isTypeahead && !this._validTerm && !this.loading;
    }
    onCompositionStart() {
        this._isComposing = true;
    }
    onCompositionEnd(term) {
        this._isComposing = false;
        if (this.searchWhileComposing) {
            return;
        }
        this.filter(term);
    }
    filter(term) {
        if (this._isComposing && !this.searchWhileComposing) {
            return;
        }
        this.searchTerm = term;
        if (this._isTypeahead && (this._validTerm || this.minTermLength === 0)) {
            this.typeahead.next(term);
        }
        if (!this._isTypeahead) {
            this.itemsList.filter(this.searchTerm);
            if (this.isOpen) {
                this.itemsList.markSelectedOrDefault(this.markFirst);
            }
        }
        this.searchEvent.emit({
            term,
            items: this.itemsList.filteredItems.map((x) => x.value),
        });
        this.open();
    }
    onInputFocus($event) {
        if (this.focused) {
            return;
        }
        if (this._editableSearchTerm) {
            this._setSearchTermFromItems();
        }
        this.element.classList.add('sc-select-focused');
        this.focusEvent.emit($event);
        this.focused = true;
    }
    onInputBlur($event) {
        this.element.classList.remove('sc-select-focused');
        this.blurEvent.emit($event);
        if (!this.isOpen && !this.disabled) {
            this._onTouched();
        }
        if (this._editableSearchTerm) {
            this._setSearchTermFromItems();
        }
        this.focused = false;
    }
    onItemHover(item) {
        if (item.disabled) {
            return;
        }
        this.itemsList.markItem(item);
    }
    detectChanges() {
        if (!this._cd.destroyed) {
            this._cd.detectChanges();
        }
    }
    _setSearchTermFromItems() {
        const selected = this.selectedItems && this.selectedItems[0];
        this.searchTerm = (selected && selected.label) || '';
    }
    _setItems(items) {
        const firstItem = items[0];
        this.bindLabel = this.bindLabel || this._defaultLabel;
        this._primitive = isDefined(firstItem)
            ? !isObject(firstItem)
            : this._primitive || this.bindLabel === this._defaultLabel;
        this.itemsList.setItems(items);
        if (items.length > 0 && this.hasValue) {
            this.itemsList.mapSelectedItems();
        }
        if (this.isOpen && this.searchTerm && !this._isTypeahead) {
            this.itemsList.filter(this.searchTerm);
        }
        if (this._isTypeahead || this.isOpen) {
            this.itemsList.markSelectedOrDefault(this.markFirst);
        }
    }
    _setItemsFromScOption() {
        const mapScOption = (options) => {
            this.items = options.map((option) => ({
                $ngOptionValue: option.value,
                $ngOptionLabel: option.elementRef.nativeElement.innerHTML,
                disabled: option.disabled,
            }));
            this.itemsList.setItems(this.items);
            if (this.hasValue) {
                this.itemsList.mapSelectedItems();
            }
            this.detectChanges();
        };
        const handleOptionChange = () => {
            const changedOrDestroyed = merge(this.scOptions.changes, this._destroy$);
            merge(...this.scOptions.map((option) => option.stateChange$))
                .pipe(takeUntil(changedOrDestroyed))
                .subscribe((option) => {
                const item = this.itemsList.findItem(option.value);
                item.disabled = option.disabled;
                item.label = option.label || item.label;
                this._cd.detectChanges();
            });
        };
        this.scOptions.changes.pipe(startWith(this.scOptions), takeUntil(this._destroy$)).subscribe((options) => {
            this.bindLabel = this._defaultLabel;
            mapScOption(options);
            handleOptionChange();
        });
    }
    _isValidWriteValue(value) {
        if (!isDefined(value) || (this.multiple && value === '') || (Array.isArray(value) && value.length === 0)) {
            return false;
        }
        const validateBinding = (item) => {
            if (!isDefined(this.compareWith) && isObject(item) && this.bindValue) {
                this._console.warn(`Setting object(${JSON.stringify(item)}) as your model with bindValue is not allowed unless [compareWith] is used.`);
                return false;
            }
            return true;
        };
        if (this.multiple) {
            if (!Array.isArray(value)) {
                this._console.warn('Multiple select ngModel should be array.');
                return false;
            }
            return value.every((item) => validateBinding(item));
        }
        else {
            return validateBinding(value);
        }
    }
    _handleWriteValue(ngModel) {
        if (!this._isValidWriteValue(ngModel)) {
            return;
        }
        const select = (val) => {
            let item = this.itemsList.findItem(val);
            if (item) {
                this.itemsList.select(item);
            }
            else {
                const isValObject = isObject(val);
                const isPrimitive = !isValObject && !this.bindValue;
                if (isValObject || isPrimitive) {
                    this.itemsList.select(this.itemsList.mapItem(val, 0));
                }
                else if (this.bindValue) {
                    item = {
                        [this.bindLabel]: null,
                        [this.bindValue]: val,
                    };
                    this.itemsList.select(this.itemsList.mapItem(item, 0));
                }
            }
        };
        if (this.multiple) {
            ngModel.forEach((item) => select(item));
        }
        else {
            select(ngModel);
        }
    }
    _handleKeyPresses() {
        if (this.searchable) {
            return;
        }
        this._keyPress$
            .pipe(takeUntil(this._destroy$), tap((letter) => this._pressedKeys.push(letter)), debounceTime(200), filter(() => this._pressedKeys.length > 0), map(() => this._pressedKeys.join('')))
            .subscribe((term) => {
            const item = this.itemsList.findByLabel(term);
            if (item) {
                if (this.isOpen) {
                    this.itemsList.markItem(item);
                    this._scrollToMarked();
                    this._cd.markForCheck();
                }
                else {
                    this.select(item);
                }
            }
            this._pressedKeys = [];
        });
    }
    _setInputAttributes() {
        const input = this.searchInput.nativeElement;
        const attributes = {
            type: 'text',
            autocorrect: 'off',
            autocapitalize: 'off',
            autocomplete: this.labelForId ? 'off' : this.dropdownId,
            ...this.inputAttrs,
        };
        for (const key of Object.keys(attributes)) {
            input.setAttribute(key, attributes[key]);
        }
    }
    _updateNgModel() {
        const model = [];
        for (const item of this.selectedItems) {
            if (this.bindValue) {
                let value = null;
                if (item.children) {
                    const groupKey = this.bindValue;
                    value = item.value[groupKey || this.groupBy];
                }
                else {
                    value = this.itemsList.resolveNested(item.value, this.bindValue);
                }
                model.push(value);
            }
            else {
                model.push(item.value);
            }
        }
        const selected = this.selectedItems.map((x) => x.value);
        if (this.multiple) {
            this._onChange(model);
            this.changeEvent.emit(selected);
        }
        else {
            this._onChange(isDefined(model[0]) ? model[0] : null);
            this.changeEvent.emit(selected[0]);
        }
        this._cd.markForCheck();
    }
    _clearSearch() {
        if (!this.searchTerm) {
            return;
        }
        this._changeSearch('');
        this.itemsList.resetFilteredItems();
    }
    _changeSearch(searchTerm) {
        this.searchTerm = searchTerm;
        if (this._isTypeahead) {
            this.typeahead.next(searchTerm);
        }
    }
    _scrollToMarked() {
        if (!this.isOpen || !this.dropdownPanel) {
            return;
        }
        this.dropdownPanel.scrollTo(this.itemsList.markedItem);
    }
    _scrollToTag() {
        if (!this.isOpen || !this.dropdownPanel) {
            return;
        }
        this.dropdownPanel.scrollToTag();
    }
    _onSelectionChanged() {
        if (this.isOpen && this.multiple && this.appendTo) {
            // Make sure items are rendered.
            this._cd.detectChanges();
            this.dropdownPanel.adjustPosition();
        }
    }
    _handleTab($event) {
        if (this.isOpen === false && !this.addTag) {
            return;
        }
        if (this.selectOnTab) {
            if (this.itemsList.markedItem) {
                this.toggleItem(this.itemsList.markedItem);
                $event.preventDefault();
            }
            else if (this.showAddTag) {
                this.selectTag();
                $event.preventDefault();
            }
            else {
                this.close();
            }
        }
        else {
            this.close();
        }
    }
    _handleEnter($event) {
        if (this.isOpen || this._manualOpen) {
            if (this.itemsList.markedItem) {
                this.toggleItem(this.itemsList.markedItem);
            }
            else if (this.showAddTag) {
                this.selectTag();
            }
        }
        else if (this.openOnEnter) {
            this.open();
        }
        else {
            return;
        }
        $event.preventDefault();
    }
    _handleSpace($event) {
        if (this.isOpen || this._manualOpen) {
            return;
        }
        this.open();
        $event.preventDefault();
    }
    _handleArrowDown($event) {
        if (this._nextItemIsTag(+1)) {
            this.itemsList.unmarkItem();
            this._scrollToTag();
        }
        else {
            this.itemsList.markNextItem();
            this._scrollToMarked();
        }
        this.open();
        $event.preventDefault();
    }
    _handleArrowUp($event) {
        if (!this.isOpen) {
            return;
        }
        if (this._nextItemIsTag(-1)) {
            this.itemsList.unmarkItem();
            this._scrollToTag();
        }
        else {
            this.itemsList.markPreviousItem();
            this._scrollToMarked();
        }
        $event.preventDefault();
    }
    _nextItemIsTag(nextStep) {
        const nextIndex = this.itemsList.markedIndex + nextStep;
        return (this.addTag &&
            !!this.searchTerm &&
            this.itemsList.markedItem &&
            (nextIndex < 0 || nextIndex === this.itemsList.filteredItems.length));
    }
    _handleBackspace() {
        if (this.searchTerm || !this.clearable || !this.clearOnBackspace || !this.hasValue) {
            return;
        }
        if (this.multiple) {
            this.unselect(this.itemsList.lastSelectedItem);
        }
        else {
            this.clearModel();
        }
    }
    get _isTypeahead() {
        return this.typeahead && this.typeahead.observers.length > 0;
    }
    get _validTerm() {
        const term = this.searchTerm && this.searchTerm.trim();
        return term && term.length >= this.minTermLength;
    }
    _mergeGlobalConfig(config) {
        this.placeholder = this.placeholder || config.placeholder;
        this.notFoundText = this.notFoundText || config.notFoundText;
        this.typeToSearchText = this.typeToSearchText || config.typeToSearchText;
        this.addTagText = this.addTagText || config.addTagText;
        this.loadingText = this.loadingText || config.loadingText;
        this.clearAllText = this.clearAllText || config.clearAllText;
        this.virtualScroll = isDefined(this.virtualScroll)
            ? this.virtualScroll
            : isDefined(config.disableVirtualScroll)
                ? !config.disableVirtualScroll
                : false;
        this.openOnEnter = isDefined(this.openOnEnter) ? this.openOnEnter : config.openOnEnter;
        this.appendTo = this.appendTo || config.appendTo;
        this.bindValue = this.bindValue || config.bindValue;
        this.bindLabel = this.bindLabel || config.bindLabel;
        this.appearance = this.appearance || config.appearance;
    }
}
ScSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSelectComponent, deps: [{ token: 'class', attribute: true }, { token: 'autofocus', attribute: true }, { token: ScSelectConfig }, { token: SELECTION_MODEL_FACTORY }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: ConsoleService }], target: i0.ɵɵFactoryTarget.Component });
ScSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScSelectComponent, selector: "sc-select", inputs: { typeahead: "typeahead", customOptionTemplate: "customOptionTemplate", customLabelTemplate: "customLabelTemplate", multiple: "multiple", single: "single", defaultClass: "defaultClass", addTag: "addTag", searchable: "searchable", clearable: "clearable", isOpen: "isOpen", bindLabel: "bindLabel", bindValue: "bindValue", markFirst: "markFirst", placeholder: "placeholder", notFoundText: "notFoundText", typeToSearchText: "typeToSearchText", addTagText: "addTagText", loadingText: "loadingText", clearAllText: "clearAllText", appearance: "appearance", dropdownPosition: "dropdownPosition", appendTo: "appendTo", loading: "loading", closeOnSelect: "closeOnSelect", hideSelected: "hideSelected", selectOnTab: "selectOnTab", openOnEnter: "openOnEnter", maxSelectedItems: "maxSelectedItems", groupBy: "groupBy", groupValue: "groupValue", bufferAmount: "bufferAmount", virtualScroll: "virtualScroll", selectableGroup: "selectableGroup", selectableGroupAsModel: "selectableGroupAsModel", searchFn: "searchFn", trackByFn: "trackByFn", clearOnBackspace: "clearOnBackspace", labelForId: "labelForId", inputAttrs: "inputAttrs", tabIndex: "tabIndex", readonly: "readonly", searchWhileComposing: "searchWhileComposing", minTermLength: "minTermLength", editableSearchTerm: "editableSearchTerm", accWarningMsg: "accWarningMsg", keyDownFn: "keyDownFn", account: "account", items: "items", compareWith: "compareWith", clearSearchOnAdd: "clearSearchOnAdd" }, outputs: { blurEvent: "blur", focusEvent: "focus", changeEvent: "change", openEvent: "open", closeEvent: "close", searchEvent: "search", clearEvent: "clear", addEvent: "add", removeEvent: "remove", scroll: "scroll", scrollToEnd: "scrollToEnd" }, host: { listeners: { "keydown": "handleKeyDown($event)" }, properties: { "class.sc-select-typeahead": "this.typeahead", "class.sc-select-multiple": "this.multiple", "class.sc-select-single": "this.single", "class.sc-select": "this.defaultClass", "class.sc-select-taggable": "this.addTag", "class.sc-select-searchable": "this.searchable", "class.sc-select-clearable": "this.clearable", "class.sc-select-opened": "this.isOpen", "class.sc-select-disabled": "this.disabled", "class.sc-select-filtered": "this.filtered", "class.sc-select-account": "this.accountClass" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScSelectComponent),
            multi: true,
        },
        ScDropdownPanelService,
    ], queries: [{ propertyName: "optionTemplate", first: true, predicate: ScOptionTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "optgroupTemplate", first: true, predicate: ScOptgroupTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "labelTemplate", first: true, predicate: ScLabelTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "multiLabelTemplate", first: true, predicate: ScMultiLabelTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "headerTemplate", first: true, predicate: ScHeaderTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "footerTemplate", first: true, predicate: ScFooterTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "notFoundTemplate", first: true, predicate: ScNotFoundTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "typeToSearchTemplate", first: true, predicate: ScTypeToSearchTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "loadingTextTemplate", first: true, predicate: ScLoadingTextTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "tagTemplate", first: true, predicate: ScTagTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "loadingSpinnerTemplate", first: true, predicate: ScLoadingSpinnerTemplateDirective, descendants: true, read: TemplateRef }, { propertyName: "scOptions", predicate: ScOptionComponent, descendants: true }], viewQueries: [{ propertyName: "dropdownPanel", first: true, predicate: i0.forwardRef(function () { return ScDropdownPanelComponent; }), descendants: true }, { propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div\r\n  (mousedown)=\"handleMousedown($event)\"\r\n  [class.sc-appearance-outline]=\"appearance === 'outline'\"\r\n  [class.sc-has-value]=\"hasValue\"\r\n  class=\"sc-select-container\"\r\n>\r\n  <div class=\"sc-value-container\">\r\n    <div class=\"sc-placeholder\">{{ placeholder }}</div>\r\n\r\n    <ng-container\r\n      *ngIf=\"(!multiLabelTemplate || !multiple) && selectedItems.length > 0\"\r\n    >\r\n      <div\r\n        [class.sc-value-disabled]=\"item.disabled\"\r\n        class=\"sc-value\"\r\n        *ngFor=\"let item of selectedItems; trackBy: trackByOption\"\r\n      >\r\n        <ng-template #defaultLabelTemplate>\r\n          <span\r\n            class=\"sc-value-icon left\"\r\n            (click)=\"unselect(item)\"\r\n            aria-hidden=\"true\"\r\n            >\u00D7</span\r\n          >\r\n          <span\r\n            class=\"sc-value-label\"\r\n            [scItemLabel]=\"account ? item.value.description : item.label\"\r\n            [escape]=\"escapeHTML\"\r\n          ></span>\r\n        </ng-template>\r\n\r\n        <ng-template\r\n          [ngTemplateOutlet]=\"labelTemplate || defaultLabelTemplate\"\r\n          [ngTemplateOutletContext]=\"{\r\n            item: item.value,\r\n            clear: clearItem,\r\n            label: item.label\r\n          }\"\r\n        >\r\n        </ng-template>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <ng-template\r\n      *ngIf=\"multiple && multiLabelTemplate && selectedValues.length > 0\"\r\n      [ngTemplateOutlet]=\"multiLabelTemplate\"\r\n      [ngTemplateOutletContext]=\"{ items: selectedValues, clear: clearItem }\"\r\n    >\r\n    </ng-template>\r\n\r\n    <div\r\n      class=\"sc-input\"\r\n      role=\"combobox\"\r\n      [attr.aria-expanded]=\"isOpen\"\r\n      [attr.aria-owns]=\"isOpen ? dropdownId : ''\"\r\n      aria-haspopup=\"listbox\"\r\n    >\r\n      <input\r\n        #searchInput\r\n        [attr.id]=\"labelForId\"\r\n        [attr.tabindex]=\"tabIndex\"\r\n        [readOnly]=\"!searchable || itemsList.maxItemsSelected\"\r\n        [disabled]=\"disabled\"\r\n        [value]=\"searchTerm ? searchTerm : ''\"\r\n        (input)=\"filter(searchInput.value)\"\r\n        (compositionstart)=\"onCompositionStart()\"\r\n        (compositionend)=\"onCompositionEnd(searchInput.value)\"\r\n        (focus)=\"onInputFocus($event)\"\r\n        (blur)=\"onInputBlur($event)\"\r\n        (change)=\"$event.stopPropagation()\"\r\n        [attr.aria-activedescendant]=\"\r\n          isOpen ? itemsList.markedItem.htmlId : ''\r\n        \"\r\n        aria-autocomplete=\"list\"\r\n        [attr.aria-controls]=\"isOpen ? dropdownId : ''\"\r\n      />\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"loading\">\r\n    <ng-template #defaultLoadingSpinnerTemplate>\r\n      <div class=\"sc-spinner-loader\"></div>\r\n    </ng-template>\r\n\r\n    <ng-template\r\n      [ngTemplateOutlet]=\"\r\n        loadingSpinnerTemplate || defaultLoadingSpinnerTemplate\r\n      \"\r\n    >\r\n    </ng-template>\r\n  </ng-container>\r\n\r\n  <span *ngIf=\"showClear()\" class=\"sc-clear-wrapper\" title=\"{{ clearAllText }}\">\r\n    <span class=\"sc-clear\" aria-hidden=\"true\">\u00D7</span>\r\n  </span>\r\n\r\n  <span class=\"sc-arrow-wrapper\">\r\n    <span class=\"sc-arrow\"></span>\r\n  </span>\r\n</div>\r\n\r\n<sc-dropdown-panel\r\n  *ngIf=\"isOpen\"\r\n  class=\"sc-dropdown-panel\"\r\n  [virtualScroll]=\"virtualScroll\"\r\n  [bufferAmount]=\"bufferAmount\"\r\n  [appendTo]=\"appendTo\"\r\n  [position]=\"dropdownPosition\"\r\n  [headerTemplate]=\"headerTemplate\"\r\n  [footerTemplate]=\"footerTemplate\"\r\n  [filterValue]=\"searchTerm\"\r\n  [items]=\"itemsList.filteredItems\"\r\n  [markedItem]=\"itemsList.markedItem\"\r\n  (update)=\"viewPortItems = $event\"\r\n  (scroll)=\"scroll.emit($event)\"\r\n  (scrollToEnd)=\"scrollToEnd.emit($event)\"\r\n  (outsideClick)=\"close()\"\r\n  [class.sc-select-multiple]=\"multiple\"\r\n  [ngClass]=\"appendTo ? classes : ''\"\r\n  [id]=\"dropdownId\"\r\n  role=\"listbox\"\r\n  aria-label=\"Options list\"\r\n>\r\n  <ng-container>\r\n    <div\r\n      class=\"sc-option\"\r\n      [attr.role]=\"item.children ? 'group' : 'option'\"\r\n      (click)=\"toggleItem(item)\"\r\n      (mouseover)=\"onItemHover(item)\"\r\n      *ngFor=\"let item of viewPortItems; trackBy: trackByOption\"\r\n      [class.sc-option-disabled]=\"item.disabled\"\r\n      [class.sc-option-selected]=\"item.selected\"\r\n      [class.sc-optgroup]=\"item.children\"\r\n      [class.sc-option]=\"!item.children\"\r\n      [class.sc-option-child]=\"!!item.parent\"\r\n      [class.sc-option-marked]=\"item === itemsList.markedItem\"\r\n      [attr.aria-selected]=\"item.selected\"\r\n      [attr.id]=\"item?.htmlId\"\r\n    >\r\n\r\n\r\n\r\n      <ng-template #defaultOptionTemplate>\r\n\r\n        <ng-container *ngIf=\"!account\">\r\n          <span\r\n            class=\"sc-option-label\"\r\n            [scItemLabel]=\"item.label\"\r\n            [escape]=\"escapeHTML\"\r\n          ></span>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"account\">\r\n          <div class=\"option-account\">\r\n            <span class=\"option-account-name\">{{\r\n              item.value.description\r\n            }}</span>\r\n            <div class=\"option-account-number\">\r\n              {{ item.value.accountno.number }}/{{\r\n                item.value.accountno.bankCode\r\n              }}\r\n            </div>\r\n            <div\r\n              class=\"option-account-price\"\r\n              [ngClass]=\"{\r\n                'text-ui-red-400': item.value.balanceStatus === 'insufficient',\r\n                'text-ui-green-400': item.value.balanceStatus === 'sufficient'\r\n              }\"\r\n            >\r\n              <span class=\"option-account-value\">{{ item.value.balance.value }},</span>\r\n              <span class=\"option-account-decimal\"><sup>{{ item.value.balance.precision }}</sup></span>\r\n              <span class=\"option-account-currency\">{{ item.value.balance.currency}}</span>\r\n            </div>\r\n\r\n            <div\r\n              class=\"option-account-warning\"\r\n              *ngIf=\"item.value.balanceStatus === 'insufficient'\"\r\n            >\r\n              {{ accWarningMsg }}\r\n            </div>\r\n\r\n          </div>\r\n        </ng-container>\r\n\r\n      </ng-template>\r\n\r\n      <ng-template\r\n        [ngTemplateOutlet]=\"item.children ? optgroupTemplate || defaultOptionTemplate : optionTemplate || defaultOptionTemplate\"\r\n        [ngTemplateOutletContext]=\"{\r\n          item: item.value,\r\n          item$: item,\r\n          index: item.index,\r\n          searchTerm: searchTerm\r\n        }\"\r\n      >\r\n      </ng-template>\r\n    </div>\r\n\r\n    <div\r\n      class=\"sc-option\"\r\n      [class.sc-option-marked]=\"!itemsList.markedItem\"\r\n      (mouseover)=\"itemsList.unmarkItem()\"\r\n      role=\"option\"\r\n      (click)=\"selectTag()\"\r\n      *ngIf=\"showAddTag\"\r\n    >\r\n      <ng-template #defaultTagTemplate>\r\n        <span>\r\n          <span class=\"sc-tag-label\"> {{ addTagText }} </span>\"{{\r\n            searchTerm\r\n          }}\"</span\r\n        >\r\n      </ng-template>\r\n\r\n      <ng-template\r\n        [ngTemplateOutlet]=\"tagTemplate || defaultTagTemplate\"\r\n        [ngTemplateOutletContext]=\"{ searchTerm: searchTerm }\"\r\n      >\r\n      </ng-template>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"showNoItemsFound()\">\r\n    <ng-template #defaultNotFoundTemplate>\r\n      <div class=\"sc-option sc-option-disabled\">{{ notFoundText }}</div>\r\n    </ng-template>\r\n\r\n    <ng-template\r\n      [ngTemplateOutlet]=\"notFoundTemplate || defaultNotFoundTemplate\"\r\n      [ngTemplateOutletContext]=\"{ searchTerm: searchTerm }\"\r\n    >\r\n    </ng-template>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"showTypeToSearch()\">\r\n    <ng-template #defaultTypeToSearchTemplate>\r\n      <div class=\"sc-option sc-option-disabled\">{{ typeToSearchText }}</div>\r\n    </ng-template>\r\n\r\n    <ng-template\r\n      [ngTemplateOutlet]=\"typeToSearchTemplate || defaultTypeToSearchTemplate\"\r\n    >\r\n    </ng-template>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"loading && itemsList.filteredItems.length === 0\">\r\n    <ng-template #defaultLoadingTextTemplate>\r\n      <div class=\"sc-option sc-option-disabled\">{{ loadingText }}</div>\r\n    </ng-template>\r\n\r\n    <ng-template\r\n      [ngTemplateOutlet]=\"loadingTextTemplate || defaultLoadingTextTemplate\"\r\n      [ngTemplateOutletContext]=\"{ searchTerm: searchTerm }\"\r\n    >\r\n    </ng-template>\r\n  </ng-container>\r\n</sc-dropdown-panel>\r\n", styles: ["@charset \"UTF-8\";.sc-select{position:relative;display:block;box-sizing:border-box}.sc-select div,.sc-select input,.sc-select span{box-sizing:border-box}.sc-select [hidden]{display:none}.sc-select.sc-select-searchable .sc-select-container .sc-value-container .sc-input{opacity:1}.sc-select.sc-select-opened .sc-select-container{z-index:1001}.sc-select.sc-select-disabled .sc-select-container .sc-value-container .sc-placeholder,.sc-select.sc-select-disabled .sc-select-container .sc-value-container .sc-value{-webkit-user-select:none;user-select:none;cursor:default}.sc-select.sc-select-disabled .sc-arrow-wrapper{cursor:default}.sc-select.sc-select-filtered .sc-placeholder{display:none}.sc-select .sc-select-container{cursor:default;display:flex;outline:none;overflow:hidden;position:relative;width:100%}.sc-select .sc-select-container .sc-value-container{display:flex;flex:1}.sc-select .sc-select-container .sc-value-container .sc-input{opacity:0}.sc-select .sc-select-container .sc-value-container .sc-input>input{box-sizing:content-box;background:none transparent;border:0 none;box-shadow:none;outline:none;padding:0;cursor:default;width:100%}.sc-select .sc-select-container .sc-value-container .sc-input>input::-ms-clear{display:none}.sc-select .sc-select-container .sc-value-container .sc-input>input[readonly]{-webkit-user-select:none;user-select:none;width:0;padding:0}.sc-select.sc-select-single.sc-select-filtered .sc-select-container .sc-value-container .sc-value{visibility:hidden}.sc-select.sc-select-single .sc-select-container .sc-value-container,.sc-select.sc-select-single .sc-select-container .sc-value-container .sc-value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sc-select.sc-select-single .sc-select-container .sc-value-container .sc-value .sc-value-icon{display:none}.sc-select.sc-select-single .sc-select-container .sc-value-container .sc-input{position:absolute;left:0;width:100%}.sc-select.sc-select-multiple.sc-select-disabled>.sc-select-container .sc-value-container .sc-value .sc-value-icon{display:none}.sc-select.sc-select-multiple .sc-select-container .sc-value-container{flex-wrap:wrap}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-placeholder{position:absolute}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-value{white-space:nowrap}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-value.sc-value-disabled .sc-value-icon{display:none}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-value .sc-value-icon{cursor:pointer}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-input{flex:1;z-index:2}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-placeholder{z-index:1}.sc-select .sc-clear-wrapper{cursor:pointer;position:relative;width:17px;-webkit-user-select:none;user-select:none}.sc-select .sc-clear-wrapper .sc-clear{display:inline-block;font-size:18px;line-height:1;pointer-events:none}.sc-select .sc-spinner-loader{border-radius:50%;width:17px;height:17px;margin-right:5px;font-size:10px;position:relative;text-indent:-9999em;border-top:2px solid rgba(66,66,66,.2);border-right:2px solid rgba(66,66,66,.2);border-bottom:2px solid rgba(66,66,66,.2);border-left:2px solid #424242;transform:translateZ(0);animation:load8 .8s infinite linear}.sc-select .sc-spinner-loader:after{border-radius:50%;width:17px;height:17px}@keyframes load8{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.sc-select .sc-arrow-wrapper{cursor:pointer;position:relative;text-align:center;-webkit-user-select:none;user-select:none}.sc-select .sc-arrow-wrapper .sc-arrow{pointer-events:none;display:inline-block;height:0;width:0;position:relative}.sc-dropdown-panel{box-sizing:border-box;position:absolute;opacity:0;width:100%;z-index:1050;-webkit-overflow-scrolling:touch}.sc-dropdown-panel .sc-dropdown-panel-items{display:block;height:auto;box-sizing:border-box;max-height:240px;overflow-y:auto}.sc-dropdown-panel .sc-dropdown-panel-items .sc-optgroup{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sc-dropdown-panel .sc-dropdown-panel-items .sc-option{box-sizing:border-box;cursor:pointer;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sc-dropdown-panel .sc-dropdown-panel-items .sc-option .sc-option-label:empty:before{content:\"\\200b\"}.sc-dropdown-panel .sc-dropdown-panel-items .sc-option .highlighted{font-weight:700;text-decoration:underline}.sc-dropdown-panel .sc-dropdown-panel-items .sc-option.disabled{cursor:default}.sc-dropdown-panel .scroll-host{overflow:hidden;overflow-y:auto;position:relative;display:block;-webkit-overflow-scrolling:touch}.sc-dropdown-panel .scrollable-content{top:0;left:0;width:100%;height:100%;position:absolute}.sc-dropdown-panel .total-padding{width:1px;opacity:0}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: ScDropdownPanelComponent, selector: "sc-dropdown-panel", inputs: ["items", "markedItem", "position", "appendTo", "bufferAmount", "virtualScroll", "headerTemplate", "footerTemplate", "filterValue"], outputs: ["update", "scroll", "scrollToEnd", "outsideClick"] }, { kind: "directive", type: ScItemLabelDirective, selector: "[scItemLabel]", inputs: ["scItemLabel", "escape"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-select', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ScSelectComponent),
                            multi: true,
                        },
                        ScDropdownPanelService,
                    ], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  (mousedown)=\"handleMousedown($event)\"\r\n  [class.sc-appearance-outline]=\"appearance === 'outline'\"\r\n  [class.sc-has-value]=\"hasValue\"\r\n  class=\"sc-select-container\"\r\n>\r\n  <div class=\"sc-value-container\">\r\n    <div class=\"sc-placeholder\">{{ placeholder }}</div>\r\n\r\n    <ng-container\r\n      *ngIf=\"(!multiLabelTemplate || !multiple) && selectedItems.length > 0\"\r\n    >\r\n      <div\r\n        [class.sc-value-disabled]=\"item.disabled\"\r\n        class=\"sc-value\"\r\n        *ngFor=\"let item of selectedItems; trackBy: trackByOption\"\r\n      >\r\n        <ng-template #defaultLabelTemplate>\r\n          <span\r\n            class=\"sc-value-icon left\"\r\n            (click)=\"unselect(item)\"\r\n            aria-hidden=\"true\"\r\n            >\u00D7</span\r\n          >\r\n          <span\r\n            class=\"sc-value-label\"\r\n            [scItemLabel]=\"account ? item.value.description : item.label\"\r\n            [escape]=\"escapeHTML\"\r\n          ></span>\r\n        </ng-template>\r\n\r\n        <ng-template\r\n          [ngTemplateOutlet]=\"labelTemplate || defaultLabelTemplate\"\r\n          [ngTemplateOutletContext]=\"{\r\n            item: item.value,\r\n            clear: clearItem,\r\n            label: item.label\r\n          }\"\r\n        >\r\n        </ng-template>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <ng-template\r\n      *ngIf=\"multiple && multiLabelTemplate && selectedValues.length > 0\"\r\n      [ngTemplateOutlet]=\"multiLabelTemplate\"\r\n      [ngTemplateOutletContext]=\"{ items: selectedValues, clear: clearItem }\"\r\n    >\r\n    </ng-template>\r\n\r\n    <div\r\n      class=\"sc-input\"\r\n      role=\"combobox\"\r\n      [attr.aria-expanded]=\"isOpen\"\r\n      [attr.aria-owns]=\"isOpen ? dropdownId : ''\"\r\n      aria-haspopup=\"listbox\"\r\n    >\r\n      <input\r\n        #searchInput\r\n        [attr.id]=\"labelForId\"\r\n        [attr.tabindex]=\"tabIndex\"\r\n        [readOnly]=\"!searchable || itemsList.maxItemsSelected\"\r\n        [disabled]=\"disabled\"\r\n        [value]=\"searchTerm ? searchTerm : ''\"\r\n        (input)=\"filter(searchInput.value)\"\r\n        (compositionstart)=\"onCompositionStart()\"\r\n        (compositionend)=\"onCompositionEnd(searchInput.value)\"\r\n        (focus)=\"onInputFocus($event)\"\r\n        (blur)=\"onInputBlur($event)\"\r\n        (change)=\"$event.stopPropagation()\"\r\n        [attr.aria-activedescendant]=\"\r\n          isOpen ? itemsList.markedItem.htmlId : ''\r\n        \"\r\n        aria-autocomplete=\"list\"\r\n        [attr.aria-controls]=\"isOpen ? dropdownId : ''\"\r\n      />\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"loading\">\r\n    <ng-template #defaultLoadingSpinnerTemplate>\r\n      <div class=\"sc-spinner-loader\"></div>\r\n    </ng-template>\r\n\r\n    <ng-template\r\n      [ngTemplateOutlet]=\"\r\n        loadingSpinnerTemplate || defaultLoadingSpinnerTemplate\r\n      \"\r\n    >\r\n    </ng-template>\r\n  </ng-container>\r\n\r\n  <span *ngIf=\"showClear()\" class=\"sc-clear-wrapper\" title=\"{{ clearAllText }}\">\r\n    <span class=\"sc-clear\" aria-hidden=\"true\">\u00D7</span>\r\n  </span>\r\n\r\n  <span class=\"sc-arrow-wrapper\">\r\n    <span class=\"sc-arrow\"></span>\r\n  </span>\r\n</div>\r\n\r\n<sc-dropdown-panel\r\n  *ngIf=\"isOpen\"\r\n  class=\"sc-dropdown-panel\"\r\n  [virtualScroll]=\"virtualScroll\"\r\n  [bufferAmount]=\"bufferAmount\"\r\n  [appendTo]=\"appendTo\"\r\n  [position]=\"dropdownPosition\"\r\n  [headerTemplate]=\"headerTemplate\"\r\n  [footerTemplate]=\"footerTemplate\"\r\n  [filterValue]=\"searchTerm\"\r\n  [items]=\"itemsList.filteredItems\"\r\n  [markedItem]=\"itemsList.markedItem\"\r\n  (update)=\"viewPortItems = $event\"\r\n  (scroll)=\"scroll.emit($event)\"\r\n  (scrollToEnd)=\"scrollToEnd.emit($event)\"\r\n  (outsideClick)=\"close()\"\r\n  [class.sc-select-multiple]=\"multiple\"\r\n  [ngClass]=\"appendTo ? classes : ''\"\r\n  [id]=\"dropdownId\"\r\n  role=\"listbox\"\r\n  aria-label=\"Options list\"\r\n>\r\n  <ng-container>\r\n    <div\r\n      class=\"sc-option\"\r\n      [attr.role]=\"item.children ? 'group' : 'option'\"\r\n      (click)=\"toggleItem(item)\"\r\n      (mouseover)=\"onItemHover(item)\"\r\n      *ngFor=\"let item of viewPortItems; trackBy: trackByOption\"\r\n      [class.sc-option-disabled]=\"item.disabled\"\r\n      [class.sc-option-selected]=\"item.selected\"\r\n      [class.sc-optgroup]=\"item.children\"\r\n      [class.sc-option]=\"!item.children\"\r\n      [class.sc-option-child]=\"!!item.parent\"\r\n      [class.sc-option-marked]=\"item === itemsList.markedItem\"\r\n      [attr.aria-selected]=\"item.selected\"\r\n      [attr.id]=\"item?.htmlId\"\r\n    >\r\n\r\n\r\n\r\n      <ng-template #defaultOptionTemplate>\r\n\r\n        <ng-container *ngIf=\"!account\">\r\n          <span\r\n            class=\"sc-option-label\"\r\n            [scItemLabel]=\"item.label\"\r\n            [escape]=\"escapeHTML\"\r\n          ></span>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"account\">\r\n          <div class=\"option-account\">\r\n            <span class=\"option-account-name\">{{\r\n              item.value.description\r\n            }}</span>\r\n            <div class=\"option-account-number\">\r\n              {{ item.value.accountno.number }}/{{\r\n                item.value.accountno.bankCode\r\n              }}\r\n            </div>\r\n            <div\r\n              class=\"option-account-price\"\r\n              [ngClass]=\"{\r\n                'text-ui-red-400': item.value.balanceStatus === 'insufficient',\r\n                'text-ui-green-400': item.value.balanceStatus === 'sufficient'\r\n              }\"\r\n            >\r\n              <span class=\"option-account-value\">{{ item.value.balance.value }},</span>\r\n              <span class=\"option-account-decimal\"><sup>{{ item.value.balance.precision }}</sup></span>\r\n              <span class=\"option-account-currency\">{{ item.value.balance.currency}}</span>\r\n            </div>\r\n\r\n            <div\r\n              class=\"option-account-warning\"\r\n              *ngIf=\"item.value.balanceStatus === 'insufficient'\"\r\n            >\r\n              {{ accWarningMsg }}\r\n            </div>\r\n\r\n          </div>\r\n        </ng-container>\r\n\r\n      </ng-template>\r\n\r\n      <ng-template\r\n        [ngTemplateOutlet]=\"item.children ? optgroupTemplate || defaultOptionTemplate : optionTemplate || defaultOptionTemplate\"\r\n        [ngTemplateOutletContext]=\"{\r\n          item: item.value,\r\n          item$: item,\r\n          index: item.index,\r\n          searchTerm: searchTerm\r\n        }\"\r\n      >\r\n      </ng-template>\r\n    </div>\r\n\r\n    <div\r\n      class=\"sc-option\"\r\n      [class.sc-option-marked]=\"!itemsList.markedItem\"\r\n      (mouseover)=\"itemsList.unmarkItem()\"\r\n      role=\"option\"\r\n      (click)=\"selectTag()\"\r\n      *ngIf=\"showAddTag\"\r\n    >\r\n      <ng-template #defaultTagTemplate>\r\n        <span>\r\n          <span class=\"sc-tag-label\"> {{ addTagText }} </span>\"{{\r\n            searchTerm\r\n          }}\"</span\r\n        >\r\n      </ng-template>\r\n\r\n      <ng-template\r\n        [ngTemplateOutlet]=\"tagTemplate || defaultTagTemplate\"\r\n        [ngTemplateOutletContext]=\"{ searchTerm: searchTerm }\"\r\n      >\r\n      </ng-template>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"showNoItemsFound()\">\r\n    <ng-template #defaultNotFoundTemplate>\r\n      <div class=\"sc-option sc-option-disabled\">{{ notFoundText }}</div>\r\n    </ng-template>\r\n\r\n    <ng-template\r\n      [ngTemplateOutlet]=\"notFoundTemplate || defaultNotFoundTemplate\"\r\n      [ngTemplateOutletContext]=\"{ searchTerm: searchTerm }\"\r\n    >\r\n    </ng-template>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"showTypeToSearch()\">\r\n    <ng-template #defaultTypeToSearchTemplate>\r\n      <div class=\"sc-option sc-option-disabled\">{{ typeToSearchText }}</div>\r\n    </ng-template>\r\n\r\n    <ng-template\r\n      [ngTemplateOutlet]=\"typeToSearchTemplate || defaultTypeToSearchTemplate\"\r\n    >\r\n    </ng-template>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"loading && itemsList.filteredItems.length === 0\">\r\n    <ng-template #defaultLoadingTextTemplate>\r\n      <div class=\"sc-option sc-option-disabled\">{{ loadingText }}</div>\r\n    </ng-template>\r\n\r\n    <ng-template\r\n      [ngTemplateOutlet]=\"loadingTextTemplate || defaultLoadingTextTemplate\"\r\n      [ngTemplateOutletContext]=\"{ searchTerm: searchTerm }\"\r\n    >\r\n    </ng-template>\r\n  </ng-container>\r\n</sc-dropdown-panel>\r\n", styles: ["@charset \"UTF-8\";.sc-select{position:relative;display:block;box-sizing:border-box}.sc-select div,.sc-select input,.sc-select span{box-sizing:border-box}.sc-select [hidden]{display:none}.sc-select.sc-select-searchable .sc-select-container .sc-value-container .sc-input{opacity:1}.sc-select.sc-select-opened .sc-select-container{z-index:1001}.sc-select.sc-select-disabled .sc-select-container .sc-value-container .sc-placeholder,.sc-select.sc-select-disabled .sc-select-container .sc-value-container .sc-value{-webkit-user-select:none;user-select:none;cursor:default}.sc-select.sc-select-disabled .sc-arrow-wrapper{cursor:default}.sc-select.sc-select-filtered .sc-placeholder{display:none}.sc-select .sc-select-container{cursor:default;display:flex;outline:none;overflow:hidden;position:relative;width:100%}.sc-select .sc-select-container .sc-value-container{display:flex;flex:1}.sc-select .sc-select-container .sc-value-container .sc-input{opacity:0}.sc-select .sc-select-container .sc-value-container .sc-input>input{box-sizing:content-box;background:none transparent;border:0 none;box-shadow:none;outline:none;padding:0;cursor:default;width:100%}.sc-select .sc-select-container .sc-value-container .sc-input>input::-ms-clear{display:none}.sc-select .sc-select-container .sc-value-container .sc-input>input[readonly]{-webkit-user-select:none;user-select:none;width:0;padding:0}.sc-select.sc-select-single.sc-select-filtered .sc-select-container .sc-value-container .sc-value{visibility:hidden}.sc-select.sc-select-single .sc-select-container .sc-value-container,.sc-select.sc-select-single .sc-select-container .sc-value-container .sc-value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sc-select.sc-select-single .sc-select-container .sc-value-container .sc-value .sc-value-icon{display:none}.sc-select.sc-select-single .sc-select-container .sc-value-container .sc-input{position:absolute;left:0;width:100%}.sc-select.sc-select-multiple.sc-select-disabled>.sc-select-container .sc-value-container .sc-value .sc-value-icon{display:none}.sc-select.sc-select-multiple .sc-select-container .sc-value-container{flex-wrap:wrap}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-placeholder{position:absolute}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-value{white-space:nowrap}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-value.sc-value-disabled .sc-value-icon{display:none}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-value .sc-value-icon{cursor:pointer}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-input{flex:1;z-index:2}.sc-select.sc-select-multiple .sc-select-container .sc-value-container .sc-placeholder{z-index:1}.sc-select .sc-clear-wrapper{cursor:pointer;position:relative;width:17px;-webkit-user-select:none;user-select:none}.sc-select .sc-clear-wrapper .sc-clear{display:inline-block;font-size:18px;line-height:1;pointer-events:none}.sc-select .sc-spinner-loader{border-radius:50%;width:17px;height:17px;margin-right:5px;font-size:10px;position:relative;text-indent:-9999em;border-top:2px solid rgba(66,66,66,.2);border-right:2px solid rgba(66,66,66,.2);border-bottom:2px solid rgba(66,66,66,.2);border-left:2px solid #424242;transform:translateZ(0);animation:load8 .8s infinite linear}.sc-select .sc-spinner-loader:after{border-radius:50%;width:17px;height:17px}@keyframes load8{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.sc-select .sc-arrow-wrapper{cursor:pointer;position:relative;text-align:center;-webkit-user-select:none;user-select:none}.sc-select .sc-arrow-wrapper .sc-arrow{pointer-events:none;display:inline-block;height:0;width:0;position:relative}.sc-dropdown-panel{box-sizing:border-box;position:absolute;opacity:0;width:100%;z-index:1050;-webkit-overflow-scrolling:touch}.sc-dropdown-panel .sc-dropdown-panel-items{display:block;height:auto;box-sizing:border-box;max-height:240px;overflow-y:auto}.sc-dropdown-panel .sc-dropdown-panel-items .sc-optgroup{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sc-dropdown-panel .sc-dropdown-panel-items .sc-option{box-sizing:border-box;cursor:pointer;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sc-dropdown-panel .sc-dropdown-panel-items .sc-option .sc-option-label:empty:before{content:\"\\200b\"}.sc-dropdown-panel .sc-dropdown-panel-items .sc-option .highlighted{font-weight:700;text-decoration:underline}.sc-dropdown-panel .sc-dropdown-panel-items .sc-option.disabled{cursor:default}.sc-dropdown-panel .scroll-host{overflow:hidden;overflow-y:auto;position:relative;display:block;-webkit-overflow-scrolling:touch}.sc-dropdown-panel .scrollable-content{top:0;left:0;width:100%;height:100%;position:absolute}.sc-dropdown-panel .total-padding{width:1px;opacity:0}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Attribute,
                    args: ['class']
                }] }, { type: undefined, decorators: [{
                    type: Attribute,
                    args: ['autofocus']
                }] }, { type: ScSelectConfig }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SELECTION_MODEL_FACTORY]
                }] }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: ConsoleService }]; }, propDecorators: { dropdownPanel: [{
                type: ViewChild,
                args: [forwardRef(() => ScDropdownPanelComponent)]
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput', { static: true }]
            }], scOptions: [{
                type: ContentChildren,
                args: [ScOptionComponent, { descendants: true }]
            }], blurEvent: [{
                type: Output,
                args: ['blur']
            }], focusEvent: [{
                type: Output,
                args: ['focus']
            }], changeEvent: [{
                type: Output,
                args: ['change']
            }], openEvent: [{
                type: Output,
                args: ['open']
            }], closeEvent: [{
                type: Output,
                args: ['close']
            }], searchEvent: [{
                type: Output,
                args: ['search']
            }], clearEvent: [{
                type: Output,
                args: ['clear']
            }], addEvent: [{
                type: Output,
                args: ['add']
            }], removeEvent: [{
                type: Output,
                args: ['remove']
            }], scroll: [{
                type: Output,
                args: ['scroll']
            }], scrollToEnd: [{
                type: Output,
                args: ['scrollToEnd']
            }], optionTemplate: [{
                type: ContentChild,
                args: [ScOptionTemplateDirective, { read: TemplateRef }]
            }], optgroupTemplate: [{
                type: ContentChild,
                args: [ScOptgroupTemplateDirective, { read: TemplateRef }]
            }], labelTemplate: [{
                type: ContentChild,
                args: [ScLabelTemplateDirective, { read: TemplateRef }]
            }], multiLabelTemplate: [{
                type: ContentChild,
                args: [ScMultiLabelTemplateDirective, { read: TemplateRef }]
            }], headerTemplate: [{
                type: ContentChild,
                args: [ScHeaderTemplateDirective, { read: TemplateRef }]
            }], footerTemplate: [{
                type: ContentChild,
                args: [ScFooterTemplateDirective, { read: TemplateRef }]
            }], notFoundTemplate: [{
                type: ContentChild,
                args: [ScNotFoundTemplateDirective, { read: TemplateRef }]
            }], typeToSearchTemplate: [{
                type: ContentChild,
                args: [ScTypeToSearchTemplateDirective, { read: TemplateRef }]
            }], loadingTextTemplate: [{
                type: ContentChild,
                args: [ScLoadingTextTemplateDirective, { read: TemplateRef }]
            }], tagTemplate: [{
                type: ContentChild,
                args: [ScTagTemplateDirective, { read: TemplateRef }]
            }], loadingSpinnerTemplate: [{
                type: ContentChild,
                args: [ScLoadingSpinnerTemplateDirective, { read: TemplateRef }]
            }], typeahead: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.sc-select-typeahead']
            }], customOptionTemplate: [{
                type: Input
            }], customLabelTemplate: [{
                type: Input
            }], multiple: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.sc-select-multiple']
            }], single: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.sc-select-single']
            }], defaultClass: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.sc-select']
            }], addTag: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.sc-select-taggable']
            }], searchable: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.sc-select-searchable']
            }], clearable: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.sc-select-clearable']
            }], isOpen: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.sc-select-opened']
            }], bindLabel: [{
                type: Input
            }], bindValue: [{
                type: Input
            }], markFirst: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], notFoundText: [{
                type: Input
            }], typeToSearchText: [{
                type: Input
            }], addTagText: [{
                type: Input
            }], loadingText: [{
                type: Input
            }], clearAllText: [{
                type: Input
            }], appearance: [{
                type: Input
            }], dropdownPosition: [{
                type: Input
            }], appendTo: [{
                type: Input
            }], loading: [{
                type: Input
            }], closeOnSelect: [{
                type: Input
            }], hideSelected: [{
                type: Input
            }], selectOnTab: [{
                type: Input
            }], openOnEnter: [{
                type: Input
            }], maxSelectedItems: [{
                type: Input
            }], groupBy: [{
                type: Input
            }], groupValue: [{
                type: Input
            }], bufferAmount: [{
                type: Input
            }], virtualScroll: [{
                type: Input
            }], selectableGroup: [{
                type: Input
            }], selectableGroupAsModel: [{
                type: Input
            }], searchFn: [{
                type: Input
            }], trackByFn: [{
                type: Input
            }], clearOnBackspace: [{
                type: Input
            }], labelForId: [{
                type: Input
            }], inputAttrs: [{
                type: Input
            }], tabIndex: [{
                type: Input
            }], readonly: [{
                type: Input
            }], searchWhileComposing: [{
                type: Input
            }], minTermLength: [{
                type: Input
            }], editableSearchTerm: [{
                type: Input
            }], accWarningMsg: [{
                type: Input
            }], keyDownFn: [{
                type: Input
            }], account: [{
                type: Input
            }], items: [{
                type: Input
            }], compareWith: [{
                type: Input
            }], clearSearchOnAdd: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['class.sc-select-disabled']
            }], filtered: [{
                type: HostBinding,
                args: ['class.sc-select-filtered']
            }], accountClass: [{
                type: HostBinding,
                args: ['class.sc-select-account']
            }], handleKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });
function coerceBooleanProperty(value) {
    return value != null && `${value}` !== 'false';
}

const currencyConfig = {
    align: 'center',
    allowNegative: true,
    allowZero: true,
    decimal: ',',
    precision: 0,
    prefix: '',
    suffix: ' Kč',
    thousands: ' ',
    nullable: true,
};
const ageConfig = {
    align: 'center',
    allowNegative: true,
    allowZero: true,
    decimal: ',',
    precision: 0,
    prefix: '',
    suffix: ' let',
    thousands: ' ',
    nullable: true,
};
const generalConfig = {
    align: 'center',
    allowNegative: true,
    allowZero: true,
    decimal: ',',
    precision: 0,
    prefix: '',
    suffix: '',
    thousands: ' ',
    nullable: true,
};

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
class ScNumericStepperComponent {
    set minValue(value) {
        this._minValue = value;
        this.clampUpdateAndPropagate();
    }
    get minValue() {
        return this._minValue;
    }
    set maxValue(value) {
        this._maxValue = value;
        this.clampUpdateAndPropagate();
    }
    get maxValue() {
        return this._maxValue;
    }
    constructor() {
        this._minValue = 0;
        this._maxValue = 9999999999;
        this.value = 0;
        this.touched = false;
        this.disabled = false;
        this.stepperType = 'general';
        this.maskConfig = generalConfig;
        this.intervalConfig = {
            intervals: [
                {
                    min: -9999999999,
                    max: 9999999999,
                    step: 1,
                },
            ],
            defaultStep: 1,
        };
        this.plusBtnClicked = new EventEmitter();
        this.minusBtnClicked = new EventEmitter();
        this.inputFocusOut = new EventEmitter();
        this.step = 1;
        this.stepDownEnabled = true;
        this.stepUpEnabled = true;
        this.configs = {
            age: ageConfig,
            currency: currencyConfig,
            general: generalConfig,
        };
        this.onChange = (_value) => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
        if (this.stepperType != 'custom') {
            this.maskConfig = this.configs[this.stepperType];
        }
        this.updateCurrentStep();
        this.updateStepButtons();
        this.updateSuffixWording();
    }
    handleKeyEvents($event) {
        switch ($event.code) {
            case 'ArrowUp':
                $event.preventDefault();
                this.updateValue(1);
                break;
            case 'ArrowDown':
                $event.preventDefault();
                this.updateValue(-1);
                break;
        }
    }
    updateValue($direction = 1) {
        if (this.disabled) {
            return;
        }
        if (($direction === 1 && !this.stepUpEnabled) || ($direction === -1 && !this.stepDownEnabled)) {
            return;
        }
        this.updateCurrentStep($direction);
        const newValue = this.clampValue(this.value + this.step * $direction);
        this.value = newValue;
        this.clampUpdateAndPropagate();
    }
    emitInputFocusOut() {
        this.clampUpdateAndPropagate();
        this.inputFocusOut.emit();
    }
    plusButtonClicked() {
        if (!this.stepUpEnabled) {
            return;
        }
        if (this.disabled) {
            return;
        }
        this.markAsTouched();
        this.updateValue(1);
        this.plusBtnClicked.emit();
    }
    minusButtonClicked() {
        if (!this.stepDownEnabled) {
            return;
        }
        if (this.disabled) {
            return;
        }
        this.markAsTouched();
        this.updateValue(-1);
        this.minusBtnClicked.emit();
    }
    onEnter() {
        this.markAsTouched();
        this.clampUpdateAndPropagate();
    }
    clampUpdateAndPropagate() {
        const newValue = this.clampValue(this.value);
        this.value = newValue;
        this.onChange(this.value);
        this.updateStepButtons();
        this.updateSuffixWording();
    }
    clampValue(newValue) {
        if (this._minValue !== null) {
            if (newValue < this._minValue) {
                newValue = this._minValue;
            }
        }
        if (this._maxValue !== null) {
            if (newValue > this._maxValue) {
                newValue = this._maxValue;
            }
        }
        return newValue;
    }
    updateCurrentStep($direction = 1) {
        const filtered = this.intervalConfig.intervals.filter((item) => {
            if ($direction === 1) {
                return item.max > this.value && item.min <= this.value;
            }
            else {
                return item.max >= this.value && item.min < this.value;
            }
        });
        if (filtered.length === 1) {
            this.step = filtered[0].step;
        }
        else if (this.intervalConfig.defaultStep) {
            this.step = this.intervalConfig.defaultStep;
        }
        else {
            this.step = 1;
        }
    }
    updateStepButtons() {
        if (this._minValue !== null) {
            this.stepDownEnabled = this.value > this._minValue;
        }
        if (this._maxValue !== null) {
            this.stepUpEnabled = this.value < this._maxValue;
        }
    }
    updateSuffixWording() {
        if (this.stepperType === 'age') {
            let suffix = ' let';
            if (this.value === 1) {
                suffix = ' rok';
            }
            if (this.value >= 2 && this.value <= 4) {
                suffix = ' roky';
            }
            this.configs['age'].suffix = suffix;
        }
    }
    writeValue(value) {
        this.value = value;
        this.clampUpdateAndPropagate();
    }
    registerOnChange(onChange) {
        this.onChange = onChange;
    }
    registerOnTouched(onTouched) {
        this.onTouched = onTouched;
    }
    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
}
ScNumericStepperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScNumericStepperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScNumericStepperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScNumericStepperComponent, isStandalone: true, selector: "sc-numeric-stepper", inputs: { id: "id", minValue: "minValue", maxValue: "maxValue", stepperType: "stepperType", maskConfig: "maskConfig", intervalConfig: "intervalConfig" }, outputs: { plusBtnClicked: "plusBtnClicked", minusBtnClicked: "minusBtnClicked", inputFocusOut: "inputFocusOut" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScNumericStepperComponent),
            multi: true,
        },
    ], ngImport: i0, template: "<div class=\"sc-numeric-stepper\">\n  <button sc-icon-button mode=\"secondary\" icon=\"ico-minus\" iconSize=\"24\" (click)=\"minusButtonClicked()\" tabindex=\"-1\" [disabled]=\"!stepDownEnabled\"></button>\n  <input\n    type=\"tel\"\n    class=\"sc-input\"\n    [(ngModel)]=\"value\"\n    (keydown)=\"handleKeyEvents($event)\"\n    (focusout)=\"emitInputFocusOut()\"\n    (keyup.enter)=\"onEnter()\"\n    [options]=\"maskConfig\"\n    currencyMask\n    inputmode=\"numeric\"\n  />\n  <button sc-icon-button mode=\"secondary\" icon=\"ico-plus\" iconSize=\"24\" (click)=\"plusButtonClicked()\" tabindex=\"-1\" [disabled]=\"!stepUpEnabled\"></button>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: ScButtonComponent, selector: "button[sc-button], button[sc-icon-button]", inputs: ["disabled", "size", "active", "mode", "iconPlacement", "iconSize", "icon", "inverted"] }, { kind: "ngmodule", type: NgxCurrencyModule }, { kind: "directive", type: i1$1.CurrencyMaskDirective, selector: "[currencyMask]", inputs: ["options"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScNumericStepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-numeric-stepper', standalone: true, imports: [CommonModule, ScButtonComponent, NgxCurrencyModule, FormsModule], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ScNumericStepperComponent),
                            multi: true,
                        },
                    ], template: "<div class=\"sc-numeric-stepper\">\n  <button sc-icon-button mode=\"secondary\" icon=\"ico-minus\" iconSize=\"24\" (click)=\"minusButtonClicked()\" tabindex=\"-1\" [disabled]=\"!stepDownEnabled\"></button>\n  <input\n    type=\"tel\"\n    class=\"sc-input\"\n    [(ngModel)]=\"value\"\n    (keydown)=\"handleKeyEvents($event)\"\n    (focusout)=\"emitInputFocusOut()\"\n    (keyup.enter)=\"onEnter()\"\n    [options]=\"maskConfig\"\n    currencyMask\n    inputmode=\"numeric\"\n  />\n  <button sc-icon-button mode=\"secondary\" icon=\"ico-plus\" iconSize=\"24\" (click)=\"plusButtonClicked()\" tabindex=\"-1\" [disabled]=\"!stepUpEnabled\"></button>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { id: [{
                type: Input
            }], minValue: [{
                type: Input
            }], maxValue: [{
                type: Input
            }], stepperType: [{
                type: Input
            }], maskConfig: [{
                type: Input
            }], intervalConfig: [{
                type: Input
            }], plusBtnClicked: [{
                type: Output
            }], minusBtnClicked: [{
                type: Output
            }], inputFocusOut: [{
                type: Output
            }] } });

class ScTextLinkComponent {
    constructor() {
        this.iconPlacement = 'right';
        this.target = '_self';
        this.linkClick = new EventEmitter();
        this.inlineClass = 'inline-block';
    }
    linkClicked() {
        this.linkClick.emit();
        return Boolean(this.href);
    }
}
ScTextLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTextLinkComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScTextLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScTextLinkComponent, isStandalone: true, selector: "sc-text-link", inputs: { iconPlacement: "iconPlacement", icon: "icon", target: "target", href: "href" }, outputs: { linkClick: "linkClick" }, host: { properties: { "class.inline-block": "this.inlineClass" } }, ngImport: i0, template: "<a\n  class=\"sc-text-link\"\n  [target]=\"target\"\n  [href]=\"href ?? '#'\"\n  [ngClass]=\"{\n    'icon-left': iconPlacement === 'left',\n    'icon-right': iconPlacement === 'right'\n  }\"\n  (click)=\"linkClicked()\"\n>\n  <span class=\"sc-text-link-label\">\n    <ng-content></ng-content>\n  </span>\n  <ng-container *ngIf=\"icon\">\n    <svg sc-icon [icon]=\"icon\" [size]=\"20\"></svg>\n  </ng-container>\n</a>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTextLinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-text-link', standalone: true, imports: [CommonModule, ScIconModule], template: "<a\n  class=\"sc-text-link\"\n  [target]=\"target\"\n  [href]=\"href ?? '#'\"\n  [ngClass]=\"{\n    'icon-left': iconPlacement === 'left',\n    'icon-right': iconPlacement === 'right'\n  }\"\n  (click)=\"linkClicked()\"\n>\n  <span class=\"sc-text-link-label\">\n    <ng-content></ng-content>\n  </span>\n  <ng-container *ngIf=\"icon\">\n    <svg sc-icon [icon]=\"icon\" [size]=\"20\"></svg>\n  </ng-container>\n</a>\n" }]
        }], propDecorators: { iconPlacement: [{
                type: Input
            }], icon: [{
                type: Input
            }], target: [{
                type: Input
            }], href: [{
                type: Input
            }], linkClick: [{
                type: Output
            }], inlineClass: [{
                type: HostBinding,
                args: ['class.inline-block']
            }] } });

class ToggleSelectionModel {
    get selected() {
        if (!this._selected) {
            this._selected = Array.from(this._selection.values());
        }
        return this._selected;
    }
    constructor(_multiple = false, initiallySelectedValues, _emitChanges = true) {
        this._multiple = _multiple;
        this._emitChanges = _emitChanges;
        this._selection = new Set();
        this._deselectedToEmit = [];
        this._selectedToEmit = [];
        this.changed = new Subject();
        if (initiallySelectedValues && initiallySelectedValues.length) {
            if (_multiple) {
                initiallySelectedValues.forEach((value) => this._markSelected(value));
            }
            else {
                this._markSelected(initiallySelectedValues[0]);
            }
            this._selectedToEmit.length = 0;
        }
    }
    select(...values) {
        values.forEach((value) => this._markSelected(value));
        this._emitChangeEvent();
    }
    deselect(...values) {
        values.forEach((value) => this._unmarkSelected(value));
        this._emitChangeEvent();
    }
    toggle(value) {
        this.isSelected(value) ? this.deselect(value) : this.select(value);
    }
    clear() {
        this._unmarkAll();
        this._emitChangeEvent();
    }
    isSelected(value) {
        return this._selection.has(value);
    }
    isEmpty() {
        return this._selection.size === 0;
    }
    hasValue() {
        return !this.isEmpty();
    }
    sort(predicate) {
        if (this._multiple && this.selected) {
            this._selected?.sort(predicate);
        }
    }
    isMultipleSelection() {
        return this._multiple;
    }
    _emitChangeEvent() {
        this._selected = undefined;
        if (this._selectedToEmit.length || this._deselectedToEmit.length) {
            this.changed.next({
                source: this,
                added: this._selectedToEmit,
                removed: this._deselectedToEmit,
            });
            this._deselectedToEmit = [];
            this._selectedToEmit = [];
        }
    }
    _markSelected(value) {
        if (!this.isSelected(value)) {
            if (!this._multiple) {
                this._unmarkAll();
            }
            this._selection.add(value);
            if (this._emitChanges) {
                this._selectedToEmit.push(value);
            }
        }
    }
    _unmarkSelected(value) {
        if (this.isSelected(value)) {
            this._selection.delete(value);
            if (this._emitChanges) {
                this._deselectedToEmit.push(value);
            }
        }
    }
    _unmarkAll() {
        if (!this.isEmpty()) {
            this._selection.forEach((value) => this._unmarkSelected(value));
        }
    }
}

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @angular-eslint/directive-class-suffix */
const SC_TOGGLE_GROUP = new InjectionToken('ScToggleGroup');
const SC_TOGGLE_GROUP_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ScToggleGroup),
    multi: true,
};
let uniqueIdCounter = 0;
class ScToggleGroup {
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
        if (this._buttonToggles) {
            this._buttonToggles.forEach((toggle) => {
                toggle.name = this._name;
                toggle._markForCheck();
            });
        }
    }
    get value() {
        const selected = this._selectionModel ? this._selectionModel.selected : [];
        return selected[0]?.value;
    }
    set value(newValue) {
        this._setSelectionByValue(newValue);
        this.selectedChange.emit(this.value);
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value;
    }
    get separatedClass() {
        return this.separated;
    }
    get directionHorizontalClass() {
        return this.mode === 'horizontal';
    }
    get directionVerticalClass() {
        return this.mode === 'vertical';
    }
    get selected() {
        const selected = this._selectionModel ? this._selectionModel.selected : [];
        return selected[0] || null;
    }
    constructor(_changeDetector) {
        this._changeDetector = _changeDetector;
        this._disabled = false;
        this.mode = 'horizontal';
        this.separated = true;
        this._name = `sc-toggle-group-${uniqueIdCounter++}`;
        this.selectedChange = new EventEmitter();
        this.mainClass = 'sc-toggle-group';
        this.role = 'group';
        this._controlValueAccessorChangeFn = () => { };
        this._onTouched = () => { };
        this._selectionModel = new ToggleSelectionModel(false, undefined, false);
    }
    ngAfterContentInit() {
        if (!this._buttonToggles) {
            return;
        }
        this._selectionModel?.select(...this._buttonToggles.filter((toggle) => toggle.checked));
    }
    // Implemented as part of ControlValueAccessor.
    writeValue(value) {
        this.value = value;
        this._changeDetector.markForCheck();
    }
    // Implemented as part of ControlValueAccessor.
    registerOnChange(fn) {
        this._controlValueAccessorChangeFn = fn;
    }
    // Implemented as part of ControlValueAccessor.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    // Implemented as part of ControlValueAccessor.
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    _emitChangeEvent() {
        this._controlValueAccessorChangeFn(this.value);
        this.selectedChange.emit(this.value);
    }
    _isSelected(toggle) {
        return this._selectionModel.isSelected(toggle);
    }
    /** Determines whether a button toggle should be checked on init. */
    _isPrechecked(toggle) {
        if (typeof this._rawValue === 'undefined') {
            return false;
        }
        return toggle.value === this._rawValue;
    }
    _syncButtonToggle(toggle, select, isUserInput = false, deferEvents = false) {
        if (this.selected && !toggle.checked) {
            this.selected.checked = false;
        }
        if (this._selectionModel) {
            if (select) {
                this._selectionModel.select(toggle);
            }
            else {
                this._selectionModel.deselect(toggle);
            }
        }
        else {
            deferEvents = true;
        }
        if (deferEvents) {
            Promise.resolve().then(() => this._updateModelValue(isUserInput));
        }
        else {
            this._updateModelValue(isUserInput);
        }
    }
    _setSelectionByValue(value) {
        this._rawValue = value;
        if (!this._buttonToggles) {
            return;
        }
        this._clearSelection();
        this._selectValue(value);
    }
    _clearSelection() {
        this._selectionModel?.clear();
        this._buttonToggles?.forEach((toggle) => (toggle.checked = false));
    }
    _selectValue(value) {
        const correspondingOption = this._buttonToggles?.find((toggle) => {
            return toggle.value != null && toggle.value === value;
        });
        if (correspondingOption) {
            correspondingOption.checked = true;
            this._selectionModel?.select(correspondingOption);
        }
    }
    _updateModelValue(isUserInput) {
        if (isUserInput) {
            this._emitChangeEvent();
        }
    }
}
ScToggleGroup.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScToggleGroup, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
ScToggleGroup.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScToggleGroup, isStandalone: true, selector: "sc-toggle-group", inputs: { mode: "mode", separated: "separated", name: "name", value: "value", disabled: "disabled" }, outputs: { selectedChange: "selectedChange" }, host: { properties: { "class.sc-toggle-group-disabled": "this._disabled", "class.sc-toggle-group": "this.mainClass", "class.sc-toggle-group-separated": "this.separatedClass", "class.sc-toggle-group-horizontal": "this.directionHorizontalClass", "class.sc-toggle-group-vertical": "this.directionVerticalClass", "attr.role": "this.role" } }, providers: [SC_TOGGLE_GROUP_VALUE_ACCESSOR, { provide: SC_TOGGLE_GROUP, useExisting: ScToggleGroup }], queries: [{ propertyName: "_buttonToggles", predicate: i0.forwardRef(function () { return ScToggleComponent; }), descendants: true }], exportAs: ["scToggleGroup"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScToggleGroup, decorators: [{
            type: Directive,
            args: [{
                    selector: 'sc-toggle-group',
                    exportAs: 'scToggleGroup',
                    standalone: true,
                    providers: [SC_TOGGLE_GROUP_VALUE_ACCESSOR, { provide: SC_TOGGLE_GROUP, useExisting: ScToggleGroup }],
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { _disabled: [{
                type: HostBinding,
                args: ['class.sc-toggle-group-disabled']
            }], mode: [{
                type: Input
            }], separated: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], mainClass: [{
                type: HostBinding,
                args: ['class.sc-toggle-group']
            }], separatedClass: [{
                type: HostBinding,
                args: ['class.sc-toggle-group-separated']
            }], directionHorizontalClass: [{
                type: HostBinding,
                args: ['class.sc-toggle-group-horizontal']
            }], directionVerticalClass: [{
                type: HostBinding,
                args: ['class.sc-toggle-group-vertical']
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], _buttonToggles: [{
                type: ContentChildren,
                args: [forwardRef(() => ScToggleComponent), {
                        descendants: true,
                    }]
            }] } });
class ScToggleComponent {
    get buttonId() {
        return `${this.id}-button`;
    }
    get checked() {
        return this.buttonToggleGroup ? this.buttonToggleGroup._isSelected(this) : this._checked;
    }
    set checked(value) {
        const newValue = value;
        if (newValue !== this._checked) {
            this._checked = newValue;
            if (this.buttonToggleGroup) {
                this.buttonToggleGroup._syncButtonToggle(this, this._checked);
            }
            this._changeDetectorRef.markForCheck();
        }
    }
    get disabled() {
        return this._disabled || (this.buttonToggleGroup && this.buttonToggleGroup.disabled);
    }
    set disabled(value) {
        this._disabled = value;
    }
    constructor(_changeDetectorRef, toggleGroup) {
        this._changeDetectorRef = _changeDetectorRef;
        this._checked = false;
        this._disabled = false;
        this._focused = false;
        this._active = false;
        this._isSingleSelector = false;
        this.mode = 'icon';
        // prepared for checkbox style but not implemented, due to component funcionality mistmach.
        // Toggles should not work like checkmarks, etc. Need to be solved better way
        this.mark = 'radio';
        this.label = 'label';
        this.toggleChange = new EventEmitter();
        this.mainClass = 'sc-toggle';
        this.buttonToggleGroup = toggleGroup;
    }
    get checkedClass() {
        return this.checked ? 'sc-toggle-checked' : null;
    }
    get disabledClass() {
        return this.disabled;
    }
    get focusClass() {
        return this._focused;
    }
    get activeClass() {
        return this._active;
    }
    get toggleId() {
        return this.id;
    }
    ngOnInit() {
        const group = this.buttonToggleGroup;
        this._isSingleSelector = !!group;
        this.id = this.id || `sc-button-toggle-${uniqueIdCounter++}`;
        if (this._isSingleSelector) {
            this.name = group.name;
        }
        if (group) {
            if (group._isPrechecked(this)) {
                this.checked = true;
            }
            else if (group._isSelected(this) !== this._checked) {
                group._syncButtonToggle(this, this._checked);
            }
        }
    }
    onButtonClick() {
        const newChecked = this._isSingleSelector ? true : !this._checked;
        if (newChecked !== this._checked) {
            this._checked = newChecked;
            if (this.buttonToggleGroup) {
                this.buttonToggleGroup._syncButtonToggle(this, this._checked, true);
                this.buttonToggleGroup._onTouched();
            }
        }
        this.toggleChange.emit(this.value);
    }
    onFocus() {
        this._focused = true;
    }
    onBlur() {
        this._focused = false;
    }
    _markForCheck() {
        this._changeDetectorRef.markForCheck();
    }
}
ScToggleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScToggleComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: SC_TOGGLE_GROUP, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ScToggleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScToggleComponent, isStandalone: true, selector: "sc-toggle", inputs: { mode: "mode", id: "id", name: "name", value: "value", icon: "icon", description: "description", label: "label", imageSrc: "imageSrc", checked: "checked", disabled: "disabled" }, outputs: { toggleChange: "toggleChange" }, host: { properties: { "class.sc-toggle": "this.mainClass", "class.sc-toggle-checked": "this.checkedClass", "class.sc-toggle-disabled": "this.disabledClass", "class.sc-toggle-focus": "this.focusClass", "class.sc-toggle-active": "this.activeClass", "attr.id": "this.toggleId" } }, viewQueries: [{ propertyName: "buttonElement", first: true, predicate: ["button"], descendants: true }], ngImport: i0, template: "<button\n  #button\n  sc-button\n  mode=\"secondary\"\n  class=\"sc-button-toggle\"\n  type=\"button\"\n  [id]=\"buttonId\"\n  [disabled]=\"disabled || false\"\n  [attr.name]=\"name || null\"\n  [attr.aria-pressed]=\"checked\"\n  (click)=\"onButtonClick()\"\n  (focus)=\"onFocus()\"\n  (blur)=\"onBlur()\"\n  [icon]=\"icon || null\"\n>\n\n  <ng-container *ngIf=\"mode==='image' && imageSrc\">\n    <div class=\"sc-button-toggle-image\">\n      <img [src]=\"imageSrc\" />\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"label\">\n    <div class=\"sc-toggle-label\">\n      {{label}}\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"description\">\n    <div class=\"sc-toggle-description\">{{description}}</div>\n  </ng-container>\n\n  <div class=\"sc-button-toggle-box\"\n    [ngClass]=\"{\n      'sc-button-toggle-box': true,\n      'sc-button-toggle-box-radio': mark === 'radio'\n    }\">\n    <ng-container *ngIf=\"mark === 'checkbox'\">\n      <div class=\"sc-checkbox-icon\"></div>\n    </ng-container>\n  </div>\n\n</button>\n\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ScButtonComponent, selector: "button[sc-button], button[sc-icon-button]", inputs: ["disabled", "size", "active", "mode", "iconPlacement", "iconSize", "icon", "inverted"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-toggle', standalone: true, imports: [CommonModule, ScButtonComponent], template: "<button\n  #button\n  sc-button\n  mode=\"secondary\"\n  class=\"sc-button-toggle\"\n  type=\"button\"\n  [id]=\"buttonId\"\n  [disabled]=\"disabled || false\"\n  [attr.name]=\"name || null\"\n  [attr.aria-pressed]=\"checked\"\n  (click)=\"onButtonClick()\"\n  (focus)=\"onFocus()\"\n  (blur)=\"onBlur()\"\n  [icon]=\"icon || null\"\n>\n\n  <ng-container *ngIf=\"mode==='image' && imageSrc\">\n    <div class=\"sc-button-toggle-image\">\n      <img [src]=\"imageSrc\" />\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"label\">\n    <div class=\"sc-toggle-label\">\n      {{label}}\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"description\">\n    <div class=\"sc-toggle-description\">{{description}}</div>\n  </ng-container>\n\n  <div class=\"sc-button-toggle-box\"\n    [ngClass]=\"{\n      'sc-button-toggle-box': true,\n      'sc-button-toggle-box-radio': mark === 'radio'\n    }\">\n    <ng-container *ngIf=\"mark === 'checkbox'\">\n      <div class=\"sc-checkbox-icon\"></div>\n    </ng-container>\n  </div>\n\n</button>\n\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: ScToggleGroup, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [SC_TOGGLE_GROUP]
                }] }]; }, propDecorators: { mode: [{
                type: Input
            }], id: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], icon: [{
                type: Input
            }], description: [{
                type: Input
            }], label: [{
                type: Input
            }], imageSrc: [{
                type: Input
            }], checked: [{
                type: Input
            }], disabled: [{
                type: Input
            }], toggleChange: [{
                type: Output
            }], buttonElement: [{
                type: ViewChild,
                args: ['button']
            }], mainClass: [{
                type: HostBinding,
                args: ['class.sc-toggle']
            }], checkedClass: [{
                type: HostBinding,
                args: ['class.sc-toggle-checked']
            }], disabledClass: [{
                type: HostBinding,
                args: ['class.sc-toggle-disabled']
            }], focusClass: [{
                type: HostBinding,
                args: ['class.sc-toggle-focus']
            }], activeClass: [{
                type: HostBinding,
                args: ['class.sc-toggle-active']
            }], toggleId: [{
                type: HostBinding,
                args: ['attr.id']
            }] } });

/** Default values provider for tooltip */
class TooltipConfig {
    constructor() {
        /** sets disable adaptive position */
        this.adaptivePosition = true;
        /** tooltip placement, supported positions: 'top', 'bottom', 'left', 'right' */
        this.placement = 'top';
        /** array of event names which triggers tooltip opening */
        this.triggers = 'hover focus';
        /** delay before showing the tooltip */
        this.delay = 0;
    }
}
TooltipConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TooltipConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TooltipConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TooltipConfig, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: TooltipConfig, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ScTooltipComponent {
    get customContainerClass() {
        return this.containerClass;
    }
    get topClass() {
        return this.placement === 'top';
    }
    get bottomClass() {
        return this.placement === 'bottom';
    }
    get attrId() {
        return this.id;
    }
    constructor(config) {
        this.mainClass = 'sc-tooltip';
        this.role = 'tooltip';
        Object.assign(this, config);
    }
}
ScTooltipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTooltipComponent, deps: [{ token: TooltipConfig }], target: i0.ɵɵFactoryTarget.Component });
ScTooltipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScTooltipComponent, isStandalone: true, selector: "sc-tooltip", host: { properties: { "class.sc-tooltip": "this.mainClass", "class": "this.customContainerClass", "class.sc-tooltip-top": "this.topClass", "class.sc-tooltip-bottom": "this.bottomClass", "role": "this.role", "attr.id": "this.attrId" } }, ngImport: i0, template: `
    <div class="sc-tooltip-arrow"></div>
    <div class="sc-tooltip-inner">
      <ng-content></ng-content>
    </div>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTooltipComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-tooltip',
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: `
    <div class="sc-tooltip-arrow"></div>
    <div class="sc-tooltip-inner">
      <ng-content></ng-content>
    </div>
  `,
                }]
        }], ctorParameters: function () { return [{ type: TooltipConfig }]; }, propDecorators: { mainClass: [{
                type: HostBinding,
                args: ['class.sc-tooltip']
            }], customContainerClass: [{
                type: HostBinding,
                args: ['class']
            }], topClass: [{
                type: HostBinding,
                args: ['class.sc-tooltip-top']
            }], bottomClass: [{
                type: HostBinding,
                args: ['class.sc-tooltip-bottom']
            }], role: [{
                type: HostBinding,
                args: ['role']
            }], attrId: [{
                type: HostBinding,
                args: ['attr.id']
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
function OnChange() {
    const sufix = 'Change';
    return function OnChangeHandler(target, propertyKey) {
        const _key = ` __${propertyKey}Value`;
        Object.defineProperty(target, propertyKey, {
            get() {
                return this[_key];
            },
            set(value) {
                const prevValue = this[_key];
                this[_key] = value;
                if (prevValue !== value && this[propertyKey + sufix]) {
                    this[propertyKey + sufix].emit(value);
                }
            }
        });
    };
}

class Trigger {
    constructor(open, close) {
        this.open = open;
        this.close = close || open;
    }
    isManual() {
        return this.open === 'manual' || this.close === 'manual';
    }
}

const DEFAULT_ALIASES = {
    hover: ['mouseover', 'mouseout'],
    focus: ['focusin', 'focusout'],
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseTriggers(triggers, aliases = DEFAULT_ALIASES) {
    const trimmedTriggers = (triggers || '').trim();
    if (trimmedTriggers.length === 0) {
        return [];
    }
    const parsedTriggers = trimmedTriggers
        .split(/\s+/)
        .map((trigger) => trigger.split(':'))
        .map((triggerPair) => {
        const alias = aliases[triggerPair[0]] || triggerPair;
        return new Trigger(alias[0], alias[1]);
    });
    const manualTriggers = parsedTriggers.filter((triggerPair) => triggerPair.isManual());
    if (manualTriggers.length > 1) {
        throw new Error('Triggers parse error: only one manual trigger is allowed');
    }
    if (manualTriggers.length === 1 && parsedTriggers.length > 1) {
        throw new Error("Triggers parse error: manual trigger can't be mixed with other triggers");
    }
    return parsedTriggers;
}
function listenToTriggers(renderer, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
target, triggers, showFn, hideFn, toggleFn) {
    const parsedTriggers = parseTriggers(triggers);
    const listeners = [];
    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
        return Function.prototype;
    }
    parsedTriggers.forEach((trigger) => {
        if (trigger.open === trigger.close) {
            listeners.push(renderer.listen(target, trigger.open, toggleFn));
            return;
        }
        listeners.push(renderer.listen(target, trigger.open, showFn));
        if (trigger.close) {
            listeners.push(renderer.listen(target, trigger.close, hideFn));
        }
    });
    return () => {
        listeners.forEach((unsubscribeFn) => unsubscribeFn());
    };
}
function listenToTriggersV2(renderer, options) {
    const parsedTriggers = parseTriggers(options.triggers);
    const target = options.target;
    // do nothing
    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
        return Function.prototype;
    }
    // all listeners
    const listeners = [];
    // lazy listeners registration
    const _registerHide = [];
    const registerHide = () => {
        // add hide listeners to unregister array
        _registerHide.forEach((fn) => listeners.push(fn()));
        // register hide events only once
        _registerHide.length = 0;
    };
    // register open\close\toggle listeners
    parsedTriggers.forEach((trigger) => {
        const useToggle = trigger.open === trigger.close;
        const showFn = useToggle ? options.toggle : options.show;
        if (!useToggle && trigger.close && options.hide) {
            const _hide = renderer.listen(target, trigger.close, options.hide);
            _registerHide.push(() => _hide);
        }
        if (showFn) {
            listeners.push(renderer.listen(target, trigger.open, () => showFn(registerHide)));
        }
    });
    return () => {
        listeners.forEach((unsubscribeFn) => unsubscribeFn());
    };
}
function registerOutsideClick(renderer, options) {
    if (!options.outsideClick) {
        return Function.prototype;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return renderer.listen('document', 'click', (event) => {
        if (options.target && options.target.contains(event.target)) {
            return;
        }
        if (options.targets && options.targets.some((target) => target.contains(event.target))) {
            return;
        }
        if (options.hide) {
            options.hide();
        }
    });
}
function registerEscClick(renderer, options) {
    if (!options.outsideEsc) {
        return Function.prototype;
    }
    return renderer.listen('document', 'keyup.esc', (event) => {
        if (options.target && options.target.contains(event.target)) {
            return;
        }
        if (options.targets && options.targets.some((target) => target.contains(event.target))) {
            return;
        }
        if (options.hide) {
            options.hide();
        }
    });
}

function getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) {
        return [];
    }
    // NOTE: 1 DOM access here
    const window = element.ownerDocument.defaultView;
    const css = window?.getComputedStyle(element, null);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return property ? css && css[property] : css;
}

/**
 * Returns the offset parent of the given element
 */
function getOffsetParent(element) {
    if (!element) {
        return document.documentElement;
    }
    const noOffsetParent = null;
    // NOTE: 1 DOM access here
    let offsetParent = element?.offsetParent;
    // Skip hidden elements which don't have an offsetParent
    let sibling = void 0;
    while (offsetParent === noOffsetParent
        && element.nextElementSibling
        && sibling !== element.nextElementSibling) {
        // todo: valorkin fix
        sibling = element.nextElementSibling;
        offsetParent = sibling.offsetParent;
    }
    const nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
        return sibling ? sibling.ownerDocument.documentElement : document.documentElement;
    }
    // .offsetParent will return the closest TH, TD or TABLE in case
    if (offsetParent &&
        ['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 &&
        getStyleComputedProperty(offsetParent, 'position') === 'static') {
        return getOffsetParent(offsetParent);
    }
    return offsetParent;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isOffsetContainer(element) {
    const { nodeName } = element;
    if (nodeName === 'BODY') {
        return false;
    }
    return (nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element);
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 */
function getRoot(node) {
    if (node.parentNode !== null) {
        return getRoot(node.parentNode);
    }
    return node;
}

function findCommonOffsetParent(element1, element2) {
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
        return document.documentElement;
    }
    const order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    const start = order ? element1 : element2;
    const end = order ? element2 : element1;
    const range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    const commonAncestorContainer = range.commonAncestorContainer;
    if ((element1 !== commonAncestorContainer && element2 !== commonAncestorContainer) || start.contains(end)) {
        if (isOffsetContainer(commonAncestorContainer)) {
            return commonAncestorContainer;
        }
        return getOffsetParent(commonAncestorContainer);
    }
    const element1root = getRoot(element1);
    if (element1root.host) {
        return findCommonOffsetParent(element1root.host, element2);
    }
    else {
        return findCommonOffsetParent(element1, getRoot(element2).host);
    }
}

/**
 * Finds the first parent of an element that has a transformed property defined
 */
function getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement) {
        return document.documentElement;
    }
    let el = element.parentElement;
    while (el?.parentElement && getStyleComputedProperty(el, 'transform') === 'none') {
        el = el.parentElement;
    }
    return el || document.documentElement;
}

/**
 * Helper to detect borders of a given element
 */
function getBordersSize(styles, axis) {
    const sideA = axis === 'x' ? 'Left' : 'Top';
    const sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return (parseFloat(styles[`border${sideA}Width`]) +
        parseFloat(styles[`border${sideB}Width`]));
}

/* eslint-disable @typescript-eslint/no-unused-vars */
function getSize(axis, body, html, computedStyle) {
    const _body = body;
    const _html = html;
    const _computedStyle = computedStyle;
    return Math.max(_body[`offset${axis}`], _body[`scroll${axis}`], _html[`client${axis}`], _html[`offset${axis}`], _html[`scroll${axis}`], 0);
}
function getWindowSizes(document) {
    const body = document.body;
    const html = document.documentElement;
    const computedStyle = void 0;
    return {
        height: getSize('Height', body, html, computedStyle),
        width: getSize('Width', body, html, computedStyle),
    };
}

function getClientRect(offsets) {
    return {
        ...offsets,
        right: (offsets.left || 0) + offsets.width,
        bottom: (offsets.top || 0) + offsets.height
    };
}

/**
 * Tells if a given input is a number
 */
function isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(Number(n));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isNumber(value) {
    return typeof value === 'number' || Object.prototype.toString.call(value) === '[object Number]';
}

/**
 * Get bounding client rect of given element
 */
function getBoundingClientRect(element) {
    const rect = element.getBoundingClientRect();
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    // try {
    //   if (isIE(10)) {
    //     const scrollTop = getScroll(element, 'top');
    //     const scrollLeft = getScroll(element, 'left');
    //     if (rect && isNumber(rect.top) && isNumber(rect.left) && isNumber(rect.bottom) && isNumber(rect.right)) {
    //       rect.top += scrollTop;
    //       rect.left += scrollLeft;
    //       rect.bottom += scrollTop;
    //       rect.right += scrollLeft;
    //     }
    //   }
    // } catch (e) {
    //   return rect;
    // }
    if (!(rect && isNumber(rect.top) && isNumber(rect.left) && isNumber(rect.bottom) && isNumber(rect.right))) {
        return rect;
    }
    const result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    const sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : undefined;
    const width = sizes?.width || element.clientWidth
        || isNumber(rect.right) && isNumber(result.left) && rect.right - result.left || 0;
    const height = sizes?.height || element.clientHeight
        || isNumber(rect.bottom) && isNumber(result.top) && rect.bottom - result.top || 0;
    let horizScrollbar = element.offsetWidth - width;
    let vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        const styles = getStyleComputedProperty(element);
        horizScrollbar -= getBordersSize(styles, 'x');
        vertScrollbar -= getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent, fixedPosition = false) {
    const isHTML = parent.nodeName === 'HTML';
    const childrenRect = getBoundingClientRect(children);
    const parentRect = getBoundingClientRect(parent);
    const styles = getStyleComputedProperty(parent);
    const borderTopWidth = parseFloat(styles.borderTopWidth);
    const borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top ?? 0, 0);
        parentRect.left = Math.max(parentRect.left ?? 0, 0);
    }
    const offsets = getClientRect({
        top: (childrenRect.top ?? 0) - (parentRect.top ?? 0) - borderTopWidth,
        left: (childrenRect.left ?? 0) - (parentRect.left ?? 0) - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (isHTML) {
        const marginTop = parseFloat(styles.marginTop);
        const marginLeft = parseFloat(styles.marginLeft);
        if (isNumber(offsets.top)) {
            offsets.top -= borderTopWidth - marginTop;
        }
        if (isNumber(offsets.bottom)) {
            offsets.bottom -= borderTopWidth - marginTop;
        }
        if (isNumber(offsets.left)) {
            offsets.left -= borderLeftWidth - marginLeft;
        }
        if (isNumber(offsets.right)) {
            offsets.right -= borderLeftWidth - marginLeft;
        }
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    return offsets;
}

/**
 * Returns the parentNode or the host of the element
 */
// todo: valorkin fix
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getParentNode(element) {
    if (element.nodeName === 'HTML') {
        return element;
    }
    return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 */
// todo: valorkin fix
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) {
        return document.body;
    }
    switch (element.nodeName) {
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
        default:
    }
    // Firefox want us to check `-x` and `-y` variations as well
    const { overflow, overflowX, overflowY } = getStyleComputedProperty(element);
    if (/(auto|scroll|overlay)/.test(String(overflow) + String(overflowY) + String(overflowX))) {
        return element;
    }
    return getScrollParent(getParentNode(element));
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 */
function getScroll(element, side = 'top') {
    const upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    const nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        const html = element.ownerDocument.documentElement;
        const scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}

function getViewportOffsetRectRelativeToArtbitraryNode(element, excludeScroll = false) {
    const html = element.ownerDocument.documentElement;
    const relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
    const width = Math.max(html.clientWidth, window.innerWidth || 0);
    const height = Math.max(html.clientHeight, window.innerHeight || 0);
    const scrollTop = !excludeScroll ? getScroll(html) : 0;
    const scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
    const offset = {
        top: scrollTop - Number(relativeOffset?.top) + Number(relativeOffset?.marginTop),
        left: scrollLeft - Number(relativeOffset?.left) + Number(relativeOffset?.marginLeft),
        width,
        height
    };
    return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 */
function isFixed(element) {
    const nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        return false;
    }
    if (getStyleComputedProperty(element, 'position') === 'fixed') {
        return true;
    }
    return isFixed(getParentNode(element));
}

function getBoundaries(target, host, padding = 0, boundariesElement, fixedPosition = false) {
    // NOTE: 1 DOM access here
    let boundaries = { top: 0, left: 0 };
    const offsetParent = fixedPosition ? getFixedPositionOffsetParent(target) : findCommonOffsetParent(target, host);
    // Handle viewport case
    if (boundariesElement === 'viewport') {
        boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    }
    else {
        // Handle other cases based on DOM element used as boundaries
        let boundariesNode;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = getScrollParent(getParentNode(host));
            if (boundariesNode.nodeName === 'BODY') {
                boundariesNode = target.ownerDocument.documentElement;
            }
        }
        else if (boundariesElement === 'window') {
            boundariesNode = target.ownerDocument.documentElement;
        }
        else {
            boundariesNode = boundariesElement;
        }
        const offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (offsets && boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
            const { height, width } = getWindowSizes(target.ownerDocument);
            if (isNumber(boundaries.top) && isNumber(offsets.top) && isNumber(offsets.marginTop)) {
                boundaries.top += offsets.top - offsets.marginTop;
            }
            if (isNumber(boundaries.top)) {
                boundaries.bottom = Number(height) + Number(offsets.top);
            }
            if (isNumber(boundaries.left) && isNumber(offsets.left) && isNumber(offsets.marginLeft)) {
                boundaries.left += offsets.left - offsets.marginLeft;
            }
            if (isNumber(boundaries.top)) {
                boundaries.right = Number(width) + Number(offsets.left);
            }
        }
        else if (offsets) {
            // for all the other DOM elements, this one is good
            boundaries = offsets;
        }
    }
    // Add paddings
    if (isNumber(boundaries.left)) {
        boundaries.left += padding;
    }
    if (isNumber(boundaries.top)) {
        boundaries.top += padding;
    }
    if (isNumber(boundaries.right)) {
        boundaries.right -= padding;
    }
    if (isNumber(boundaries.bottom)) {
        boundaries.bottom -= padding;
    }
    return boundaries;
}

function getArea({ width, height }) {
    return width * height;
}
function computeAutoPlacement(placement, refRect, target, host, allowedPositions = ['top', 'bottom', 'right', 'left'], boundariesElement = 'viewport', padding = 0) {
    if (placement.indexOf('auto') === -1) {
        return placement;
    }
    const boundaries = getBoundaries(target, host, padding, boundariesElement);
    const rects = {
        top: {
            width: boundaries?.width ?? 0,
            height: (refRect?.top ?? 0) - (boundaries?.top ?? 0)
        },
        right: {
            width: (boundaries?.right ?? 0) - (refRect?.right ?? 0),
            height: boundaries?.height ?? 0
        },
        bottom: {
            width: boundaries?.width ?? 0,
            height: (boundaries?.bottom ?? 0) - (refRect?.bottom ?? 0)
        },
        left: {
            width: (refRect.left ?? 0) - (boundaries?.left ?? 0),
            height: boundaries?.height ?? 0
        }
    };
    const sortedAreas = Object.keys(rects)
        .map((key) => ({
        position: key,
        ...rects[key],
        area: getArea(rects[key])
    }))
        .sort((a, b) => b.area - a.area);
    let filteredAreas = sortedAreas.filter(({ width, height }) => {
        return width >= target.clientWidth && height >= target.clientHeight;
    });
    filteredAreas = filteredAreas.filter(({ position }) => {
        return allowedPositions.some((allowedPosition) => {
            return allowedPosition === position;
        });
    });
    const computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].position : sortedAreas[0].position;
    const variation = placement.split(' ')[1];
    // for tooltip on auto position
    target.className = target.className.replace(/bs-tooltip-auto/g, `bs-tooltip-${computedPlacement}`);
    return computedPlacement + (variation ? `-${variation}` : '');
}

function getOffsets(data) {
    return {
        width: data.offsets.target.width,
        height: data.offsets.target.height,
        left: Math.floor(data.offsets.target.left ?? 0),
        top: Math.round(data.offsets.target.top ?? 0),
        bottom: Math.round(data.offsets.target.bottom ?? 0),
        right: Math.floor(data.offsets.target.right ?? 0)
    };
}

/**
 * Get the opposite placement of the given one
 */
function getOppositePlacement(placement) {
    const hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
    return placement.replace(/left|right|bottom|top/g, matched => hash[matched]);
}

/**
 * Get the opposite placement variation of the given one
 */
function getOppositeVariation(variation) {
    if (variation === 'right') {
        return 'left';
    }
    else if (variation === 'left') {
        return 'right';
    }
    return variation;
}

const parse = (value, def = 0) => value ? parseFloat(value) : def;
function getOuterSizes(element) {
    const window = element.ownerDocument.defaultView;
    const styles = window?.getComputedStyle(element);
    const x = parse(styles?.marginTop) + parse(styles?.marginBottom);
    const y = parse(styles?.marginLeft) + parse(styles?.marginRight);
    return {
        width: Number(element.offsetWidth) + y,
        height: Number(element.offsetHeight) + x
    };
}

/**
 * Get offsets to the reference element
 */
function getReferenceOffsets(target, host, fixedPosition) {
    const commonOffsetParent = fixedPosition
        ? getFixedPositionOffsetParent(target)
        : findCommonOffsetParent(target, host);
    return getOffsetRectRelativeToArbitraryNode(host, commonOffsetParent, fixedPosition);
}

/**
 * Get offsets to the target
 */
function getTargetOffsets(target, hostOffsets, position) {
    const placement = position.split(' ')[0];
    // Get target node sizes
    const targetRect = getOuterSizes(target);
    // Add position, width and height to our offsets object
    const targetOffsets = {
        width: targetRect.width,
        height: targetRect.height
    };
    // depending by the target placement we have to compute its offsets slightly differently
    const isHoriz = ['right', 'left'].indexOf(placement) !== -1;
    const mainSide = isHoriz ? 'top' : 'left';
    const secondarySide = isHoriz ? 'left' : 'top';
    const measurement = isHoriz ? 'height' : 'width';
    const secondaryMeasurement = !isHoriz ? 'height' : 'width';
    targetOffsets[mainSide] =
        (hostOffsets[mainSide] ?? 0) +
            hostOffsets[measurement] / 2 -
            targetRect[measurement] / 2;
    targetOffsets[secondarySide] = placement === secondarySide
        ? (hostOffsets[secondarySide] ?? 0) - targetRect[secondaryMeasurement]
        : hostOffsets[getOppositePlacement(secondarySide)] ?? 0;
    return targetOffsets;
}

function isModifierEnabled(options, modifierName) {
    return !!options.modifiers[modifierName]?.enabled;
}

const availablePositions = {
    top: ['top'],
    bottom: ['bottom'],
};
function checkPopoverMargin(placement, checkPosition) {
    return availablePositions[checkPosition].includes(placement);
}
function checkMargins(placement) {
    if (checkPopoverMargin(placement, 'top')) {
        return 'mb-2';
    }
    if (checkPopoverMargin(placement, 'bottom')) {
        return 'mt-2';
    }
    return '';
}

function updateContainerClass(data, renderer) {
    const target = data.instance.target;
    let containerClass = target.className;
    const dataPlacement = data.placement;
    if (data.placementAuto) {
        containerClass = containerClass.replace(/bs-popover-auto/g, `bs-popover-${dataPlacement}`);
        containerClass = containerClass.replace(/ms-2|me-2|mb-2|mt-2/g, '');
        containerClass = containerClass.replace(/bs-tooltip-auto/g, `bs-tooltip-${dataPlacement}`);
        containerClass = containerClass.replace(/\sauto/g, ` ${dataPlacement}`);
        if (containerClass.indexOf('popover') !== -1) {
            containerClass = containerClass + ' ' + checkMargins(dataPlacement);
        }
        if (containerClass.indexOf('popover') !== -1 && containerClass.indexOf('popover-auto') === -1) {
            containerClass += ' popover-auto';
        }
        if (containerClass.indexOf('tooltip') !== -1 && containerClass.indexOf('tooltip-auto') === -1) {
            containerClass += ' tooltip-auto';
        }
    }
    containerClass = containerClass.replace(/left|right|top|bottom|end|start/g, `${dataPlacement.split(' ')[0]}`);
    if (renderer) {
        renderer.setAttribute(target, 'class', containerClass);
        return;
    }
    target.className = containerClass;
}

function setStyles(element, styles, renderer) {
    if (!element || !styles) {
        return;
    }
    Object.keys(styles).forEach((prop) => {
        let unit = '';
        if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 &&
            isNumeric(styles[prop])) {
            unit = 'px';
        }
        if (renderer) {
            renderer.setStyle(element, prop, `${String(styles[prop])}${unit}`);
            return;
        }
        element.style[prop] = String(styles[prop]) + unit;
    });
}

class ContentRef {
    constructor(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
class ComponentLoader {
    /**
     * Do not use this directly, it should be instanced via
     * `ComponentLoadFactory.attach`
     * @internal
     */
    constructor(_viewContainerRef, _renderer, _elementRef, _injector, _componentFactoryResolver, _ngZone, _applicationRef, _posService, _document) {
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._injector = _injector;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._ngZone = _ngZone;
        this._applicationRef = _applicationRef;
        this._posService = _posService;
        this._document = _document;
        this.onBeforeShow = new EventEmitter();
        this.onShown = new EventEmitter();
        this.onBeforeHide = new EventEmitter();
        this.onHidden = new EventEmitter();
        this._providers = [];
        this._isHiding = false;
        /**
         * A selector used if container element was not found
         */
        this.containerDefaultSelector = 'body';
        this._listenOpts = {};
        this._globalListener = Function.prototype;
    }
    get isShown() {
        if (this._isHiding) {
            return false;
        }
        return !!this._componentRef;
    }
    attach(compType) {
        this._componentFactory = this._componentFactoryResolver
            .resolveComponentFactory(compType);
        return this;
    }
    // todo: add behaviour: to target element, `body`, custom element
    to(container) {
        this.container = container || this.container;
        return this;
    }
    position(opts) {
        if (!opts) {
            return this;
        }
        this.attachment = opts.attachment || this.attachment;
        this._elementRef = opts.target || this._elementRef;
        return this;
    }
    provide(provider) {
        this._providers.push(provider);
        return this;
    }
    show(opts = {}) {
        this._subscribePositioning();
        this._innerComponent = void 0;
        if (!this._componentRef) {
            this.onBeforeShow.emit();
            this._contentRef = this._getContentRef(opts.content, opts.context, opts.initialState);
            const injector = Injector.create({
                providers: this._providers,
                parent: this._injector
            });
            if (!this._componentFactory) {
                return;
            }
            this._componentRef = this._componentFactory.create(injector, this._contentRef.nodes);
            this._applicationRef.attachView(this._componentRef.hostView);
            this.instance = this._componentRef.instance;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            Object.assign(this._componentRef.instance, opts);
            if (this.container instanceof ElementRef) {
                this.container.nativeElement.appendChild(this._componentRef.location.nativeElement);
            }
            if (typeof this.container === 'string' && typeof this._document !== 'undefined') {
                const selectedElement = this._document.querySelector(this.container) ||
                    this._document.querySelector(this.containerDefaultSelector);
                if (!selectedElement) {
                    return;
                }
                selectedElement.appendChild(this._componentRef.location.nativeElement);
            }
            if (!this.container &&
                this._elementRef &&
                this._elementRef.nativeElement.parentElement) {
                this._elementRef.nativeElement.parentElement.appendChild(this._componentRef.location.nativeElement);
            }
            if (this._contentRef.componentRef) {
                this._innerComponent = this._contentRef.componentRef.instance;
                this._contentRef.componentRef.changeDetectorRef.markForCheck();
                this._contentRef.componentRef.changeDetectorRef.detectChanges();
            }
            this._componentRef.changeDetectorRef.markForCheck();
            this._componentRef.changeDetectorRef.detectChanges();
            this.onShown.emit(opts.id ? { id: opts.id } : this._componentRef.instance);
        }
        this._registerOutsideClick();
        return this._componentRef;
    }
    hide(id) {
        if (!this._componentRef) {
            return this;
        }
        this._posService.deletePositionElement(this._componentRef.location);
        this.onBeforeHide.emit(this._componentRef.instance);
        const componentEl = this._componentRef.location.nativeElement;
        componentEl.parentNode?.removeChild(componentEl);
        this._contentRef?.componentRef?.destroy();
        if (this._viewContainerRef && this._contentRef?.viewRef) {
            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._contentRef.viewRef));
        }
        this._contentRef?.viewRef?.destroy();
        this._contentRef = void 0;
        this._componentRef = void 0;
        this._removeGlobalListener();
        this.onHidden.emit(id ? { id } : null);
        return this;
    }
    toggle() {
        if (this.isShown) {
            this.hide();
            return;
        }
        this.show();
    }
    dispose() {
        if (this.isShown) {
            this.hide();
        }
        this._unsubscribePositioning();
        if (this._unregisterListenersFn) {
            this._unregisterListenersFn();
        }
    }
    listen(listenOpts) {
        this.triggers = listenOpts.triggers || this.triggers;
        this._listenOpts.outsideClick = listenOpts.outsideClick;
        this._listenOpts.outsideEsc = listenOpts.outsideEsc;
        listenOpts.target = listenOpts.target || this._elementRef?.nativeElement;
        const hide = (this._listenOpts.hide = () => listenOpts.hide ? listenOpts.hide() : void this.hide());
        const show = (this._listenOpts.show = (registerHide) => {
            listenOpts.show ? listenOpts.show(registerHide) : this.show(registerHide);
            registerHide();
        });
        const toggle = (registerHide) => {
            this.isShown ? hide() : show(registerHide);
        };
        if (this._renderer) {
            this._unregisterListenersFn = listenToTriggersV2(this._renderer, {
                target: listenOpts.target,
                triggers: listenOpts.triggers,
                show,
                hide,
                toggle
            });
        }
        return this;
    }
    _removeGlobalListener() {
        if (this._globalListener) {
            this._globalListener();
            this._globalListener = Function.prototype;
        }
    }
    attachInline(vRef, template) {
        if (vRef && template) {
            this._inlineViewRef = vRef.createEmbeddedView(template);
        }
        return this;
    }
    _registerOutsideClick() {
        if (!this._componentRef || !this._componentRef.location) {
            return;
        }
        if (this._listenOpts.outsideClick) {
            const target = this._componentRef.location.nativeElement;
            setTimeout(() => {
                if (this._renderer && this._elementRef) {
                    this._globalListener = registerOutsideClick(this._renderer, {
                        targets: [target, this._elementRef.nativeElement],
                        outsideClick: this._listenOpts.outsideClick,
                        hide: () => this._listenOpts.hide && this._listenOpts.hide()
                    });
                }
            });
        }
        if (this._listenOpts.outsideEsc && this._renderer && this._elementRef) {
            const target = this._componentRef.location.nativeElement;
            this._globalListener = registerEscClick(this._renderer, {
                targets: [target, this._elementRef.nativeElement],
                outsideEsc: this._listenOpts.outsideEsc,
                hide: () => this._listenOpts.hide && this._listenOpts.hide()
            });
        }
    }
    getInnerComponent() {
        return this._innerComponent;
    }
    _subscribePositioning() {
        if (this._zoneSubscription || !this.attachment) {
            return;
        }
        this.onShown.subscribe(() => {
            this._posService.position({
                element: this._componentRef?.location,
                target: this._elementRef,
                attachment: this.attachment,
                appendToBody: this.container === 'body'
            });
        });
        this._zoneSubscription = this._ngZone.onStable.subscribe(() => {
            if (!this._componentRef) {
                return;
            }
            this._posService.calcPosition();
        });
    }
    _unsubscribePositioning() {
        if (!this._zoneSubscription) {
            return;
        }
        this._zoneSubscription.unsubscribe();
        this._zoneSubscription = void 0;
    }
    _getContentRef(content, context, initialState) {
        if (!content) {
            return new ContentRef([]);
        }
        if (content instanceof TemplateRef) {
            if (this._viewContainerRef) {
                const _viewRef = this._viewContainerRef
                    .createEmbeddedView(content, context);
                _viewRef.markForCheck();
                return new ContentRef([_viewRef.rootNodes], _viewRef);
            }
            const viewRef = content.createEmbeddedView({});
            this._applicationRef.attachView(viewRef);
            return new ContentRef([viewRef.rootNodes], viewRef);
        }
        if (typeof content === 'function') {
            const contentCmptFactory = this._componentFactoryResolver.resolveComponentFactory(content);
            const modalContentInjector = Injector.create({
                providers: this._providers,
                parent: this._injector
            });
            const componentRef = contentCmptFactory.create(modalContentInjector);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            Object.assign(componentRef.instance, initialState);
            this._applicationRef.attachView(componentRef.hostView);
            return new ContentRef([[componentRef.location.nativeElement]], componentRef.hostView, componentRef);
        }
        const nodes = this._renderer
            ? [this._renderer.createText(`${content}`)]
            : [];
        return new ContentRef([nodes]);
    }
}

var MapPlacementInToRL;
(function (MapPlacementInToRL) {
    MapPlacementInToRL["top"] = "top";
    MapPlacementInToRL["bottom"] = "bottom";
})(MapPlacementInToRL || (MapPlacementInToRL = {}));

function arrow(data) {
    let targetOffsets = data.offsets.target;
    const arrowElement = data.instance.target.querySelector('.sc-tooltip-arrow');
    if (!arrowElement) {
        return data;
    }
    const isVertical = ['left', 'right'].indexOf(data.placement.split(' ')[0]) !== -1;
    const len = isVertical ? 'height' : 'width';
    const sideCapitalized = isVertical ? 'Top' : 'Left';
    const side = sideCapitalized.toLowerCase();
    const altSide = isVertical ? 'left' : 'top';
    const opSide = isVertical ? 'bottom' : 'right';
    const arrowElementSize = getOuterSizes(arrowElement)[len];
    const placementVariation = data.placement.split(' ')[1];
    // top/left side
    if ((data.offsets.host[opSide] ?? 0) - arrowElementSize < (targetOffsets[side] ?? 0)) {
        (targetOffsets)[side] -=
            (targetOffsets[side] ?? 0) - ((data.offsets.host[opSide] ?? 0) - arrowElementSize);
    }
    // bottom/right side
    if (Number((data).offsets.host[side]) + Number(arrowElementSize) > (targetOffsets[opSide] ?? 0)) {
        (targetOffsets)[side] +=
            Number((data).offsets.host[side]) + Number(arrowElementSize) - Number((targetOffsets)[opSide]);
    }
    targetOffsets = getClientRect(targetOffsets);
    const css = getStyleComputedProperty(data.instance.target);
    const targetMarginSide = parseFloat(css[`margin${sideCapitalized}`]) || 0;
    const targetBorderSide = parseFloat(css[`border${sideCapitalized}Width`]) || 0;
    let center;
    if (!placementVariation) {
        center = Number((data).offsets.host[side]) + Number(data.offsets.host[len] / 2 - arrowElementSize / 2);
    }
    else {
        const targetBorderRadius = parseFloat(css["borderRadius"]) || 0;
        const targetSideArrowOffset = Number(targetMarginSide + targetBorderSide + targetBorderRadius);
        center = side === placementVariation ?
            Number((data).offsets.host[side]) + targetSideArrowOffset :
            Number((data).offsets.host[side]) + Number(data.offsets.host[len] - targetSideArrowOffset);
    }
    let sideValue = center - (targetOffsets[side] ?? 0) - targetMarginSide - targetBorderSide;
    sideValue = Math.max(Math.min(targetOffsets[len] - (arrowElementSize + 5), sideValue), 0);
    data.offsets.arrow = {
        [side]: Math.round(sideValue),
        [altSide]: ''
    };
    data.instance.arrow = arrowElement;
    return data;
}

function flip(data) {
    data.offsets.target = getClientRect(data.offsets.target);
    if (!isModifierEnabled(data.options, 'flip')) {
        data.offsets.target = {
            ...data.offsets.target,
            ...getTargetOffsets(data.instance.target, data.offsets.host, data.placement)
        };
        return data;
    }
    const boundaries = getBoundaries(data.instance.target, data.instance.host, 0, // padding
    'viewport', false // positionFixed
    );
    let placement = data.placement.split(' ')[0];
    let variation = data.placement.split(' ')[1] || '';
    const offsetsHost = data.offsets.host;
    const target = data.instance.target;
    const host = data.instance.host;
    const adaptivePosition = computeAutoPlacement('auto', offsetsHost, target, host, data.options.allowedPositions);
    const flipOrder = [placement, adaptivePosition];
    flipOrder.forEach((step, index) => {
        if (placement !== step || flipOrder.length === index + 1) {
            return;
        }
        placement = data.placement.split(' ')[0];
        // using floor because the host offsets may contain decimals we are not going to consider here
        const overlapsRef = (placement === 'left' &&
            Math.floor(data.offsets.target.right ?? 0) > Math.floor(data.offsets.host.left ?? 0)) ||
            (placement === 'right' &&
                Math.floor(data.offsets.target.left ?? 0) < Math.floor(data.offsets.host.right ?? 0)) ||
            (placement === 'top' &&
                Math.floor(data.offsets.target.bottom ?? 0) > Math.floor(data.offsets.host.top ?? 0)) ||
            (placement === 'bottom' &&
                Math.floor(data.offsets.target.top ?? 0) < Math.floor(data.offsets.host.bottom ?? 0));
        const overflowsLeft = Math.floor(data.offsets.target.left ?? 0) < Math.floor(boundaries.left ?? 0);
        const overflowsRight = Math.floor(data.offsets.target.right ?? 0) > Math.floor(boundaries.right ?? 0);
        const overflowsTop = Math.floor(data.offsets.target.top ?? 0) < Math.floor(boundaries.top ?? 0);
        const overflowsBottom = Math.floor(data.offsets.target.bottom ?? 0) > Math.floor(boundaries.bottom ?? 0);
        const overflowsBoundaries = (placement === 'left' && overflowsLeft) ||
            (placement === 'right' && overflowsRight) ||
            (placement === 'top' && overflowsTop) ||
            (placement === 'bottom' && overflowsBottom);
        // flip the variation if required
        const isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
        const flippedVariation = ((isVertical && variation === 'left' && overflowsLeft) ||
            (isVertical && variation === 'right' && overflowsRight) ||
            (!isVertical && variation === 'left' && overflowsTop) ||
            (!isVertical && variation === 'right' && overflowsBottom));
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            if (overlapsRef || overflowsBoundaries) {
                placement = flipOrder[index + 1];
            }
            if (flippedVariation) {
                variation = getOppositeVariation(variation);
            }
            data.placement = placement + (variation ? ` ${variation}` : '');
            data.offsets.target = {
                ...data.offsets.target,
                ...getTargetOffsets(data.instance.target, data.offsets.host, data.placement)
            };
        }
    });
    return data;
}

function initData(targetElement, hostElement, position, options) {
    if (!targetElement || !hostElement) {
        return;
    }
    const hostElPosition = getReferenceOffsets(targetElement, hostElement);
    if (!position.match(/^(auto)*\s*(left|right|top|bottom|start|end)*$/)
        && !position.match(/^(left|right|top|bottom|start|end)*(?: (left|right|top|bottom|start|end))*$/)) {
        position = 'auto';
    }
    const placementAuto = !!position.match(/auto/g);
    // support old placements 'auto left|right|top|bottom'
    let placement = position.match(/auto\s(left|right|top|bottom|start|end)/)
        ? position.split(' ')[1] || 'auto'
        : position;
    // Normalize placements that have identical main placement and variation ("right right" => "right").
    const matches = placement.match(/^(left|right|top|bottom|start|end)* ?(?!\1)(left|right|top|bottom|start|end)?/);
    if (matches) {
        placement = matches[1] + (matches[2] ? ` ${matches[2]}` : '');
    }
    // "left right", "top bottom" etc. placements also considered incorrect.
    if (['left right', 'right left', 'top bottom', 'bottom top'].indexOf(placement) !== -1) {
        placement = 'auto';
    }
    placement = computeAutoPlacement(placement, hostElPosition, targetElement, hostElement, options ? options.allowedPositions : undefined);
    const targetOffset = getTargetOffsets(targetElement, hostElPosition, placement);
    return {
        options: options || { modifiers: {} },
        instance: {
            target: targetElement,
            host: hostElement,
            arrow: void 0
        },
        offsets: {
            target: targetOffset,
            host: hostElPosition,
            arrow: void 0
        },
        positionFixed: false,
        placement,
        placementAuto
    };
}

function preventOverflow(data) {
    if (!isModifierEnabled(data.options, 'preventOverflow')) {
        return data;
    }
    // NOTE: DOM access here
    // resets the target Offsets's position so that the document size can be calculated excluding
    // the size of the targetOffsets element itself
    const transformProp = 'transform';
    const targetStyles = data.instance.target.style; // assignment to help minification
    const { top, left, [transformProp]: transform } = targetStyles;
    targetStyles.top = '';
    targetStyles.left = '';
    targetStyles[transformProp] = '';
    const boundaries = getBoundaries(data.instance.target, data.instance.host, 0, // padding
    data.options.modifiers.preventOverflow?.boundariesElement || 'scrollParent', false // positionFixed
    );
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    targetStyles.top = top;
    targetStyles.left = left;
    targetStyles[transformProp] = transform;
    const order = ['left', 'right', 'top', 'bottom'];
    const check = {
        primary(placement) {
            let value = data.offsets.target[placement];
            // options.escapeWithReference
            if ((data.offsets.target[placement] ?? 0) < (boundaries[placement] ?? 0)) {
                value = Math.max(data.offsets.target[placement] ?? 0, boundaries[placement] ?? 0);
            }
            return { [placement]: value };
        },
        secondary(placement) {
            const isPlacementHorizontal = placement === 'right';
            const mainSide = isPlacementHorizontal ? 'left' : 'top';
            const measurement = isPlacementHorizontal ? 'width' : 'height';
            let value = data.offsets.target[mainSide];
            // escapeWithReference
            if ((data.offsets.target[placement] ?? 0) > (boundaries[placement] ?? 0)) {
                value = Math.min(data.offsets.target[mainSide] ?? 0, (boundaries[placement] ?? 0) - data.offsets.target[measurement]);
            }
            return { [mainSide]: value };
        }
    };
    order.forEach((placement) => {
        const side = ['left', 'top', 'start'].indexOf(placement) !== -1 ? check['primary'] : check['secondary'];
        data.offsets.target = {
            ...data.offsets.target,
            ...side(placement)
        };
    });
    return data;
}

function shift(data) {
    const placement = data.placement;
    const basePlacement = placement.split(' ')[0];
    const shiftVariation = placement.split(' ')[1];
    if (shiftVariation) {
        const { host, target } = data.offsets;
        const isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
        const side = isVertical ? 'left' : 'top';
        const measurement = isVertical ? 'width' : 'height';
        const shiftOffsets = {
            start: { [side]: host[side] },
            end: {
                [side]: (host[side] ?? 0) + host[measurement] - target[measurement]
            }
        };
        data.offsets.target = {
            ...target, ...{
                [side]: (side === shiftVariation ? shiftOffsets.start[side] : shiftOffsets.end[side])
            }
        };
    }
    return data;
}

class Positioning {
    position(hostElement, targetElement) {
        return this.offset(hostElement, targetElement);
    }
    offset(hostElement, targetElement) {
        return getReferenceOffsets(targetElement, hostElement);
    }
    positionElements(hostElement, targetElement, position, appendToBody, options) {
        const chainOfModifiers = [flip, shift, preventOverflow, arrow];
        const _position = MapPlacementInToRL[position];
        const data = initData(targetElement, hostElement, _position, options);
        if (!data) {
            return;
        }
        return chainOfModifiers.reduce((modifiedData, modifier) => modifier(modifiedData), data);
    }
}
const positionService = new Positioning();
function positionElements(hostElement, targetElement, placement, appendToBody, options, renderer) {
    const data = positionService.positionElements(hostElement, targetElement, placement, appendToBody, options);
    if (!data) {
        return;
    }
    const offsets = getOffsets(data);
    setStyles(targetElement, {
        top: '0px',
        transform: `translate3d(${offsets.left}px, ${offsets.top}px, 0px)`,
    }, renderer);
    if (data.instance.arrow) {
        setStyles(data.instance.arrow, data.offsets.arrow, renderer);
    }
    updateContainerClass(data, renderer);
}

class PositioningService {
    constructor(ngZone, rendererFactory, platformId) {
        this.update$$ = new Subject();
        this.positionElements = new Map();
        this.isDisabled = false;
        if (isPlatformBrowser(platformId)) {
            ngZone.runOutsideAngular(() => {
                this.triggerEvent$ = merge(fromEvent(window, 'scroll', { passive: true }), fromEvent(window, 'resize', { passive: true }), of(0, animationFrameScheduler), this.update$$);
                this.triggerEvent$.subscribe(() => {
                    if (this.isDisabled) {
                        return;
                    }
                    this.positionElements
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        .forEach((positionElement) => {
                        positionElements(_getHtmlElement(positionElement.target), _getHtmlElement(positionElement.element), positionElement.attachment, positionElement.appendToBody, this.options, rendererFactory.createRenderer(null, null));
                    });
                });
            });
        }
    }
    position(options) {
        this.addPositionElement(options);
    }
    get event$() {
        return this.triggerEvent$;
    }
    disable() {
        this.isDisabled = true;
    }
    enable() {
        this.isDisabled = false;
    }
    addPositionElement(options) {
        this.positionElements.set(_getHtmlElement(options.element), options);
    }
    calcPosition() {
        this.update$$.next(null);
    }
    deletePositionElement(elRef) {
        this.positionElements.delete(_getHtmlElement(elRef));
    }
    setOptions(options) {
        this.options = options;
    }
}
PositioningService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: PositioningService, deps: [{ token: i0.NgZone }, { token: i0.RendererFactory2 }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable });
PositioningService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: PositioningService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: PositioningService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: i0.RendererFactory2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });
function _getHtmlElement(element) {
    // it means that we got a selector
    if (typeof element === 'string') {
        return document.querySelector(element);
    }
    if (element instanceof ElementRef) {
        return element.nativeElement;
    }
    return element ?? null;
}

class ComponentLoaderFactory {
    constructor(_componentFactoryResolver, _ngZone, _injector, _posService, _applicationRef, _document) {
        this._componentFactoryResolver = _componentFactoryResolver;
        this._ngZone = _ngZone;
        this._injector = _injector;
        this._posService = _posService;
        this._applicationRef = _applicationRef;
        this._document = _document;
    }
    /**
     *
     * @param _elementRef
     * @param _viewContainerRef
     * @param _renderer
     */
    createLoader(_elementRef, _viewContainerRef, _renderer) {
        return new ComponentLoader(_viewContainerRef, _renderer, _elementRef, this._injector, this._componentFactoryResolver, this._ngZone, this._applicationRef, this._posService, this._document);
    }
}
ComponentLoaderFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ComponentLoaderFactory, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.NgZone }, { token: i0.Injector }, { token: PositioningService }, { token: i0.ApplicationRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
ComponentLoaderFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ComponentLoaderFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ComponentLoaderFactory, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.NgZone }, { type: i0.Injector }, { type: PositioningService }, { type: i0.ApplicationRef }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

let id = 0;
class ScTooltipDirective {
    get isOpen() {
        return this._tooltip.isShown;
    }
    set isOpen(value) {
        if (value) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    constructor(_viewContainerRef, cis, config, _elementRef, _renderer, _positionService) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._positionService = _positionService;
        this.tooltipId = id++;
        this.tooltipFadeDuration = 150;
        this.adaptivePosition = true;
        this.placement = 'top';
        this.triggers = 'hover focus';
        this.containerClass = '';
        this.isDisabled = false;
        this.delay = 0;
        this.collapsed = true;
        this._tooltip = cis
            .createLoader(this._elementRef, _viewContainerRef, this._renderer)
            .provide({ provide: TooltipConfig, useValue: config });
        Object.assign(this, config);
        this.onShown = this._tooltip.onShown;
        this.onHidden = this._tooltip.onHidden;
    }
    ngOnInit() {
        this._tooltip.listen({
            triggers: this.triggers,
            show: () => this.show(),
        });
        this.onShown.subscribe(() => {
            this.setAriaDescribedBy();
        });
        this.onHidden.subscribe(() => {
            this.setAriaDescribedBy();
        });
    }
    setAriaDescribedBy() {
        this._ariaDescribedby = this.isOpen ? `tooltip-${this.tooltipId}` : void 0;
        if (this._ariaDescribedby) {
            this._renderer.setAttribute(this._elementRef.nativeElement, 'aria-describedby', this._ariaDescribedby);
        }
        else {
            this._renderer.removeAttribute(this._elementRef.nativeElement, 'aria-describedby');
        }
    }
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of
     * the tooltip.
     */
    toggle() {
        if (this.isOpen) {
            return this.hide();
        }
        this.show();
    }
    /**
     * Opens an element’s tooltip. This is considered a “manual” triggering of
     * the tooltip.
     */
    show() {
        this._positionService.setOptions({
            modifiers: {
                flip: {
                    enabled: this.adaptivePosition,
                },
                preventOverflow: {
                    enabled: this.adaptivePosition,
                    boundariesElement: this.boundariesElement || 'scrollParent',
                },
            },
        });
        if (this.isOpen || this.isDisabled || this._delayTimeoutId || !this.scTooltip) {
            return;
        }
        const showTooltip = () => {
            if (this._delayTimeoutId) {
                this._delayTimeoutId = undefined;
            }
            this._tooltip
                .attach(ScTooltipComponent)
                .to(this.container)
                .position({ attachment: this.placement })
                .show({
                content: this.scTooltip,
                placement: this.placement,
                containerClass: this.containerClass,
                id: `tooltip-${this.tooltipId}`,
            });
        };
        const cancelDelayedTooltipShowing = () => {
            if (this._tooltipCancelShowFn) {
                this._tooltipCancelShowFn();
            }
        };
        if (this.delay) {
            if (this._delaySubscription) {
                this._delaySubscription.unsubscribe();
            }
            this._delaySubscription = timer(this.delay).subscribe(() => {
                showTooltip();
                cancelDelayedTooltipShowing();
            });
            if (this.triggers) {
                parseTriggers(this.triggers).forEach((trigger) => {
                    if (!trigger.close) {
                        return;
                    }
                    this._tooltipCancelShowFn = this._renderer.listen(this._elementRef.nativeElement, trigger.close, () => {
                        this._delaySubscription?.unsubscribe();
                        cancelDelayedTooltipShowing();
                    });
                });
            }
        }
        else {
            showTooltip();
        }
    }
    /**
     * Closes an element’s tooltip. This is considered a “manual” triggering of
     * the tooltip.
     */
    hide() {
        if (this._delayTimeoutId) {
            clearTimeout(this._delayTimeoutId);
            this._delayTimeoutId = undefined;
        }
        if (!this._tooltip.isShown) {
            return;
        }
        if (this._tooltip.instance?.classMap) {
            this._tooltip.instance.classMap['in'] = false;
        }
        setTimeout(() => {
            this._tooltip.hide();
        }, this.tooltipFadeDuration);
    }
    toggleOpened() {
        if (this.isOpen) {
            this.onShown.emit();
        }
        else {
            this.onHidden.emit();
        }
    }
    ngOnDestroy() {
        this._tooltip.dispose();
        if (this._delaySubscription) {
            this._delaySubscription.unsubscribe();
        }
        this.onShown.unsubscribe();
        this.onHidden.unsubscribe();
    }
}
ScTooltipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTooltipDirective, deps: [{ token: i0.ViewContainerRef }, { token: ComponentLoaderFactory }, { token: TooltipConfig }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: PositioningService }], target: i0.ɵɵFactoryTarget.Directive });
ScTooltipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScTooltipDirective, isStandalone: true, selector: "[scTooltip]", inputs: { adaptivePosition: "adaptivePosition", scTooltip: "scTooltip", placement: "placement", triggers: "triggers", container: "container", containerClass: "containerClass", boundariesElement: "boundariesElement", isOpen: "isOpen", isDisabled: "isDisabled", delay: "delay", collapsed: "collapsed" }, outputs: { onShown: "onShown", onHidden: "onHidden" }, exportAs: ["sc-tooltip"], ngImport: i0 });
__decorate([
    OnChange(),
    __metadata("design:type", Object)
], ScTooltipDirective.prototype, "scTooltip", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[scTooltip]',
                    standalone: true,
                    exportAs: 'sc-tooltip',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: ComponentLoaderFactory }, { type: TooltipConfig }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: PositioningService }]; }, propDecorators: { adaptivePosition: [{
                type: Input
            }], scTooltip: [{
                type: Input
            }], placement: [{
                type: Input
            }], triggers: [{
                type: Input
            }], container: [{
                type: Input
            }], containerClass: [{
                type: Input
            }], boundariesElement: [{
                type: Input
            }], isOpen: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], delay: [{
                type: Input
            }], onShown: [{
                type: Output
            }], onHidden: [{
                type: Output
            }], collapsed: [{
                type: Input
            }] } });

function DefaultSelectionModelFactory() {
    return new DefaultSelectionModel();
}
class DefaultSelectionModel {
    constructor() {
        this._selected = [];
    }
    get value() {
        return this._selected;
    }
    select(item, multiple, groupAsModel) {
        item.selected = true;
        if (!item.children || (!multiple && groupAsModel)) {
            this._selected.push(item);
        }
        if (multiple) {
            if (item.parent) {
                const childrenCount = item.parent.children?.length;
                const selectedCount = item.parent.children?.filter((x) => x.selected).length;
                item.parent.selected = childrenCount === selectedCount;
            }
            else if (item.children) {
                this._setChildrenSelectedState(item.children, true);
                this._removeChildren(item);
                if (groupAsModel && this._activeChildren(item)) {
                    this._selected = [
                        ...this._selected.filter((x) => x.parent !== item),
                        item,
                    ];
                }
                else {
                    this._selected = [
                        ...this._selected,
                        ...item.children.filter((x) => !x.disabled),
                    ];
                }
            }
        }
    }
    unselect(item, multiple) {
        this._selected = this._selected.filter((x) => x !== item);
        item.selected = false;
        if (multiple) {
            if (item.parent && item.parent.selected) {
                const children = item.parent.children;
                this._removeParent(item.parent);
                this._removeChildren(item.parent);
                if (children) {
                    this._selected.push(...children.filter((x) => x !== item && !x.disabled));
                }
                item.parent.selected = false;
            }
            else if (item.children) {
                this._setChildrenSelectedState(item.children, false);
                this._removeChildren(item);
            }
        }
    }
    clear(keepDisabled) {
        this._selected = keepDisabled
            ? this._selected.filter((x) => x.disabled)
            : [];
    }
    _setChildrenSelectedState(children, selected) {
        for (const child of children) {
            if (child.disabled) {
                continue;
            }
            child.selected = selected;
        }
    }
    _removeChildren(parent) {
        if (parent.children) {
            this._selected = [
                ...this._selected.filter((x) => x.parent !== parent),
                ...parent.children.filter((x) => x.parent === parent && x.disabled && x.selected),
            ];
        }
    }
    _removeParent(parent) {
        this._selected = this._selected.filter((x) => x !== parent);
    }
    _activeChildren(item) {
        return item.children
            ? item.children.every((x) => !x.disabled || x.selected)
            : false;
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
class HighlightPipe {
    transform(text, search, searchKeyword) {
        let pattern = search.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
        pattern = pattern
            .split(' ')
            .filter((t) => {
            return t.length > 0;
        })
            .join('|');
        const regex = new RegExp(pattern, 'gi');
        if (!search) {
            return text;
        }
        if (searchKeyword) {
            const name = text[searchKeyword].replace(regex, (match) => `<b>${match}</b>`);
            const text2 = { ...text };
            text2[searchKeyword] = name;
            return text2;
        }
        else {
            return search
                ? text.replace(regex, (match) => `<b>${match}</b>`)
                : text;
        }
    }
}
HighlightPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: HighlightPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
HighlightPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: HighlightPipe, isStandalone: true, name: "highlight" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: HighlightPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'highlight',
                    standalone: true,
                }]
        }] });

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
const isArrowUp = (keyCode) => keyCode === 38;
const isArrowDown = (keyCode) => keyCode === 40;
const isArrowUpDown = (keyCode) => isArrowUp(keyCode) || isArrowDown(keyCode);
const isEnter = (keyCode) => keyCode === 13;
const isBackspace = (keyCode) => keyCode === 8;
const isDelete = (keyCode) => keyCode === 46;
const isESC = (keyCode) => keyCode === 27;
const isTab = (keyCode) => keyCode === 9;
class ScAutocompleteComponent {
    onClick($event) {
        this.handleClick($event);
    }
    writeValue(value = '') {
        this.query = value && !this.isTypeString(value) ? value[this.searchKeyword] : value;
    }
    registerOnChange(onChange) {
        this.onChange = onChange;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    handleInput(event) {
        this.query = event.target.value;
        this.onChange(event.target.value);
        this.handleItemsChange();
    }
    constructor(elementRef, renderer) {
        this.renderer = renderer;
        this.searchInput = {};
        this.filteredListElement = {};
        this.historyListElement = {};
        this.inputKeyUp$ = new Observable();
        this.inputKeyDown$ = new Observable();
        this.query = '';
        this.filteredList = [];
        this.historyList = [];
        this.isHistoryListVisible = true;
        this.selectedIdx = -1;
        this.toHighlight = '';
        this.notFound = false;
        this.isFocused = false;
        this.isOpen = false;
        this.isScrollToEnd = false;
        this.overlay = false;
        this.manualOpen = undefined;
        this.manualClose = undefined;
        this.data = [];
        this.searchKeyword = '';
        this.placeholder = '';
        this.heading = '';
        this.historyHeading = 'Recently selected';
        this.historyListMaxNumber = 15;
        this.notFoundText = 'Not found';
        this.disabled = false;
        this.minQueryLength = 1;
        this.focusFirst = false;
        this.selected = new EventEmitter();
        this.inputChanged = new EventEmitter();
        this.inputFocused = new EventEmitter();
        this.inputCleared = new EventEmitter();
        this.opened = new EventEmitter();
        this.closed = new EventEmitter();
        this.scrolledToEnd = new EventEmitter();
        this.mainClass = 'sc-autocomplete';
        this.onChange = (_value) => { };
        this.onTouched = () => { };
        this.elementRef = elementRef;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngAfterViewInit() {
        this.initEventStream();
        this.handleScroll();
    }
    setInitialValue(value) {
        if (this.initialValue) {
            this.select(value);
        }
    }
    ngOnChanges(changes) {
        this.setInitialValue(this.initialValue);
        if (changes && changes['data'] && Array.isArray(changes['data'].currentValue)) {
            this.handleItemsChange();
            if (!changes['data'].firstChange && this.isFocused) {
                this.handleOpen();
            }
        }
    }
    handleItemsChange() {
        this.isScrollToEnd = false;
        if (!this.isOpen) {
            return;
        }
        this.filteredList = this.data;
        this.notFound = !this.filteredList || this.filteredList.length === 0;
        if (this.isOpen) {
            this.filterList();
        }
    }
    filterList() {
        this.selectedIdx = -1;
        this.initSearchHistory();
        if (this.query != null && this.data) {
            this.toHighlight = this.query;
            this.filteredList =
                this.customFilter !== undefined ? this.customFilter([...this.data], this.query) : this.defaultFilterFunction();
            if (this.filteredList.length > 0 && this.focusFirst) {
                this.selectedIdx = 0;
            }
        }
        else {
            this.notFound = false;
        }
    }
    defaultFilterFunction() {
        return this.data.filter((item) => {
            if (typeof item === 'string') {
                return item.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
            }
            else if (typeof item === 'object' && item instanceof Object) {
                return item[this.searchKeyword].toLowerCase().indexOf(this.query.toLowerCase()) > -1;
            }
            return;
        });
    }
    isTypeString(item) {
        return typeof item === 'string';
    }
    select(item) {
        this.query = !this.isTypeString(item) ? item[this.searchKeyword] : item;
        this.isOpen = true;
        this.overlay = false;
        this.selected.emit(item);
        this.onChange(item);
        if (this.initialValue) {
            const history = window.localStorage.getItem(`${this.historyIdentifier}`);
            if (history) {
                let existingHistory = JSON.parse(localStorage[`${this.historyIdentifier}`]);
                if (!(existingHistory instanceof Array))
                    existingHistory = [];
                if (!existingHistory.some((existingItem) => !this.isTypeString(existingItem)
                    ? existingItem[this.searchKeyword] == item[this.searchKeyword]
                    : existingItem == item)) {
                    existingHistory.unshift(item);
                    localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(existingHistory));
                    if (existingHistory.length >= this.historyListMaxNumber) {
                        existingHistory.splice(existingHistory.length - 1, 1);
                        localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(existingHistory));
                    }
                }
                else {
                    if (!this.isTypeString(item)) {
                        const copiedExistingHistory = existingHistory.slice();
                        const selectedIndex = copiedExistingHistory
                            .map((el) => el[this.searchKeyword])
                            .indexOf(item[this.searchKeyword]);
                        copiedExistingHistory.splice(selectedIndex, 1);
                        copiedExistingHistory.splice(0, 0, item);
                        localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(copiedExistingHistory));
                    }
                    else {
                        const copiedExistingHistory = existingHistory.slice();
                        copiedExistingHistory.splice(copiedExistingHistory.indexOf(item), 1);
                        copiedExistingHistory.splice(0, 0, item);
                        localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(copiedExistingHistory));
                    }
                }
            }
            else {
                this.saveHistory(item);
            }
        }
        else {
            this.saveHistory(item);
        }
        this.handleClose();
    }
    handleClick(e) {
        let clickedComponent = e.target;
        let inside = false;
        do {
            if (clickedComponent === this.elementRef.nativeElement) {
                inside = true;
                if (this.filteredList.length) {
                    this.handleOpen();
                }
            }
            clickedComponent = clickedComponent.parentNode;
        } while (clickedComponent);
        if (!inside) {
            this.handleClose();
        }
    }
    async handleBlur() {
        return of(true)
            .pipe(delay(500), tap(() => {
            this.onTouched();
            this.handleClose();
        }))
            .toPromise();
    }
    handleOverlay() {
        this.overlay = false;
    }
    handleScroll() {
        this.renderer.listen(this.filteredListElement.nativeElement, 'scroll', () => {
            this.scrollToEnd();
        });
    }
    setPanelState(event) {
        if (event) {
            event.stopPropagation();
        }
        if (typeof this.manualOpen === 'undefined' && typeof this.manualClose === 'undefined') {
            this.isOpen = false;
            this.handleOpen();
        }
        if ((typeof this.manualOpen === 'undefined' && this.manualClose === false) ||
            (typeof this.manualClose === 'undefined' && this.manualOpen === false)) {
            this.isOpen = false;
            this.handleOpen();
        }
        if (this.manualOpen === false && this.manualClose === false) {
            this.isOpen = false;
            this.handleOpen();
        }
        if (this.manualOpen) {
            this.isOpen = false;
            this.handleOpen();
            this.manualOpen = false;
        }
        if (this.manualClose) {
            this.isOpen = true;
            this.handleClose();
            this.manualClose = false;
        }
    }
    open() {
        this.manualOpen = true;
        this.isOpen = false;
        this.handleOpen();
    }
    close() {
        this.manualClose = true;
        this.isOpen = true;
        this.handleClose();
    }
    focus() {
        this.handleFocus(event);
    }
    clear() {
        this.remove(event);
    }
    remove(e) {
        e.stopPropagation();
        this.query = '';
        this.inputCleared.emit();
        this.onChange(this.query);
        this.setPanelState(e);
        if (this.data && !this.data.length) {
            this.notFound = false;
        }
    }
    initSearchHistory() {
        this.isHistoryListVisible = false;
        if (this.historyIdentifier && !this.query) {
            const history = window.localStorage.getItem(`${this.historyIdentifier}`);
            if (history) {
                this.isHistoryListVisible = true;
                this.filteredList = [];
                this.historyList = history ? JSON.parse(history) : [];
            }
            else {
                this.isHistoryListVisible = false;
            }
        }
        else {
            this.isHistoryListVisible = false;
        }
    }
    handleOpen() {
        if (this.isOpen || (this.isOpen && !this.isLoading)) {
            return;
        }
        if (this.data && this.data.length) {
            this.isOpen = true;
            this.overlay = true;
            this.filterList();
            this.opened.emit();
        }
    }
    handleClose() {
        if (!this.isOpen) {
            this.isFocused = false;
            return;
        }
        this.isOpen = false;
        this.overlay = false;
        this.filteredList = [];
        this.selectedIdx = -1;
        this.notFound = false;
        this.isHistoryListVisible = false;
        this.isFocused = false;
        this.closed.emit();
    }
    handleFocus(e) {
        this.searchInput.nativeElement.focus();
        if (this.isFocused) {
            return;
        }
        this.inputFocused.emit(e);
        if (this.data && this.data.length) {
            this.setPanelState(event);
        }
        this.isFocused = true;
    }
    scrollToEnd() {
        if (this.isScrollToEnd) {
            return;
        }
        const scrollTop = this.filteredListElement.nativeElement.scrollTop;
        const scrollHeight = this.filteredListElement.nativeElement.scrollHeight;
        const elementHeight = this.filteredListElement.nativeElement.clientHeight;
        const atBottom = scrollHeight === scrollTop + elementHeight;
        if (atBottom) {
            this.scrolledToEnd.emit();
            this.isScrollToEnd = true;
        }
    }
    initEventStream() {
        this.inputKeyUp$ = fromEvent(this.searchInput.nativeElement, 'keyup').pipe(map((e) => e));
        this.inputKeyDown$ = fromEvent(this.searchInput.nativeElement, 'keydown').pipe(map((e) => e));
        this.listenEventStream();
    }
    listenEventStream() {
        this.inputKeyUp$
            .pipe(filter((e) => !isArrowUpDown(e.keyCode) && !isEnter(e.keyCode) && !isESC(e.keyCode) && !isTab(e.keyCode)), debounceTime(this.debounceTime))
            .subscribe((e) => {
            this.onKeyUp(e);
        });
        this.inputKeyDown$.pipe(filter((e) => isArrowUpDown(e.keyCode))).subscribe((e) => {
            e.preventDefault();
            this.onFocusItem(e);
        });
        this.inputKeyDown$.pipe(filter((e) => isEnter(e.keyCode))).subscribe(() => {
            this.onHandleEnter();
        });
        this.inputKeyUp$.pipe(filter((e) => isESC(e.keyCode), debounceTime(100))).subscribe(() => {
            this.onEsc();
        });
        this.inputKeyDown$.pipe(filter((e) => isTab(e.keyCode))).subscribe(() => {
            this.onTab();
        });
        this.inputKeyDown$.pipe(filter((e) => isBackspace(e.keyCode) || isDelete(e.keyCode))).subscribe(() => {
            this.onDelete();
        });
    }
    onKeyUp(e) {
        this.notFound = false;
        if (!this.query) {
            this.notFound = false;
            this.inputChanged.emit(e.target.value);
            this.inputCleared.emit();
            this.setPanelState(e);
        }
        if (!this.query && this.query !== '') {
            return;
        }
        if (this.query.length >= this.minQueryLength) {
            this.inputChanged.emit(e.target.value);
            this.filterList();
            if (!this.filteredList.length && !this.isLoading) {
                this.notFoundText ? (this.notFound = true) : (this.notFound = false);
            }
            if (this.data && !this.data.length) {
                this.isOpen = true;
            }
        }
    }
    onFocusItem(e) {
        if (!this.historyList.length || !this.isHistoryListVisible) {
            const totalNumItem = this.filteredList.length;
            if (e.key === 'ArrowDown') {
                let sum = this.selectedIdx;
                sum = this.selectedIdx === null ? 0 : sum + 1;
                this.selectedIdx = (totalNumItem + sum) % totalNumItem;
                this.scrollToFocusedItem(this.selectedIdx);
            }
            else if (e.key === 'ArrowUp') {
                if (this.selectedIdx == -1) {
                    this.selectedIdx = 0;
                }
                this.selectedIdx = (totalNumItem + this.selectedIdx - 1) % totalNumItem;
                this.scrollToFocusedItem(this.selectedIdx);
            }
        }
        else {
            const totalNumItem = this.historyList.length;
            if (e.key === 'ArrowDown') {
                let sum = this.selectedIdx;
                sum = this.selectedIdx === null ? 0 : sum + 1;
                this.selectedIdx = (totalNumItem + sum) % totalNumItem;
                this.scrollToFocusedItem(this.selectedIdx);
            }
            else if (e.key === 'ArrowUp') {
                if (this.selectedIdx == -1) {
                    this.selectedIdx = 0;
                }
                this.selectedIdx = (totalNumItem + this.selectedIdx - 1) % totalNumItem;
                this.scrollToFocusedItem(this.selectedIdx);
            }
        }
    }
    scrollToFocusedItem(index) {
        let listElement = null;
        if (!this.historyList.length || !this.isHistoryListVisible) {
            listElement = this.filteredListElement.nativeElement;
        }
        else {
            listElement = this.historyListElement.nativeElement;
        }
        const items = Array.prototype.slice.call(listElement.childNodes).filter((node) => {
            if (node.nodeType === 1) {
                return node.className.includes('item');
            }
            else {
                return false;
            }
        });
        if (!items.length) {
            return;
        }
        const listHeight = listElement.offsetHeight;
        const itemHeight = items[index].offsetHeight;
        const visibleTop = listElement.scrollTop;
        const visibleBottom = listElement.scrollTop + listHeight - itemHeight;
        const targetPosition = items[index].offsetTop;
        if (targetPosition < visibleTop) {
            listElement.scrollTop = targetPosition;
        }
        if (targetPosition > visibleBottom) {
            listElement.scrollTop = targetPosition - listHeight + itemHeight;
        }
    }
    onHandleEnter() {
        if (this.selectedIdx > -1) {
            if (!this.historyList.length || !this.isHistoryListVisible) {
                this.query = !this.isTypeString(this.filteredList[this.selectedIdx])
                    ? this.filteredList[this.selectedIdx][this.searchKeyword]
                    : this.filteredList[this.selectedIdx];
                this.saveHistory(this.filteredList[this.selectedIdx]);
                this.select(this.filteredList[this.selectedIdx]);
            }
            else {
                this.query = !this.isTypeString(this.historyList[this.selectedIdx])
                    ? this.historyList[this.selectedIdx][this.searchKeyword]
                    : this.historyList[this.selectedIdx];
                this.saveHistory(this.historyList[this.selectedIdx]);
                this.select(this.historyList[this.selectedIdx]);
            }
        }
        this.isHistoryListVisible = false;
        this.handleClose();
    }
    onEsc() {
        this.searchInput.nativeElement.blur();
        this.handleClose();
    }
    onTab() {
        this.searchInput.nativeElement.blur();
        this.handleClose();
    }
    onDelete() {
        this.isOpen = true;
    }
    saveHistory(selected) {
        if (this.historyIdentifier) {
            if (!this.historyList.some((item) => !this.isTypeString(item) ? item[this.searchKeyword] == selected[this.searchKeyword] : item == selected)) {
                this.saveHistoryToLocalStorage([selected, ...this.historyList]);
                if (this.historyList.length >= this.historyListMaxNumber) {
                    this.historyList.splice(this.historyList.length - 1, 1);
                    this.saveHistoryToLocalStorage([selected, ...this.historyList]);
                }
            }
            else {
                if (!this.isTypeString(selected)) {
                    const copiedHistoryList = this.historyList.slice();
                    const selectedIndex = copiedHistoryList
                        .map((item) => item[this.searchKeyword])
                        .indexOf(selected[this.searchKeyword]);
                    copiedHistoryList.splice(selectedIndex, 1);
                    copiedHistoryList.splice(0, 0, selected);
                    this.saveHistoryToLocalStorage([...copiedHistoryList]);
                }
                else {
                    const copiedHistoryList = this.historyList.slice();
                    copiedHistoryList.splice(this.historyList.indexOf(selected), 1);
                    copiedHistoryList.splice(0, 0, selected);
                    this.saveHistoryToLocalStorage([...copiedHistoryList]);
                }
            }
        }
    }
    saveHistoryToLocalStorage(selected) {
        window.localStorage.setItem(`${this.historyIdentifier}`, JSON.stringify(selected));
    }
    removeHistoryItem(index, e) {
        e.stopPropagation();
        this.historyList = this.historyList.filter((v, i) => i !== index);
        this.saveHistoryToLocalStorage(this.historyList);
        if (this.historyList.length == 0) {
            window.localStorage.removeItem(`${this.historyIdentifier}`);
            this.filterList();
        }
    }
    resetHistoryList(e) {
        e.stopPropagation();
        this.historyList = [];
        window.localStorage.removeItem(`${this.historyIdentifier}`);
        this.filterList();
    }
}
ScAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScAutocompleteComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
ScAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScAutocompleteComponent, isStandalone: true, selector: "sc-autocomplete", inputs: { data: "data", searchKeyword: "searchKeyword", placeholder: "placeholder", heading: "heading", initialValue: "initialValue", historyIdentifier: "historyIdentifier", historyHeading: "historyHeading", historyListMaxNumber: "historyListMaxNumber", notFoundText: "notFoundText", isLoading: "isLoading", debounceTime: "debounceTime", disabled: "disabled", minQueryLength: "minQueryLength", focusFirst: "focusFirst", customFilter: "customFilter", itemTemplate: "itemTemplate", notFoundTemplate: "notFoundTemplate" }, outputs: { selected: "selected", inputChanged: "inputChanged", inputFocused: "inputFocused", inputCleared: "inputCleared", opened: "opened", closed: "closed", scrolledToEnd: "scrolledToEnd" }, host: { listeners: { "click": "onClick($event)" }, properties: { "class.sc-autocomplete": "this.mainClass" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScAutocompleteComponent),
            multi: true,
        },
    ], queries: [{ propertyName: "customTemplate", first: true, predicate: TemplateRef, descendants: true }], viewQueries: [{ propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true }, { propertyName: "filteredListElement", first: true, predicate: ["filteredListElement"], descendants: true }, { propertyName: "historyListElement", first: true, predicate: ["historyListElement"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"sc-autocomplete-overlay\" *ngIf=\"overlay\" (click)=\"handleOverlay()\"></div>\r\n\r\n<div class=\"sc-autocomplete-container\" [ngClass]=\"{ active: isOpen }\">\r\n\r\n  <div class=\"sc-autocomplete-input-container\">\r\n    <input\r\n      #searchInput\r\n      type=\"text\"\r\n      placeholder=\"{{ placeholder }}\"\r\n      [value]=\"query\"\r\n      (input)=\"handleInput($event)\"\r\n      (focus)=\"handleFocus($event)\"\r\n      (blur)=\"handleBlur()\"\r\n      [disabled]=\"disabled\"\r\n      class=\"sc-input\"\r\n      autocomplete=\"off\"\r\n    />\r\n\r\n    <div class=\"sc-autocomplete-icon\" *ngIf=\"query && !isLoading && !disabled\" (click)=\"remove($event)\">\r\n      <svg class=\"sc-icon\" viewBox=\"0 0 512 512\">\r\n        <path\r\n          d=\"m226 257l-113-113c-8-9-8-22 0-30 8-9 22-9 30 0l113 112 113-112c8-9 22-9 30 0 8 8 8 21 0 30l-113 113 113 113c8 8 8 21 0 30-8 8-22 8-30 0l-113-113-113 113c-8 8-22 8-30 0-8-9-8-22 0-30z\"></path>\r\n      </svg>\r\n    </div>\r\n\r\n    <ng-container *ngIf=\"isLoading\">\r\n      <div class=\"sk-fading-circle\">\r\n        <div class=\"sk-circle1 sk-circle\"></div>\r\n        <div class=\"sk-circle2 sk-circle\"></div>\r\n        <div class=\"sk-circle3 sk-circle\"></div>\r\n        <div class=\"sk-circle4 sk-circle\"></div>\r\n        <div class=\"sk-circle5 sk-circle\"></div>\r\n        <div class=\"sk-circle6 sk-circle\"></div>\r\n        <div class=\"sk-circle7 sk-circle\"></div>\r\n        <div class=\"sk-circle8 sk-circle\"></div>\r\n        <div class=\"sk-circle9 sk-circle\"></div>\r\n        <div class=\"sk-circle10 sk-circle\"></div>\r\n        <div class=\"sk-circle11 sk-circle\"></div>\r\n        <div class=\"sk-circle12 sk-circle\"></div>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n\r\n  <div class=\"sc-autocomplete-suggestions-container\" [ngClass]=\"{'is-hidden': isHistoryListVisible}\">\r\n\r\n    <div class=\"sc-autocomplete-heading\" *ngIf=\"filteredList.length > 0 && heading\">\r\n      <div class=\"sc-autocomplete-heading-text\">{{ heading }}</div>\r\n    </div>\r\n\r\n    <ul #filteredListElement class=\"sc-autocomplete-suggestion-list\">\r\n      <ng-container *ngFor=\"let item of filteredList; let idx = index\">\r\n\r\n        <li [class.complete-selected]=\"idx === selectedIdx\"\r\n            (click)=\"select(item)\"\r\n            class=\"sc-autocomplete-suggestion-item\">\r\n\r\n          <ng-container *ngIf=\"isTypeString(item)\">\r\n            <ng-container\r\n              [ngTemplateOutlet]=\"itemTemplate || defaultItemTemplate\"\r\n              [ngTemplateOutletContext]=\"{\r\n              $implicit: item | highlight: toHighlight\r\n            }\">\r\n            </ng-container>\r\n          </ng-container>\r\n\r\n          <ng-container *ngIf=\"!isTypeString(item)\">\r\n            <ng-container\r\n              [ngTemplateOutlet]=\"itemTemplate || defaultItemTemplate\"\r\n              [ngTemplateOutletContext]=\"{\r\n              $implicit: item | highlight: toHighlight:searchKeyword\r\n            }\">\r\n            </ng-container>\r\n          </ng-container>\r\n\r\n        </li>\r\n      </ng-container>\r\n    </ul>\r\n  </div>\r\n\r\n  <div class=\"sc-autocomplete-suggestions-container\" [ngClass]=\"{'is-hidden': !isHistoryListVisible}\">\r\n\r\n    <div class=\"sc-autocomplete-heading\" *ngIf=\"historyList.length > 0 && historyHeading\">\r\n      <div class=\"sc-autocomplete-heading-text\">{{ historyHeading }}</div>\r\n      <div class=\"sc-autocomplete-icon\" (click)=\"resetHistoryList($event)\">\r\n        Smazat\r\n        <svg class=\"sc-icon\" viewBox=\"0 0 512 512\">\r\n          <path d=\"m226 257l-113-113c-8-9-8-22 0-30 8-9 22-9 30 0l113 112 113-112c8-9 22-9 30 0 8 8 8 21 0 30l-113 113 113 113c8 8 8 21 0 30-8 8-22 8-30 0l-113-113-113 113c-8 8-22 8-30 0-8-9-8-22 0-30z\"></path>\r\n        </svg>\r\n      </div>\r\n    </div>\r\n\r\n    <ul #historyListElement class=\"sc-autocomplete-suggestion-list\">\r\n      <ng-container *ngFor=\"let item of historyList; let idx = index\">\r\n        <li [class.complete-selected]=\"idx === selectedIdx\"\r\n            (click)=\"select(item)\"\r\n            class=\"sc-autocomplete-suggestion-item\">\r\n          <ng-container\r\n            [ngTemplateOutlet]=\"itemTemplate || defaultItemTemplate\"\r\n            [ngTemplateOutletContext]=\"{\r\n              $implicit: item\r\n            }\">\r\n          </ng-container>\r\n        </li>\r\n        <div class=\"sc-autocomplete-icon\" (click)=\"removeHistoryItem(idx, $event)\">\r\n          <svg class=\"sc-icon\" viewBox=\"0 0 512 512\">\r\n            <path d=\"m226 257l-113-113c-8-9-8-22 0-30 8-9 22-9 30 0l113 112 113-112c8-9 22-9 30 0 8 8 8 21 0 30l-113 113 113 113c8 8 8 21 0 30-8 8-22 8-30 0l-113-113-113 113c-8 8-22 8-30 0-8-9-8-22 0-30z\"></path>\r\n          </svg>\r\n        </div>\r\n      </ng-container>\r\n    </ul>\r\n  </div>\r\n\r\n  <!-- not found -->\r\n  <div class=\"sc-autocomplete-not-found\" *ngIf=\"isLoading ? !isLoading && notFound : notFound\">\r\n    <ng-container\r\n      [ngTemplateOutlet]=\"notFoundTemplate || defaultNotFoundTemplate\"\r\n      [ngTemplateOutletContext]=\"{\r\n        $implicit: notFoundText\r\n      }\"\r\n    ></ng-container>\r\n  </div>\r\n</div>\r\n\r\n\r\n<ng-template #defaultItemTemplate let-item>\r\n  <a [innerHTML]=\"item[searchKeyword]\"></a>\r\n</ng-template>\r\n\r\n<ng-template #defaultNotFoundTemplate let-notFound>\r\n  <div [outerHTML]=\"notFound\"></div>\r\n</ng-template>\r\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: HighlightPipe, name: "highlight" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-autocomplete', standalone: true, imports: [CommonModule, HighlightPipe], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ScAutocompleteComponent),
                            multi: true,
                        },
                    ], encapsulation: ViewEncapsulation.None, template: "<div class=\"sc-autocomplete-overlay\" *ngIf=\"overlay\" (click)=\"handleOverlay()\"></div>\r\n\r\n<div class=\"sc-autocomplete-container\" [ngClass]=\"{ active: isOpen }\">\r\n\r\n  <div class=\"sc-autocomplete-input-container\">\r\n    <input\r\n      #searchInput\r\n      type=\"text\"\r\n      placeholder=\"{{ placeholder }}\"\r\n      [value]=\"query\"\r\n      (input)=\"handleInput($event)\"\r\n      (focus)=\"handleFocus($event)\"\r\n      (blur)=\"handleBlur()\"\r\n      [disabled]=\"disabled\"\r\n      class=\"sc-input\"\r\n      autocomplete=\"off\"\r\n    />\r\n\r\n    <div class=\"sc-autocomplete-icon\" *ngIf=\"query && !isLoading && !disabled\" (click)=\"remove($event)\">\r\n      <svg class=\"sc-icon\" viewBox=\"0 0 512 512\">\r\n        <path\r\n          d=\"m226 257l-113-113c-8-9-8-22 0-30 8-9 22-9 30 0l113 112 113-112c8-9 22-9 30 0 8 8 8 21 0 30l-113 113 113 113c8 8 8 21 0 30-8 8-22 8-30 0l-113-113-113 113c-8 8-22 8-30 0-8-9-8-22 0-30z\"></path>\r\n      </svg>\r\n    </div>\r\n\r\n    <ng-container *ngIf=\"isLoading\">\r\n      <div class=\"sk-fading-circle\">\r\n        <div class=\"sk-circle1 sk-circle\"></div>\r\n        <div class=\"sk-circle2 sk-circle\"></div>\r\n        <div class=\"sk-circle3 sk-circle\"></div>\r\n        <div class=\"sk-circle4 sk-circle\"></div>\r\n        <div class=\"sk-circle5 sk-circle\"></div>\r\n        <div class=\"sk-circle6 sk-circle\"></div>\r\n        <div class=\"sk-circle7 sk-circle\"></div>\r\n        <div class=\"sk-circle8 sk-circle\"></div>\r\n        <div class=\"sk-circle9 sk-circle\"></div>\r\n        <div class=\"sk-circle10 sk-circle\"></div>\r\n        <div class=\"sk-circle11 sk-circle\"></div>\r\n        <div class=\"sk-circle12 sk-circle\"></div>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n\r\n  <div class=\"sc-autocomplete-suggestions-container\" [ngClass]=\"{'is-hidden': isHistoryListVisible}\">\r\n\r\n    <div class=\"sc-autocomplete-heading\" *ngIf=\"filteredList.length > 0 && heading\">\r\n      <div class=\"sc-autocomplete-heading-text\">{{ heading }}</div>\r\n    </div>\r\n\r\n    <ul #filteredListElement class=\"sc-autocomplete-suggestion-list\">\r\n      <ng-container *ngFor=\"let item of filteredList; let idx = index\">\r\n\r\n        <li [class.complete-selected]=\"idx === selectedIdx\"\r\n            (click)=\"select(item)\"\r\n            class=\"sc-autocomplete-suggestion-item\">\r\n\r\n          <ng-container *ngIf=\"isTypeString(item)\">\r\n            <ng-container\r\n              [ngTemplateOutlet]=\"itemTemplate || defaultItemTemplate\"\r\n              [ngTemplateOutletContext]=\"{\r\n              $implicit: item | highlight: toHighlight\r\n            }\">\r\n            </ng-container>\r\n          </ng-container>\r\n\r\n          <ng-container *ngIf=\"!isTypeString(item)\">\r\n            <ng-container\r\n              [ngTemplateOutlet]=\"itemTemplate || defaultItemTemplate\"\r\n              [ngTemplateOutletContext]=\"{\r\n              $implicit: item | highlight: toHighlight:searchKeyword\r\n            }\">\r\n            </ng-container>\r\n          </ng-container>\r\n\r\n        </li>\r\n      </ng-container>\r\n    </ul>\r\n  </div>\r\n\r\n  <div class=\"sc-autocomplete-suggestions-container\" [ngClass]=\"{'is-hidden': !isHistoryListVisible}\">\r\n\r\n    <div class=\"sc-autocomplete-heading\" *ngIf=\"historyList.length > 0 && historyHeading\">\r\n      <div class=\"sc-autocomplete-heading-text\">{{ historyHeading }}</div>\r\n      <div class=\"sc-autocomplete-icon\" (click)=\"resetHistoryList($event)\">\r\n        Smazat\r\n        <svg class=\"sc-icon\" viewBox=\"0 0 512 512\">\r\n          <path d=\"m226 257l-113-113c-8-9-8-22 0-30 8-9 22-9 30 0l113 112 113-112c8-9 22-9 30 0 8 8 8 21 0 30l-113 113 113 113c8 8 8 21 0 30-8 8-22 8-30 0l-113-113-113 113c-8 8-22 8-30 0-8-9-8-22 0-30z\"></path>\r\n        </svg>\r\n      </div>\r\n    </div>\r\n\r\n    <ul #historyListElement class=\"sc-autocomplete-suggestion-list\">\r\n      <ng-container *ngFor=\"let item of historyList; let idx = index\">\r\n        <li [class.complete-selected]=\"idx === selectedIdx\"\r\n            (click)=\"select(item)\"\r\n            class=\"sc-autocomplete-suggestion-item\">\r\n          <ng-container\r\n            [ngTemplateOutlet]=\"itemTemplate || defaultItemTemplate\"\r\n            [ngTemplateOutletContext]=\"{\r\n              $implicit: item\r\n            }\">\r\n          </ng-container>\r\n        </li>\r\n        <div class=\"sc-autocomplete-icon\" (click)=\"removeHistoryItem(idx, $event)\">\r\n          <svg class=\"sc-icon\" viewBox=\"0 0 512 512\">\r\n            <path d=\"m226 257l-113-113c-8-9-8-22 0-30 8-9 22-9 30 0l113 112 113-112c8-9 22-9 30 0 8 8 8 21 0 30l-113 113 113 113c8 8 8 21 0 30-8 8-22 8-30 0l-113-113-113 113c-8 8-22 8-30 0-8-9-8-22 0-30z\"></path>\r\n          </svg>\r\n        </div>\r\n      </ng-container>\r\n    </ul>\r\n  </div>\r\n\r\n  <!-- not found -->\r\n  <div class=\"sc-autocomplete-not-found\" *ngIf=\"isLoading ? !isLoading && notFound : notFound\">\r\n    <ng-container\r\n      [ngTemplateOutlet]=\"notFoundTemplate || defaultNotFoundTemplate\"\r\n      [ngTemplateOutletContext]=\"{\r\n        $implicit: notFoundText\r\n      }\"\r\n    ></ng-container>\r\n  </div>\r\n</div>\r\n\r\n\r\n<ng-template #defaultItemTemplate let-item>\r\n  <a [innerHTML]=\"item[searchKeyword]\"></a>\r\n</ng-template>\r\n\r\n<ng-template #defaultNotFoundTemplate let-notFound>\r\n  <div [outerHTML]=\"notFound\"></div>\r\n</ng-template>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { searchInput: [{
                type: ViewChild,
                args: ['searchInput']
            }], filteredListElement: [{
                type: ViewChild,
                args: ['filteredListElement']
            }], historyListElement: [{
                type: ViewChild,
                args: ['historyListElement']
            }], data: [{
                type: Input
            }], searchKeyword: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], heading: [{
                type: Input
            }], initialValue: [{
                type: Input
            }], historyIdentifier: [{
                type: Input
            }], historyHeading: [{
                type: Input
            }], historyListMaxNumber: [{
                type: Input
            }], notFoundText: [{
                type: Input
            }], isLoading: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], disabled: [{
                type: Input
            }], minQueryLength: [{
                type: Input
            }], focusFirst: [{
                type: Input
            }], customFilter: [{
                type: Input
            }], itemTemplate: [{
                type: Input
            }], notFoundTemplate: [{
                type: Input
            }], selected: [{
                type: Output
            }], inputChanged: [{
                type: Output
            }], inputFocused: [{
                type: Output
            }], inputCleared: [{
                type: Output
            }], opened: [{
                type: Output
            }], closed: [{
                type: Output
            }], scrolledToEnd: [{
                type: Output
            }], mainClass: [{
                type: HostBinding,
                args: ['class.sc-autocomplete']
            }], customTemplate: [{
                type: ContentChild,
                args: [TemplateRef]
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

var BadgeVariant;
(function (BadgeVariant) {
    BadgeVariant["CATEGORY"] = "Badge.VARIANT.CATEGORY";
    BadgeVariant["ERROR"] = "Badge.VARIANT.ERROR";
    BadgeVariant["STATE"] = "Badge.VARIANT.STATE";
    BadgeVariant["SUCCESS"] = "Badge.VARIANT.SUCCESS";
    BadgeVariant["TODO"] = "Badge.VARIANT.TODO";
    BadgeVariant["WARNING"] = "Badge.VARIANT.WARNING";
})(BadgeVariant || (BadgeVariant = {}));
class ScBadgeComponent {
    constructor() {
        this.variant = BadgeVariant.TODO;
        this.icon = null;
    }
    get cc() {
        switch (this.variant) {
            case BadgeVariant.CATEGORY:
                return 'sc-badge sc-badge-category';
            case BadgeVariant.ERROR:
                return 'sc-badge sc-badge-error';
            case BadgeVariant.STATE:
                return 'sc-badge sc-badge-state';
            case BadgeVariant.SUCCESS:
                return 'sc-badge sc-badge-success';
            case BadgeVariant.TODO:
                return 'sc-badge sc-badge-todo';
            case BadgeVariant.WARNING:
                return 'sc-badge sc-badge-warning';
        }
    }
}
ScBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScBadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScBadgeComponent, isStandalone: true, selector: "sc-badge", inputs: { variant: "variant", icon: "icon" }, host: { properties: { "class": "this.cc" } }, ngImport: i0, template: `<svg sc-icon [icon]="icon" *ngIf="icon"></svg> <ng-content></ng-content>`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScBadgeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-badge',
                    standalone: true,
                    imports: [CommonModule, ScIconModule],
                    template: `<svg sc-icon [icon]="icon" *ngIf="icon"></svg> <ng-content></ng-content>`,
                }]
        }], propDecorators: { variant: [{
                type: Input
            }], icon: [{
                type: Input
            }], cc: [{
                type: HostBinding,
                args: ['class']
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
const MODAL_DATA = new InjectionToken('MODAL_DATA');

/* eslint-disable @typescript-eslint/no-explicit-any */
// CDK simple modal (https://johnbwoodruff.com/posts/angular-cdk-dialog/)
class ModalRef {
    constructor(overlayRef) {
        this.overlayRef = overlayRef;
        this.afterClosedSubject = new Subject();
    }
    close(result) {
        this.overlayRef.dispose();
        this.afterClosedSubject.next(result);
        this.afterClosedSubject.complete();
    }
    afterClosed() {
        return this.afterClosedSubject.asObservable();
    }
}
class ModalService {
    constructor(overlay, injector) {
        this.overlay = overlay;
        this.injector = injector;
    }
    open(component, config) {
        // create overlay
        const positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();
        const scrollStrategy = this.overlay.scrollStrategies.block();
        const overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: true,
            backdropClass: 'overlay-backdrop',
            panelClass: 'overlay-panel',
        });
        const modalRef = new ModalRef(overlayRef);
        const injector = Injector.create({
            parent: this.injector,
            providers: [
                { provide: ModalRef, useValue: modalRef },
                { provide: MODAL_DATA, useValue: config?.data },
            ],
        });
        const portal = new ComponentPortal(component, null, injector);
        overlayRef.attach(portal);
        return modalRef;
    }
}
ModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalService, deps: [{ token: i1$2.Overlay }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
ModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.Overlay }, { type: i0.Injector }]; } });

/* eslint-disable @typescript-eslint/no-explicit-any */
class ScModalBaseComponent {
    constructor(modalRef, data) {
        this.modalRef = modalRef;
        this.data = data;
    }
    action() {
        this.modalRef.close('Modal.Action');
    }
    close() {
        this.modalRef.close('Modal.Close');
    }
}
ScModalBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScModalBaseComponent, deps: [{ token: ModalRef }, { token: MODAL_DATA }], target: i0.ɵɵFactoryTarget.Component });
ScModalBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScModalBaseComponent, selector: "sc-modal-base", ngImport: i0, template: ``, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScModalBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-modal-base',
                    template: ``,
                }]
        }], ctorParameters: function () { return [{ type: ModalRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_DATA]
                }] }]; } });

class ModalFooterComponent {
    constructor() {
        this.classes = 'sc-modal-footer';
    }
}
ModalFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ModalFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ModalFooterComponent, selector: "sc-modal-footer", host: { properties: { "class": "this.classes" } }, ngImport: i0, template: `
    <sc-divider></sc-divider>
    <div class="sc-modal-footer-content">
      <ng-content></ng-content>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: ScDividerComponent, selector: "sc-divider", inputs: ["vertical"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-modal-footer', template: `
    <sc-divider></sc-divider>
    <div class="sc-modal-footer-content">
      <ng-content></ng-content>
    </div>
  ` }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ModalContentComponent {
    constructor() {
        this.classes = 'sc-modal-content';
    }
}
ModalContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ModalContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ModalContentComponent, selector: "sc-modal-content", host: { properties: { "class": "this.classes" } }, ngImport: i0, template: `
    <sc-card-content class="p-16 md:p-32">
      <ng-content></ng-content>
    </sc-card-content>
  `, isInline: true, dependencies: [{ kind: "component", type: ScCardContentComponent, selector: "sc-card-content", inputs: ["mode"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-modal-content',
                    template: `
    <sc-card-content class="p-16 md:p-32">
      <ng-content></ng-content>
    </sc-card-content>
  `,
                }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ModalHeaderComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.headline = null;
        this.icon = null; //ico-file-upload-xl
        this.classes = 'sc-modal-header';
    }
    close() {
        this.dialogRef.close('Modal.Close');
    }
}
ModalHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalHeaderComponent, deps: [{ token: ModalRef }], target: i0.ɵɵFactoryTarget.Component });
ModalHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ModalHeaderComponent, selector: "sc-modal-header", inputs: { headline: "headline", icon: "icon" }, host: { properties: { "class": "this.classes" } }, ngImport: i0, template: `
    <div
      class="sc-modal-header-content"
      [ngClass]="{
        'p-0': !headline && !icon
      }"
    >
      <button (click)="close()"
        class="sc-modal-close md:hidden"
        sc-icon-button
        mode="tertiary" 
        icon="ico-error"
        size="small">
        <span class="sr-only">Zavřít</span>
      </button>
      <button (click)="close()"
        class="sc-modal-close hidden md:flex"
        sc-button
        mode="tertiary" 
        icon="ico-error"
        iconPlacement="right"
        size="small">
        Zavřít
      </button>
      <ng-container *ngIf="icon || headline">
        <div class="flex flex-col justify-center items-center md:mx-64">
          <svg
            *ngIf="icon"
            sc-icon
            [icon]="icon"
            class="text-gray-300 mb-4"
            size="48"
          ></svg>
          <h2 class="sc-modal-title">
            {{ headline }}
          </h2>
        </div>
      </ng-container>
    </div>

    <sc-divider *ngIf="icon || headline"></sc-divider>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }, { kind: "component", type: ScDividerComponent, selector: "sc-divider", inputs: ["vertical"] }, { kind: "component", type: ScButtonComponent, selector: "button[sc-button], button[sc-icon-button]", inputs: ["disabled", "size", "active", "mode", "iconPlacement", "iconSize", "icon", "inverted"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-modal-header', template: `
    <div
      class="sc-modal-header-content"
      [ngClass]="{
        'p-0': !headline && !icon
      }"
    >
      <button (click)="close()"
        class="sc-modal-close md:hidden"
        sc-icon-button
        mode="tertiary" 
        icon="ico-error"
        size="small">
        <span class="sr-only">Zavřít</span>
      </button>
      <button (click)="close()"
        class="sc-modal-close hidden md:flex"
        sc-button
        mode="tertiary" 
        icon="ico-error"
        iconPlacement="right"
        size="small">
        Zavřít
      </button>
      <ng-container *ngIf="icon || headline">
        <div class="flex flex-col justify-center items-center md:mx-64">
          <svg
            *ngIf="icon"
            sc-icon
            [icon]="icon"
            class="text-gray-300 mb-4"
            size="48"
          ></svg>
          <h2 class="sc-modal-title">
            {{ headline }}
          </h2>
        </div>
      </ng-container>
    </div>

    <sc-divider *ngIf="icon || headline"></sc-divider>
  ` }]
        }], ctorParameters: function () { return [{ type: ModalRef }]; }, propDecorators: { headline: [{
                type: Input
            }], icon: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ModalComponent {
}
ModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ModalComponent, selector: "sc-modal", ngImport: i0, template: `
    <div class="sc-modal max-w-xl md:max-w-3xl">
      <div class="sc-modal-card">
        <ng-content></ng-content>
      </div>
    </div>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-modal',
                    template: `
    <div class="sc-modal max-w-xl md:max-w-3xl">
      <div class="sc-modal-card">
        <ng-content></ng-content>
      </div>
    </div>
  `,
                }]
        }] });

class ScContainerComponent {
    constructor() {
        this.classes = 'sc-container';
    }
}
ScContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScContainerComponent, isStandalone: true, selector: "sc-container", host: { properties: { "class": "this.classes" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-container',
                    standalone: true,
                    template: `<ng-content></ng-content>`,
                }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScFocusPageComponent {
    get cssHasHeader() {
        return this.stripeHeaderTemplate;
    }
    constructor(document) {
        this.size = 'large';
        this.altBodyBGLight = null;
        this.altBodyBGDark = null;
        this.stripeHeaderTemplate = null;
        this.bannerTemplate = null;
        this.classes = 'sc-focus-page';
        this.focusPageClass = '';
        this._document = document;
    }
    getFocusPageClass() {
        return 'sc-focus-page-content ' + 'sc-focus-page-' + this.size.toString();
    }
    ngOnInit() {
        this.focusPageClass = this.getFocusPageClass();
        if (this.altBodyBGLight) {
            this._document?.body.classList.add(this.altBodyBGLight);
        }
        if (this.altBodyBGDark) {
            this._document?.body.classList.add(this.altBodyBGDark);
        }
    }
    ngOnDestroy() {
        if (this.altBodyBGLight) {
            this._document?.body.classList.remove(this.altBodyBGLight);
        }
        if (this.altBodyBGDark) {
            this._document?.body.classList.remove(this.altBodyBGDark);
        }
    }
}
ScFocusPageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScFocusPageComponent, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
ScFocusPageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScFocusPageComponent, isStandalone: true, selector: "sc-focus-page", inputs: { size: "size", altBodyBGLight: "altBodyBGLight", altBodyBGDark: "altBodyBGDark", stripeHeaderTemplate: "stripeHeaderTemplate", bannerTemplate: "bannerTemplate" }, host: { properties: { "class": "this.classes", "class.has-stripe-header": "this.cssHasHeader" } }, ngImport: i0, template: `
    <ng-container *ngIf="stripeHeaderTemplate">
      <ng-container [ngTemplateOutlet]="stripeHeaderTemplate"></ng-container>
    </ng-container>
    <ng-container *ngIf="bannerTemplate">
      <ng-container [ngTemplateOutlet]="bannerTemplate"></ng-container>
    </ng-container>
    <div [ngClass]="this.focusPageClass">
      <ng-content></ng-content>
    </div>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScFocusPageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-focus-page',
                    standalone: true,
                    imports: [CommonModule],
                    template: `
    <ng-container *ngIf="stripeHeaderTemplate">
      <ng-container [ngTemplateOutlet]="stripeHeaderTemplate"></ng-container>
    </ng-container>
    <ng-container *ngIf="bannerTemplate">
      <ng-container [ngTemplateOutlet]="bannerTemplate"></ng-container>
    </ng-container>
    <div [ngClass]="this.focusPageClass">
      <ng-content></ng-content>
    </div>
  `,
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { size: [{
                type: Input
            }], altBodyBGLight: [{
                type: Input
            }], altBodyBGDark: [{
                type: Input
            }], stripeHeaderTemplate: [{
                type: Input
            }], bannerTemplate: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], cssHasHeader: [{
                type: HostBinding,
                args: ['class.has-stripe-header']
            }] } });

class ScFocusPageBodyComponent {
    constructor() {
        this.classes = 'sc-focus-page-body';
    }
}
ScFocusPageBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScFocusPageBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScFocusPageBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScFocusPageBodyComponent, isStandalone: true, selector: "sc-focus-page-body", host: { properties: { "class": "this.classes" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScFocusPageBodyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-focus-page-body',
                    standalone: true,
                    template: `<ng-content></ng-content>`,
                }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScStripeHeaderCloseComponent {
    constructor() {
        this.classes = 'sc-stripe-header-close';
    }
}
ScStripeHeaderCloseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStripeHeaderCloseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScStripeHeaderCloseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScStripeHeaderCloseComponent, isStandalone: true, selector: "sc-stripe-header-close", host: { properties: { "class": "this.classes" } }, ngImport: i0, template: `<button sc-button icon="ico-error" iconPlacement="right">Zavřít</button>`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: ScButtonComponent, selector: "button[sc-button], button[sc-icon-button]", inputs: ["disabled", "size", "active", "mode", "iconPlacement", "iconSize", "icon", "inverted"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStripeHeaderCloseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-stripe-header-close',
                    standalone: true,
                    imports: [CommonModule, ScButtonComponent],
                    template: `<button sc-button icon="ico-error" iconPlacement="right">Zavřít</button>`,
                }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScStripeHeaderComponent {
    constructor() {
        this.stripeTitle = null;
        this.fullWidth = false;
        this.rightActionTemplate = null;
        this.leftActionTemplate = null;
        this.closeAction = new EventEmitter();
        this.classes = 'sc-stripe-header';
    }
    handleClose() {
        this.closeAction.emit();
    }
}
ScStripeHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStripeHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScStripeHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScStripeHeaderComponent, isStandalone: true, selector: "sc-stripe-header", inputs: { stripeTitle: "stripeTitle", fullWidth: "fullWidth", rightActionTemplate: "rightActionTemplate", leftActionTemplate: "leftActionTemplate" }, outputs: { closeAction: "closeAction" }, host: { properties: { "class": "this.classes" } }, ngImport: i0, template: "<ng-container *ngIf=\"fullWidth;then fluid else fixed\"></ng-container>\n<ng-template #fixed>\n  <sc-container>\n    <ng-container *ngTemplateOutlet=\"innerContent\"></ng-container>\n  </sc-container>\n</ng-template>\n<ng-template #fluid>\n  <ng-container *ngTemplateOutlet=\"innerContent\"></ng-container>\n</ng-template>\n\n<ng-template #innerContent>\n  <div class=\"sc-stripe-header-grid\">\n    <div *ngIf=\"leftActionTemplate\">\n      <ng-container *ngTemplateOutlet=\"leftActionTemplate\"></ng-container>\n    </div>\n    <div class=\"sc-stripe-header-center\">\n      <h1 *ngIf=\"stripeTitle\" class=\"sc-stripe-header-title\">{{stripeTitle}}</h1>\n    </div>\n    <div class=\"sc-stripe-header-right\">\n      <ng-container *ngTemplateOutlet=\"rightActionTemplate || closeActionTemplate\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #closeActionTemplate>\n  <sc-stripe-header-close (click)=\"handleClose()\"></sc-stripe-header-close>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: ScContainerComponent, selector: "sc-container" }, { kind: "component", type: ScStripeHeaderCloseComponent, selector: "sc-stripe-header-close" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStripeHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-stripe-header', standalone: true, imports: [CommonModule, ScContainerComponent, ScStripeHeaderCloseComponent], template: "<ng-container *ngIf=\"fullWidth;then fluid else fixed\"></ng-container>\n<ng-template #fixed>\n  <sc-container>\n    <ng-container *ngTemplateOutlet=\"innerContent\"></ng-container>\n  </sc-container>\n</ng-template>\n<ng-template #fluid>\n  <ng-container *ngTemplateOutlet=\"innerContent\"></ng-container>\n</ng-template>\n\n<ng-template #innerContent>\n  <div class=\"sc-stripe-header-grid\">\n    <div *ngIf=\"leftActionTemplate\">\n      <ng-container *ngTemplateOutlet=\"leftActionTemplate\"></ng-container>\n    </div>\n    <div class=\"sc-stripe-header-center\">\n      <h1 *ngIf=\"stripeTitle\" class=\"sc-stripe-header-title\">{{stripeTitle}}</h1>\n    </div>\n    <div class=\"sc-stripe-header-right\">\n      <ng-container *ngTemplateOutlet=\"rightActionTemplate || closeActionTemplate\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #closeActionTemplate>\n  <sc-stripe-header-close (click)=\"handleClose()\"></sc-stripe-header-close>\n</ng-template>\n" }]
        }], propDecorators: { stripeTitle: [{
                type: Input
            }], fullWidth: [{
                type: Input
            }], rightActionTemplate: [{
                type: Input
            }], leftActionTemplate: [{
                type: Input
            }], closeAction: [{
                type: Output
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScStripeHeaderLogoComponent {
    constructor() {
        this.classes = 'sc-stripe-header-logo';
    }
}
ScStripeHeaderLogoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStripeHeaderLogoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScStripeHeaderLogoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScStripeHeaderLogoComponent, isStandalone: true, selector: "sc-stripe-header-logo", host: { properties: { "class": "this.classes" } }, ngImport: i0, template: "<svg id=\"b\" data-name=\"Ebene 2\" xmlns=\"http://www.w3.org/2000/svg\"  viewBox=\"0 0 541.63 243.66\">\n  <defs>\n    <style>\n      .d {\n        fill: #fff;\n      }\n    </style>\n  </defs>\n  <g id=\"c\" data-name=\"Ebene 1\">\n    <g>\n      <g>\n        <path class=\"d\" d=\"M43.19,50.15c20.75,0,27.4,3.25,27.4,11.3v8.21h-27.4c-15.33,0-20.13,6.66-20.13,30.81s4.8,30.81,20.13,30.81h27.4v8.21c0,8.05-6.66,11.3-27.4,11.3C14.86,150.78,0,135.61,0,100.46S14.86,50.15,43.19,50.15Zm-3.56-4.8c-1.86,0-2.94-.46-4.8-2.63l-13-15.79c-.62-.77-.62-1.7-.62-2.32h8.98c2.01,0,2.94,.46,5.11,2.32l7.43,6.35,7.28-6.35c2.32-1.86,3.1-2.32,5.26-2.32h8.82c0,.62,0,1.55-.62,2.32l-13,15.79c-1.86,2.17-2.94,2.63-4.95,2.63h-5.88Z\"/>\n        <path class=\"d\" d=\"M78.33,59.44c0-5.57,2.48-8.51,8.21-8.51h56.35v10.84c0,5.57-2.94,8.21-8.82,8.21h-33.29v20.59h36.38v17.8h-36.38v22.76h42.88v10.84c0,5.57-2.94,8.05-8.67,8.05h-48.46c-5.73,0-8.21-2.94-8.21-8.51V59.44Z\"/>\n        <path class=\"d\" d=\"M183.14,50.15c19.97,0,31.43,2.17,31.43,10.99v8.52h-29.26c-8.67,0-12.08,2.63-12.08,7.59,0,13.47,46.6,11.15,46.6,44.28,0,15.79-9.75,29.26-38.08,29.26-17.8,0-32.51-2.48-32.51-10.99v-8.52h33.6c8.82,0,13.16-2.79,13.16-8.51,0-14.55-46.44-12.39-46.44-46.14,0-14.86,10.53-26.47,33.6-26.47Z\"/>\n        <path class=\"d\" d=\"M252.81,96.75l28.8-41.65c2.32-3.56,3.56-4.18,6.5-4.18h20.75c0,1.39-.31,2.63-1.39,4.18l-31.89,43.81,33.44,46.91c.77,1.24,1.39,2.79,1.39,4.18h-19.82c-4.33,0-5.73-.31-8.52-4.49l-29.26-41.18v45.67h-22.45V59.44c0-5.57,2.48-8.51,8.21-8.51h14.24v45.83Z\"/>\n        <path class=\"d\" d=\"M364.73,50.61c4.03,0,5.88,.46,6.81,3.87l25.23,91.81c.31,1.39,.46,2.79,.46,3.72h-17.8c-4.02,0-5.26-.15-6.19-3.56l-5.57-21.06h-27.09l-5.57,21.06c-.77,3.41-2.01,3.56-6.04,3.56h-17.8c0-.93,.15-2.17,.46-3.72l25.39-91.81c.93-3.41,2.79-3.87,6.81-3.87h20.9Zm-20.44,57.75h19.35l-9.29-34.52h-.77l-9.29,34.52Zm18.11-65.33c-2.01,2.17-3.1,2.32-5.11,2.32h-8.98c0-.62,0-1.55,.62-2.32l13-15.79c1.86-2.17,2.94-2.63,4.8-2.63h8.82c1.24,0,1.86,.46,1.86,1.08,0,.77-.31,1.39-1.55,2.79l-13.47,14.55Z\"/>\n      </g>\n      <g>\n        <path class=\"d\" d=\"M426.17,123.39h88.43v-11.87h-88.26c-.07-1.37-.03-28.14-.21-40.51-.15-10.55,7.05-20.82,20.66-20.59,24.8,.41,49.63,.41,74.43-.02,10.69-.19,20.42,7.66,20.41,20.43,0,1.78-.01,3.96-.01,6.27h-88.51v11.59l88.51-.02c0,1.59,.03,28.4,0,40.87-.04,12.55-8.08,20.44-20.78,20.45-24.6,0-49.2,0-73.8,0-12.8,0-20.81-7.98-20.86-20.77,0-1.78,0-3.56,0-5.83\"/>\n        <path class=\"d\" d=\"M484,38.03c-10.46,0-18.92-8.62-18.86-19.2C465.2,8.43,473.7-.02,484.07,0c10.37,.02,18.85,8.51,18.87,18.9,.02,10.56-8.47,19.14-18.94,19.13\"/>\n      </g>\n      <g>\n        <path class=\"d\" d=\"M17.25,184.02c8.74,0,14.66,.27,14.66,4.64v2.64h-14.75c-4.1,0-6.56,1.73-6.56,4.28,0,8.56,23.68,6.1,23.68,21.49,0,7.47-4.83,13.39-18.67,13.39-8.1,0-15.57,0-15.57-4.19v-3.1H16.43c5.46,0,7.83-1.64,7.83-5.28,0-7.74-23.77-6.37-23.77-21.67,0-7.65,6.19-12.2,16.76-12.2Z\"/>\n        <path class=\"d\" d=\"M50.31,243.66h-9.56v-59.19h5.01c3.37,0,4.55,1.82,4.55,4.01v1.28c2.73-3,7.01-5.74,12.38-5.74,11.47,0,16.67,8.92,16.67,23.22s-5.19,23.22-16.67,23.22c-5.37,0-9.65-2.73-12.38-5.65v18.85Zm9.02-52.09c-3.55,0-6.56,1.46-9.02,3.37v24.5c2.46,1.91,5.46,3.37,9.02,3.37,7.38,0,10.11-5.37,10.11-15.57s-2.73-15.66-10.11-15.66Z\"/>\n        <path class=\"d\" d=\"M84.82,207.24c0-12.75,4.64-23.22,20.03-23.22s20.03,10.47,20.03,23.22-4.64,23.22-20.03,23.22-20.03-10.47-20.03-23.22Zm30.23,0c0-10.56-2.37-16.39-10.2-16.39s-10.11,5.83-10.11,16.39,2.28,16.39,10.11,16.39,10.2-5.74,10.2-16.39Z\"/>\n        <path class=\"d\" d=\"M141.91,180.83c-1.18,0-1.82-.36-2.91-1.55l-7.65-8.92c-.46-.46-.46-1-.46-1.37h4.19c1.28,0,1.82,.27,3.1,1.37l5.01,4.28,5.1-4.28c1.27-1.09,1.82-1.37,3.01-1.37h4.19c0,.36,0,.91-.36,1.37l-7.74,8.92c-1.09,1.18-1.73,1.55-2.91,1.55h-2.55Zm-9.47,49.17v-45.53h5.01c3.1,0,4.37,2.28,4.55,5.74,3.73-4.83,8.47-6.19,12.11-6.19,1.64,0,3.28,.46,3.28,2.28v7.1h-2.28c-7.01,0-10.38,1.46-13.11,3.37v33.24h-9.56Z\"/>\n        <path class=\"d\" d=\"M170.78,179.74h-9.56v-5.28c0-2.91,1.09-4.55,4.1-4.55h5.46v9.83Zm-9.56,4.74h5.37c3.01,0,4.19,1.64,4.19,4.55v40.98h-9.56v-45.53Z\"/>\n        <path class=\"d\" d=\"M192.36,184.47h10.2v7.1h-10.2v26.5c0,3.55,.46,4.92,3.55,4.92h6.65v2.37c0,3.82-3.28,4.92-8.47,4.92-10.38,0-11.29-5.55-11.29-12.2v-26.5h-6.01v-5.28l6.01-1.82,3.46-7.29c1-1.91,1.73-2.73,3.46-2.73h2.64v10.02Z\"/>\n        <path class=\"d\" d=\"M240.81,223.17v2.55c0,3.73-5.01,4.74-16.03,4.74-15.3,0-20.03-10.47-20.03-23.22s5.01-23.22,19.94-23.22c12.02,0,18.3,6.92,18.3,17.21,0,2.28,0,4.01-.46,8.56h-27.87c0,9.74,3.64,13.39,11.2,13.39h14.93Zm-7.47-19.76c.09-.82,.09-2.46,.09-3.46,0-4.1-1.73-9.11-8.65-9.11-6.37,0-9.74,3.64-10.11,12.57h18.67Z\"/>\n        <path class=\"d\" d=\"M259.84,230h-9.56v-55.55c0-2.91,1.09-4.55,4.1-4.55h5.46v60.1Z\"/>\n        <path class=\"d\" d=\"M269.86,230v-45.53h5.01c3.37,0,4.55,1.73,4.55,3.92v1.37c3.92-4.1,8.65-5.74,13.39-5.74,9.47,0,14.02,5.74,14.02,14.12v31.87h-9.56v-31.42c0-5.01-3.19-7.01-8.29-7.01-3.46,0-7.01,1.46-9.56,3.37v35.06h-9.56Z\"/>\n        <path class=\"d\" d=\"M346.35,230c-3.28,0-4.55-1.73-4.55-3.92v-1.28c-3.92,4.1-9.02,5.65-13.3,5.65-8.65,0-14.02-5.01-14.02-12.75,0-11.38,12.48-14.48,27.32-15.12v-3.82c0-5.74-4.1-7.47-9.93-7.47h-14.02v-2.64c0-4.37,5.46-4.64,15.57-4.64,11.29,0,17.94,4.74,17.94,14.3v31.69h-5.01Zm-4.55-21.67c-12.48,.18-17.21,2.64-17.21,8.01,0,4.74,3.46,6.37,8.1,6.37,3.37,0,6.83-1.27,9.11-3.28v-11.11Z\"/>\n      </g>\n    </g>\n  </g>\n</svg>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStripeHeaderLogoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-stripe-header-logo', standalone: true, template: "<svg id=\"b\" data-name=\"Ebene 2\" xmlns=\"http://www.w3.org/2000/svg\"  viewBox=\"0 0 541.63 243.66\">\n  <defs>\n    <style>\n      .d {\n        fill: #fff;\n      }\n    </style>\n  </defs>\n  <g id=\"c\" data-name=\"Ebene 1\">\n    <g>\n      <g>\n        <path class=\"d\" d=\"M43.19,50.15c20.75,0,27.4,3.25,27.4,11.3v8.21h-27.4c-15.33,0-20.13,6.66-20.13,30.81s4.8,30.81,20.13,30.81h27.4v8.21c0,8.05-6.66,11.3-27.4,11.3C14.86,150.78,0,135.61,0,100.46S14.86,50.15,43.19,50.15Zm-3.56-4.8c-1.86,0-2.94-.46-4.8-2.63l-13-15.79c-.62-.77-.62-1.7-.62-2.32h8.98c2.01,0,2.94,.46,5.11,2.32l7.43,6.35,7.28-6.35c2.32-1.86,3.1-2.32,5.26-2.32h8.82c0,.62,0,1.55-.62,2.32l-13,15.79c-1.86,2.17-2.94,2.63-4.95,2.63h-5.88Z\"/>\n        <path class=\"d\" d=\"M78.33,59.44c0-5.57,2.48-8.51,8.21-8.51h56.35v10.84c0,5.57-2.94,8.21-8.82,8.21h-33.29v20.59h36.38v17.8h-36.38v22.76h42.88v10.84c0,5.57-2.94,8.05-8.67,8.05h-48.46c-5.73,0-8.21-2.94-8.21-8.51V59.44Z\"/>\n        <path class=\"d\" d=\"M183.14,50.15c19.97,0,31.43,2.17,31.43,10.99v8.52h-29.26c-8.67,0-12.08,2.63-12.08,7.59,0,13.47,46.6,11.15,46.6,44.28,0,15.79-9.75,29.26-38.08,29.26-17.8,0-32.51-2.48-32.51-10.99v-8.52h33.6c8.82,0,13.16-2.79,13.16-8.51,0-14.55-46.44-12.39-46.44-46.14,0-14.86,10.53-26.47,33.6-26.47Z\"/>\n        <path class=\"d\" d=\"M252.81,96.75l28.8-41.65c2.32-3.56,3.56-4.18,6.5-4.18h20.75c0,1.39-.31,2.63-1.39,4.18l-31.89,43.81,33.44,46.91c.77,1.24,1.39,2.79,1.39,4.18h-19.82c-4.33,0-5.73-.31-8.52-4.49l-29.26-41.18v45.67h-22.45V59.44c0-5.57,2.48-8.51,8.21-8.51h14.24v45.83Z\"/>\n        <path class=\"d\" d=\"M364.73,50.61c4.03,0,5.88,.46,6.81,3.87l25.23,91.81c.31,1.39,.46,2.79,.46,3.72h-17.8c-4.02,0-5.26-.15-6.19-3.56l-5.57-21.06h-27.09l-5.57,21.06c-.77,3.41-2.01,3.56-6.04,3.56h-17.8c0-.93,.15-2.17,.46-3.72l25.39-91.81c.93-3.41,2.79-3.87,6.81-3.87h20.9Zm-20.44,57.75h19.35l-9.29-34.52h-.77l-9.29,34.52Zm18.11-65.33c-2.01,2.17-3.1,2.32-5.11,2.32h-8.98c0-.62,0-1.55,.62-2.32l13-15.79c1.86-2.17,2.94-2.63,4.8-2.63h8.82c1.24,0,1.86,.46,1.86,1.08,0,.77-.31,1.39-1.55,2.79l-13.47,14.55Z\"/>\n      </g>\n      <g>\n        <path class=\"d\" d=\"M426.17,123.39h88.43v-11.87h-88.26c-.07-1.37-.03-28.14-.21-40.51-.15-10.55,7.05-20.82,20.66-20.59,24.8,.41,49.63,.41,74.43-.02,10.69-.19,20.42,7.66,20.41,20.43,0,1.78-.01,3.96-.01,6.27h-88.51v11.59l88.51-.02c0,1.59,.03,28.4,0,40.87-.04,12.55-8.08,20.44-20.78,20.45-24.6,0-49.2,0-73.8,0-12.8,0-20.81-7.98-20.86-20.77,0-1.78,0-3.56,0-5.83\"/>\n        <path class=\"d\" d=\"M484,38.03c-10.46,0-18.92-8.62-18.86-19.2C465.2,8.43,473.7-.02,484.07,0c10.37,.02,18.85,8.51,18.87,18.9,.02,10.56-8.47,19.14-18.94,19.13\"/>\n      </g>\n      <g>\n        <path class=\"d\" d=\"M17.25,184.02c8.74,0,14.66,.27,14.66,4.64v2.64h-14.75c-4.1,0-6.56,1.73-6.56,4.28,0,8.56,23.68,6.1,23.68,21.49,0,7.47-4.83,13.39-18.67,13.39-8.1,0-15.57,0-15.57-4.19v-3.1H16.43c5.46,0,7.83-1.64,7.83-5.28,0-7.74-23.77-6.37-23.77-21.67,0-7.65,6.19-12.2,16.76-12.2Z\"/>\n        <path class=\"d\" d=\"M50.31,243.66h-9.56v-59.19h5.01c3.37,0,4.55,1.82,4.55,4.01v1.28c2.73-3,7.01-5.74,12.38-5.74,11.47,0,16.67,8.92,16.67,23.22s-5.19,23.22-16.67,23.22c-5.37,0-9.65-2.73-12.38-5.65v18.85Zm9.02-52.09c-3.55,0-6.56,1.46-9.02,3.37v24.5c2.46,1.91,5.46,3.37,9.02,3.37,7.38,0,10.11-5.37,10.11-15.57s-2.73-15.66-10.11-15.66Z\"/>\n        <path class=\"d\" d=\"M84.82,207.24c0-12.75,4.64-23.22,20.03-23.22s20.03,10.47,20.03,23.22-4.64,23.22-20.03,23.22-20.03-10.47-20.03-23.22Zm30.23,0c0-10.56-2.37-16.39-10.2-16.39s-10.11,5.83-10.11,16.39,2.28,16.39,10.11,16.39,10.2-5.74,10.2-16.39Z\"/>\n        <path class=\"d\" d=\"M141.91,180.83c-1.18,0-1.82-.36-2.91-1.55l-7.65-8.92c-.46-.46-.46-1-.46-1.37h4.19c1.28,0,1.82,.27,3.1,1.37l5.01,4.28,5.1-4.28c1.27-1.09,1.82-1.37,3.01-1.37h4.19c0,.36,0,.91-.36,1.37l-7.74,8.92c-1.09,1.18-1.73,1.55-2.91,1.55h-2.55Zm-9.47,49.17v-45.53h5.01c3.1,0,4.37,2.28,4.55,5.74,3.73-4.83,8.47-6.19,12.11-6.19,1.64,0,3.28,.46,3.28,2.28v7.1h-2.28c-7.01,0-10.38,1.46-13.11,3.37v33.24h-9.56Z\"/>\n        <path class=\"d\" d=\"M170.78,179.74h-9.56v-5.28c0-2.91,1.09-4.55,4.1-4.55h5.46v9.83Zm-9.56,4.74h5.37c3.01,0,4.19,1.64,4.19,4.55v40.98h-9.56v-45.53Z\"/>\n        <path class=\"d\" d=\"M192.36,184.47h10.2v7.1h-10.2v26.5c0,3.55,.46,4.92,3.55,4.92h6.65v2.37c0,3.82-3.28,4.92-8.47,4.92-10.38,0-11.29-5.55-11.29-12.2v-26.5h-6.01v-5.28l6.01-1.82,3.46-7.29c1-1.91,1.73-2.73,3.46-2.73h2.64v10.02Z\"/>\n        <path class=\"d\" d=\"M240.81,223.17v2.55c0,3.73-5.01,4.74-16.03,4.74-15.3,0-20.03-10.47-20.03-23.22s5.01-23.22,19.94-23.22c12.02,0,18.3,6.92,18.3,17.21,0,2.28,0,4.01-.46,8.56h-27.87c0,9.74,3.64,13.39,11.2,13.39h14.93Zm-7.47-19.76c.09-.82,.09-2.46,.09-3.46,0-4.1-1.73-9.11-8.65-9.11-6.37,0-9.74,3.64-10.11,12.57h18.67Z\"/>\n        <path class=\"d\" d=\"M259.84,230h-9.56v-55.55c0-2.91,1.09-4.55,4.1-4.55h5.46v60.1Z\"/>\n        <path class=\"d\" d=\"M269.86,230v-45.53h5.01c3.37,0,4.55,1.73,4.55,3.92v1.37c3.92-4.1,8.65-5.74,13.39-5.74,9.47,0,14.02,5.74,14.02,14.12v31.87h-9.56v-31.42c0-5.01-3.19-7.01-8.29-7.01-3.46,0-7.01,1.46-9.56,3.37v35.06h-9.56Z\"/>\n        <path class=\"d\" d=\"M346.35,230c-3.28,0-4.55-1.73-4.55-3.92v-1.28c-3.92,4.1-9.02,5.65-13.3,5.65-8.65,0-14.02-5.01-14.02-12.75,0-11.38,12.48-14.48,27.32-15.12v-3.82c0-5.74-4.1-7.47-9.93-7.47h-14.02v-2.64c0-4.37,5.46-4.64,15.57-4.64,11.29,0,17.94,4.74,17.94,14.3v31.69h-5.01Zm-4.55-21.67c-12.48,.18-17.21,2.64-17.21,8.01,0,4.74,3.46,6.37,8.1,6.37,3.37,0,6.83-1.27,9.11-3.28v-11.11Z\"/>\n      </g>\n    </g>\n  </g>\n</svg>\n" }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScStripeHeaderCartComponent {
    constructor() {
        this.cartAmount = 0;
        this.cartClick = new EventEmitter();
        this.classes = 'sc-stripe-header-cart';
    }
    handleCartClick() {
        this.cartClick.emit();
    }
}
ScStripeHeaderCartComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStripeHeaderCartComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScStripeHeaderCartComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScStripeHeaderCartComponent, isStandalone: true, selector: "sc-stripe-header-cart", inputs: { cartAmount: "cartAmount" }, outputs: { cartClick: "cartClick" }, host: { properties: { "class": "this.classes" } }, ngImport: i0, template: "<button sc-button icon=\"ico-cart\" class=\"sc-button-cart\" (click)=\"handleCartClick()\">\n  {{cartAmount | currency}}\n</button>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "pipe", type: i1.CurrencyPipe, name: "currency" }, { kind: "component", type: ScButtonComponent, selector: "button[sc-button], button[sc-icon-button]", inputs: ["disabled", "size", "active", "mode", "iconPlacement", "iconSize", "icon", "inverted"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScStripeHeaderCartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-stripe-header-cart', standalone: true, imports: [CommonModule, ScButtonComponent], template: "<button sc-button icon=\"ico-cart\" class=\"sc-button-cart\" (click)=\"handleCartClick()\">\n  {{cartAmount | currency}}\n</button>\n" }]
        }], propDecorators: { cartAmount: [{
                type: Input
            }], cartClick: [{
                type: Output
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
class ScInputResizeDirective {
    get el() {
        return this.elementRef.nativeElement;
    }
    constructor(inputElement, ctrl) {
        this.inputElement = inputElement;
        this.ctrl = ctrl;
        this.characterSize = 20; // widht of monotyped character in px
        this.spaceSize = 6; // widht of monotyped character in px
        this.numericFormating = true;
        this.autoResize = false;
        this.elementRef = this.inputElement;
    }
    ngOnInit() {
        if (!this.autoResize) {
            return;
        }
        this.recalcSize(this.parseValue(this.el.value));
        this.change$ = this.ctrl.valueChanges?.subscribe((value) => {
            this.recalcSize(this.parseValue(value));
        });
    }
    ngOnDestroy() {
        if (this.change$) {
            this.change$.unsubscribe();
        }
    }
    parseValue(value) {
        let out = value.toString();
        if (this.numericFormating) {
            out = this.formatNumber(out);
        }
        return out;
    }
    recalcSize(value = null) {
        if (!value)
            return;
        const spaces = value.split(' ').length - 1;
        const characters = value.length - spaces;
        this.el.style.width = characters * this.characterSize + spaces * this.spaceSize + this.spaceSize + 'px';
    }
    formatNumber(numberString) {
        // format number 1234567 to 1 234 567
        return numberString.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
}
ScInputResizeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScInputResizeDirective, deps: [{ token: i0.ElementRef }, { token: i2$1.NgControl }], target: i0.ɵɵFactoryTarget.Directive });
ScInputResizeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScInputResizeDirective, isStandalone: true, selector: "[scInputResize]", inputs: { characterSize: "characterSize", spaceSize: "spaceSize", number: "number", input: "input", numericFormating: "numericFormating", autoResize: "autoResize" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScInputResizeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[scInputResize]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i2$1.NgControl }]; }, propDecorators: { characterSize: [{
                type: Input
            }], spaceSize: [{
                type: Input
            }], number: [{
                type: Input
            }], input: [{
                type: Input
            }], numericFormating: [{
                type: Input
            }], autoResize: [{
                type: Input
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
class AmountInputComponent {
    constructor() {
        this.min = null;
        this.max = null;
        this.addon = null;
        this.autoResize = false;
        this.addonTemplate = null;
        this.footerTemplate = null;
        this.Focus = new EventEmitter();
        this.Click = new EventEmitter();
        this.Blur = new EventEmitter();
        this.pattern = '^\\d{1,3}(\\s\\d{3})*(\\.\\d+)?$';
        this.decimal = '.';
        this.enabledKeys = [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '0',
            'ArrowLeft',
            'ArrowRight',
            'Backspace',
            'Delete',
            'Tab',
        ];
        this.keyboardStep = 100;
        this.keyboardShiftStep = 1000;
        this.classes = 'sc-amount-input';
        this.disabled = false;
        this.value = 0;
        this.visibleValue = this.formatVisible(this.value);
        this.inputSize = 1;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    passFocus(event) {
        this.Focus.emit(event);
    }
    passClick(event) {
        this.Click.emit(event);
    }
    passBlur(event) {
        this.Blur.emit(event);
    }
    writeValue(value) {
        this.value = value;
        this.visibleValue = this.formatVisible(this.value);
        this.onChange(this.value);
    }
    formatVisible(value) {
        const outString = this.formatNumber(value.toString());
        return outString;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onKeyDown(event) {
        if (!this.enabledKeys.includes(event.key)) {
            event.preventDefault();
        }
    }
    onKeyUp(event) {
        if (!this.enabledKeys.includes(event.key)) {
            event.preventDefault();
        }
        const el = event.target;
        const caret_pos = el.selectionStart;
        let newVal = parseFloat(el.value.toString().replace(/\s/g, ''));
        let step = this.keyboardStep;
        if (event.shiftKey) {
            step = this.keyboardShiftStep;
        }
        if (event.key === 'ArrowUp') {
            newVal = newVal + step;
        }
        if (event.key === 'ArrowDown') {
            newVal = newVal - step;
        }
        this.writeValue(newVal);
        if (caret_pos) {
            setTimeout(() => {
                // caret_pos = updated_len - original_len + caret_pos;
                el.setSelectionRange(caret_pos, caret_pos);
            });
        }
    }
    formatNumber(numberString) {
        // format number 1234567 to 1 234 567
        return numberString.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
}
AmountInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: AmountInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AmountInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: AmountInputComponent, isStandalone: true, selector: "sc-amount-input", inputs: { min: "min", max: "max", addon: "addon", autoResize: "autoResize", addonTemplate: "addonTemplate", footerTemplate: "footerTemplate", keyboardStep: "keyboardStep", keyboardShiftStep: "keyboardShiftStep" }, outputs: { Focus: "Focus", Click: "Click", Blur: "Blur" }, host: { properties: { "class": "this.classes" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AmountInputComponent),
            multi: true,
        },
    ], viewQueries: [{ propertyName: "amountInput", first: true, predicate: ["amountInput"], descendants: true, static: true }], ngImport: i0, template: `
    <div class="sc-input-group" [class.sc-input-group-with-footer]="footerTemplate">
      <input
        #amountInput
        scInputResize
        [numericFormating]="true"
        [autoResize]="autoResize"
        class="sc-form-control sc-input"
        type="text"
        inputmode="numeric"
        [value]="visibleValue"
        [disabled]="disabled"
        (keydown)="onKeyDown($event)"
        (keyup)="onKeyUp($event)"
        (focus)="passFocus($event)"
        (click)="passClick($event)"
        (blur)="passBlur($event)"
        [pattern]="pattern"
        [min]="min"
        [max]="max"
      />
      <ng-container *ngIf="addon && !addonTemplate">
        <div class="sc-input-group-append">
          <span>{{ addon }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="addonTemplate">
        <div class="sc-input-group-append sc-input-group-append-custom">
          <ng-container *ngTemplateOutlet="addonTemplate"></ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="footerTemplate">
        <div class="sc-input-group-footer">
          <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
        </div>
      </ng-container>
    </div>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ScInputResizeDirective, selector: "[scInputResize]", inputs: ["characterSize", "spaceSize", "number", "input", "numericFormating", "autoResize"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: AmountInputComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-amount-input',
                    standalone: true,
                    imports: [CommonModule, ScInputResizeDirective],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => AmountInputComponent),
                            multi: true,
                        },
                    ],
                    template: `
    <div class="sc-input-group" [class.sc-input-group-with-footer]="footerTemplate">
      <input
        #amountInput
        scInputResize
        [numericFormating]="true"
        [autoResize]="autoResize"
        class="sc-form-control sc-input"
        type="text"
        inputmode="numeric"
        [value]="visibleValue"
        [disabled]="disabled"
        (keydown)="onKeyDown($event)"
        (keyup)="onKeyUp($event)"
        (focus)="passFocus($event)"
        (click)="passClick($event)"
        (blur)="passBlur($event)"
        [pattern]="pattern"
        [min]="min"
        [max]="max"
      />
      <ng-container *ngIf="addon && !addonTemplate">
        <div class="sc-input-group-append">
          <span>{{ addon }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="addonTemplate">
        <div class="sc-input-group-append sc-input-group-append-custom">
          <ng-container *ngTemplateOutlet="addonTemplate"></ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="footerTemplate">
        <div class="sc-input-group-footer">
          <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
        </div>
      </ng-container>
    </div>
  `,
                }]
        }], propDecorators: { amountInput: [{
                type: ViewChild,
                args: ['amountInput', { static: true }]
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], addon: [{
                type: Input
            }], autoResize: [{
                type: Input
            }], addonTemplate: [{
                type: Input
            }], footerTemplate: [{
                type: Input
            }], Focus: [{
                type: Output
            }], Click: [{
                type: Output
            }], Blur: [{
                type: Output
            }], keyboardStep: [{
                type: Input
            }], keyboardShiftStep: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class FormFieldComponent {
    constructor() {
        this.classes = 'sc-form-field';
        this.large = true;
        this.label = null;
    }
}
FormFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: FormFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: FormFieldComponent, isStandalone: true, selector: "sc-form-field", inputs: { label: "label" }, host: { properties: { "class": "this.classes", "class.sc-form-field-variant-large": "this.large" } }, ngImport: i0, template: `
    <label class="sc-label" *ngIf="label">{{ label }}</label>
    <div class="sc-form-field-input">
      <ng-content></ng-content>
    </div>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: FormFieldComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-form-field',
                    standalone: true,
                    imports: [CommonModule],
                    template: `
    <label class="sc-label" *ngIf="label">{{ label }}</label>
    <div class="sc-form-field-input">
      <ng-content></ng-content>
    </div>
  `,
                }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }], large: [{
                type: HostBinding,
                args: ['class.sc-form-field-variant-large']
            }], label: [{
                type: Input
            }] } });

class ScCollapsibleComponent {
    constructor() {
        this.collapsed = true;
        this.collapseLabel = 'Skrýt';
        this.expandLabel = 'Zobrazit';
        this.headerTemplate = null;
        this.centered = false;
        this.headerClass = '';
        this.contentClass = '';
        this.headerIcon = '';
        this.toggleOpened = new EventEmitter();
        this.onToggleFocus = new EventEmitter();
        this.onToggleBlur = new EventEmitter();
        this.class = 'sc-collapsible';
        this.contentId = 'collapsible-content-' + crypto.randomUUID();
        this.toggleLabel = '';
        this.headerIsHovered = false;
    }
    ngOnInit() {
        this.toggleLabel = this.collapsed ? this.expandLabel : this.collapseLabel;
    }
    toggleBlur() {
        this.onToggleBlur.emit();
    }
    toggleClick() {
        this.collapsed = !this.collapsed;
        this.toggleOpened.emit(!this.collapsed);
        if (this.collapsed) {
            this.toggleLabel = this.expandLabel;
            return;
        }
        this.toggleLabel = this.collapseLabel;
    }
    toggleFocus() {
        this.onToggleFocus.emit();
    }
}
ScCollapsibleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCollapsibleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScCollapsibleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScCollapsibleComponent, isStandalone: true, selector: "sc-collapsible", inputs: { collapsed: "collapsed", heading: "heading", headerText: "headerText", collapseLabel: "collapseLabel", expandLabel: "expandLabel", headerTemplate: "headerTemplate", centered: "centered", headerClass: "headerClass", contentClass: "contentClass", headerIcon: "headerIcon" }, outputs: { toggleOpened: "toggleOpened", onToggleFocus: "onToggleFocus", onToggleBlur: "onToggleBlur" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<div\n  class=\"sc-collapsible-header {{ headerClass }}\"\n  [ngClass]=\"centered ? 'justify-center' : 'justify-end'\"\n  (mouseenter)=\"this.headerIsHovered = true\"\n  (mouseleave)=\"this.headerIsHovered = false\"\n>\n  <div class=\"sc-collapsible-header-content\" *ngIf=\"headerTemplate || heading || headerIcon || headerText\">\n    <svg *ngIf=\"headerIcon\" class=\"w-24 h-24 mr-8 shrink-0\" sc-icon [icon]=\"headerIcon\"></svg>\n    <div class=\"sc-collapsible-header-typo\">\n      <h3 class=\"text-xl\" *ngIf=\"heading\">{{ heading }}</h3>\n      <p *ngIf=\"headerText\" class=\"mb-0\" [class.mt-16]=\"heading\">{{ headerText }}</p>\n      <ng-container *ngIf=\"headerTemplate\">\n        <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n      </ng-container>\n    </div>\n  </div>\n  <button\n    (blur)=\"toggleBlur()\"\n    (click)=\"toggleClick()\"\n    (focus)=\"toggleFocus()\"\n    [attr.aria-expanded]=\"!collapsed\"\n    [attr.aria-controls]=\"contentId\"\n    class=\"sc-collapsible-toggle sc-button tertiary icon-right sc-button-small\"\n    [class.hover]=\"headerIsHovered\"\n    [class.md:mt-0]=\"(headerTemplate || heading || headerText) && toggleLabel\"\n  >\n    <span *ngIf=\"toggleLabel\" class=\"sc-collapsible-toggle-label\">\n      {{ toggleLabel }}\n    </span>\n    <svg class=\"sc-collapsible-toggle-icon\" [class.expanded]=\"!collapsed\" sc-icon icon=\"ico-caret-down\"></svg>\n    <span class=\"sc-collapsible-toggle-clickable-area\"></span>\n  </button>\n</div>\n<div\n  [@collapse]=\"collapsed ? 'collapsed' : 'expanded'\"\n  class=\"sc-collapsible-content\"\n  [attr.aria-hidden]=\"collapsed\"\n  [id]=\"contentId\"\n  role=\"region\"\n>\n  <div [ngClass]=\"contentClass\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }], animations: [
        trigger('collapse', [
            state('collapsed', style({
                height: '0',
                opacity: '0',
            })),
            state('expanded', style({
                height: '*',
                opacity: '1',
            })),
            transition('collapsed <=> expanded', animate('300ms ease-out')),
        ]),
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScCollapsibleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-collapsible', standalone: true, imports: [CommonModule, ScIconModule], animations: [
                        trigger('collapse', [
                            state('collapsed', style({
                                height: '0',
                                opacity: '0',
                            })),
                            state('expanded', style({
                                height: '*',
                                opacity: '1',
                            })),
                            transition('collapsed <=> expanded', animate('300ms ease-out')),
                        ]),
                    ], template: "<div\n  class=\"sc-collapsible-header {{ headerClass }}\"\n  [ngClass]=\"centered ? 'justify-center' : 'justify-end'\"\n  (mouseenter)=\"this.headerIsHovered = true\"\n  (mouseleave)=\"this.headerIsHovered = false\"\n>\n  <div class=\"sc-collapsible-header-content\" *ngIf=\"headerTemplate || heading || headerIcon || headerText\">\n    <svg *ngIf=\"headerIcon\" class=\"w-24 h-24 mr-8 shrink-0\" sc-icon [icon]=\"headerIcon\"></svg>\n    <div class=\"sc-collapsible-header-typo\">\n      <h3 class=\"text-xl\" *ngIf=\"heading\">{{ heading }}</h3>\n      <p *ngIf=\"headerText\" class=\"mb-0\" [class.mt-16]=\"heading\">{{ headerText }}</p>\n      <ng-container *ngIf=\"headerTemplate\">\n        <ng-container *ngTemplateOutlet=\"headerTemplate\"></ng-container>\n      </ng-container>\n    </div>\n  </div>\n  <button\n    (blur)=\"toggleBlur()\"\n    (click)=\"toggleClick()\"\n    (focus)=\"toggleFocus()\"\n    [attr.aria-expanded]=\"!collapsed\"\n    [attr.aria-controls]=\"contentId\"\n    class=\"sc-collapsible-toggle sc-button tertiary icon-right sc-button-small\"\n    [class.hover]=\"headerIsHovered\"\n    [class.md:mt-0]=\"(headerTemplate || heading || headerText) && toggleLabel\"\n  >\n    <span *ngIf=\"toggleLabel\" class=\"sc-collapsible-toggle-label\">\n      {{ toggleLabel }}\n    </span>\n    <svg class=\"sc-collapsible-toggle-icon\" [class.expanded]=\"!collapsed\" sc-icon icon=\"ico-caret-down\"></svg>\n    <span class=\"sc-collapsible-toggle-clickable-area\"></span>\n  </button>\n</div>\n<div\n  [@collapse]=\"collapsed ? 'collapsed' : 'expanded'\"\n  class=\"sc-collapsible-content\"\n  [attr.aria-hidden]=\"collapsed\"\n  [id]=\"contentId\"\n  role=\"region\"\n>\n  <div [ngClass]=\"contentClass\">\n    <ng-content></ng-content>\n  </div>\n</div>\n" }]
        }], propDecorators: { collapsed: [{
                type: Input
            }], heading: [{
                type: Input
            }], headerText: [{
                type: Input
            }], collapseLabel: [{
                type: Input
            }], expandLabel: [{
                type: Input
            }], headerTemplate: [{
                type: Input
            }], centered: [{
                type: Input
            }], headerClass: [{
                type: Input
            }], contentClass: [{
                type: Input
            }], headerIcon: [{
                type: Input
            }], toggleOpened: [{
                type: Output
            }], onToggleFocus: [{
                type: Output
            }], onToggleBlur: [{
                type: Output
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class SmallModalComponent {
}
SmallModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: SmallModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SmallModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: SmallModalComponent, selector: "sc-small-modal", ngImport: i0, template: `
    <div class="sc-small-modal">
      <div class="sc-small-modal-card">
        <ng-content></ng-content>
      </div>
    </div>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: SmallModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-small-modal',
                    template: `
    <div class="sc-small-modal">
      <div class="sc-small-modal-card">
        <ng-content></ng-content>
      </div>
    </div>
  `,
                }]
        }] });

class SmallModalHeaderComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.headline = null;
        this.classes = 'sc-small-modal-header';
    }
    close() {
        this.dialogRef.close('Modal.Close');
    }
}
SmallModalHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: SmallModalHeaderComponent, deps: [{ token: ModalRef }], target: i0.ɵɵFactoryTarget.Component });
SmallModalHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: SmallModalHeaderComponent, selector: "sc-small-modal-header", inputs: { headline: "headline" }, host: { properties: { "class": "this.classes" } }, ngImport: i0, template: `
    <div
      class="sc-small-modal-header-content"
      [ngClass]="{ 'p-0': !headline }"
    >
      <button (click)="close()"
        class="sc-small-modal-close"
        sc-icon-button mode="tertiary" 
        icon="ico-error"
        size="small"></button>
      <h2 *ngIf="headline" class="sc-small-modal-header-title">
        {{ headline }}
      </h2>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ScButtonComponent, selector: "button[sc-button], button[sc-icon-button]", inputs: ["disabled", "size", "active", "mode", "iconPlacement", "iconSize", "icon", "inverted"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: SmallModalHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-small-modal-header', template: `
    <div
      class="sc-small-modal-header-content"
      [ngClass]="{ 'p-0': !headline }"
    >
      <button (click)="close()"
        class="sc-small-modal-close"
        sc-icon-button mode="tertiary" 
        icon="ico-error"
        size="small"></button>
      <h2 *ngIf="headline" class="sc-small-modal-header-title">
        {{ headline }}
      </h2>
    </div>
  ` }]
        }], ctorParameters: function () { return [{ type: ModalRef }]; }, propDecorators: { headline: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class SmallModalContentComponent {
    constructor() {
        this.classes = 'sc-small-modal-content';
    }
}
SmallModalContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: SmallModalContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SmallModalContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: SmallModalContentComponent, selector: "sc-small-modal-content", host: { properties: { "class": "this.classes" } }, ngImport: i0, template: `
    <div class="p-24">
      <ng-content></ng-content>
    </div>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: SmallModalContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-small-modal-content',
                    template: `
    <div class="p-24">
      <ng-content></ng-content>
    </div>
  `,
                }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class SmallModalFooterComponent {
    constructor() {
        this.classes = 'sc-small-modal-footer';
    }
}
SmallModalFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: SmallModalFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SmallModalFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: SmallModalFooterComponent, selector: "sc-small-modal-footer", host: { properties: { "class": "this.classes" } }, ngImport: i0, template: `
    <sc-divider></sc-divider>
    <div class="sc-small-modal-footer-content">
      <ng-content></ng-content>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: ScDividerComponent, selector: "sc-divider", inputs: ["vertical"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: SmallModalFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-small-modal-footer',
                    template: `
    <sc-divider></sc-divider>
    <div class="sc-small-modal-footer-content">
      <ng-content></ng-content>
    </div>
  `,
                }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScTabComponent {
    constructor() {
        this.title = 'Title';
        this.disabled = false;
        this.id = 'tab-' + crypto.randomUUID();
        this.isActive = false;
    }
}
ScTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTabComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScTabComponent, isStandalone: true, selector: "sc-tab", inputs: { title: "title", disabled: "disabled" }, ngImport: i0, template: "<div class=\"sc-tab-content\" role=\"tabpanel\" [id]=\"id\" [class.active]=\"isActive\">\n  <ng-content></ng-content>\n</div>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-tab', standalone: true, template: "<div class=\"sc-tab-content\" role=\"tabpanel\" [id]=\"id\" [class.active]=\"isActive\">\n  <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

class ScTabsComponent {
    constructor() {
        this.activeTabIndex = 0;
        this.inverted = false;
        this.ariaLabel = '';
        this.centered = false;
        this.tabSelect = new EventEmitter();
        this.showOverlayAfter = true;
        this.showOverlayBefore = false;
        this.scrollSubscription = new Subscription();
        this.scrollTimeThreshold = 100;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.selectTab(this.activeTabIndex);
        }, 0);
        this.scrollSubscription = fromEvent(this.tabsHeader.nativeElement, 'scroll')
            .pipe(debounceTime$1(this.scrollTimeThreshold))
            .subscribe(() => {
            this.showOverlayBefore = this.tabsHeader.nativeElement.scrollLeft > 0;
            this.showOverlayAfter =
                this.tabsHeader.nativeElement.scrollLeft !==
                    this.tabsHeader.nativeElement.scrollWidth - this.tabsHeader.nativeElement.clientWidth;
        });
    }
    selectTab(index) {
        this.activeTabIndex = index;
        this.tabs.forEach((tab, i) => {
            if (i === index) {
                const tabInfo = { id: tab.id, index: i, title: tab.title };
                this.tabSelect.emit(tabInfo);
            }
            tab.isActive = i === index;
        });
    }
    ngOnDestroy() {
        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
        }
    }
}
ScTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTabsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScTabsComponent, isStandalone: true, selector: "sc-tabs", inputs: { activeTabIndex: "activeTabIndex", inverted: "inverted", ariaLabel: "ariaLabel", centered: "centered" }, outputs: { tabSelect: "tabSelect" }, queries: [{ propertyName: "tabs", predicate: ScTabComponent }], viewQueries: [{ propertyName: "tabsHeader", first: true, predicate: ["tabsHeader"], descendants: true }], ngImport: i0, template: "<div class=\"sc-tabs\" [class.inverted]=\"inverted\" role=\"tablist\" [attr.aria-labelleby]=\"ariaLabel\">\n  <div class=\"sc-tabs-header-wrapper\">\n    <ul #tabsHeader class=\"sc-tabs-header\" [ngClass]=\"{ 'justify-center': centered }\">\n      <li class=\"sc-tabs-header-item\" *ngFor=\"let tab of tabs; let i = index\">\n        <button\n          class=\"sc-tabs-button\"\n          [class.active]=\"activeTabIndex === i\"\n          (click)=\"selectTab(i)\"\n          role=\"tab\"\n          [attr.aria-controls]=\"tab.id\"\n          [attr.aria-selected]=\"tab.isActive\"\n          [disabled]=\"tab.disabled\"\n        >\n          {{ tab.title }}\n        </button>\n      </li>\n    </ul>\n    <div class=\"sc-tabs-header-overlay sc-tabs-header-overlay-before\" [class.active]=\"showOverlayBefore\"></div>\n    <div class=\"sc-tabs-header-overlay sc-tabs-header-overlay-after\" [class.active]=\"showOverlayAfter\"></div>\n  </div>\n  <div class=\"sc-tabs-content\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sc-tabs', standalone: true, imports: [CommonModule], template: "<div class=\"sc-tabs\" [class.inverted]=\"inverted\" role=\"tablist\" [attr.aria-labelleby]=\"ariaLabel\">\n  <div class=\"sc-tabs-header-wrapper\">\n    <ul #tabsHeader class=\"sc-tabs-header\" [ngClass]=\"{ 'justify-center': centered }\">\n      <li class=\"sc-tabs-header-item\" *ngFor=\"let tab of tabs; let i = index\">\n        <button\n          class=\"sc-tabs-button\"\n          [class.active]=\"activeTabIndex === i\"\n          (click)=\"selectTab(i)\"\n          role=\"tab\"\n          [attr.aria-controls]=\"tab.id\"\n          [attr.aria-selected]=\"tab.isActive\"\n          [disabled]=\"tab.disabled\"\n        >\n          {{ tab.title }}\n        </button>\n      </li>\n    </ul>\n    <div class=\"sc-tabs-header-overlay sc-tabs-header-overlay-before\" [class.active]=\"showOverlayBefore\"></div>\n    <div class=\"sc-tabs-header-overlay sc-tabs-header-overlay-after\" [class.active]=\"showOverlayAfter\"></div>\n  </div>\n  <div class=\"sc-tabs-content\">\n    <ng-content></ng-content>\n  </div>\n</div>\n" }]
        }], propDecorators: { activeTabIndex: [{
                type: Input
            }], inverted: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], centered: [{
                type: Input
            }], tabSelect: [{
                type: Output
            }], tabs: [{
                type: ContentChildren,
                args: [ScTabComponent]
            }], tabsHeader: [{
                type: ViewChild,
                args: ['tabsHeader']
            }] } });

class ScPageProgressComponent {
    constructor() {
        this.class = 'sc-page-progress';
    }
}
ScPageProgressComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScPageProgressComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScPageProgressComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScPageProgressComponent, isStandalone: true, selector: "sc-page-progress", host: { properties: { "class": "this.class" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScPageProgressComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-page-progress',
                    standalone: true,
                    template: `<ng-content></ng-content>`,
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScListItemComponent {
    constructor() {
        this.icon = '';
        this.role = 'listitem';
        this.hostClass = 'sc-list-item';
    }
}
ScListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScListItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScListItemComponent, isStandalone: true, selector: "sc-list-item", inputs: { icon: "icon" }, host: { properties: { "role": "this.role", "class": "this.hostClass" } }, ngImport: i0, template: `<svg *ngIf="icon" sc-icon [icon]="icon" size="16" class="sc-list-item-icon"></svg>
    <ng-content></ng-content>`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ScIconModule }, { kind: "component", type: i2.ScIconComponent, selector: "[sc-icon]", inputs: ["icon", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScListItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-list-item',
                    standalone: true,
                    imports: [CommonModule, ScIconModule],
                    template: `<svg *ngIf="icon" sc-icon [icon]="icon" size="16" class="sc-list-item-icon"></svg>
    <ng-content></ng-content>`,
                }]
        }], propDecorators: { icon: [{
                type: Input
            }], role: [{
                type: HostBinding,
                args: ['role']
            }], hostClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ScListComponent {
    constructor() {
        this.mode = 'disc';
        this.icon = 'ico-disc';
        this.role = 'list';
    }
    get hostClass() {
        return {
            'sc-list': true,
            'sc-list-style-icon': this.mode !== 'plain',
        };
    }
    ngAfterViewInit() {
        if (this.mode !== 'plain') {
            if (this.mode === 'checkmark') {
                this.icon = 'ico-checkmark-circle';
            }
            setTimeout(() => {
                this.items.forEach((item) => {
                    item.icon = this.icon;
                });
            }, 0);
        }
    }
}
ScListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScListComponent, isStandalone: true, selector: "sc-list", inputs: { mode: "mode", icon: "icon" }, host: { properties: { "role": "this.role", "class": "this.hostClass" } }, queries: [{ propertyName: "items", predicate: ScListItemComponent }], ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-list',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { mode: [{
                type: Input
            }], icon: [{
                type: Input
            }], role: [{
                type: HostBinding,
                args: ['role']
            }], hostClass: [{
                type: HostBinding,
                args: ['class']
            }], items: [{
                type: ContentChildren,
                args: [ScListItemComponent]
            }] } });

class ScDropdownGroupComponent {
    constructor() {
        this.class = 'sc-dropdown-group';
    }
}
ScDropdownGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScDropdownGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScDropdownGroupComponent, isStandalone: true, selector: "sc-dropdown-group", inputs: { heading: "heading" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: ` <div *ngIf="heading" class="sc-dropdown-group-header">{{ heading }}</div>
    <ng-content></ng-content>`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-dropdown-group',
                    standalone: true,
                    imports: [CommonModule],
                    template: ` <div *ngIf="heading" class="sc-dropdown-group-header">{{ heading }}</div>
    <ng-content></ng-content>`,
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], heading: [{
                type: Input
            }] } });

class ScDropdownItemComponent {
    constructor() {
        this.mainClass = 'sc-dropdown-item';
        this.disabled = false;
    }
    get disabledClass() {
        return this.disabled ? 'disabled' : null;
    }
}
ScDropdownItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScDropdownItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScDropdownItemComponent, isStandalone: true, selector: "sc-dropdown-item", inputs: { disabled: "disabled" }, host: { properties: { "class.sc-dropdown-item": "this.mainClass", "class.disabled": "this.disabledClass" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-dropdown-item',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { mainClass: [{
                type: HostBinding,
                args: ['class.sc-dropdown-item']
            }], disabled: [{
                type: Input
            }], disabledClass: [{
                type: HostBinding,
                args: ['class.disabled']
            }] } });

let dropdownUniqueId$1 = 0;
class ScDropdownComponent extends NgxPopperjsContentComponent {
    constructor(elRef, _renderer, _viewRef, _changeDetectorRef) {
        super(elRef, _renderer, _viewRef, _changeDetectorRef);
        this.elRef = elRef;
        this._renderer = _renderer;
        this._viewRef = _viewRef;
        this._changeDetectorRef = _changeDetectorRef;
        this._uniqueId = `dropdown-${++dropdownUniqueId$1}`;
        this.dropdownId = this._uniqueId;
        this.arrowShow = true;
        this.contentPadding = true;
        this.itemsSeparated = false;
    }
}
ScDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ViewContainerRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
ScDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScDropdownComponent, isStandalone: true, selector: "sc-dropdown", inputs: { dropdownId: "dropdownId", arrowShow: "arrowShow", contentPadding: "contentPadding", itemsSeparated: "itemsSeparated" }, usesInheritance: true, ngImport: i0, template: `<div
    #popperViewRef
    [attr.id]="dropdownId"
    [style.display]="displayType"
    [attr.aria-hidden]="ariaHidden"
    [attr.role]="popperOptions.ariaRole"
    [ngClass]="['sc-dropdown', !arrowShow ? 'sc-dropdown-arrow-hidden' : '']"
  >
    <div
      class="sc-dropdown-content"
      [ngClass]="[
        contentPadding ? 'sc-dropdown-content-padding' : '',
        itemsSeparated ? 'sc-dropdown-items-separated' : ''
      ]"
    >
      <ng-content></ng-content>
    </div>
    <div
      *ngIf="arrowShow"
      data-popper-arrow
      [attr.aria-hidden]="true"
      class="ngxp__arrow sc-dropdown-arrow"
      [ngClass]="extractAppliedClassListExpr(popperOptions.applyArrowClass)"
    ></div>
  </div>`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-dropdown',
                    standalone: true,
                    imports: [CommonModule],
                    template: `<div
    #popperViewRef
    [attr.id]="dropdownId"
    [style.display]="displayType"
    [attr.aria-hidden]="ariaHidden"
    [attr.role]="popperOptions.ariaRole"
    [ngClass]="['sc-dropdown', !arrowShow ? 'sc-dropdown-arrow-hidden' : '']"
  >
    <div
      class="sc-dropdown-content"
      [ngClass]="[
        contentPadding ? 'sc-dropdown-content-padding' : '',
        itemsSeparated ? 'sc-dropdown-items-separated' : ''
      ]"
    >
      <ng-content></ng-content>
    </div>
    <div
      *ngIf="arrowShow"
      data-popper-arrow
      [attr.aria-hidden]="true"
      class="ngxp__arrow sc-dropdown-arrow"
      [ngClass]="extractAppliedClassListExpr(popperOptions.applyArrowClass)"
    ></div>
  </div>`,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ViewContainerRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { dropdownId: [{
                type: Input
            }], arrowShow: [{
                type: Input
            }], contentPadding: [{
                type: Input
            }], itemsSeparated: [{
                type: Input
            }] } });

let dropdownUniqueId = 0;
class ScDropdownTargetDirective extends NgxPopperjsDirective {
    constructor() {
        super(...arguments);
        this._uniqueId = `dropdown-${++dropdownUniqueId}`;
        this.dropdownTarget = this.getRefElement();
        this.dropdownId = this._uniqueId;
        this.hasPopup = true;
        this.isDropdownExpanded = false;
    }
    set contentFromAlias(content) {
        this.content = content;
    }
    get ariaControlsAttr() {
        return this.dropdownId;
    }
    toggleExpand() {
        this.isDropdownExpanded = !this.isDropdownExpanded;
    }
    ngAfterViewInit() {
        this.dropdownTarget.addEventListener('click', () => this.toggleExpand());
    }
}
ScDropdownTargetDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownTargetDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
ScDropdownTargetDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.0", type: ScDropdownTargetDirective, isStandalone: true, selector: "[sc-dropdown-target]", inputs: { dropdownId: "dropdownId", contentFromAlias: ["sc-dropdown-target", "contentFromAlias"] }, host: { properties: { "attr.aria-haspopup": "this.hasPopup", "attr.aria-controls": "this.ariaControlsAttr", "attr.aria-expanded": "this.isDropdownExpanded" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownTargetDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[sc-dropdown-target]',
                    standalone: true,
                }]
        }], propDecorators: { dropdownId: [{
                type: Input
            }], contentFromAlias: [{
                type: Input,
                args: ['sc-dropdown-target']
            }], hasPopup: [{
                type: HostBinding,
                args: ['attr.aria-haspopup']
            }], ariaControlsAttr: [{
                type: HostBinding,
                args: ['attr.aria-controls']
            }], isDropdownExpanded: [{
                type: HostBinding,
                args: ['attr.aria-expanded']
            }] } });

class ScDropdownModule extends NgxPopperjsModule {
}
ScDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownModule, deps: null, target: i0.ɵɵFactoryTarget.NgModule });
ScDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownModule, imports: [CommonModule,
        ScDropdownGroupComponent,
        ScDropdownItemComponent,
        ScDropdownTargetDirective,
        ScDropdownComponent, i1$3.NgxPopperjsModule], exports: [NgxPopperjsModule,
        ScDropdownComponent,
        ScDropdownTargetDirective,
        ScDropdownGroupComponent,
        ScDropdownItemComponent] });
ScDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownModule, imports: [CommonModule,
        ScDropdownGroupComponent,
        ScDropdownItemComponent,
        ScDropdownComponent,
        NgxPopperjsModule.forRoot({
            showDelay: 25,
            placement: NgxPopperjsPlacements.BOTTOMEND,
            hideOnClickOutside: true,
            preventOverflow: true,
            popperModifiers: [
                {
                    name: 'flip',
                    options: {
                        offset: ['top-end', 'bottom-end'],
                        rootBoundary: 'document',
                    },
                },
                {
                    name: 'arrow',
                    options: {
                        padding: 8, // 8px from the edges of the dropdown
                    },
                },
            ],
        }), NgxPopperjsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ScDropdownGroupComponent,
                        ScDropdownItemComponent,
                        ScDropdownTargetDirective,
                        ScDropdownComponent,
                        NgxPopperjsModule.forRoot({
                            showDelay: 25,
                            placement: NgxPopperjsPlacements.BOTTOMEND,
                            hideOnClickOutside: true,
                            preventOverflow: true,
                            popperModifiers: [
                                {
                                    name: 'flip',
                                    options: {
                                        offset: ['top-end', 'bottom-end'],
                                        rootBoundary: 'document',
                                    },
                                },
                                {
                                    name: 'arrow',
                                    options: {
                                        padding: 8, // 8px from the edges of the dropdown
                                    },
                                },
                            ],
                        }),
                    ],
                    exports: [
                        NgxPopperjsModule,
                        ScDropdownComponent,
                        ScDropdownTargetDirective,
                        ScDropdownGroupComponent,
                        ScDropdownItemComponent,
                    ],
                }]
        }] });

class ScSliderService {
    constructor() {
        this.isDragging = false;
    }
}
ScSliderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ScSliderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderService, decorators: [{
            type: Injectable
        }] });

class ScSliderHandleComponent {
    constructor(sliderService, cdr) {
        this.sliderService = sliderService;
        this.cdr = cdr;
        this.tooltipVisible = 'default';
        this.active = false;
        this.dir = 'ltr';
        this.style = {};
        this.enterHandle = () => {
            if (!this.sliderService.isDragging) {
                this.toggleTooltip(true);
                this.updateTooltipPosition();
                this.cdr.detectChanges();
            }
        };
        this.leaveHandle = () => {
            if (!this.sliderService.isDragging) {
                this.toggleTooltip(false);
                this.cdr.detectChanges();
            }
        };
    }
    ngOnChanges(changes) {
        const { offset, value, active, tooltipVisible, reverse, dir } = changes;
        if (offset || reverse || dir) {
            this.updateStyle();
        }
        if (value) {
            this.updateTooltipTitle();
            this.updateTooltipPosition();
        }
        if (active) {
            if (active.currentValue) {
                this.toggleTooltip(true);
            }
            else {
                this.toggleTooltip(false);
            }
        }
        if (tooltipVisible?.currentValue === 'always') {
            Promise.resolve().then(() => this.toggleTooltip(true, true));
        }
    }
    focus() {
        this.handleEl?.nativeElement.focus();
    }
    toggleTooltip(show, force = false) {
        // if (!force && (this.tooltipVisible !== 'default' || !this.tooltip)) {
        //   return;
        // }
        //
        // if (show) {
        //   this.tooltip?.show();
        // } else {
        //   this.tooltip?.hide();
        // }
    }
    updateTooltipTitle() {
        if (this.value)
            this.tooltipTitle = this.tooltipFormatter ? this.tooltipFormatter(this.value) : `${this.value}`;
    }
    updateTooltipPosition() {
        // if (this.tooltip) {
        //   Promise.resolve().then(() => this.tooltip?.updatePosition());
        // }
    }
    updateStyle() {
        const vertical = this.vertical;
        const reverse = this.reverse;
        let offset = this.offset;
        //console.log(offset);
        // patch huge
        if (offset && offset > 100) {
            offset = 100;
        }
        const positionStyle = vertical
            ? {
                [reverse ? 'top' : 'bottom']: `${offset}%`,
                [reverse ? 'bottom' : 'top']: 'auto',
                transform: reverse ? null : `translateY(+50%)`,
            }
            : {
                ...this.getHorizontalStylePosition(),
                transform: `translateX(${reverse ? (this.dir === 'rtl' ? '-' : '+') : this.dir === 'rtl' ? '+' : '-'}50%)`,
            };
        this.style = positionStyle;
        this.cdr.markForCheck();
    }
    getHorizontalStylePosition() {
        let offset = this.offset;
        if (this.offset && this.offset > 100) {
            offset = 100;
        }
        if (this.offset && this.offset < 0) {
            offset = 0;
        }
        let left = this.reverse ? 'auto' : `${offset}%`;
        let right = this.reverse ? `${this.offset}%` : 'auto';
        if (this.dir === 'rtl') {
            const tmp = left;
            left = right;
            right = tmp;
        }
        return { left, right };
    }
}
ScSliderHandleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderHandleComponent, deps: [{ token: ScSliderService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
ScSliderHandleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScSliderHandleComponent, selector: "sc-slider-handle", inputs: { vertical: "vertical", reverse: "reverse", offset: "offset", value: "value", tooltipVisible: "tooltipVisible", tooltipPlacement: "tooltipPlacement", tooltipFormatter: "tooltipFormatter", active: "active", dir: "dir" }, host: { listeners: { "mouseenter": "enterHandle()", "mouseleave": "leaveHandle()" } }, viewQueries: [{ propertyName: "handleEl", first: true, predicate: ["handle"], descendants: true }], usesOnChanges: true, ngImport: i0, template: ` <div #handle class="sc-slider-handle" tabindex="0" [ngStyle]="style"></div> `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderHandleComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    selector: 'sc-slider-handle',
                    preserveWhitespaces: false,
                    template: ` <div #handle class="sc-slider-handle" tabindex="0" [ngStyle]="style"></div> `,
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        '(mouseenter)': 'enterHandle()',
                        '(mouseleave)': 'leaveHandle()',
                    },
                }]
        }], ctorParameters: function () { return [{ type: ScSliderService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { handleEl: [{
                type: ViewChild,
                args: ['handle', { static: false }]
            }], vertical: [{
                type: Input
            }], reverse: [{
                type: Input
            }], offset: [{
                type: Input
            }], value: [{
                type: Input
            }], tooltipVisible: [{
                type: Input
            }], tooltipPlacement: [{
                type: Input
            }], tooltipFormatter: [{
                type: Input
            }], active: [{
                type: Input
            }], dir: [{
                type: Input
            }] } });

function arraysEqual(array1, array2) {
    if (!array1 || !array2 || array1.length !== array2.length) {
        return false;
    }
    const len = array1.length;
    for (let i = 0; i < len; i++) {
        if (array1[i] !== array2[i]) {
            return false;
        }
    }
    return true;
}
function getPercent(min, max, value) {
    return ((value - min) / (max - min)) * 100;
}
function getPrecision(num) {
    const numStr = num.toString();
    const dotIndex = numStr.indexOf('.');
    return dotIndex >= 0 ? numStr.length - dotIndex - 1 : 0;
}
function ensureNumberInRange(num, min, max) {
    if (isNaN(num) || num < min) {
        return min;
    }
    else if (num > max) {
        return max;
    }
    else {
        return num;
    }
}
function isNil(value) {
    return typeof value === 'undefined' || value === null;
}
function ArrayToMarks(numericArray) {
    const marks = {};
    numericArray.forEach((idx) => {
        marks[idx] = idx.toString();
    });
    return marks;
}
/**
 * This module provides utility functions to query DOM information or
 * set properties.
 */
/**
 * Silent an event by stopping and preventing it.
 */
function silentEvent(e) {
    e.stopPropagation();
    e.preventDefault();
}
function getElementOffset(elem) {
    if (!elem.getClientRects().length) {
        return { top: 0, left: 0 };
    }
    const rect = elem.getBoundingClientRect();
    const win = elem.ownerDocument?.defaultView;
    let axis = { top: 0, left: 0 };
    if (win) {
        axis = {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset,
        };
    }
    return axis;
}
/**
 * Investigate if an event is a `TouchEvent`.
 */
function isTouchEvent(event) {
    return event.type.startsWith('touch');
}
function getEventPosition(event) {
    return isTouchEvent(event) ? event.touches[0] || event.changedTouches[0] : event;
}

class ScSliderTrackComponent {
    constructor() {
        this.offset = 0;
        this.reverse = false;
        this.dir = 'ltr';
        this.length = 0;
        this.vertical = false;
        this.included = false;
        this.style = {};
    }
    ngOnChanges() {
        const vertical = this.vertical;
        const reverse = this.reverse;
        const visibility = this.included ? 'visible' : 'hidden';
        const offset = this.offset;
        const length = this.length;
        const positonStyle = vertical
            ? {
                [reverse ? 'top' : 'bottom']: `${offset}%`,
                [reverse ? 'bottom' : 'top']: 'auto',
                height: `${length}%`,
                visibility,
            }
            : {
                ...this.getHorizontalStylePosition(),
                width: `${length}%`,
                visibility,
            };
        this.style = positonStyle;
    }
    getHorizontalStylePosition() {
        let left = this.reverse ? 'auto' : `${this.offset}%`;
        let right = this.reverse ? `${this.offset}%` : 'auto';
        if (this.dir === 'rtl') {
            const tmp = left;
            left = right;
            right = tmp;
        }
        return { left, right };
    }
}
ScSliderTrackComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderTrackComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScSliderTrackComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScSliderTrackComponent, selector: "sc-slider-track", inputs: { offset: "offset", reverse: "reverse", dir: "dir", length: "length", vertical: "vertical", included: "included" }, usesOnChanges: true, ngImport: i0, template: ` <div class="sc-slider-track" [ngStyle]="style"></div>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderTrackComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    selector: 'sc-slider-track',
                    preserveWhitespaces: false,
                    template: ` <div class="sc-slider-track" [ngStyle]="style"></div>`,
                }]
        }], propDecorators: { offset: [{
                type: Input
            }], reverse: [{
                type: Input
            }], dir: [{
                type: Input
            }], length: [{
                type: Input
            }], vertical: [{
                type: Input
            }], included: [{
                type: Input
            }] } });

class ScSliderStepComponent {
    constructor() {
        this.lowerBound = null;
        this.upperBound = null;
        this.marksArray = [];
        this.vertical = false;
        this.included = false;
        this.steps = [];
    }
    ngOnChanges(changes) {
        const { marksArray, lowerBound, upperBound, reverse } = changes;
        if (marksArray || reverse) {
            this.buildSteps();
        }
        if (marksArray || lowerBound || upperBound || reverse) {
            this.togglePointActive();
        }
    }
    trackById(_index, step) {
        return step.value;
    }
    buildSteps() {
        const orient = this.vertical ? 'bottom' : 'left';
        this.steps = this.marksArray.map((mark) => {
            const { value, config } = mark;
            let offset = mark.offset;
            const range = this.max - this.min;
            if (this.reverse) {
                offset = ((this.max - value) / range) * 100;
            }
            return {
                value,
                offset,
                config,
                active: false,
                style: {
                    [orient]: `${offset}%`,
                },
            };
        });
    }
    togglePointActive() {
        if (this.steps && this.lowerBound !== null && this.upperBound !== null) {
            this.steps.forEach((step) => {
                const value = step.value;
                if (this.upperBound && this.lowerBound) {
                    const isActive = (!this.included && value === this.upperBound) ||
                        (this.included && value <= this.upperBound && value >= this.lowerBound);
                    step.active = isActive;
                }
            });
        }
    }
}
ScSliderStepComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderStepComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScSliderStepComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScSliderStepComponent, selector: "sc-slider-step", inputs: { lowerBound: "lowerBound", upperBound: "upperBound", marksArray: "marksArray", min: "min", max: "max", vertical: "vertical", included: "included", reverse: "reverse" }, usesOnChanges: true, ngImport: i0, template: `
    <div class="sc-slider-step">
      <span
        class="sc-slider-dot"
        *ngFor="let mark of steps; trackBy: trackById"
        [class.ant-slider-dot-active]="mark.active"
        [ngStyle]="mark.style!"
      ></span>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderStepComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    selector: 'sc-slider-step',
                    preserveWhitespaces: false,
                    template: `
    <div class="sc-slider-step">
      <span
        class="sc-slider-dot"
        *ngFor="let mark of steps; trackBy: trackById"
        [class.ant-slider-dot-active]="mark.active"
        [ngStyle]="mark.style!"
      ></span>
    </div>
  `,
                }]
        }], propDecorators: { lowerBound: [{
                type: Input
            }], upperBound: [{
                type: Input
            }], marksArray: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], vertical: [{
                type: Input
            }], included: [{
                type: Input
            }], reverse: [{
                type: Input
            }] } });

class ScSliderMarksComponent {
    constructor() {
        this.lowerBound = null;
        this.upperBound = null;
        this.marksArray = [];
        this.vertical = false;
        this.included = false;
        this.marks = [];
    }
    ngOnChanges(changes) {
        const { marksArray, lowerBound, upperBound, reverse } = changes;
        if (marksArray || reverse) {
            this.buildMarks();
        }
        if (marksArray || lowerBound || upperBound || reverse) {
            this.togglePointActive();
        }
    }
    trackById(_index, mark) {
        return mark.value;
    }
    buildMarks() {
        const range = this.max - this.min;
        this.marks = this.marksArray.map((mark) => {
            const { value, offset, config } = mark;
            const style = this.getMarkStyles(value, range, config);
            const label = isConfigObject(config) ? config.label : config;
            return {
                label,
                offset,
                style,
                value,
                config,
                active: false,
            };
        });
    }
    getMarkStyles(value, range, config) {
        let style;
        const markValue = this.reverse ? this.max + this.min - value : value;
        if (this.vertical) {
            style = {
                marginBottom: '-50%',
                bottom: `${((markValue - this.min) / range) * 100}%`,
            };
        }
        else {
            style = {
                transform: `translate3d(-50%, 0, 0)`,
                left: `${((markValue - this.min) / range) * 100}%`,
            };
        }
        if (isConfigObject(config) && config.style) {
            style = { ...style, ...config.style };
        }
        return style;
    }
    togglePointActive() {
        if (this.marks && this.lowerBound !== null && this.upperBound !== null) {
            this.marks.forEach((mark) => {
                const value = mark.value;
                if (this.upperBound && this.lowerBound) {
                    const isActive = (!this.included && value === this.upperBound) ||
                        (this.included && value <= this.upperBound && value >= this.lowerBound);
                    mark.active = isActive;
                }
            });
        }
    }
}
ScSliderMarksComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderMarksComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScSliderMarksComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScSliderMarksComponent, selector: "sc-slider-marks", inputs: { lowerBound: "lowerBound", upperBound: "upperBound", marksArray: "marksArray", min: "min", max: "max", vertical: "vertical", included: "included", reverse: "reverse" }, usesOnChanges: true, ngImport: i0, template: `
    <div class="sc-slider-mark">
      <span
        class="sc-slider-mark-text"
        *ngFor="let attr of marks; trackBy: trackById"
        [class.ant-slider-mark-active]="attr.active"
        [ngStyle]="attr.style!"
        [innerHTML]="attr.label"
      ></span>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderMarksComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    preserveWhitespaces: false,
                    selector: 'sc-slider-marks',
                    template: `
    <div class="sc-slider-mark">
      <span
        class="sc-slider-mark-text"
        *ngFor="let attr of marks; trackBy: trackById"
        [class.ant-slider-mark-active]="attr.active"
        [ngStyle]="attr.style!"
        [innerHTML]="attr.label"
      ></span>
    </div>
  `,
                }]
        }], propDecorators: { lowerBound: [{
                type: Input
            }], upperBound: [{
                type: Input
            }], marksArray: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], vertical: [{
                type: Input
            }], included: [{
                type: Input
            }], reverse: [{
                type: Input
            }] } });
function isConfigObject(config) {
    return typeof config !== 'string';
}

class ScSliderComponent {
    set scMax(val) {
        this._scMax = val;
        this.forceUpdate();
    }
    get scMax() {
        return this._scMax;
    }
    set scMin(val) {
        this._scMin = val;
        this.forceUpdate();
    }
    get scMin() {
        return this._scMin;
    }
    constructor(sliderService, cdr, platform, directionality) {
        this.sliderService = sliderService;
        this.cdr = cdr;
        this.platform = platform;
        this.directionality = directionality;
        this.scDisabled = false;
        this.scDots = false;
        this.scIncluded = true;
        this.scRange = false;
        this.scVertical = false;
        this.scReverse = false;
        this.scMarks = null;
        this._scMax = 100;
        this._scMin = 0;
        this.scStep = 1;
        this.scTooltipVisible = 'default';
        this.scTooltipPlacement = 'top';
        this.scOnAfterChange = new EventEmitter();
        this.value = 0;
        this.cacheSliderStart = null;
        this.cacheSliderLength = null;
        this.activeValueIndex = undefined; // Current activated handle's index ONLY for range=true
        this.track = { offset: null, length: null }; // Track's offset and length
        this.handles = []; // Handles' offset
        this.marksArray = null; // "steps" in array type with more data & FILTER out the invalid mark
        this.bounds = { lower: null, upper: null }; // now for nz-slider-step
        this.dir = 'ltr';
        this.destroy$ = new Subject();
        this.isScDisableFirstChange = true;
    }
    ngOnInit() {
        this.dir = this.directionality.value;
        this.directionality.change?.pipe(takeUntil(this.destroy$)).subscribe((direction) => {
            this.dir = direction;
            this.cdr.detectChanges();
            this.updateTrackAndHandles();
            this.onValueChange(this.getValue(true));
        });
        this.handles = generateHandlers(this.scRange ? 2 : 1);
        this.updateMarks();
        this.bindDraggingHandlers();
        this.toggleDragDisabled(this.scDisabled);
        if (this.getValue() === null) {
            this.setValue(this.formatValue(null));
        }
    }
    ngOnChanges(changes) {
        const { scDisabled, scMarks, scRange } = changes;
        if (scDisabled && !scDisabled.firstChange) {
            this.toggleDragDisabled(scDisabled.currentValue);
        }
        else if (scMarks && !scMarks.firstChange) {
            this.updateMarks();
        }
        else if (scRange && !scRange.firstChange) {
            this.handles = generateHandlers(scRange.currentValue ? 2 : 1);
            this.setValue(this.formatValue(null));
        }
    }
    ngOnDestroy() {
        this.unsubscribeDrag();
        this.destroy$.next(0); //?? @todo what value shoud subject need ??
        this.destroy$.complete();
    }
    writeValue(val) {
        this.setValue(val, true);
    }
    onValueChange(_value) { }
    onTouched() { }
    registerOnChange(fn) {
        this.onValueChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.scDisabled = (this.isScDisableFirstChange && this.scDisabled) || isDisabled;
        this.isScDisableFirstChange = false;
        this.toggleDragDisabled(isDisabled);
        this.cdr.markForCheck();
    }
    /**
     * Event handler is only triggered when a slider handler is focused.
     */
    onKeyDown(e) {
        if (this.scDisabled) {
            return;
        }
        const code = e.keyCode;
        const isIncrease = code === RIGHT_ARROW || code === UP_ARROW;
        const isDecrease = code === LEFT_ARROW || code === DOWN_ARROW;
        if (!(isIncrease || isDecrease)) {
            return;
        }
        e.preventDefault();
        let step = (isDecrease ? -this.scStep : this.scStep) * (this.scReverse ? -1 : 1);
        step = this.dir === 'rtl' ? step * -1 : step;
        const newVal = this.scRange
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ? this.value[this.activeValueIndex] + step
            : this.value + step;
        this.setActiveValue(ensureNumberInRange(newVal, this.scMin, this.scMax));
        this.scOnAfterChange.emit(this.getValue(true));
    }
    onHandleFocusIn(index) {
        this.activeValueIndex = index;
    }
    setValue(value, isWriteValue = false) {
        if (isWriteValue) {
            this.value = this.formatValue(value);
            this.updateTrackAndHandles();
        }
        else if (!valuesEqual$2(this.value, value)) {
            this.value = value;
            this.updateTrackAndHandles();
            this.onValueChange(this.getValue(true));
        }
    }
    getValue(cloneAndSort = false) {
        if (cloneAndSort && this.value && isValueRange(this.value)) {
            return [...this.value].sort((a, b) => a - b);
        }
        return this.value;
    }
    /**
     * Clone & sort current value and convert them to offsets, then return the new one.
     */
    getValueToOffset(value) {
        let normalizedValue = value;
        if (typeof normalizedValue === 'undefined') {
            normalizedValue = this.getValue(true);
        }
        return isValueRange(normalizedValue)
            ? normalizedValue.map((val) => this.valueToOffset(val))
            : this.valueToOffset(normalizedValue);
    }
    /**
     * Find the closest value to be activated.
     */
    setActiveValueIndex(pointerValue) {
        const value = this.getValue();
        if (isValueRange(value)) {
            let minimal = null;
            let gap;
            let activeIndex = -1;
            value.forEach((val, index) => {
                gap = Math.abs(pointerValue - val);
                if (minimal === null || gap < minimal) {
                    minimal = gap;
                    activeIndex = index;
                }
            });
            this.activeValueIndex = activeIndex;
            this.handlerComponents.toArray()[activeIndex].focus();
        }
        else {
            this.handlerComponents.toArray()[0].focus();
        }
    }
    setActiveValue(pointerValue) {
        if (isValueRange(this.value)) {
            const newValue = [...this.value];
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            newValue[this.activeValueIndex] = pointerValue;
            this.setValue(newValue);
        }
        else {
            this.setValue(pointerValue);
        }
    }
    /**
     * Update track and handles' position and length.
     */
    updateTrackAndHandles() {
        const value = this.getValue();
        const offset = this.getValueToOffset(value);
        const valueSorted = this.getValue(true);
        const offsetSorted = this.getValueToOffset(valueSorted);
        const boundParts = isValueRange(valueSorted) ? valueSorted : [0, valueSorted];
        const trackParts = isValueRange(offsetSorted)
            ? [offsetSorted[0], offsetSorted[1] - offsetSorted[0]]
            : [0, offsetSorted];
        this.handles.forEach((handle, index) => {
            handle.offset = isValueRange(offset) ? offset[index] : offset;
            handle.value = isValueRange(value) ? value[index] : value || 0;
        });
        [this.bounds.lower, this.bounds.upper] = boundParts;
        [this.track.offset, this.track.length] = trackParts;
        this.cdr.markForCheck();
    }
    updateMarks() {
        this.marksArray = this.scMarks ? this.generateMarkItems(this.scMarks) : null;
    }
    forceUpdate() {
        this.updateMarks();
        this.updateTrackAndHandles();
        this.cdr.markForCheck();
    }
    onDragStart(value) {
        this.toggleDragMoving(true);
        this.cacheSliderProperty();
        this.setActiveValueIndex(this.getLogicalValue(value));
        this.setActiveValue(this.getLogicalValue(value));
        this.showHandleTooltip(this.scRange ? this.activeValueIndex : 0);
    }
    onDragMove(value) {
        this.setActiveValue(this.getLogicalValue(value));
        this.cdr.markForCheck();
    }
    getLogicalValue(value) {
        if (this.scReverse) {
            if (!this.scVertical && this.dir === 'rtl') {
                return value;
            }
            return this.scMax - value + this.scMin;
        }
        if (!this.scVertical && this.dir === 'rtl') {
            return this.scMax - value + this.scMin;
        }
        return value;
    }
    onDragEnd() {
        this.scOnAfterChange.emit(this.getValue(true));
        this.toggleDragMoving(false);
        this.cacheSliderProperty(true);
        this.hideAllHandleTooltip();
        this.cdr.markForCheck();
    }
    /**
     * Create user interactions handles.
     */
    bindDraggingHandlers() {
        if (!this.platform.isBrowser) {
            return;
        }
        const sliderDOM = this.slider.nativeElement;
        const orientField = this.scVertical ? 'pageY' : 'pageX';
        const mouse = {
            start: 'mousedown',
            move: 'mousemove',
            end: 'mouseup',
            pluckKey: [orientField],
        };
        const touch = {
            start: 'touchstart',
            move: 'touchmove',
            end: 'touchend',
            pluckKey: ['touches', '0', orientField],
            filter: (e) => e instanceof TouchEvent,
        };
        [mouse, touch].forEach((source) => {
            const { start, move, end, pluckKey, filter: filterFunc = () => true } = source;
            source.startPlucked$ = fromEvent(sliderDOM, start).pipe(filter(filterFunc), tap(silentEvent), 
            // @todo check pluck issues, fix ts lint
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            pluck(...pluckKey), map((position) => this.findClosestValue(position)));
            source.end$ = fromEvent(document, end);
            source.moveResolved$ = fromEvent(document, move).pipe(filter(filterFunc), tap(silentEvent), 
            // @todo check pluck issues + fix tslint
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            pluck(...pluckKey), 
            // @todo check distinctUntilChanged issues + fix ts lint
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            distinctUntilChanged(), map((position) => this.findClosestValue(position)), distinctUntilChanged(), takeUntil(source.end$));
        });
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.dragStart$ = merge(mouse.startPlucked$, touch.startPlucked$);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.dragMove$ = merge(mouse.moveResolved$, touch.moveResolved$);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.dragEnd$ = merge(mouse.end$, touch.end$);
    }
    subscribeDrag(periods = ['start', 'move', 'end']) {
        if (periods.indexOf('start') !== -1 && this.dragStart$ && !this.dragStart_) {
            this.dragStart_ = this.dragStart$.subscribe(this.onDragStart.bind(this));
        }
        if (periods.indexOf('move') !== -1 && this.dragMove$ && !this.dragMove_) {
            this.dragMove_ = this.dragMove$.subscribe(this.onDragMove.bind(this));
        }
        if (periods.indexOf('end') !== -1 && this.dragEnd$ && !this.dragEnd_) {
            this.dragEnd_ = this.dragEnd$.subscribe(this.onDragEnd.bind(this));
        }
    }
    unsubscribeDrag(periods = ['start', 'move', 'end']) {
        if (periods.indexOf('start') !== -1 && this.dragStart_) {
            this.dragStart_.unsubscribe();
            this.dragStart_ = null;
        }
        if (periods.indexOf('move') !== -1 && this.dragMove_) {
            this.dragMove_.unsubscribe();
            this.dragMove_ = null;
        }
        if (periods.indexOf('end') !== -1 && this.dragEnd_) {
            this.dragEnd_.unsubscribe();
            this.dragEnd_ = null;
        }
    }
    toggleDragMoving(movable) {
        const periods = ['move', 'end'];
        if (movable) {
            this.sliderService.isDragging = true;
            this.subscribeDrag(periods);
        }
        else {
            this.sliderService.isDragging = false;
            this.unsubscribeDrag(periods);
        }
    }
    toggleDragDisabled(disabled) {
        if (disabled) {
            this.unsubscribeDrag();
        }
        else {
            this.subscribeDrag(['start']);
        }
    }
    findClosestValue(position) {
        const sliderStart = this.getSliderStartPosition();
        const sliderLength = this.getSliderLength();
        const ratio = ensureNumberInRange((position - sliderStart) / sliderLength, 0, 1);
        const val = (this.scMax - this.scMin) * (this.scVertical ? 1 - ratio : ratio) + this.scMin;
        const points = this.scMarks === null
            ? []
            : Object.keys(this.scMarks)
                .map(parseFloat)
                .sort((a, b) => a - b);
        if (this.scStep !== 0 && !this.scDots) {
            const closestOne = Math.round(val / this.scStep) * this.scStep;
            points.push(closestOne);
        }
        const gaps = points.map((point) => Math.abs(val - point));
        const closest = points[gaps.indexOf(Math.min(...gaps))];
        // return parseFloat(closest.toFixed(getPrecision(this.nzStep)));
        return this.scStep === 0 ? closest : parseFloat(closest.toFixed(getPrecision(this.scStep)));
    }
    valueToOffset(value) {
        return getPercent(this.scMin, this.scMax, value);
    }
    getSliderStartPosition() {
        if (this.cacheSliderStart !== null) {
            return this.cacheSliderStart;
        }
        const offset = getElementOffset(this.slider.nativeElement);
        return this.scVertical ? offset.top : offset.left;
    }
    getSliderLength() {
        if (this.cacheSliderLength !== null) {
            return this.cacheSliderLength;
        }
        const sliderDOM = this.slider.nativeElement;
        return this.scVertical ? sliderDOM.clientHeight : sliderDOM.clientWidth;
    }
    /**
     * Cache DOM layout/reflow operations for performance (may not necessary?)
     */
    cacheSliderProperty(remove = false) {
        this.cacheSliderStart = remove ? null : this.getSliderStartPosition();
        this.cacheSliderLength = remove ? null : this.getSliderLength();
    }
    formatValue(value) {
        if (isNil(value)) {
            return this.scRange ? [this.scMin, this.scMax] : this.scMin;
        }
        else if (assertValueValid(value, this.scRange)) {
            return isValueRange(value)
                ? value.map((val) => ensureNumberInRange(val, this.scMin, this.scMax))
                : ensureNumberInRange(value, this.scMin, this.scMax);
        }
        else {
            return this.scDefaultValue ? this.scDefaultValue : this.scRange ? [this.scMin, this.scMax] : this.scMin;
        }
    }
    /**
     * Show one handle's tooltip and hide others'.
     */
    showHandleTooltip(handleIndex = 0) {
        this.handles.forEach((handle, index) => {
            handle.active = index === handleIndex;
        });
    }
    hideAllHandleTooltip() {
        this.handles.forEach((handle) => (handle.active = false));
    }
    generateMarkItems(marks) {
        const marksArray = [];
        for (const key in marks) {
            // eslint-disable-next-line no-prototype-builtins
            if (marks.hasOwnProperty(key)) {
                const mark = marks[key];
                const val = typeof key === 'number' ? key : parseFloat(key);
                if (val >= this.scMin && val <= this.scMax) {
                    marksArray.push({ value: val, offset: this.valueToOffset(val), config: mark });
                }
            }
        }
        return marksArray.length ? marksArray : null;
    }
}
ScSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderComponent, deps: [{ token: ScSliderService }, { token: i0.ChangeDetectorRef }, { token: i2$2.Platform }, { token: i3.Directionality, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ScSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScSliderComponent, selector: "sc-slider", inputs: { scDisabled: "scDisabled", scDots: "scDots", scIncluded: "scIncluded", scRange: "scRange", scVertical: "scVertical", scReverse: "scReverse", scDefaultValue: "scDefaultValue", scMarks: "scMarks", scMax: "scMax", scMin: "scMin", scStep: "scStep", scTooltipVisible: "scTooltipVisible", scTooltipPlacement: "scTooltipPlacement", scTipFormatter: "scTipFormatter" }, outputs: { scOnAfterChange: "scOnAfterChange" }, host: { listeners: { "keydown": "onKeyDown($event)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScSliderComponent),
            multi: true,
        },
        ScSliderService,
    ], viewQueries: [{ propertyName: "slider", first: true, predicate: ["slider"], descendants: true, static: true }, { propertyName: "handlerComponents", predicate: ScSliderHandleComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div
      #slider
      class="sc-slider"
      [class.sc-slider-rtl]="dir === 'rtl'"
      [class.sc-slider-disabled]="scDisabled"
      [class.sc-slider-vertical]="scVertical"
      [class.sc-slider-with-marks]="marksArray"
    >
      <div class="sc-slider-rail"></div>
      <sc-slider-track
        [vertical]="scVertical"
        [included]="scIncluded"
        [offset]="track.offset!"
        [length]="track.length!"
        [reverse]="scReverse"
        [dir]="dir"
      ></sc-slider-track>
      <sc-slider-step
        *ngIf="marksArray"
        [vertical]="scVertical"
        [min]="scMin"
        [max]="scMax"
        [lowerBound]="$any(bounds.lower)"
        [upperBound]="$any(bounds.upper)"
        [marksArray]="marksArray"
        [included]="scIncluded"
        [reverse]="scReverse"
      ></sc-slider-step>
      <sc-slider-handle
        *ngFor="let handle of handles; index as handleIndex"
        [vertical]="scVertical"
        [reverse]="scReverse"
        [offset]="handle.offset!"
        [value]="handle.value!"
        [active]="handle.active"
        [dir]="dir"
        (focusin)="onHandleFocusIn(handleIndex)"
      ></sc-slider-handle>
      <sc-slider-marks
        *ngIf="marksArray"
        [vertical]="scVertical"
        [min]="scMin"
        [max]="scMax"
        [lowerBound]="$any(bounds.lower)"
        [upperBound]="$any(bounds.upper)"
        [marksArray]="marksArray"
        [included]="scIncluded"
        [reverse]="scReverse"
      ></sc-slider-marks>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ScSliderHandleComponent, selector: "sc-slider-handle", inputs: ["vertical", "reverse", "offset", "value", "tooltipVisible", "tooltipPlacement", "tooltipFormatter", "active", "dir"] }, { kind: "component", type: ScSliderTrackComponent, selector: "sc-slider-track", inputs: ["offset", "reverse", "dir", "length", "vertical", "included"] }, { kind: "component", type: ScSliderStepComponent, selector: "sc-slider-step", inputs: ["lowerBound", "upperBound", "marksArray", "min", "max", "vertical", "included", "reverse"] }, { kind: "component", type: ScSliderMarksComponent, selector: "sc-slider-marks", inputs: ["lowerBound", "upperBound", "marksArray", "min", "max", "vertical", "included", "reverse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderComponent, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    selector: 'sc-slider',
                    preserveWhitespaces: false,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ScSliderComponent),
                            multi: true,
                        },
                        ScSliderService,
                    ],
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        '(keydown)': 'onKeyDown($event)',
                    },
                    template: `
    <div
      #slider
      class="sc-slider"
      [class.sc-slider-rtl]="dir === 'rtl'"
      [class.sc-slider-disabled]="scDisabled"
      [class.sc-slider-vertical]="scVertical"
      [class.sc-slider-with-marks]="marksArray"
    >
      <div class="sc-slider-rail"></div>
      <sc-slider-track
        [vertical]="scVertical"
        [included]="scIncluded"
        [offset]="track.offset!"
        [length]="track.length!"
        [reverse]="scReverse"
        [dir]="dir"
      ></sc-slider-track>
      <sc-slider-step
        *ngIf="marksArray"
        [vertical]="scVertical"
        [min]="scMin"
        [max]="scMax"
        [lowerBound]="$any(bounds.lower)"
        [upperBound]="$any(bounds.upper)"
        [marksArray]="marksArray"
        [included]="scIncluded"
        [reverse]="scReverse"
      ></sc-slider-step>
      <sc-slider-handle
        *ngFor="let handle of handles; index as handleIndex"
        [vertical]="scVertical"
        [reverse]="scReverse"
        [offset]="handle.offset!"
        [value]="handle.value!"
        [active]="handle.active"
        [dir]="dir"
        (focusin)="onHandleFocusIn(handleIndex)"
      ></sc-slider-handle>
      <sc-slider-marks
        *ngIf="marksArray"
        [vertical]="scVertical"
        [min]="scMin"
        [max]="scMax"
        [lowerBound]="$any(bounds.lower)"
        [upperBound]="$any(bounds.upper)"
        [marksArray]="marksArray"
        [included]="scIncluded"
        [reverse]="scReverse"
      ></sc-slider-marks>
    </div>
  `,
                }]
        }], ctorParameters: function () { return [{ type: ScSliderService }, { type: i0.ChangeDetectorRef }, { type: i2$2.Platform }, { type: i3.Directionality, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { slider: [{
                type: ViewChild,
                args: ['slider', { static: true }]
            }], handlerComponents: [{
                type: ViewChildren,
                args: [ScSliderHandleComponent]
            }], scDisabled: [{
                type: Input
            }], scDots: [{
                type: Input
            }], scIncluded: [{
                type: Input
            }], scRange: [{
                type: Input
            }], scVertical: [{
                type: Input
            }], scReverse: [{
                type: Input
            }], scDefaultValue: [{
                type: Input
            }], scMarks: [{
                type: Input
            }], scMax: [{
                type: Input
            }], scMin: [{
                type: Input
            }], scStep: [{
                type: Input
            }], scTooltipVisible: [{
                type: Input
            }], scTooltipPlacement: [{
                type: Input
            }], scTipFormatter: [{
                type: Input
            }], scOnAfterChange: [{
                type: Output
            }] } });
function getValueTypeNotMatchError() {
    return new Error(`The "scRange" can't match the "ngModel"'s type, please check these properties: "scRange", "ngModel", "scDefaultValue".`);
}
function isValueRange(value) {
    if (value instanceof Array) {
        return value.length === 2;
    }
    else {
        return false;
    }
}
function generateHandlers(amount) {
    return Array(amount)
        .fill(0)
        .map(() => ({ offset: null, value: null, active: false }));
}
/**
 * Check if value is valid and throw error if value-type/range not match.
 */
function assertValueValid(value, isRange) {
    if ((!isValueRange(value) && isNaN(value)) || (isValueRange(value) && value.some((v) => isNaN(v)))) {
        return false;
    }
    return assertValueTypeMatch(value, isRange);
}
/**
 * Assert that if `this.nzRange` is `true`, value is also a range, vice versa.
 */
function assertValueTypeMatch(value, isRange = false) {
    if (isValueRange(value) !== isRange) {
        throw getValueTypeNotMatchError();
    }
    return true;
}
function valuesEqual$2(valA, valB) {
    if (typeof valA !== typeof valB) {
        return false;
    }
    return isValueRange(valA) && isValueRange(valB) ? arraysEqual(valA, valB) : valA === valB;
}

var SliderEvents;
(function (SliderEvents) {
    SliderEvents["RANGE_SET_MAX"] = "rangeSetMax";
    SliderEvents["RANGE_SET_MIN"] = "rangeSetMin";
    SliderEvents["OUT_OF_RANGE_MIN"] = "outOfRangeMin";
    SliderEvents["OUT_OF_RANGE_MAX"] = "outOfRangeMax";
})(SliderEvents || (SliderEvents = {}));
class ScMarks {
}

class ScSliderLargeComponent {
    set rangeMax(val) {
        if (val === this._rangeMax)
            return;
        this.notifyRangeExceed();
        this._rangeMax = val;
        if (this.value) {
            this.rangeSet.emit({
                type: SliderEvents.RANGE_SET_MAX,
                min: this.rangeMin,
                max: this.rangeMax,
                value: this.value,
                target: this.elRef.nativeElement,
            });
        }
        //this.UpdateInnerControllers();
    }
    get rangeMax() {
        return this._rangeMax;
    }
    set rangeMin(val) {
        if (val === this._rangeMin)
            return;
        this._rangeMin = val;
        this.notifyRangeExceed();
        if (this.value) {
            this.rangeSet.emit({
                type: SliderEvents.RANGE_SET_MIN,
                min: this.rangeMin,
                max: this.rangeMax,
                value: this.value,
                target: this.elRef.nativeElement,
            });
        }
        //this.UpdateInnerControllers();
    }
    get rangeMin() {
        return this._rangeMin;
    }
    /**
     * @description focused style
     */
    get getActiveClass() {
        return this.active;
    }
    /**
     * @description disabled state styles
     */
    get disabledClass() {
        return this.disabled;
    }
    /**
     * @description loading state styles
     */
    get loadingClass() {
        return this.loading;
    }
    /**
     * @description hide ticks (by css)
     */
    get hideTicksClass() {
        return !this.showTicks;
    }
    constructor(cdr, elRef) {
        this.cdr = cdr;
        this.elRef = elRef;
        /**
         * Range events
         */
        this.outOfRange = new EventEmitter();
        this.rangeSet = new EventEmitter();
        /**
         * Input label
         */
        this.label = null;
        /**
         * @description template for text below field
         */
        this.tplMetaTemplate = null;
        /**
         * @description template for min value container
         */
        this.tplRightValueTemplate = null;
        /**
         * @description template for min value container
         */
        this.tplLeftValueTemplate = null;
        /**
         * @description template for prefix/postfix (Kč)
         */
        this.tplPrefixTemplate = null;
        /**
         * @description standard value behind the field
         */
        this.prefix = 'Kč';
        this.loading = false;
        this.disabled = false;
        /**
         * @description delay for setting range
         */
        this.rangesetDelay = 50;
        /**
         * @description if for testers
         */
        this.testId = 'testid';
        /**
         * @description show/hide ticks
         */
        this.showTicks = false;
        /**
         * @description array of ticks ScMarks[] (not compatibile with touch-slider)
         */
        this.ticks = null;
        // region MinMax setters/getters
        this._rangeMax = 100;
        this._rangeMin = 0;
        // endregion
        this.stepValue = 1;
        this.value = 0;
        this.innerInputFC = new FormControl();
        this.innerSliderFc = new FormControl();
        this.isScDisableFirstChange = true;
        this.classes = 'sc-range-slider-large';
        /**
         * @description active = focused state
         */
        this.active = false;
    }
    ngOnInit() {
        this.bindInputRelations();
    }
    ngOnDestroy() {
        this.unbindInputRelations();
    }
    // ngOnChanges() not implemented
    writeValue(val) {
        this.setValue(val, true);
    }
    onValueChange(_value) { }
    onTouched() { }
    registerOnChange(fn) {
        this.onValueChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = (this.isScDisableFirstChange && this.disabled) || isDisabled;
        if (this.disabled) {
            this.innerSliderFc.disable();
            this.innerInputFC.disable();
        }
        else {
            this.innerSliderFc.enable();
            this.innerInputFC.enable();
        }
        this.isScDisableFirstChange = false;
        this.cdr.markForCheck();
    }
    setValue(value, isWriteValue = false) {
        if (isWriteValue) {
            this.value = value;
            this.UpdateInnerControllers();
            this.notifyRangeExceed();
        }
        else if (value && this.value) {
            if (!valuesEqual$1(this.value, value)) {
                this.value = value;
                this.UpdateInnerControllers();
                this.notifyRangeExceed();
                this.onValueChange(this.getValue(true));
            }
        }
    }
    notifyRangeExceed() {
        if (this.value && this.value < this.rangeMin) {
            this.outOfRange.emit({
                type: SliderEvents.OUT_OF_RANGE_MIN,
                min: this.rangeMin,
                max: this.rangeMax,
                oldValue: this.value,
                target: this.elRef.nativeElement,
            });
        }
        if (this.value && this.value > this.rangeMax) {
            this.outOfRange.emit({
                type: SliderEvents.OUT_OF_RANGE_MAX,
                min: this.rangeMin,
                max: this.rangeMax,
                oldValue: this.value,
                target: this.elRef.nativeElement,
            });
        }
    }
    getValue(cloneAndSort = false) {
        return this.value;
    }
    /**
     * Update inner elements
     */
    UpdateInnerControllers() {
        const value = this.getValue();
        this.innerInputFC.setValue(value, { onlySelf: true, emitEvent: false });
        this.innerSliderFc.patchValue(value, { onlySelf: true, emitEvent: false });
        this.cdr.markForCheck();
    }
    /**
     * Relations between input text & input slider
     */
    bindInputRelations() {
        this.innerSlider_ = this.innerSliderFc.valueChanges.subscribe((value) => {
            this.setValue(value);
            this.cdr.markForCheck();
        });
        this.innerInput_ = this.innerInputFC.valueChanges.pipe(debounceTime$1(1000)).subscribe((value) => {
            this.setValue(value);
            this.cdr.markForCheck();
        });
        // patch issue with range overlap
        this.ranges_ = this.rangeSet.pipe(debounceTime$1(this.rangesetDelay)).subscribe((e) => {
            this.UpdateInnerControllers();
        });
    }
    unbindInputRelations() {
        this.innerInput_?.unsubscribe();
        this.innerSlider_?.unsubscribe();
        this.ranges_?.unsubscribe();
    }
    onFocusIn(event) {
        this.active = true;
    }
    onFocusOut(event) {
        this.active = false;
    }
    onInputClick(event) { }
    onInputBlur(event) { }
}
ScSliderLargeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderLargeComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
ScSliderLargeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScSliderLargeComponent, selector: "sc-slider-large", inputs: { label: "label", tplMetaTemplate: "tplMetaTemplate", tplRightValueTemplate: "tplRightValueTemplate", tplLeftValueTemplate: "tplLeftValueTemplate", tplPrefixTemplate: "tplPrefixTemplate", prefix: "prefix", loading: "loading", disabled: "disabled", rangesetDelay: "rangesetDelay", testId: "testId", showTicks: "showTicks", ticks: "ticks", rangeMax: "rangeMax", rangeMin: "rangeMin", stepValue: "stepValue" }, outputs: { outOfRange: "outOfRange", rangeSet: "rangeSet" }, host: { properties: { "class": "this.classes", "class.focused": "this.getActiveClass", "class.sc-slider-disabled": "this.disabledClass", "class.sc-slider-loading": "this.loadingClass", "class.sc-slider-hide-marks": "this.hideTicksClass" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScSliderLargeComponent),
            multi: true,
        },
    ], viewQueries: [{ propertyName: "slider", first: true, predicate: ["scSlider"], descendants: true, static: true }, { propertyName: "sliderElement", first: true, predicate: ["scSlider"], descendants: true, read: ElementRef, static: true }, { propertyName: "amountInput", first: true, predicate: ["scAmountInput"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"p-16 pt-12 pb-0 relative\">\n  <div class=\"relative\">\n\n    <!-- {{value}} -->\n\n    <!-- label -->\n    <ng-container *ngIf=\"label\">\n      <div class=\"sc-label\"  [attr.data-test]=\"'amount-label-' + testId\">{{label}}</div>\n    </ng-container>\n\n    <div class=\"mb-4\">\n\n      <!-- field -->\n\n      <div class=\"flex items-center gap-16\">\n        <div class=\"flex\">\n\n          <sc-amount-input #scAmountInput\n            [formControl]=\"innerInputFC\"\n            (focusin)=\"onFocusIn($event)\"\n            (focusout)=\"onFocusOut($event)\"\n            (blur)=\"onInputBlur($event)\"\n            (focus)=\"onInputClick($event)\"\n            (click)=\"onInputClick($event)\"\n            [addonTemplate]=\"addonTemplate\"\n            [autoResize]=\"true\"\n            [attr.data-test]=\"'amount-input-' + testId\"\n          >\n          </sc-amount-input>\n\n          <ng-template #addonTemplate>\n            <div class=\"sc-input-group-postfix\">\n              <ng-container *ngTemplateOutlet=\"tplPrefixTemplate || prefixTemplateDefault\"></ng-container>\n            </div>\n          </ng-template>\n        </div>\n      </div>\n\n      <div class=\"sc-input-large-meta\" *ngIf=\"tplMetaTemplate\">\n        <ng-container *ngTemplateOutlet=\"tplMetaTemplate\"></ng-container>\n      </div>\n    </div>\n\n    <!-- slider -->\n    <div class=\"slider-holder\">\n      <sc-slider #scSlider\n                 [formControl]=\"innerSliderFc\"\n                 [scMin]=\"rangeMin\"\n                 [scMax]=\"rangeMax\"\n                 [scStep]=\"stepValue\"\n                 [scMarks]=\"ticks\"\n                 [scDots]=\"ticks ? true : false\"\n                 [attr.data-test]=\"'amount-input-' + testId\"\n      ></sc-slider>\n    </div>\n\n    <!-- limits -->\n    <div class=\"slider-label-max\" [attr.data-test]=\"'amount-max-' + testId\">\n      <ng-container *ngTemplateOutlet=\"tplRightValueTemplate || rightValueTemplateDefault\"></ng-container>\n    </div>\n\n    <div class=\"slider-label-min\" [attr.data-test]=\"'amount-min-' + testId\">\n      <ng-container *ngTemplateOutlet=\"tplLeftValueTemplate || leftValueTemplateDefault\"></ng-container>\n    </div>\n\n\n  </div>\n</div>\n\n<ng-template #prefixTemplateDefault>{{prefix}}</ng-template>\n<ng-template #metaTemplateDefault></ng-template>\n<ng-template #leftValueTemplateDefault>{{rangeMin | number}} {{prefix}}</ng-template>\n<ng-template #rightValueTemplateDefault>{{rangeMax | number}} {{prefix}}</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: AmountInputComponent, selector: "sc-amount-input", inputs: ["min", "max", "addon", "autoResize", "addonTemplate", "footerTemplate", "keyboardStep", "keyboardShiftStep"], outputs: ["Focus", "Click", "Blur"] }, { kind: "component", type: ScSliderComponent, selector: "sc-slider", inputs: ["scDisabled", "scDots", "scIncluded", "scRange", "scVertical", "scReverse", "scDefaultValue", "scMarks", "scMax", "scMin", "scStep", "scTooltipVisible", "scTooltipPlacement", "scTipFormatter"], outputs: ["scOnAfterChange"] }, { kind: "pipe", type: i1.DecimalPipe, name: "number" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScSliderLargeComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, selector: 'sc-slider-large', preserveWhitespaces: false, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ScSliderLargeComponent),
                            multi: true,
                        },
                    ], template: "<div class=\"p-16 pt-12 pb-0 relative\">\n  <div class=\"relative\">\n\n    <!-- {{value}} -->\n\n    <!-- label -->\n    <ng-container *ngIf=\"label\">\n      <div class=\"sc-label\"  [attr.data-test]=\"'amount-label-' + testId\">{{label}}</div>\n    </ng-container>\n\n    <div class=\"mb-4\">\n\n      <!-- field -->\n\n      <div class=\"flex items-center gap-16\">\n        <div class=\"flex\">\n\n          <sc-amount-input #scAmountInput\n            [formControl]=\"innerInputFC\"\n            (focusin)=\"onFocusIn($event)\"\n            (focusout)=\"onFocusOut($event)\"\n            (blur)=\"onInputBlur($event)\"\n            (focus)=\"onInputClick($event)\"\n            (click)=\"onInputClick($event)\"\n            [addonTemplate]=\"addonTemplate\"\n            [autoResize]=\"true\"\n            [attr.data-test]=\"'amount-input-' + testId\"\n          >\n          </sc-amount-input>\n\n          <ng-template #addonTemplate>\n            <div class=\"sc-input-group-postfix\">\n              <ng-container *ngTemplateOutlet=\"tplPrefixTemplate || prefixTemplateDefault\"></ng-container>\n            </div>\n          </ng-template>\n        </div>\n      </div>\n\n      <div class=\"sc-input-large-meta\" *ngIf=\"tplMetaTemplate\">\n        <ng-container *ngTemplateOutlet=\"tplMetaTemplate\"></ng-container>\n      </div>\n    </div>\n\n    <!-- slider -->\n    <div class=\"slider-holder\">\n      <sc-slider #scSlider\n                 [formControl]=\"innerSliderFc\"\n                 [scMin]=\"rangeMin\"\n                 [scMax]=\"rangeMax\"\n                 [scStep]=\"stepValue\"\n                 [scMarks]=\"ticks\"\n                 [scDots]=\"ticks ? true : false\"\n                 [attr.data-test]=\"'amount-input-' + testId\"\n      ></sc-slider>\n    </div>\n\n    <!-- limits -->\n    <div class=\"slider-label-max\" [attr.data-test]=\"'amount-max-' + testId\">\n      <ng-container *ngTemplateOutlet=\"tplRightValueTemplate || rightValueTemplateDefault\"></ng-container>\n    </div>\n\n    <div class=\"slider-label-min\" [attr.data-test]=\"'amount-min-' + testId\">\n      <ng-container *ngTemplateOutlet=\"tplLeftValueTemplate || leftValueTemplateDefault\"></ng-container>\n    </div>\n\n\n  </div>\n</div>\n\n<ng-template #prefixTemplateDefault>{{prefix}}</ng-template>\n<ng-template #metaTemplateDefault></ng-template>\n<ng-template #leftValueTemplateDefault>{{rangeMin | number}} {{prefix}}</ng-template>\n<ng-template #rightValueTemplateDefault>{{rangeMax | number}} {{prefix}}</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }]; }, propDecorators: { slider: [{
                type: ViewChild,
                args: ['scSlider', { static: true }]
            }], sliderElement: [{
                type: ViewChild,
                args: ['scSlider', { static: true, read: ElementRef }]
            }], amountInput: [{
                type: ViewChild,
                args: ['scAmountInput', { static: true }]
            }], outOfRange: [{
                type: Output
            }], rangeSet: [{
                type: Output
            }], label: [{
                type: Input
            }], tplMetaTemplate: [{
                type: Input
            }], tplRightValueTemplate: [{
                type: Input
            }], tplLeftValueTemplate: [{
                type: Input
            }], tplPrefixTemplate: [{
                type: Input
            }], prefix: [{
                type: Input
            }], loading: [{
                type: Input
            }], disabled: [{
                type: Input
            }], rangesetDelay: [{
                type: Input
            }], testId: [{
                type: Input
            }], showTicks: [{
                type: Input
            }], ticks: [{
                type: Input
            }], rangeMax: [{
                type: Input
            }], rangeMin: [{
                type: Input
            }], stepValue: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], getActiveClass: [{
                type: HostBinding,
                args: ['class.focused']
            }], disabledClass: [{
                type: HostBinding,
                args: ['class.sc-slider-disabled']
            }], loadingClass: [{
                type: HostBinding,
                args: ['class.sc-slider-loading']
            }], hideTicksClass: [{
                type: HostBinding,
                args: ['class.sc-slider-hide-marks']
            }] } });
function valuesEqual$1(valA, valB) {
    if (typeof valA !== typeof valB) {
        return false;
    }
    return valA === valB;
}

class ScTouchSliderService {
    constructor() {
        this.isDragging = false;
    }
}
ScTouchSliderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTouchSliderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ScTouchSliderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTouchSliderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTouchSliderService, decorators: [{
            type: Injectable
        }] });

class SliderUtils {
    /**
     * Map a value from one range to another
     *
     * @method map
     * @param {Number} [value] Value to map
     * @param {Array} [oldRange] Range to map from
     * @param {Array} [newRange] Range to map to
     * @return {Number} Mapped value
     */
    static map(value, oldRange, newRange) {
        const newValue = (value - oldRange[0]) * (newRange[1] - newRange[0]) / (oldRange[1] - oldRange[0]) + newRange[0];
        return Math.min(Math.max(newValue, newRange[0]), newRange[1]);
    }
    static between(x, min, max) {
        return x >= min && x <= max;
    }
}

class ScTouchSliderV2Component {
    get sliderEl() {
        return this.slider.nativeElement;
    }
    get ticksAreaEl() {
        return this.ticksArea.nativeElement;
    }
    get dragElement() {
        return this.ticksAreaEl;
    }
    get snapperHi() {
        return this.snapperHiRef.nativeElement;
    }
    get snapperLow() {
        return this.snapperLowRef.nativeElement;
    }
    set scMax(val) {
        this._scMax = val;
    }
    get scMax() {
        return this._scMax;
    }
    set scMin(val) {
        this._scMin = val;
    }
    get scMin() {
        return this._scMin;
    }
    set ticks(ticks) {
        this._ticks = ticks;
    }
    get ticks() {
        return this._ticks;
    }
    set currentX(value) {
        this._currentX = value;
    }
    get currentX() {
        return this._currentX;
    }
    /**
     * add disabled class based on _disabled var
     */
    get disabledClass() {
        return this.scDisabled;
    }
    //endregion
    constructor(elRef, sliderService, cdr, platform, directionality) {
        this.elRef = elRef;
        this.sliderService = sliderService;
        this.cdr = cdr;
        this.platform = platform;
        this.directionality = directionality;
        this.sliderid = 0;
        // inputs
        this.scDisabled = false;
        this.scMarks = null;
        this._scMax = 100;
        this._scMin = 0;
        this.scStep = 1;
        this.transitionSpeed = 1;
        /**
         * @description value snap to defined step scStep
         */
        this.stepSnapping = false;
        /**
         * @description snap to ticks/marks defined by @Input() ticks ,
         */
        this.tickSnapping = false; //enables snapping
        // not float value
        this.rounding = false; //enables snapping
        // outputs
        this.scOnAfterChange = new EventEmitter();
        this.value = 0;
        this.isScDisableFirstChange = true;
        // internal calculations
        this.scaleStepValue = 1;
        this.ticksAreaWidth = 1000; // pixels
        this.scale = 0;
        this.scaleStepValueWidth = 0;
        this.scaleOffset = 0;
        this.scaleOffsetWidth = 0;
        this.scaleSmallDivisions = 6;
        this.isTouch = false;
        this.isDragging = false;
        this.isSnapping = false;
        this.isStarted = false;
        this._ticks = [];
        this.touchTicksDataPositions = []; // ticks data converted to pixels
        this.mouseOffsetX = 0;
        this.previousX = 0;
        this.speed = 0;
        this.velocityX = 0;
        this.directionX = 0;
        this._currentX = 0;
        this.mass = 0.99;
        this.start$ = null;
        this.move$ = null;
        this.end$ = null;
        this.classes = 'sc-touch-slider-v2';
        this.sliderid = ScTouchSliderV2Component.counter;
        ScTouchSliderV2Component.counter++;
    }
    ngOnInit() {
        this.isTouch = this.isTouchDevice();
        this.recalculateScales();
        this.setupTickArea();
        this.attachEvents();
        this.currentX = 0;
        if (this.getValue() === null) {
            this.setValue(this.formatValue(null));
        }
    }
    ngOnDestroy() {
        this.detachEvents();
    }
    ngOnChanges(changes) {
        const { scDisabled, ticksAreaWidth, scMarks, scMin, scMax } = changes;
        if (scDisabled && !scDisabled.firstChange) {
            // this.toggleDragDisabled(scDisabled.currentValue);
        }
        else if (ticksAreaWidth && !ticksAreaWidth.firstChange) {
            this.updateTrackAndHandles();
            this.setOffsetToCurrentValue(true, false);
        }
        else if (scMarks && !scMarks.firstChange) {
            this.updateTrackAndHandles();
        }
        else if ((scMin && !scMin.firstChange) || (scMax && !scMax.firstChange)) {
            this.updateTrackAndHandles();
            this.setOffsetToCurrentValue(true, false);
        }
    }
    // region RegionControlAccessor
    writeValue(val) {
        this.setValue(val, true);
    }
    onValueChange(_value) { }
    onTouched() { }
    registerOnChange(fn) {
        this.onValueChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.scDisabled = (this.isScDisableFirstChange && this.scDisabled) || isDisabled;
        this.isScDisableFirstChange = false;
        this.cdr.markForCheck();
    }
    //endregion
    setValue(value, isWriteValue = false) {
        if (isWriteValue) {
            this.value = this.formatValue(value);
            this.cdr.markForCheck();
            this.setOffsetToCurrentValue();
            this.updateTrackAndHandles();
        }
        else if (this.value !== value) {
            this.value = value;
            this.updateTrackAndHandles();
            this.cdr.markForCheck();
            this.onValueChange(this.getValue(true));
        }
    }
    getValue(cloneAndSort = false) {
        return this.value;
    }
    attachEvents() {
        if (this.isTouch) {
            this.start$ = fromEvent(this.sliderEl, 'touchstart').subscribe((event) => {
                this.onDragStart(event.touches[0].clientX);
            });
        }
        else {
            this.start$ = fromEvent(this.sliderEl, 'mousedown').subscribe((event) => {
                this.onDragStart(event.clientX);
            });
        }
    }
    detachEvents() {
        this.start$?.unsubscribe();
        this.unsubscribeDrag();
    }
    subscribeDrag() {
        if (this.isTouch) {
            this.move$ = fromEvent(document, 'touchmove').subscribe((event) => {
                this.onDragMove(event.touches[0].clientX);
            });
            this.end$ = fromEvent(document, 'touchend').subscribe((event) => {
                this.onDragEnd();
            });
        }
        else {
            this.move$ = fromEvent(document, 'mousemove').subscribe((event) => {
                this.onDragMove(event.clientX);
            });
            this.end$ = fromEvent(document, 'mouseup').subscribe((event) => {
                this.onDragEnd();
            });
        }
    }
    unsubscribeDrag() {
        this.move$?.unsubscribe();
        this.end$?.unsubscribe();
    }
    onDragStart(clientX) {
        this.isStarted = true;
        this.isDragging = true;
        this.subscribeDrag();
        this.mouseOffsetX = clientX - this.sliderEl.offsetLeft - this.dragElement.offsetLeft;
    }
    clampToArea(targetX) {
        if (targetX < -this.ticksAreaWidth) {
            targetX = -this.ticksAreaWidth;
        }
        if (targetX > 0) {
            targetX = 0;
        }
        return targetX;
    }
    onDragMove(clientX) {
        if (this.isDragging) {
            let targetX = clientX - this.sliderEl.offsetLeft - this.mouseOffsetX;
            targetX = this.clampToArea(targetX);
            this.currentX = targetX;
            const snapData = this.calculateSnap(targetX);
            this.transform(this.currentX);
            this.setValue(snapData.value);
            this.velocityX = this.currentX - this.previousX;
            this.speed = Math.abs(this.velocityX) / this.mass;
            this.directionX = this.velocityX >= 0 ? 1 : -1;
            this.previousX = this.currentX;
            //this.cdr.markForCheck();
        }
    }
    onDragEnd() {
        this.unsubscribeDrag();
        this.isDragging = false;
        if (!this.isStarted)
            return;
        if (this.speed < 1) {
            // this.snapTo();
        }
        else {
            this.slowDown();
        }
        this.isStarted = false;
        this.scOnAfterChange.emit(this.getValue(true));
        this.cdr.markForCheck();
    }
    calculateSnap(targetX) {
        // clamp values to available area (0..ticksareawidth)
        const cleanTargetX = this.clampToArea(targetX);
        const value = this.offsetToValue2(cleanTargetX);
        const valueLow = value - (value % this.scStep);
        const valueHi = value + (this.scStep - (value % this.scStep));
        // get low / hi steps
        let snapXHi = -this.valueToOffset(valueHi);
        let snapXLow = -this.valueToOffset(valueLow);
        // find ticks on sides
        let isTickHi = false;
        let isTickLow = false;
        let tickIdxLow = -1;
        let tickIdxHi = -1;
        let tmpValueLow = 0;
        let tmpValueHi = 0;
        if (this.touchTicksDataPositions.length) {
            this.touchTicksDataPositions.forEach((tick, index) => {
                if (SliderUtils.between(tick, -cleanTargetX, -snapXHi)) {
                    snapXHi = -tick;
                    isTickHi = true;
                    tickIdxHi = index;
                    tmpValueHi = this.ticks[index];
                }
                if (SliderUtils.between(tick, -snapXLow, -cleanTargetX)) {
                    snapXLow = -tick;
                    isTickLow = true;
                    tickIdxLow = index;
                    tmpValueLow = this.ticks[index];
                }
            });
        }
        const diffLow = Math.abs(snapXLow) - Math.abs(cleanTargetX);
        const diffHi = Math.abs(cleanTargetX) - Math.abs(snapXHi);
        const snapData = {
            snapTo: 0,
            isTick: false,
            tickIdx: -1,
            value: 0,
        };
        if (diffHi > diffLow) {
            // snap to Hi
            this.snapperHi.style.top = 0 + 'px';
            this.snapperLow.style.top = 20 + 'px';
            snapData.snapTo = snapXHi;
            snapData.isTick = isTickHi;
            snapData.tickIdx = tickIdxHi;
            snapData.value = tmpValueHi;
            if (!isTickHi) {
                snapData.value = this.offsetToValue2(snapXHi);
            }
        }
        else {
            // snap to Low
            this.snapperHi.style.top = 20 + 'px';
            this.snapperLow.style.top = 0 + 'px';
            snapData.snapTo = snapXLow;
            snapData.isTick = isTickLow;
            snapData.tickIdx = tickIdxLow;
            snapData.value = tmpValueLow;
            if (!isTickLow) {
                snapData.value = this.offsetToValue2(snapXLow);
            }
        }
        this.snapperHi.style.left = -snapXHi + 'px';
        this.snapperLow.style.left = -snapXLow + 'px';
        return snapData;
    }
    formatValue(value) {
        if (isNil(value)) {
            return this.scMin;
        }
        return ensureNumberInRange(value, this.scMin, this.scMax);
    }
    updateTrackAndHandles() {
        this.recalculateScales();
        this.setupTickArea();
    }
    recalculateScales() {
        this.scaleStepValue = this.scStep;
        this.scale = this.ticksAreaWidth / (this.scMax - this.scMin);
        this.scaleOffset = this.scaleStepValue - (this.scMin % this.scaleStepValue);
        this.scaleStepValueWidth = this.scaleStepValue * this.scale;
        this.scaleOffsetWidth = this.scaleOffset * this.scale;
    }
    setupTickArea() {
        this.ticksAreaEl.style.width = this.ticksAreaWidth + 'px';
        this.ticksAreaEl.style.setProperty('--tick-step', this.scaleStepValueWidth + 'px');
        this.ticksAreaEl.style.setProperty('--tick-offset', this.scaleOffsetWidth + 'px');
        this.ticksAreaEl.style.setProperty('--tick-small-div', (this.scaleSmallDivisions).toString());
        this.touchTicksDataPositions = [];
        this.ticks.forEach((realTickValue) => {
            // remap to size of element and round this value due to pixels
            const remapedTickPosition = Math.round(SliderUtils.map(realTickValue, [this.scMin, this.scMax], [0, this.ticksAreaWidth]));
            this.touchTicksDataPositions.push(remapedTickPosition);
        });
    }
    /**
     * @description Transform container and limit position to defined area
     * @param x x axis offset in pixels
     */
    transform(x) {
        // block scroll behind are width
        if (x < -1 * this.ticksAreaWidth)
            return;
        if (x > 0)
            return;
        this.dragElement.style.left = x + 'px';
    }
    isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    }
    offsetToValue2(offset, forceValue = null) {
        if (!forceValue) {
            const realValueRaw = SliderUtils.map(Math.abs(offset), [0, this.ticksAreaWidth], [this.scMin, this.scMax]);
            let cleanValue = realValueRaw;
            if (this.stepSnapping) {
                cleanValue = realValueRaw - (realValueRaw % this.scStep);
            }
            if (this.rounding) {
                cleanValue = Math.round(cleanValue);
            }
            return cleanValue;
        }
        else {
            return forceValue;
        }
    }
    valueToOffset(value = 0) {
        const offset = SliderUtils.map(Math.abs(value), [this.scMin, this.scMax], [0, this.ticksAreaWidth]);
        return offset;
    }
    setOffsetToCurrentValue(transform = true, animated = true) {
        const targetX = -1 * Math.round(SliderUtils.map(this.value, [this.scMin, this.scMax], [0, this.ticksAreaWidth]));
        if (transform) {
            if (animated) {
                gsap.fromTo(this.dragElement, { left: this.currentX }, { left: targetX, duration: this.transitionSpeed });
                this.currentX = targetX;
            }
            else {
                this.currentX = targetX;
                this.transform(this.currentX);
            }
        }
    }
    slowDown() {
        if (this.speed > 0.01) {
            let targetX = this.currentX + this.speed * this.directionX;
            targetX = this.clampToArea(targetX);
            // prevent continue when loop is on edge points
            if (this.currentX === targetX)
                return;
            const snapData = this.calculateSnap(targetX);
            this.currentX = targetX;
            this.transform(this.currentX);
            this.setValue(snapData.value);
            this.speed = this.speed * 0.9;
            if (this.speed < 0.2) {
                this.snapTo(snapData);
            }
            else {
                setTimeout(() => {
                    this.slowDown();
                }, 10);
            }
        }
        else {
            this.speed = 0;
        }
    }
    snapTo(snapData) {
        this.isSnapping = true;
        this.transform(snapData.snapTo);
        this.setValue(snapData.value);
        this.isSnapping = false;
    }
}
ScTouchSliderV2Component.counter = 0;
ScTouchSliderV2Component.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTouchSliderV2Component, deps: [{ token: i0.ElementRef }, { token: ScTouchSliderService }, { token: i0.ChangeDetectorRef }, { token: i2$2.Platform }, { token: i3.Directionality, optional: true }], target: i0.ɵɵFactoryTarget.Component });
ScTouchSliderV2Component.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScTouchSliderV2Component, selector: "sc-touch-slider-v2", inputs: { scDisabled: "scDisabled", scMarks: "scMarks", scMax: "scMax", scMin: "scMin", scStep: "scStep", transitionSpeed: "transitionSpeed", stepSnapping: "stepSnapping", tickSnapping: "tickSnapping", rounding: "rounding", ticksAreaWidth: "ticksAreaWidth", scaleSmallDivisions: "scaleSmallDivisions", ticks: "ticks" }, outputs: { scOnAfterChange: "scOnAfterChange" }, host: { properties: { "class": "this.classes", "class.sc-touch-slider-disabled": "this.disabledClass" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScTouchSliderV2Component),
            multi: true,
        },
        ScSliderService,
    ], viewQueries: [{ propertyName: "slider", first: true, predicate: ["slider"], descendants: true, static: true }, { propertyName: "ticksArea", first: true, predicate: ["dragArea"], descendants: true, static: true }, { propertyName: "snapperHiRef", first: true, predicate: ["snaperHi"], descendants: true, static: true }, { propertyName: "snapperLowRef", first: true, predicate: ["snaperLow"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: `
    <div #slider class="sc-touch-slider-frame">
      <div class="sc-slider-wrapper">
        <div class="sc-ts-inner-slider">
          <div #dragArea class="slider-ticks-area">
            <div class="slider-small-ticks-area"></div>
            <div class="slider-tick-first"></div>
            <div class="slider-tick-last"></div>
            <!-- snap visualiser -->
            <div #snaperLow class="snap-indicator snap-indicator-low"></div>
            <div #snaperHi class="snap-indicator snap-indicator-hi"></div>
            <ng-container *ngIf="touchTicksDataPositions.length">
              <ng-container *ngFor="let tickPos of touchTicksDataPositions; let i = index">
                <div class="slider-tick" [style.left.px]="tickPos" [attr.data-realval]="ticks[i]"></div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="slider-central-tick sc-touch-slider-arrow-bgimage"></div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTouchSliderV2Component, decorators: [{
            type: Component,
            args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    selector: 'sc-touch-slider-v2',
                    preserveWhitespaces: false,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ScTouchSliderV2Component),
                            multi: true,
                        },
                        ScSliderService,
                    ],
                    template: `
    <div #slider class="sc-touch-slider-frame">
      <div class="sc-slider-wrapper">
        <div class="sc-ts-inner-slider">
          <div #dragArea class="slider-ticks-area">
            <div class="slider-small-ticks-area"></div>
            <div class="slider-tick-first"></div>
            <div class="slider-tick-last"></div>
            <!-- snap visualiser -->
            <div #snaperLow class="snap-indicator snap-indicator-low"></div>
            <div #snaperHi class="snap-indicator snap-indicator-hi"></div>
            <ng-container *ngIf="touchTicksDataPositions.length">
              <ng-container *ngFor="let tickPos of touchTicksDataPositions; let i = index">
                <div class="slider-tick" [style.left.px]="tickPos" [attr.data-realval]="ticks[i]"></div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="slider-central-tick sc-touch-slider-arrow-bgimage"></div>
    </div>
  `,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: ScTouchSliderService }, { type: i0.ChangeDetectorRef }, { type: i2$2.Platform }, { type: i3.Directionality, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { slider: [{
                type: ViewChild,
                args: ['slider', { static: true }]
            }], ticksArea: [{
                type: ViewChild,
                args: ['dragArea', { static: true }]
            }], snapperHiRef: [{
                type: ViewChild,
                args: ['snaperHi', { static: true }]
            }], snapperLowRef: [{
                type: ViewChild,
                args: ['snaperLow', { static: true }]
            }], scDisabled: [{
                type: Input
            }], scMarks: [{
                type: Input
            }], scMax: [{
                type: Input
            }], scMin: [{
                type: Input
            }], scStep: [{
                type: Input
            }], transitionSpeed: [{
                type: Input
            }], stepSnapping: [{
                type: Input
            }], tickSnapping: [{
                type: Input
            }], rounding: [{
                type: Input
            }], scOnAfterChange: [{
                type: Output
            }], ticksAreaWidth: [{
                type: Input
            }], scaleSmallDivisions: [{
                type: Input
            }], ticks: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], disabledClass: [{
                type: HostBinding,
                args: ['class.sc-touch-slider-disabled']
            }] } });

class ScTouchSliderLargeV2Component {
    set rangeMax(val) {
        if (val === this._rangeMax)
            return;
        this.notifyRangeExceed();
        this._rangeMax = val;
        if (this.value) {
            this.rangeSet.emit({
                type: SliderEvents.RANGE_SET_MAX,
                min: this.rangeMin,
                max: this.rangeMax,
                value: this.value,
                target: this.elRef.nativeElement,
            });
        }
        // this.UpdateInnerControllers();
        this.innerSliderFc.setValue(this.value, { emitEvent: false });
        this.innerInputFC.setValue(this.value, { emitEvent: false });
    }
    get rangeMax() {
        return this._rangeMax;
    }
    set rangeMin(val) {
        if (val === this._rangeMin)
            return;
        this._rangeMin = val;
        this.notifyRangeExceed();
        if (this.value) {
            this.rangeSet.emit({
                type: SliderEvents.RANGE_SET_MIN,
                min: this.rangeMin,
                max: this.rangeMax,
                value: this.value,
                target: this.elRef.nativeElement,
            });
        }
        // this.UpdateInnerControllers();
        this.innerSliderFc.setValue(this.value, { emitEvent: false });
        this.innerInputFC.setValue(this.value, { emitEvent: false });
    }
    get rangeMin() {
        return this._rangeMin;
    }
    /**
     * @description focused style
     */
    get getActiveClass() {
        return this.active;
    }
    /**
     * @description disabled state styles
     */
    get disabledClass() {
        return this.disabled;
    }
    /**
     * @description loading state styles
     */
    get loadingClass() {
        return this.loading;
    }
    /**
     * @description hide ticks (by css)
     */
    get hideTicksClass() {
        return !this.showTicks;
    }
    constructor(cdr, elRef) {
        this.cdr = cdr;
        this.elRef = elRef;
        /**
         * Range events
         */
        this.outOfRange = new EventEmitter();
        this.rangeSet = new EventEmitter();
        /**
         * Input label
         */
        this.label = null;
        /**
         * @description template for text below field
         */
        this.tplMetaTemplate = null;
        /**
         * @description template for min value container
         */
        this.tplRightValueTemplate = null;
        /**
         * @description template for min value container
         */
        this.tplLeftValueTemplate = null;
        /**
         * @description template for prefix/postfix (Kč)
         */
        this.tplPrefixTemplate = null;
        /**
         * @description standard value behind the field
         */
        this.prefix = 'Kč';
        this.loading = false;
        this.disabled = false;
        /**
         * @description if for testers
         */
        this.testId = 'testid';
        /**
         * @description write from input to slider debounce
         */
        this.writeDelay = 1000;
        /**
         * @description ticks array of values number[] (not compatibile with range-slider)
         */
        this.ticks = [];
        /**
         * @description show/hide ticks
         */
        this.showTicks = false;
        /**
         * @description small substeps (non snappable) set zero to hide
         */
        this.subSteps = 5;
        /**
         * @description write from input to slider debounce
         */
        this.ticksAreaWidth = 400;
        // region MinMax setters/getters
        this._rangeMax = 100;
        this._rangeMin = 0;
        // endregion
        this.stepValue = 1;
        this.value = 0;
        this.innerInputFC = new FormControl();
        this.innerSliderFc = new FormControl();
        this.isScDisableFirstChange = true;
        this.classes = 'sc-touch-slider-large';
        /**
         * @description active = focused state
         */
        this.active = false;
    }
    ngOnInit() {
        this.bindInputRelations();
    }
    ngOnDestroy() {
        this.unbindInputRelations();
    }
    ngOnChanges(changes) {
        const { scDisabled, ticksAreaWidth, scMarks, scMin, scMax } = changes;
        if (ticksAreaWidth && !ticksAreaWidth.firstChange) {
            console.log('change ticks');
        }
        // if (scDisabled && !scDisabled.firstChange) {
        // this.toggleDragDisabled(scDisabled.currentValue);
        // } else if (ticksAreaWidth && !ticksAreaWidth.firstChange) {
        //   console.log('change ticks area')
        // }
        // } else if (scMarks && !scMarks.firstChange) {
        //   this.updateTrackAndHandles();
        // } else if ((scMin && !scMin.firstChange) || (scMax && !scMax.firstChange)) {
        //   this.updateTrackAndHandles();
        //   this.setOffsetToCurrentValue(true, false);
        // }
    }
    writeValue(val) {
        this.setValue(val, true);
    }
    onValueChange(_value) { }
    onTouched() { }
    registerOnChange(fn) {
        this.onValueChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = (this.isScDisableFirstChange && this.disabled) || isDisabled;
        if (this.disabled) {
            this.innerSliderFc.disable();
            this.innerInputFC.disable();
        }
        else {
            this.innerSliderFc.enable();
            this.innerInputFC.enable();
        }
        this.isScDisableFirstChange = false;
        this.cdr.markForCheck();
    }
    setValue(value, isWriteValue = false) {
        if (isWriteValue) {
            this.value = value;
            this.notifyRangeExceed();
            this.innerSliderFc.setValue(this.value, { emitEvent: false });
            this.innerInputFC.setValue(this.value, { emitEvent: false });
        }
        else if (value && this.value) {
            if (!valuesEqual(this.value, value)) {
                this.value = value;
                this.notifyRangeExceed();
                this.onValueChange(this.getValue(true));
            }
        }
    }
    notifyRangeExceed() {
        if (this.value && this.value < this.rangeMin) {
            this.outOfRange.emit({
                type: SliderEvents.OUT_OF_RANGE_MIN,
                min: this.rangeMin,
                max: this.rangeMax,
                oldValue: this.value,
                target: this.elRef.nativeElement,
            });
        }
        if (this.value && this.value > this.rangeMax) {
            this.outOfRange.emit({
                type: SliderEvents.OUT_OF_RANGE_MAX,
                min: this.rangeMin,
                max: this.rangeMax,
                oldValue: this.value,
                target: this.elRef.nativeElement,
            });
        }
    }
    getValue(cloneAndSort = false) {
        return this.value;
    }
    /**
     * Relations between input text & input slider
     */
    bindInputRelations() {
        this.innerSlider_ = this.innerSliderFc.valueChanges.subscribe((value) => {
            this.setValue(value);
            this.innerInputFC.setValue(value, { onlySelf: true, emitEvent: false });
            this.cdr.markForCheck();
        });
        // amount input throw
        this.innerInput_ = this.innerInputFC.valueChanges
            .pipe(debounceTime$1(this.writeDelay))
            .pipe(distinctUntilChanged())
            .subscribe((value) => {
            if (value === this.innerSliderFc.value)
                return;
            console.log('pathch', value, this.innerSliderFc.value);
            this.setValue(value);
            this.innerSliderFc.patchValue(value, { onlySelf: true, emitEvent: false });
            this.cdr.markForCheck();
        });
    }
    unbindInputRelations() {
        this.innerInput_?.unsubscribe();
        this.innerSlider_?.unsubscribe();
    }
    onFocusIn(event) {
        this.active = true;
    }
    onFocusOut(event) {
        this.active = false;
    }
    onInputClick(event) { }
    onInputBlur(event) { }
}
ScTouchSliderLargeV2Component.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTouchSliderLargeV2Component, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
ScTouchSliderLargeV2Component.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.0", type: ScTouchSliderLargeV2Component, selector: "sc-touch-slider-large-v2", inputs: { label: "label", tplMetaTemplate: "tplMetaTemplate", tplRightValueTemplate: "tplRightValueTemplate", tplLeftValueTemplate: "tplLeftValueTemplate", tplPrefixTemplate: "tplPrefixTemplate", prefix: "prefix", loading: "loading", disabled: "disabled", testId: "testId", writeDelay: "writeDelay", ticks: "ticks", showTicks: "showTicks", subSteps: "subSteps", ticksAreaWidth: "ticksAreaWidth", rangeMax: "rangeMax", rangeMin: "rangeMin", stepValue: "stepValue" }, outputs: { outOfRange: "outOfRange", rangeSet: "rangeSet" }, host: { properties: { "class": "this.classes", "class.focused": "this.getActiveClass", "class.sc-touch-slider-disabled": "this.disabledClass", "class.sc-touch-slider-loading": "this.loadingClass", "class.sc-touch-slider-hide-marks": "this.hideTicksClass" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScTouchSliderLargeV2Component),
            multi: true,
        },
    ], viewQueries: [{ propertyName: "slider", first: true, predicate: ["scSlider"], descendants: true, static: true }, { propertyName: "sliderElement", first: true, predicate: ["scSlider"], descendants: true, read: ElementRef, static: true }, { propertyName: "amountInput", first: true, predicate: ["scAmountInput"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"p-16 pt-12 pb-0 relative\">\n  <div class=\"relative\">\n\n    <!-- {{value}} -->\n\n    <!-- label -->\n    <ng-container *ngIf=\"label\">\n      <div class=\"sc-label\"  [attr.data-test]=\"'amount-label-' + testId\">{{label}}</div>\n    </ng-container>\n\n    <div class=\"mb-4\">\n\n      <!-- field -->\n\n      <div class=\"flex items-center gap-16\">\n        <div class=\"flex\">\n\n          <sc-amount-input\n            #scAmountInput\n            [formControl]=\"innerInputFC\"\n            (focusin)=\"onFocusIn($event)\"\n            (focusout)=\"onFocusOut($event)\"\n            (blur)=\"onInputBlur($event)\"\n            (focus)=\"onInputClick($event)\"\n            (click)=\"onInputClick($event)\"\n            [addonTemplate]=\"addonTemplate\"\n            [attr.data-test]=\"'amount-input-' + testId\"\n            [autoResize]=\"true\"\n          >\n          </sc-amount-input>\n\n          <ng-template #addonTemplate>\n            <div class=\"sc-input-group-postfix\">\n              <ng-container *ngTemplateOutlet=\"tplPrefixTemplate || prefixTemplateDefault\"></ng-container>\n            </div>\n          </ng-template>\n        </div>\n      </div>\n\n      <div class=\"sc-input-large-meta\" *ngIf=\"tplMetaTemplate\">\n        <ng-container *ngTemplateOutlet=\"tplMetaTemplate\"></ng-container>\n      </div>\n    </div>\n\n    <!-- slider -->\n    <div class=\"slider-holder\">\n      <sc-touch-slider-v2\n        #scSlider\n        [formControl]=\"innerSliderFc\"\n        [scMin]=\"rangeMin\"\n        [scMax]=\"rangeMax\"\n        [scStep]=\"stepValue\"\n        [rounding]=\"true\"\n        [ticksAreaWidth]=\"ticksAreaWidth\"\n        [scaleSmallDivisions]=\"subSteps\"\n        [ticks]=\"ticks\"\n      ></sc-touch-slider-v2>\n    </div>\n\n    <!-- limits -->\n    <div class=\"slider-label-max\" [attr.data-test]=\"'amount-max-' + testId\">\n      <ng-container *ngTemplateOutlet=\"tplRightValueTemplate || rightValueTemplateDefault\"></ng-container>\n    </div>\n\n    <div class=\"slider-label-min\" [attr.data-test]=\"'amount-min-' + testId\">\n      <ng-container *ngTemplateOutlet=\"tplLeftValueTemplate || leftValueTemplateDefault\"></ng-container>\n    </div>\n\n\n  </div>\n</div>\n\n<ng-template #prefixTemplateDefault>{{prefix}}</ng-template>\n<ng-template #metaTemplateDefault></ng-template>\n<ng-template #leftValueTemplateDefault>{{rangeMin | number}} {{prefix}}</ng-template>\n<ng-template #rightValueTemplateDefault>{{rangeMax | number}} {{prefix}}</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: AmountInputComponent, selector: "sc-amount-input", inputs: ["min", "max", "addon", "autoResize", "addonTemplate", "footerTemplate", "keyboardStep", "keyboardShiftStep"], outputs: ["Focus", "Click", "Blur"] }, { kind: "component", type: ScTouchSliderV2Component, selector: "sc-touch-slider-v2", inputs: ["scDisabled", "scMarks", "scMax", "scMin", "scStep", "transitionSpeed", "stepSnapping", "tickSnapping", "rounding", "ticksAreaWidth", "scaleSmallDivisions", "ticks"], outputs: ["scOnAfterChange"] }, { kind: "pipe", type: i1.DecimalPipe, name: "number" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScTouchSliderLargeV2Component, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, selector: 'sc-touch-slider-large-v2', preserveWhitespaces: false, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ScTouchSliderLargeV2Component),
                            multi: true,
                        },
                    ], template: "<div class=\"p-16 pt-12 pb-0 relative\">\n  <div class=\"relative\">\n\n    <!-- {{value}} -->\n\n    <!-- label -->\n    <ng-container *ngIf=\"label\">\n      <div class=\"sc-label\"  [attr.data-test]=\"'amount-label-' + testId\">{{label}}</div>\n    </ng-container>\n\n    <div class=\"mb-4\">\n\n      <!-- field -->\n\n      <div class=\"flex items-center gap-16\">\n        <div class=\"flex\">\n\n          <sc-amount-input\n            #scAmountInput\n            [formControl]=\"innerInputFC\"\n            (focusin)=\"onFocusIn($event)\"\n            (focusout)=\"onFocusOut($event)\"\n            (blur)=\"onInputBlur($event)\"\n            (focus)=\"onInputClick($event)\"\n            (click)=\"onInputClick($event)\"\n            [addonTemplate]=\"addonTemplate\"\n            [attr.data-test]=\"'amount-input-' + testId\"\n            [autoResize]=\"true\"\n          >\n          </sc-amount-input>\n\n          <ng-template #addonTemplate>\n            <div class=\"sc-input-group-postfix\">\n              <ng-container *ngTemplateOutlet=\"tplPrefixTemplate || prefixTemplateDefault\"></ng-container>\n            </div>\n          </ng-template>\n        </div>\n      </div>\n\n      <div class=\"sc-input-large-meta\" *ngIf=\"tplMetaTemplate\">\n        <ng-container *ngTemplateOutlet=\"tplMetaTemplate\"></ng-container>\n      </div>\n    </div>\n\n    <!-- slider -->\n    <div class=\"slider-holder\">\n      <sc-touch-slider-v2\n        #scSlider\n        [formControl]=\"innerSliderFc\"\n        [scMin]=\"rangeMin\"\n        [scMax]=\"rangeMax\"\n        [scStep]=\"stepValue\"\n        [rounding]=\"true\"\n        [ticksAreaWidth]=\"ticksAreaWidth\"\n        [scaleSmallDivisions]=\"subSteps\"\n        [ticks]=\"ticks\"\n      ></sc-touch-slider-v2>\n    </div>\n\n    <!-- limits -->\n    <div class=\"slider-label-max\" [attr.data-test]=\"'amount-max-' + testId\">\n      <ng-container *ngTemplateOutlet=\"tplRightValueTemplate || rightValueTemplateDefault\"></ng-container>\n    </div>\n\n    <div class=\"slider-label-min\" [attr.data-test]=\"'amount-min-' + testId\">\n      <ng-container *ngTemplateOutlet=\"tplLeftValueTemplate || leftValueTemplateDefault\"></ng-container>\n    </div>\n\n\n  </div>\n</div>\n\n<ng-template #prefixTemplateDefault>{{prefix}}</ng-template>\n<ng-template #metaTemplateDefault></ng-template>\n<ng-template #leftValueTemplateDefault>{{rangeMin | number}} {{prefix}}</ng-template>\n<ng-template #rightValueTemplateDefault>{{rangeMax | number}} {{prefix}}</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }]; }, propDecorators: { slider: [{
                type: ViewChild,
                args: ['scSlider', { static: true }]
            }], sliderElement: [{
                type: ViewChild,
                args: ['scSlider', { static: true, read: ElementRef }]
            }], amountInput: [{
                type: ViewChild,
                args: ['scAmountInput', { static: true }]
            }], outOfRange: [{
                type: Output
            }], rangeSet: [{
                type: Output
            }], label: [{
                type: Input
            }], tplMetaTemplate: [{
                type: Input
            }], tplRightValueTemplate: [{
                type: Input
            }], tplLeftValueTemplate: [{
                type: Input
            }], tplPrefixTemplate: [{
                type: Input
            }], prefix: [{
                type: Input
            }], loading: [{
                type: Input
            }], disabled: [{
                type: Input
            }], testId: [{
                type: Input
            }], writeDelay: [{
                type: Input
            }], ticks: [{
                type: Input
            }], showTicks: [{
                type: Input
            }], subSteps: [{
                type: Input
            }], ticksAreaWidth: [{
                type: Input
            }], rangeMax: [{
                type: Input
            }], rangeMin: [{
                type: Input
            }], stepValue: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], getActiveClass: [{
                type: HostBinding,
                args: ['class.focused']
            }], disabledClass: [{
                type: HostBinding,
                args: ['class.sc-touch-slider-disabled']
            }], loadingClass: [{
                type: HostBinding,
                args: ['class.sc-touch-slider-loading']
            }], hideTicksClass: [{
                type: HostBinding,
                args: ['class.sc-touch-slider-hide-marks']
            }] } });
function valuesEqual(valA, valB) {
    if (typeof valA !== typeof valB) {
        return false;
    }
    return valA === valB;
}

class ScMobileModule {
}
ScMobileModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScMobileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ScMobileModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.0", ngImport: i0, type: ScMobileModule, declarations: [
        // select
        ScDropdownPanelComponent,
        ScOptionComponent,
        ScSelectComponent,
        ScOptgroupTemplateDirective,
        ScOptionTemplateDirective,
        ScLabelTemplateDirective,
        ScMultiLabelTemplateDirective,
        ScHeaderTemplateDirective,
        ScFooterTemplateDirective,
        ScNotFoundTemplateDirective,
        ScTypeToSearchTemplateDirective,
        ScLoadingTextTemplateDirective,
        ScTagTemplateDirective,
        ScLoadingSpinnerTemplateDirective,
        ScItemLabelDirective,
        // modals
        ScModalBaseComponent,
        ModalHeaderComponent,
        ModalContentComponent,
        ModalFooterComponent,
        ModalComponent,
        SmallModalComponent,
        SmallModalHeaderComponent,
        SmallModalContentComponent,
        SmallModalFooterComponent,
        // sliders
        ScSliderComponent,
        ScSliderHandleComponent,
        ScSliderTrackComponent,
        ScSliderStepComponent,
        ScSliderMarksComponent,
        ScSliderLargeComponent,
        ScTouchSliderV2Component,
        ScTouchSliderLargeV2Component], imports: [CommonModule,
        ScIconModule,
        FormsModule,
        ReactiveFormsModule,
        ScDropdownModule,
        ScAccordionComponent,
        ScAlertComponent,
        ScAlertValidationComponent,
        ScBannerComponent,
        ScBannerBrandComponent,
        ScBadgeComponent,
        ScDividerComponent,
        ScContainerComponent,
        ScOverlayMenuComponent,
        ScCardComponent,
        ScCardContentComponent,
        ScCardHeaderComponent,
        ScButtonComponent,
        ScTextLinkComponent,
        ScTabsComponent,
        ScTabComponent,
        ScStepperComponent,
        ScPageComponent,
        ScPageActionsComponent,
        ScPageContentComponent,
        ScFocusPageComponent,
        ScFocusPageBodyComponent,
        ScPageProgressComponent,
        ScLoaderComponent,
        ScLoaderContainerComponent,
        ScListComponent,
        ScListItemComponent,
        ScCollapsibleComponent,
        ScOffcanvasPageComponent,
        ScCheckboxComponent,
        ScDatepickerComponent,
        FormFieldComponent,
        AmountInputComponent,
        ScNumericStepperComponent,
        ScRadioComponent,
        ScAutocompleteComponent,
        ScToggleComponent,
        ScToggleGroup,
        ScTooltipDirective,
        ScTooltipComponent,
        ScStripeHeaderComponent,
        ScStripeHeaderCloseComponent,
        ScStripeHeaderLogoComponent,
        ScStripeHeaderCartComponent], exports: [ScAccordionComponent,
        ScAlertComponent,
        ScAlertValidationComponent,
        ScBannerComponent,
        ScBannerBrandComponent,
        ScButtonComponent,
        ScCardComponent,
        ScCardContentComponent,
        ScCardHeaderComponent,
        ScDatepickerComponent,
        ScDividerComponent,
        ScCheckboxComponent,
        ScLoaderComponent,
        ScLoaderContainerComponent,
        ScStepperComponent,
        ScOverlayMenuComponent,
        ScPageComponent,
        ScPageActionsComponent,
        ScPageContentComponent,
        ScOffcanvasPageComponent,
        ScDropdownPanelComponent,
        ScOptionComponent,
        ScSelectComponent,
        ScOptgroupTemplateDirective,
        ScOptionTemplateDirective,
        ScLabelTemplateDirective,
        ScMultiLabelTemplateDirective,
        ScHeaderTemplateDirective,
        ScFooterTemplateDirective,
        ScNotFoundTemplateDirective,
        ScTypeToSearchTemplateDirective,
        ScLoadingTextTemplateDirective,
        ScTagTemplateDirective,
        ScLoadingSpinnerTemplateDirective,
        ScItemLabelDirective,
        ScNumericStepperComponent,
        ScTextLinkComponent,
        ScToggleComponent,
        ScToggleGroup,
        ScTooltipComponent,
        ScTooltipDirective,
        ScAutocompleteComponent,
        ScModalBaseComponent,
        ModalHeaderComponent,
        ModalContentComponent,
        ModalFooterComponent,
        ModalComponent,
        SmallModalComponent,
        SmallModalHeaderComponent,
        SmallModalContentComponent,
        SmallModalFooterComponent,
        ScBadgeComponent,
        ScContainerComponent,
        ScFocusPageComponent,
        ScFocusPageBodyComponent,
        ScStripeHeaderComponent,
        ScStripeHeaderCloseComponent,
        ScStripeHeaderLogoComponent,
        ScStripeHeaderCartComponent,
        AmountInputComponent,
        FormFieldComponent,
        ScRadioComponent,
        ScCollapsibleComponent,
        ScTabsComponent,
        ScTabComponent,
        ScPageProgressComponent,
        ScListComponent,
        ScListItemComponent,
        ScSliderComponent,
        ScSliderHandleComponent,
        ScSliderTrackComponent,
        ScSliderStepComponent,
        ScSliderMarksComponent,
        ScSliderLargeComponent,
        ScTouchSliderV2Component,
        ScTouchSliderLargeV2Component,
        ScDropdownModule] });
ScMobileModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScMobileModule, providers: [
        ScSliderService,
        ScTouchSliderService,
        ModalService,
        {
            provide: SELECTION_MODEL_FACTORY,
            useValue: DefaultSelectionModelFactory,
        },
    ], imports: [CommonModule,
        ScIconModule,
        FormsModule,
        ReactiveFormsModule,
        ScDropdownModule,
        ScAccordionComponent,
        ScAlertComponent,
        ScAlertValidationComponent,
        ScBannerComponent,
        ScBannerBrandComponent,
        ScBadgeComponent,
        ScDividerComponent,
        ScContainerComponent,
        ScOverlayMenuComponent,
        ScCardComponent,
        ScCardContentComponent,
        ScCardHeaderComponent,
        ScButtonComponent,
        ScTextLinkComponent,
        ScTabsComponent,
        ScTabComponent,
        ScStepperComponent,
        ScPageComponent,
        ScPageActionsComponent,
        ScPageContentComponent,
        ScFocusPageComponent,
        ScFocusPageBodyComponent,
        ScPageProgressComponent,
        ScLoaderComponent,
        ScLoaderContainerComponent,
        ScListComponent,
        ScListItemComponent,
        ScCollapsibleComponent,
        ScOffcanvasPageComponent,
        ScCheckboxComponent,
        ScDatepickerComponent,
        FormFieldComponent,
        AmountInputComponent,
        ScNumericStepperComponent,
        ScRadioComponent,
        ScAutocompleteComponent,
        ScToggleComponent,
        ScTooltipComponent,
        ScStripeHeaderComponent,
        ScStripeHeaderCloseComponent,
        ScStripeHeaderLogoComponent,
        ScStripeHeaderCartComponent, ScDropdownModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: ScMobileModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ScIconModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ScDropdownModule,
                        ScAccordionComponent,
                        ScAlertComponent,
                        ScAlertValidationComponent,
                        ScBannerComponent,
                        ScBannerBrandComponent,
                        ScBadgeComponent,
                        ScDividerComponent,
                        ScContainerComponent,
                        ScOverlayMenuComponent,
                        ScCardComponent,
                        ScCardContentComponent,
                        ScCardHeaderComponent,
                        ScButtonComponent,
                        ScTextLinkComponent,
                        ScTabsComponent,
                        ScTabComponent,
                        ScStepperComponent,
                        ScPageComponent,
                        ScPageActionsComponent,
                        ScPageContentComponent,
                        ScFocusPageComponent,
                        ScFocusPageBodyComponent,
                        ScPageProgressComponent,
                        ScLoaderComponent,
                        ScLoaderContainerComponent,
                        ScListComponent,
                        ScListItemComponent,
                        ScCollapsibleComponent,
                        ScOffcanvasPageComponent,
                        ScCheckboxComponent,
                        ScDatepickerComponent,
                        FormFieldComponent,
                        AmountInputComponent,
                        ScNumericStepperComponent,
                        ScRadioComponent,
                        ScAutocompleteComponent,
                        ScToggleComponent,
                        ScToggleGroup,
                        ScTooltipDirective,
                        ScTooltipComponent,
                        ScStripeHeaderComponent,
                        ScStripeHeaderCloseComponent,
                        ScStripeHeaderLogoComponent,
                        ScStripeHeaderCartComponent,
                    ],
                    declarations: [
                        // select
                        ScDropdownPanelComponent,
                        ScOptionComponent,
                        ScSelectComponent,
                        ScOptgroupTemplateDirective,
                        ScOptionTemplateDirective,
                        ScLabelTemplateDirective,
                        ScMultiLabelTemplateDirective,
                        ScHeaderTemplateDirective,
                        ScFooterTemplateDirective,
                        ScNotFoundTemplateDirective,
                        ScTypeToSearchTemplateDirective,
                        ScLoadingTextTemplateDirective,
                        ScTagTemplateDirective,
                        ScLoadingSpinnerTemplateDirective,
                        ScItemLabelDirective,
                        // modals
                        ScModalBaseComponent,
                        ModalHeaderComponent,
                        ModalContentComponent,
                        ModalFooterComponent,
                        ModalComponent,
                        SmallModalComponent,
                        SmallModalHeaderComponent,
                        SmallModalContentComponent,
                        SmallModalFooterComponent,
                        // sliders
                        ScSliderComponent,
                        ScSliderHandleComponent,
                        ScSliderTrackComponent,
                        ScSliderStepComponent,
                        ScSliderMarksComponent,
                        ScSliderLargeComponent,
                        ScTouchSliderV2Component,
                        ScTouchSliderLargeV2Component,
                    ],
                    exports: [
                        ScAccordionComponent,
                        ScAlertComponent,
                        ScAlertValidationComponent,
                        ScBannerComponent,
                        ScBannerBrandComponent,
                        ScButtonComponent,
                        ScCardComponent,
                        ScCardContentComponent,
                        ScCardHeaderComponent,
                        ScDatepickerComponent,
                        ScDividerComponent,
                        ScCheckboxComponent,
                        ScLoaderComponent,
                        ScLoaderContainerComponent,
                        ScStepperComponent,
                        ScOverlayMenuComponent,
                        ScPageComponent,
                        ScPageActionsComponent,
                        ScPageContentComponent,
                        ScOffcanvasPageComponent,
                        ScDropdownPanelComponent,
                        ScOptionComponent,
                        ScSelectComponent,
                        ScOptgroupTemplateDirective,
                        ScOptionTemplateDirective,
                        ScLabelTemplateDirective,
                        ScMultiLabelTemplateDirective,
                        ScHeaderTemplateDirective,
                        ScFooterTemplateDirective,
                        ScNotFoundTemplateDirective,
                        ScTypeToSearchTemplateDirective,
                        ScLoadingTextTemplateDirective,
                        ScTagTemplateDirective,
                        ScLoadingSpinnerTemplateDirective,
                        ScItemLabelDirective,
                        ScNumericStepperComponent,
                        ScTextLinkComponent,
                        ScToggleComponent,
                        ScToggleGroup,
                        ScTooltipComponent,
                        ScTooltipDirective,
                        ScAutocompleteComponent,
                        ScModalBaseComponent,
                        ModalHeaderComponent,
                        ModalContentComponent,
                        ModalFooterComponent,
                        ModalComponent,
                        SmallModalComponent,
                        SmallModalHeaderComponent,
                        SmallModalContentComponent,
                        SmallModalFooterComponent,
                        ScBadgeComponent,
                        ScContainerComponent,
                        ScFocusPageComponent,
                        ScFocusPageBodyComponent,
                        ScStripeHeaderComponent,
                        ScStripeHeaderCloseComponent,
                        ScStripeHeaderLogoComponent,
                        ScStripeHeaderCartComponent,
                        AmountInputComponent,
                        FormFieldComponent,
                        ScRadioComponent,
                        ScCollapsibleComponent,
                        ScTabsComponent,
                        ScTabComponent,
                        ScPageProgressComponent,
                        ScListComponent,
                        ScListItemComponent,
                        ScSliderComponent,
                        ScSliderHandleComponent,
                        ScSliderTrackComponent,
                        ScSliderStepComponent,
                        ScSliderMarksComponent,
                        ScSliderLargeComponent,
                        ScTouchSliderV2Component,
                        ScTouchSliderLargeV2Component,
                        ScDropdownModule,
                    ],
                    providers: [
                        ScSliderService,
                        ScTouchSliderService,
                        ModalService,
                        {
                            provide: SELECTION_MODEL_FACTORY,
                            useValue: DefaultSelectionModelFactory,
                        },
                    ],
                }]
        }] });

var ModalEvents;
(function (ModalEvents) {
    ModalEvents[ModalEvents["ModalClose"] = 0] = "ModalClose";
    ModalEvents[ModalEvents["ModalAction"] = 1] = "ModalAction";
})(ModalEvents || (ModalEvents = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { AmountInputComponent, ArrayToMarks, BadgeVariant, CONTROL_VALUE_ACCESSOR, DefaultSelectionModel, DefaultSelectionModelFactory, FormFieldComponent, HighlightPipe, KeyCode, MODAL_DATA, ModalComponent, ModalContentComponent, ModalEvents, ModalFooterComponent, ModalHeaderComponent, ModalRef, ModalService, PositioningService, RADIO_VALUE_ACCESSOR, RadioControlRegistry, SC_TOGGLE_GROUP, SC_TOGGLE_GROUP_VALUE_ACCESSOR, SELECTION_MODEL_FACTORY, ScAccordionComponent, ScAlertComponent, ScAlertValidationComponent, ScAutocompleteComponent, ScBadgeComponent, ScBannerBrandComponent, ScBannerComponent, ScButtonComponent, ScCardComponent, ScCardContentComponent, ScCardHeaderComponent, ScCheckboxComponent, ScCollapsibleComponent, ScContainerComponent, ScDatepickerComponent, ScDividerComponent, ScDropdownComponent, ScDropdownGroupComponent, ScDropdownItemComponent, ScDropdownModule, ScDropdownPanelComponent, ScDropdownTargetDirective, ScFocusPageBodyComponent, ScFocusPageComponent, ScFooterTemplateDirective, ScHeaderTemplateDirective, ScInputResizeDirective, ScItemLabelDirective, ScLabelTemplateDirective, ScListComponent, ScListItemComponent, ScLoaderComponent, ScLoaderContainerComponent, ScLoadingSpinnerTemplateDirective, ScLoadingTextTemplateDirective, ScMarks, ScMobileModule, ScModalBaseComponent, ScMultiLabelTemplateDirective, ScNotFoundTemplateDirective, ScNumericStepperComponent, ScOffcanvasPageComponent, ScOptgroupTemplateDirective, ScOptionComponent, ScOptionTemplateDirective, ScOverlayMenuComponent, ScPageActionsComponent, ScPageComponent, ScPageContentComponent, ScPageProgressComponent, ScRadioComponent, ScSelectComponent, ScSelectConfig, ScSliderComponent, ScSliderHandleComponent, ScSliderLargeComponent, ScSliderMarksComponent, ScSliderService, ScSliderStepComponent, ScSliderTrackComponent, ScStepperComponent, ScStripeHeaderCartComponent, ScStripeHeaderCloseComponent, ScStripeHeaderComponent, ScStripeHeaderLogoComponent, ScTabComponent, ScTabsComponent, ScTagTemplateDirective, ScTextLinkComponent, ScToggleComponent, ScToggleGroup, ScTooltipComponent, ScTooltipDirective, ScTouchSliderLargeV2Component, ScTouchSliderV2Component, ScTypeToSearchTemplateDirective, SliderEvents, SmallModalComponent, SmallModalContentComponent, SmallModalFooterComponent, SmallModalHeaderComponent, ToggleSelectionModel, arraysEqual, ensureNumberInRange, getElementOffset, getEventPosition, getPercent, getPrecision, isNil, isTouchEvent, silentEvent, slideType };
